import type { GraphQLClient, RequestOptions } from "graphql-request";
import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
type GraphQLClientRequestHeaders = RequestOptions["requestHeaders"];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: string; output: string };
  EmailAddress: { input: string; output: string };
  JSONObject: { input: Record<string, any>; output: Record<string, any> };
  LowercaseTrimmedString: { input: string; output: string };
  NonNegativeInt: { input: number; output: number };
  PaginationLimit: { input: number; output: number };
  PositiveInt: { input: number; output: number };
  PositivePercentage: { input: number; output: number };
  TimeZone: { input: string; output: string };
  TrimmedString: { input: string; output: string };
  UUID: { input: string; output: string };
  Upload: { input: never; output: never };
  UppercaseTrimmedString: { input: string; output: string };
};

export type ApCollectionSection = {
  __typename?: "APCollectionSection";
  id: Scalars["UUID"]["output"];
  productTags: Array<ProductTag>;
  translations: Array<CollectionSectionTranslation>;
};

export type ActiveCheckout = {
  __typename?: "ActiveCheckout";
  id: Scalars["UUID"]["output"];
  secret: Scalars["String"]["output"];
  storeId: StoreId;
};

export type Activity =
  | ActivityCheckoutProcessForceIntegrity
  | ActivityCheckoutProcessUpdate
  | ActivityCollectionUserArchive
  | ActivityCollectionUserCreate
  | ActivityCollectionUserDelete
  | ActivityCollectionUserPublish
  | ActivityCollectionUserUpdate
  | ActivityCustomerTaxExemptionCustomerAttachmentDelete
  | ActivityCustomerTaxExemptionCustomerAttachmentUpload
  | ActivityCustomerTaxExemptionCustomerRequest
  | ActivityCustomerTaxExemptionUserAttachmentDelete
  | ActivityCustomerTaxExemptionUserAttachmentUpload
  | ActivityCustomerTaxExemptionUserCreate
  | ActivityCustomerTaxExemptionUserDelete
  | ActivityCustomerTaxExemptionUserUpdate
  | ActivityCustomerUserInvite
  | ActivityDiscountUserCreate
  | ActivityDiscountUserDelete
  | ActivityDiscountUserUpdate
  | ActivityExchangeProcessCreate
  | ActivityExchangeUserCreate
  | ActivityGalleryItemUserCreate
  | ActivityGalleryItemUserDelete
  | ActivityGalleryItemUserUpdate
  | ActivityIntegrationUserCreate
  | ActivityIntegrationUserDelete
  | ActivityIntegrationUserUpdate
  | ActivityOrderCustomerCancel
  | ActivityOrderCustomerCreate
  | ActivityOrderOperationTransactionCustomerCreate
  | ActivityOrderOperationTransactionProcessAuthorize
  | ActivityOrderOperationTransactionProcessCancel
  | ActivityOrderOperationTransactionProcessComplete
  | ActivityOrderOperationTransactionProcessFail
  | ActivityOrderOperationTransactionProcessPartialComplete
  | ActivityOrderOperationTransactionUserCreate
  | ActivityOrderProcessCancel
  | ActivityOrderProcessComplete
  | ActivityOrderProcessItemsCommit
  | ActivityOrderProcessItemsDeliver
  | ActivityOrderProcessItemsPick
  | ActivityOrderProcessItemsShip
  | ActivityOrderProcessNetsuiteCreate
  | ActivityOrderProcessNetsuiteSync
  | ActivityOrderProcessPartialClose
  | ActivityOrderProcessUpdate
  | ActivityOrderReturnCustomerCreate
  | ActivityOrderReturnProcessApprove
  | ActivityOrderReturnProcessCreate
  | ActivityOrderReturnUserApprove
  | ActivityOrderReturnUserCreate
  | ActivityOrderReturnUserReject
  | ActivityOrderUserCreate
  | ActivityOrderUserMarkAsPaid
  | ActivityOrderUserPickAndFulfill
  | ActivityOrderUserReopen
  | ActivityProductDocumentUserCreate
  | ActivityProductDocumentUserDelete
  | ActivityProductDocumentUserUpdate
  | ActivityProductInventoryUserUpdate
  | ActivityProductUserArchive
  | ActivityProductUserCreate
  | ActivityProductUserDelete
  | ActivityProductUserPublish
  | ActivityProductUserUpdate
  | ActivityProductVariantUserCreate
  | ActivityProductVariantUserUpdate
  | ActivityStoreUserUpdate
  | ActivityTaxIdValidationProcessCancel
  | ActivityTaxIdValidationProcessComplete
  | ActivityTaxIdValidationProcessRetry
  | ActivityUserUserDeactivate
  | ActivityUserUserDelete
  | ActivityUserUserInvite
  | ActivityUserUserUpdate
  | ActivityWarehouseUserCreate
  | ActivityWarehouseUserDelete
  | ActivityWarehouseUserUpdate;

export enum ActivityAction {
  Approve = "approve",
  Archive = "archive",
  AttachmentDelete = "attachmentDelete",
  AttachmentUpload = "attachmentUpload",
  Authorize = "authorize",
  Cancel = "cancel",
  Complete = "complete",
  Create = "create",
  Deactivate = "deactivate",
  Delete = "delete",
  Fail = "fail",
  ForceIntegrity = "forceIntegrity",
  Invite = "invite",
  ItemsCommit = "itemsCommit",
  ItemsDeliver = "itemsDeliver",
  ItemsPick = "itemsPick",
  ItemsShip = "itemsShip",
  MarkAsPaid = "markAsPaid",
  NetsuiteCreate = "netsuiteCreate",
  NetsuiteSync = "netsuiteSync",
  PartialClose = "partialClose",
  PartialComplete = "partialComplete",
  PickAndFulfill = "pickAndFulfill",
  Publish = "publish",
  Reject = "reject",
  Reopen = "reopen",
  Request = "request",
  Retry = "retry",
  Update = "update",
  Upload = "upload",
}

/**
 * Generic type for all ActivitiesXXX for easier queries.
 * So instead of querying the ActivitiesXXX union, you can query the ActivitiesAny (smaller query and more type-safe)
 * and then just assert the results to the correct type.
 */
export type ActivityAny = {
  __typename?: "ActivityAny";
  createdAt: Scalars["DateTime"]["output"];
  customer?: Maybe<Customer>;
  entityChanges?: Maybe<Scalars["JSONObject"]["output"]>;
  entityId?: Maybe<Scalars["String"]["output"]>;
  entityType: EntityType;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["String"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload?: Maybe<Scalars["JSONObject"]["output"]>;
  processId?: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
  user?: Maybe<User>;
};

export type ActivityCheckoutProcessForceIntegrity = {
  __typename?: "ActivityCheckoutProcessForceIntegrity";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCheckout;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCheckoutProcessForceIntegrityPayload;
  processId: Scalars["String"]["output"];
};

export type ActivityCheckoutProcessForceIntegrityPayload = {
  __typename?: "ActivityCheckoutProcessForceIntegrityPayload";
  newQuantity: Scalars["Int"]["output"];
  oldQuantity?: Maybe<Scalars["Int"]["output"]>;
  sku?: Maybe<Scalars["String"]["output"]>;
  table: Scalars["String"]["output"];
  tableId?: Maybe<Scalars["UUID"]["output"]>;
};

export type ActivityCheckoutProcessUpdate = {
  __typename?: "ActivityCheckoutProcessUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCheckout;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCheckoutProcessUpdatePayload;
  processId: Scalars["String"]["output"];
};

export type ActivityCheckoutProcessUpdatePayload = {
  __typename?: "ActivityCheckoutProcessUpdatePayload";
  status: Scalars["String"]["output"];
};

export type ActivityCollectionUserArchive = {
  __typename?: "ActivityCollectionUserArchive";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCollection;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityCollectionUserCreate = {
  __typename?: "ActivityCollectionUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCollection;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCollectionUserCreatePayload;
  user: User;
};

export type ActivityCollectionUserCreatePayload = {
  __typename?: "ActivityCollectionUserCreatePayload";
  name: Scalars["String"]["output"];
};

export type ActivityCollectionUserDelete = {
  __typename?: "ActivityCollectionUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCollection;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityCollectionUserPublish = {
  __typename?: "ActivityCollectionUserPublish";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCollection;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityCollectionUserUpdate = {
  __typename?: "ActivityCollectionUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCollection;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityCustomerTaxExemptionCustomerAttachmentDelete = {
  __typename?: "ActivityCustomerTaxExemptionCustomerAttachmentDelete";
  createdAt: Scalars["DateTime"]["output"];
  customer: Customer;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCustomerTaxExemptionCustomerAttachmentDeletePayload;
};

export type ActivityCustomerTaxExemptionCustomerAttachmentDeletePayload = {
  __typename?: "ActivityCustomerTaxExemptionCustomerAttachmentDeletePayload";
  customerTaxExemptionId: Scalars["UUID"]["output"];
  fileName: Scalars["String"]["output"];
  mimeType: Scalars["String"]["output"];
};

export type ActivityCustomerTaxExemptionCustomerAttachmentUpload = {
  __typename?: "ActivityCustomerTaxExemptionCustomerAttachmentUpload";
  createdAt: Scalars["DateTime"]["output"];
  customer: Customer;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCustomerTaxExemptionCustomerAttachmentUploadPayload;
};

export type ActivityCustomerTaxExemptionCustomerAttachmentUploadPayload = {
  __typename?: "ActivityCustomerTaxExemptionCustomerAttachmentUploadPayload";
  customerTaxExemptionId: Scalars["UUID"]["output"];
  fileName: Scalars["String"]["output"];
  mimeType: Scalars["String"]["output"];
};

export type ActivityCustomerTaxExemptionCustomerRequest = {
  __typename?: "ActivityCustomerTaxExemptionCustomerRequest";
  createdAt: Scalars["DateTime"]["output"];
  customer: Customer;
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
};

export type ActivityCustomerTaxExemptionUserAttachmentDelete = {
  __typename?: "ActivityCustomerTaxExemptionUserAttachmentDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCustomerTaxExemptionUserAttachmentDeletePayload;
  user: User;
};

export type ActivityCustomerTaxExemptionUserAttachmentDeletePayload = {
  __typename?: "ActivityCustomerTaxExemptionUserAttachmentDeletePayload";
  customerTaxExemptionId: Scalars["UUID"]["output"];
  fileName: Scalars["String"]["output"];
  mimeType: Scalars["String"]["output"];
};

export type ActivityCustomerTaxExemptionUserAttachmentUpload = {
  __typename?: "ActivityCustomerTaxExemptionUserAttachmentUpload";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCustomerTaxExemptionUserAttachmentUploadPayload;
  user: User;
};

export type ActivityCustomerTaxExemptionUserAttachmentUploadPayload = {
  __typename?: "ActivityCustomerTaxExemptionUserAttachmentUploadPayload";
  customerTaxExemptionId: Scalars["UUID"]["output"];
  fileName: Scalars["String"]["output"];
  mimeType: Scalars["String"]["output"];
};

export type ActivityCustomerTaxExemptionUserCreate = {
  __typename?: "ActivityCustomerTaxExemptionUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityCustomerTaxExemptionUserDelete = {
  __typename?: "ActivityCustomerTaxExemptionUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityCustomerTaxExemptionUserUpdate = {
  __typename?: "ActivityCustomerTaxExemptionUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityCustomerUserInvite = {
  __typename?: "ActivityCustomerUserInvite";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomer;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCustomerUserInvitePayload;
  user: User;
};

export type ActivityCustomerUserInvitePayload = {
  __typename?: "ActivityCustomerUserInvitePayload";
  email: Scalars["EmailAddress"]["output"];
  slug: Scalars["String"]["output"];
  username?: Maybe<Scalars["String"]["output"]>;
};

/** Backend only type, use Activity instead */
export type ActivityDb =
  | ActivityDbCheckoutProcessForceIntegrity
  | ActivityDbCheckoutProcessUpdate
  | ActivityDbCollectionUserArchive
  | ActivityDbCollectionUserCreate
  | ActivityDbCollectionUserDelete
  | ActivityDbCollectionUserPublish
  | ActivityDbCollectionUserUpdate
  | ActivityDbCustomerTaxExemptionCustomerAttachmentDelete
  | ActivityDbCustomerTaxExemptionCustomerAttachmentUpload
  | ActivityDbCustomerTaxExemptionCustomerRequest
  | ActivityDbCustomerTaxExemptionUserAttachmentDelete
  | ActivityDbCustomerTaxExemptionUserAttachmentUpload
  | ActivityDbCustomerTaxExemptionUserCreate
  | ActivityDbCustomerTaxExemptionUserDelete
  | ActivityDbCustomerTaxExemptionUserUpdate
  | ActivityDbCustomerUserInvite
  | ActivityDbDiscountUserCreate
  | ActivityDbDiscountUserDelete
  | ActivityDbDiscountUserUpdate
  | ActivityDbExchangeProcessCreate
  | ActivityDbExchangeUserCreate
  | ActivityDbGalleryItemUserCreate
  | ActivityDbGalleryItemUserDelete
  | ActivityDbGalleryItemUserUpdate
  | ActivityDbIntegrationUserCreate
  | ActivityDbIntegrationUserDelete
  | ActivityDbIntegrationUserUpdate
  | ActivityDbOrderCustomerCancel
  | ActivityDbOrderCustomerCreate
  | ActivityDbOrderOperationTransactionCustomerCreate
  | ActivityDbOrderOperationTransactionProcessAuthorize
  | ActivityDbOrderOperationTransactionProcessCancel
  | ActivityDbOrderOperationTransactionProcessComplete
  | ActivityDbOrderOperationTransactionProcessFail
  | ActivityDbOrderOperationTransactionProcessPartialComplete
  | ActivityDbOrderOperationTransactionUserCreate
  | ActivityDbOrderProcessCancel
  | ActivityDbOrderProcessComplete
  | ActivityDbOrderProcessItemsCommit
  | ActivityDbOrderProcessItemsDeliver
  | ActivityDbOrderProcessItemsPick
  | ActivityDbOrderProcessItemsShip
  | ActivityDbOrderProcessNetsuiteCreate
  | ActivityDbOrderProcessNetsuiteSync
  | ActivityDbOrderProcessPartialClose
  | ActivityDbOrderProcessUpdate
  | ActivityDbOrderReturnCustomerCreate
  | ActivityDbOrderReturnProcessApprove
  | ActivityDbOrderReturnProcessCreate
  | ActivityDbOrderReturnUserApprove
  | ActivityDbOrderReturnUserCreate
  | ActivityDbOrderReturnUserReject
  | ActivityDbOrderUserCreate
  | ActivityDbOrderUserMarkAsPaid
  | ActivityDbOrderUserPickAndFulfill
  | ActivityDbOrderUserReopen
  | ActivityDbProductDocumentUserCreate
  | ActivityDbProductDocumentUserDelete
  | ActivityDbProductDocumentUserUpdate
  | ActivityDbProductInventoryUserUpdate
  | ActivityDbProductUserArchive
  | ActivityDbProductUserCreate
  | ActivityDbProductUserDelete
  | ActivityDbProductUserPublish
  | ActivityDbProductUserUpdate
  | ActivityDbProductVariantUserCreate
  | ActivityDbProductVariantUserUpdate
  | ActivityDbStoreUserUpdate
  | ActivityDbTaxIdValidationProcessCancel
  | ActivityDbTaxIdValidationProcessComplete
  | ActivityDbTaxIdValidationProcessRetry
  | ActivityDbUserUserDeactivate
  | ActivityDbUserUserDelete
  | ActivityDbUserUserInvite
  | ActivityDbUserUserUpdate
  | ActivityDbWarehouseUserCreate
  | ActivityDbWarehouseUserDelete
  | ActivityDbWarehouseUserUpdate;

/** Backend only type, use ActivityCheckoutProcessForceIntegrity instead */
export type ActivityDbCheckoutProcessForceIntegrity = {
  __typename?: "ActivityDbCheckoutProcessForceIntegrity";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCheckout;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCheckoutProcessForceIntegrity;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCheckoutProcessForceIntegrityPayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityCheckoutProcessUpdate instead */
export type ActivityDbCheckoutProcessUpdate = {
  __typename?: "ActivityDbCheckoutProcessUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCheckout;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCheckoutProcessUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCheckoutProcessUpdatePayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityCollectionUserArchive instead */
export type ActivityDbCollectionUserArchive = {
  __typename?: "ActivityDbCollectionUserArchive";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCollection;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCollectionUserArchive;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityCollectionUserCreate instead */
export type ActivityDbCollectionUserCreate = {
  __typename?: "ActivityDbCollectionUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCollection;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCollectionUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCollectionUserCreatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityCollectionUserDelete instead */
export type ActivityDbCollectionUserDelete = {
  __typename?: "ActivityDbCollectionUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCollection;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCollectionUserDelete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityCollectionUserPublish instead */
export type ActivityDbCollectionUserPublish = {
  __typename?: "ActivityDbCollectionUserPublish";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCollection;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCollectionUserPublish;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityCollectionUserUpdate instead */
export type ActivityDbCollectionUserUpdate = {
  __typename?: "ActivityDbCollectionUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCollection;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCollectionUserUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityCustomerTaxExemptionCustomerAttachmentDelete instead */
export type ActivityDbCustomerTaxExemptionCustomerAttachmentDelete = {
  __typename?: "ActivityDbCustomerTaxExemptionCustomerAttachmentDelete";
  createdAt: Scalars["DateTime"]["output"];
  customerId: Scalars["UUID"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCustomerTaxExemptionCustomerAttachmentDelete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCustomerTaxExemptionCustomerAttachmentDeletePayload;
};

/** Backend only type, use ActivityCustomerTaxExemptionCustomerAttachmentUpload instead */
export type ActivityDbCustomerTaxExemptionCustomerAttachmentUpload = {
  __typename?: "ActivityDbCustomerTaxExemptionCustomerAttachmentUpload";
  createdAt: Scalars["DateTime"]["output"];
  customerId: Scalars["UUID"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCustomerTaxExemptionCustomerAttachmentUpload;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCustomerTaxExemptionCustomerAttachmentUploadPayload;
};

/** Backend only type, use ActivityCustomerTaxExemptionCustomerRequest instead */
export type ActivityDbCustomerTaxExemptionCustomerRequest = {
  __typename?: "ActivityDbCustomerTaxExemptionCustomerRequest";
  createdAt: Scalars["DateTime"]["output"];
  customerId: Scalars["UUID"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCustomerTaxExemptionCustomerRequest;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
};

/** Backend only type, use ActivityCustomerTaxExemptionUserAttachmentDelete instead */
export type ActivityDbCustomerTaxExemptionUserAttachmentDelete = {
  __typename?: "ActivityDbCustomerTaxExemptionUserAttachmentDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCustomerTaxExemptionUserAttachmentDelete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCustomerTaxExemptionUserAttachmentDeletePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityCustomerTaxExemptionUserAttachmentUpload instead */
export type ActivityDbCustomerTaxExemptionUserAttachmentUpload = {
  __typename?: "ActivityDbCustomerTaxExemptionUserAttachmentUpload";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCustomerTaxExemptionUserAttachmentUpload;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCustomerTaxExemptionUserAttachmentUploadPayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityCustomerTaxExemptionUserCreate instead */
export type ActivityDbCustomerTaxExemptionUserCreate = {
  __typename?: "ActivityDbCustomerTaxExemptionUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCustomerTaxExemptionUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityCustomerTaxExemptionUserDelete instead */
export type ActivityDbCustomerTaxExemptionUserDelete = {
  __typename?: "ActivityDbCustomerTaxExemptionUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCustomerTaxExemptionUserDelete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityCustomerTaxExemptionUserUpdate instead */
export type ActivityDbCustomerTaxExemptionUserUpdate = {
  __typename?: "ActivityDbCustomerTaxExemptionUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomerTaxExemption;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCustomerTaxExemptionUserUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityCustomerUserInvite instead */
export type ActivityDbCustomerUserInvite = {
  __typename?: "ActivityDbCustomerUserInvite";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityCustomer;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityCustomerUserInvite;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityCustomerUserInvitePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityDiscountUserCreate instead */
export type ActivityDbDiscountUserCreate = {
  __typename?: "ActivityDbDiscountUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityDiscount;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityDiscountUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityDiscountUserDelete instead */
export type ActivityDbDiscountUserDelete = {
  __typename?: "ActivityDbDiscountUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityDiscount;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityDiscountUserDelete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityDiscountUserDeletePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityDiscountUserUpdate instead */
export type ActivityDbDiscountUserUpdate = {
  __typename?: "ActivityDbDiscountUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityDiscount;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityDiscountUserUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityDiscountUserUpdatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityExchangeProcessCreate instead */
export type ActivityDbExchangeProcessCreate = {
  __typename?: "ActivityDbExchangeProcessCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityExchange;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityExchangeProcessCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityExchangeProcessCreatePayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityExchangeUserCreate instead */
export type ActivityDbExchangeUserCreate = {
  __typename?: "ActivityDbExchangeUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityExchange;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityExchangeUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityExchangeUserCreatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityGalleryItemUserCreate instead */
export type ActivityDbGalleryItemUserCreate = {
  __typename?: "ActivityDbGalleryItemUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityGalleryItem;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityGalleryItemUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityGalleryItemUserCreatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityGalleryItemUserDelete instead */
export type ActivityDbGalleryItemUserDelete = {
  __typename?: "ActivityDbGalleryItemUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityGalleryItem;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityGalleryItemUserDelete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityGalleryItemUserDeletePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityGalleryItemUserUpdate instead */
export type ActivityDbGalleryItemUserUpdate = {
  __typename?: "ActivityDbGalleryItemUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityGalleryItem;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityGalleryItemUserUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityGalleryItemUserUpdatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityIntegrationUserCreate instead */
export type ActivityDbIntegrationUserCreate = {
  __typename?: "ActivityDbIntegrationUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityIntegration;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityIntegrationUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityIntegrationUserDelete instead */
export type ActivityDbIntegrationUserDelete = {
  __typename?: "ActivityDbIntegrationUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityIntegration;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityIntegrationUserDelete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityIntegrationUserUpdate instead */
export type ActivityDbIntegrationUserUpdate = {
  __typename?: "ActivityDbIntegrationUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityIntegration;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityIntegrationUserUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityOrderCustomerCancel instead */
export type ActivityDbOrderCustomerCancel = {
  __typename?: "ActivityDbOrderCustomerCancel";
  createdAt: Scalars["DateTime"]["output"];
  customerId: Scalars["UUID"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderCustomerCancel;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
};

/** Backend only type, use ActivityOrderCustomerCreate instead */
export type ActivityDbOrderCustomerCreate = {
  __typename?: "ActivityDbOrderCustomerCreate";
  createdAt: Scalars["DateTime"]["output"];
  customerId: Scalars["UUID"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderCustomerCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
};

/** Backend only type, use ActivityOrderOperationTransactionCustomerCreate instead */
export type ActivityDbOrderOperationTransactionCustomerCreate = {
  __typename?: "ActivityDbOrderOperationTransactionCustomerCreate";
  createdAt: Scalars["DateTime"]["output"];
  customerId: Scalars["UUID"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderOperationTransactionCustomerCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionCustomerCreatePayload;
};

/** Backend only type, use ActivityOrderOperationTransactionProcessAuthorize instead */
export type ActivityDbOrderOperationTransactionProcessAuthorize = {
  __typename?: "ActivityDbOrderOperationTransactionProcessAuthorize";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderOperationTransactionProcessAuthorize;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionProcessAuthorizePayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderOperationTransactionProcessCancel instead */
export type ActivityDbOrderOperationTransactionProcessCancel = {
  __typename?: "ActivityDbOrderOperationTransactionProcessCancel";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderOperationTransactionProcessCancel;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionProcessCancelPayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderOperationTransactionProcessComplete instead */
export type ActivityDbOrderOperationTransactionProcessComplete = {
  __typename?: "ActivityDbOrderOperationTransactionProcessComplete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderOperationTransactionProcessComplete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionProcessCompletePayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderOperationTransactionProcessFail instead */
export type ActivityDbOrderOperationTransactionProcessFail = {
  __typename?: "ActivityDbOrderOperationTransactionProcessFail";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderOperationTransactionProcessFail;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionProcessFailPayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderOperationTransactionProcessPartialComplete instead */
export type ActivityDbOrderOperationTransactionProcessPartialComplete = {
  __typename?: "ActivityDbOrderOperationTransactionProcessPartialComplete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderOperationTransactionProcessPartialComplete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionProcessPartialCompletePayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderOperationTransactionUserCreate instead */
export type ActivityDbOrderOperationTransactionUserCreate = {
  __typename?: "ActivityDbOrderOperationTransactionUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderOperationTransactionUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionUserCreatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityOrderProcessCancel instead */
export type ActivityDbOrderProcessCancel = {
  __typename?: "ActivityDbOrderProcessCancel";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderProcessCancel;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessCancelPayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderProcessComplete instead */
export type ActivityDbOrderProcessComplete = {
  __typename?: "ActivityDbOrderProcessComplete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderProcessComplete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderProcessItemsCommit instead */
export type ActivityDbOrderProcessItemsCommit = {
  __typename?: "ActivityDbOrderProcessItemsCommit";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderProcessItemsCommit;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessItemsCommitPayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderProcessItemsDeliver instead */
export type ActivityDbOrderProcessItemsDeliver = {
  __typename?: "ActivityDbOrderProcessItemsDeliver";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderProcessItemsDeliver;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessItemsDeliverPayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderProcessItemsPick instead */
export type ActivityDbOrderProcessItemsPick = {
  __typename?: "ActivityDbOrderProcessItemsPick";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderProcessItemsPick;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessItemsPickPayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderProcessItemsShip instead */
export type ActivityDbOrderProcessItemsShip = {
  __typename?: "ActivityDbOrderProcessItemsShip";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderProcessItemsShip;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessItemsShipPayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderProcessNetsuiteCreate instead */
export type ActivityDbOrderProcessNetsuiteCreate = {
  __typename?: "ActivityDbOrderProcessNetsuiteCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderProcessNetsuiteCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessNetsuiteCreatePayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderProcessNetsuiteSync instead */
export type ActivityDbOrderProcessNetsuiteSync = {
  __typename?: "ActivityDbOrderProcessNetsuiteSync";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderProcessNetsuiteSync;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessNetsuiteSyncPayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderProcessPartialClose instead */
export type ActivityDbOrderProcessPartialClose = {
  __typename?: "ActivityDbOrderProcessPartialClose";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderProcessPartialClose;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessPartialClosePayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderProcessUpdate instead */
export type ActivityDbOrderProcessUpdate = {
  __typename?: "ActivityDbOrderProcessUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderProcessUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessUpdatePayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderReturnCustomerCreate instead */
export type ActivityDbOrderReturnCustomerCreate = {
  __typename?: "ActivityDbOrderReturnCustomerCreate";
  createdAt: Scalars["DateTime"]["output"];
  customerId: Scalars["UUID"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderReturn;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderReturnCustomerCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderReturnCustomerCreatePayload;
};

/** Backend only type, use ActivityOrderReturnProcessApprove instead */
export type ActivityDbOrderReturnProcessApprove = {
  __typename?: "ActivityDbOrderReturnProcessApprove";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderReturn;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderReturnProcessApprove;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderReturnProcessApprovePayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderReturnProcessCreate instead */
export type ActivityDbOrderReturnProcessCreate = {
  __typename?: "ActivityDbOrderReturnProcessCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderReturn;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderReturnProcessCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderReturnProcessCreatePayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityOrderReturnUserApprove instead */
export type ActivityDbOrderReturnUserApprove = {
  __typename?: "ActivityDbOrderReturnUserApprove";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderReturn;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderReturnUserApprove;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderReturnUserApprovePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityOrderReturnUserCreate instead */
export type ActivityDbOrderReturnUserCreate = {
  __typename?: "ActivityDbOrderReturnUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderReturn;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderReturnUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderReturnUserCreatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityOrderReturnUserReject instead */
export type ActivityDbOrderReturnUserReject = {
  __typename?: "ActivityDbOrderReturnUserReject";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderReturn;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderReturnUserReject;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderReturnUserRejectPayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityOrderUserCreate instead */
export type ActivityDbOrderUserCreate = {
  __typename?: "ActivityDbOrderUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderUserCreatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityOrderUserMarkAsPaid instead */
export type ActivityDbOrderUserMarkAsPaid = {
  __typename?: "ActivityDbOrderUserMarkAsPaid";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderUserMarkAsPaid;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderUserMarkAsPaidPayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityOrderUserPickAndFulfill instead */
export type ActivityDbOrderUserPickAndFulfill = {
  __typename?: "ActivityDbOrderUserPickAndFulfill";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderUserPickAndFulfill;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderUserPickAndFulfillPayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityOrderUserReopen instead */
export type ActivityDbOrderUserReopen = {
  __typename?: "ActivityDbOrderUserReopen";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityOrderUserReopen;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderUserReopenPayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityProductDocumentUserCreate instead */
export type ActivityDbProductDocumentUserCreate = {
  __typename?: "ActivityDbProductDocumentUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProductDocument;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityProductDocumentUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductDocumentUserCreatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityProductDocumentUserDelete instead */
export type ActivityDbProductDocumentUserDelete = {
  __typename?: "ActivityDbProductDocumentUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProductDocument;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityProductDocumentUserDelete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductDocumentUserDeletePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityProductDocumentUserUpdate instead */
export type ActivityDbProductDocumentUserUpdate = {
  __typename?: "ActivityDbProductDocumentUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProductDocument;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityProductDocumentUserUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductDocumentUserUpdatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityProductInventoryUserUpdate instead */
export type ActivityDbProductInventoryUserUpdate = {
  __typename?: "ActivityDbProductInventoryUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProductInventory;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityProductInventoryUserUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductInventoryUserUpdatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityProductUserArchive instead */
export type ActivityDbProductUserArchive = {
  __typename?: "ActivityDbProductUserArchive";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProduct;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityProductUserArchive;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityProductUserCreate instead */
export type ActivityDbProductUserCreate = {
  __typename?: "ActivityDbProductUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProduct;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityProductUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductUserCreatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityProductUserDelete instead */
export type ActivityDbProductUserDelete = {
  __typename?: "ActivityDbProductUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProduct;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityProductUserDelete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityProductUserPublish instead */
export type ActivityDbProductUserPublish = {
  __typename?: "ActivityDbProductUserPublish";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProduct;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityProductUserPublish;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityProductUserUpdate instead */
export type ActivityDbProductUserUpdate = {
  __typename?: "ActivityDbProductUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProduct;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityProductUserUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductUserUpdatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityProductVariantUserCreate instead */
export type ActivityDbProductVariantUserCreate = {
  __typename?: "ActivityDbProductVariantUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProductVariant;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityProductVariantUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductVariantUserCreatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityProductVariantUserUpdate instead */
export type ActivityDbProductVariantUserUpdate = {
  __typename?: "ActivityDbProductVariantUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProductVariant;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityProductVariantUserUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductVariantUserUpdatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityStoreUserUpdate instead */
export type ActivityDbStoreUserUpdate = {
  __typename?: "ActivityDbStoreUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityStore;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityStoreUserUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityTaxIdValidationProcessCancel instead */
export type ActivityDbTaxIdValidationProcessCancel = {
  __typename?: "ActivityDbTaxIdValidationProcessCancel";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityTaxIdValidation;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityTaxIdValidationProcessCancel;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityTaxIdValidationProcessCancelPayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityTaxIdValidationProcessComplete instead */
export type ActivityDbTaxIdValidationProcessComplete = {
  __typename?: "ActivityDbTaxIdValidationProcessComplete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityTaxIdValidation;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityTaxIdValidationProcessComplete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityTaxIdValidationProcessCompletePayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityTaxIdValidationProcessRetry instead */
export type ActivityDbTaxIdValidationProcessRetry = {
  __typename?: "ActivityDbTaxIdValidationProcessRetry";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityTaxIdValidation;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityTaxIdValidationProcessRetry;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityTaxIdValidationProcessRetryPayload;
  processId: Scalars["String"]["output"];
};

/** Backend only type, use ActivityUserUserDeactivate instead */
export type ActivityDbUserUserDeactivate = {
  __typename?: "ActivityDbUserUserDeactivate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityUser;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityUserUserDeactivate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityUserUserDeactivatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityUserUserDelete instead */
export type ActivityDbUserUserDelete = {
  __typename?: "ActivityDbUserUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityUser;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityUserUserDelete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityUserUserDeletePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityUserUserInvite instead */
export type ActivityDbUserUserInvite = {
  __typename?: "ActivityDbUserUserInvite";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityUser;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityUserUserInvite;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityUserUserInvitePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityUserUserUpdate instead */
export type ActivityDbUserUserUpdate = {
  __typename?: "ActivityDbUserUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityUser;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityUserUserUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityUserUserUpdatePayload;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityWarehouseUserCreate instead */
export type ActivityDbWarehouseUserCreate = {
  __typename?: "ActivityDbWarehouseUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityWarehouse;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityWarehouseUserCreate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityWarehouseUserDelete instead */
export type ActivityDbWarehouseUserDelete = {
  __typename?: "ActivityDbWarehouseUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityWarehouse;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityWarehouseUserDelete;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

/** Backend only type, use ActivityWarehouseUserUpdate instead */
export type ActivityDbWarehouseUserUpdate = {
  __typename?: "ActivityDbWarehouseUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityWarehouse;
  id: Scalars["UUID"]["output"];
  /** Required for type-magic */
  parent: ActivityWarehouseUserUpdate;
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  userId: Scalars["UUID"]["output"];
};

export type ActivityDiscountUserCreate = {
  __typename?: "ActivityDiscountUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityDiscount;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityDiscountUserDelete = {
  __typename?: "ActivityDiscountUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityDiscount;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityDiscountUserDeletePayload;
  user: User;
};

export type ActivityDiscountUserDeletePayload = {
  __typename?: "ActivityDiscountUserDeletePayload";
  name: Scalars["String"]["output"];
};

export type ActivityDiscountUserUpdate = {
  __typename?: "ActivityDiscountUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityDiscount;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityDiscountUserUpdatePayload;
  user: User;
};

export type ActivityDiscountUserUpdatePayload = {
  __typename?: "ActivityDiscountUserUpdatePayload";
  name: Scalars["String"]["output"];
};

export type ActivityEntityChanges = {
  __typename?: "ActivityEntityChanges";
  new: ActivityEntityChangesItem;
  old: ActivityEntityChangesItem;
};

export type ActivityEntityChangesItem = {
  __typename?: "ActivityEntityChangesItem";
  br?: Maybe<Scalars["JSONObject"]["output"]>;
  ca?: Maybe<Scalars["JSONObject"]["output"]>;
  cn?: Maybe<Scalars["JSONObject"]["output"]>;
  default?: Maybe<Scalars["JSONObject"]["output"]>;
  eu?: Maybe<Scalars["JSONObject"]["output"]>;
  in?: Maybe<Scalars["JSONObject"]["output"]>;
  jp?: Maybe<Scalars["JSONObject"]["output"]>;
  me?: Maybe<Scalars["JSONObject"]["output"]>;
  mx?: Maybe<Scalars["JSONObject"]["output"]>;
  ph?: Maybe<Scalars["JSONObject"]["output"]>;
  sg?: Maybe<Scalars["JSONObject"]["output"]>;
  tw?: Maybe<Scalars["JSONObject"]["output"]>;
  uk?: Maybe<Scalars["JSONObject"]["output"]>;
  us?: Maybe<Scalars["JSONObject"]["output"]>;
  za?: Maybe<Scalars["JSONObject"]["output"]>;
};

export enum ActivityEntityCheckout {
  Checkout = "checkout",
}

export enum ActivityEntityCollection {
  Collection = "collection",
}

export enum ActivityEntityCustomer {
  Customer = "customer",
}

export enum ActivityEntityCustomerTaxExemption {
  CustomerTaxExemption = "customerTaxExemption",
}

export enum ActivityEntityDiscount {
  Discount = "discount",
}

export enum ActivityEntityExchange {
  Exchange = "exchange",
}

export enum ActivityEntityGalleryItem {
  GalleryItem = "galleryItem",
}

export enum ActivityEntityIntegration {
  Integration = "integration",
}

export enum ActivityEntityOrder {
  Order = "order",
}

export enum ActivityEntityOrderOperationTransaction {
  OrderOperationTransaction = "orderOperationTransaction",
}

export enum ActivityEntityOrderReturn {
  OrderReturn = "orderReturn",
}

export enum ActivityEntityProduct {
  Product = "product",
}

export enum ActivityEntityProductDocument {
  ProductDocument = "productDocument",
}

export enum ActivityEntityProductInventory {
  ProductInventory = "productInventory",
}

export enum ActivityEntityProductVariant {
  ProductVariant = "productVariant",
}

export enum ActivityEntityStore {
  Store = "store",
}

export enum ActivityEntityTaxIdValidation {
  TaxIdValidation = "taxIdValidation",
}

export enum ActivityEntityUser {
  User = "user",
}

export enum ActivityEntityWarehouse {
  Warehouse = "warehouse",
}

export type ActivityExchangeProcessCreate = {
  __typename?: "ActivityExchangeProcessCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityExchange;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityExchangeProcessCreatePayload;
  processId: Scalars["String"]["output"];
};

export type ActivityExchangeProcessCreatePayload = {
  __typename?: "ActivityExchangeProcessCreatePayload";
  from: Currency;
  rate: Scalars["String"]["output"];
  to: Currency;
};

export type ActivityExchangeUserCreate = {
  __typename?: "ActivityExchangeUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityExchange;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityExchangeUserCreatePayload;
  user: User;
};

export type ActivityExchangeUserCreatePayload = {
  __typename?: "ActivityExchangeUserCreatePayload";
  from: Currency;
  rate: Scalars["String"]["output"];
  to: Currency;
};

export type ActivityGalleryItemUserCreate = {
  __typename?: "ActivityGalleryItemUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityGalleryItem;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityGalleryItemUserCreatePayload;
  user: User;
};

export type ActivityGalleryItemUserCreatePayload = {
  __typename?: "ActivityGalleryItemUserCreatePayload";
  filename?: Maybe<Scalars["String"]["output"]>;
  galleryTag: GalleryTag;
  parentEntityId: Scalars["UUID"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
};

export type ActivityGalleryItemUserDelete = {
  __typename?: "ActivityGalleryItemUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityGalleryItem;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityGalleryItemUserDeletePayload;
  user: User;
};

export type ActivityGalleryItemUserDeletePayload = {
  __typename?: "ActivityGalleryItemUserDeletePayload";
  filename?: Maybe<Scalars["String"]["output"]>;
  galleryTag: GalleryTag;
  parentEntityId: Scalars["UUID"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
};

export type ActivityGalleryItemUserUpdate = {
  __typename?: "ActivityGalleryItemUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityGalleryItem;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityGalleryItemUserUpdatePayload;
  user: User;
};

export type ActivityGalleryItemUserUpdatePayload = {
  __typename?: "ActivityGalleryItemUserUpdatePayload";
  filename?: Maybe<Scalars["String"]["output"]>;
  galleryTag: GalleryTag;
  parentEntityId: Scalars["UUID"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
};

export type ActivityIntegrationUserCreate = {
  __typename?: "ActivityIntegrationUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityIntegration;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityIntegrationUserDelete = {
  __typename?: "ActivityIntegrationUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityIntegration;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityIntegrationUserUpdate = {
  __typename?: "ActivityIntegrationUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityIntegration;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityListFilterDateRangeInput = {
  /** EXCLUSIVE = order.created_at < startDate */
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** INCLUSIVE = order.created_at >= startDate */
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type ActivityListFilterInput = {
  creationDateRange?: InputMaybe<ActivityListFilterDateRangeInput>;
};

export type ActivityListInput = {
  entityId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  entityType?: InputMaybe<EntityType>;
  filter?: InputMaybe<ActivityListFilterInput>;
  /**
   * If true and both entityId & entityType are provided:
   * - also queries for child activities of selected entity.
   */
  includeChildren?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  type?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type ActivityListResponse = PageResponse & {
  __typename?: "ActivityListResponse";
  items: Array<ActivityAny>;
  pagination: PaginationResponse;
};

export type ActivityOrderCustomerCancel = {
  __typename?: "ActivityOrderCustomerCancel";
  createdAt: Scalars["DateTime"]["output"];
  customer: Customer;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
};

export type ActivityOrderCustomerCreate = {
  __typename?: "ActivityOrderCustomerCreate";
  createdAt: Scalars["DateTime"]["output"];
  customer: Customer;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
};

export type ActivityOrderOperationTransactionCustomerCreate = {
  __typename?: "ActivityOrderOperationTransactionCustomerCreate";
  createdAt: Scalars["DateTime"]["output"];
  customer: Customer;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionCustomerCreatePayload;
};

export type ActivityOrderOperationTransactionCustomerCreatePayload = {
  __typename?: "ActivityOrderOperationTransactionCustomerCreatePayload";
  id: Scalars["UUID"]["output"];
  orderId: Scalars["UUID"]["output"];
  type: OrderTransactionType;
};

export type ActivityOrderOperationTransactionProcessAuthorize = {
  __typename?: "ActivityOrderOperationTransactionProcessAuthorize";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionProcessAuthorizePayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderOperationTransactionProcessAuthorizePayload = {
  __typename?: "ActivityOrderOperationTransactionProcessAuthorizePayload";
  id: Scalars["UUID"]["output"];
  orderId: Scalars["UUID"]["output"];
  type: OrderTransactionType;
};

export type ActivityOrderOperationTransactionProcessCancel = {
  __typename?: "ActivityOrderOperationTransactionProcessCancel";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionProcessCancelPayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderOperationTransactionProcessCancelPayload = {
  __typename?: "ActivityOrderOperationTransactionProcessCancelPayload";
  id: Scalars["UUID"]["output"];
  orderId: Scalars["UUID"]["output"];
  type: OrderTransactionType;
};

export type ActivityOrderOperationTransactionProcessComplete = {
  __typename?: "ActivityOrderOperationTransactionProcessComplete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionProcessCompletePayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderOperationTransactionProcessCompletePayload = {
  __typename?: "ActivityOrderOperationTransactionProcessCompletePayload";
  id: Scalars["UUID"]["output"];
  orderId: Scalars["UUID"]["output"];
  type: OrderTransactionType;
};

export type ActivityOrderOperationTransactionProcessFail = {
  __typename?: "ActivityOrderOperationTransactionProcessFail";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionProcessFailPayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderOperationTransactionProcessFailPayload = {
  __typename?: "ActivityOrderOperationTransactionProcessFailPayload";
  id: Scalars["UUID"]["output"];
  orderId: Scalars["UUID"]["output"];
  type: OrderTransactionType;
};

export type ActivityOrderOperationTransactionProcessPartialComplete = {
  __typename?: "ActivityOrderOperationTransactionProcessPartialComplete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionProcessPartialCompletePayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderOperationTransactionProcessPartialCompletePayload = {
  __typename?: "ActivityOrderOperationTransactionProcessPartialCompletePayload";
  id: Scalars["UUID"]["output"];
  orderId: Scalars["UUID"]["output"];
  type: OrderTransactionType;
};

export type ActivityOrderOperationTransactionUserCreate = {
  __typename?: "ActivityOrderOperationTransactionUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderOperationTransaction;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderOperationTransactionUserCreatePayload;
  user: User;
};

export type ActivityOrderOperationTransactionUserCreatePayload = {
  __typename?: "ActivityOrderOperationTransactionUserCreatePayload";
  id: Scalars["UUID"]["output"];
  orderId: Scalars["UUID"]["output"];
  type: OrderTransactionType;
};

export type ActivityOrderProcessCancel = {
  __typename?: "ActivityOrderProcessCancel";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessCancelPayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderProcessCancelPayload = {
  __typename?: "ActivityOrderProcessCancelPayload";
  data: Scalars["JSONObject"]["output"];
};

export type ActivityOrderProcessComplete = {
  __typename?: "ActivityOrderProcessComplete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderProcessItemsCommit = {
  __typename?: "ActivityOrderProcessItemsCommit";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessItemsCommitPayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderProcessItemsCommitPayload = {
  __typename?: "ActivityOrderProcessItemsCommitPayload";
  data: Scalars["JSONObject"]["output"];
};

export type ActivityOrderProcessItemsDeliver = {
  __typename?: "ActivityOrderProcessItemsDeliver";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessItemsDeliverPayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderProcessItemsDeliverPayload = {
  __typename?: "ActivityOrderProcessItemsDeliverPayload";
  trackingNumber: Scalars["String"]["output"];
};

export type ActivityOrderProcessItemsPick = {
  __typename?: "ActivityOrderProcessItemsPick";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessItemsPickPayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderProcessItemsPickPayload = {
  __typename?: "ActivityOrderProcessItemsPickPayload";
  data: Scalars["JSONObject"]["output"];
};

export type ActivityOrderProcessItemsShip = {
  __typename?: "ActivityOrderProcessItemsShip";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessItemsShipPayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderProcessItemsShipPayload = {
  __typename?: "ActivityOrderProcessItemsShipPayload";
  data: Scalars["JSONObject"]["output"];
};

export type ActivityOrderProcessNetsuiteCreate = {
  __typename?: "ActivityOrderProcessNetsuiteCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessNetsuiteCreatePayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderProcessNetsuiteCreatePayload = {
  __typename?: "ActivityOrderProcessNetsuiteCreatePayload";
  data: Scalars["JSONObject"]["output"];
};

export type ActivityOrderProcessNetsuiteSync = {
  __typename?: "ActivityOrderProcessNetsuiteSync";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessNetsuiteSyncPayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderProcessNetsuiteSyncPayload = {
  __typename?: "ActivityOrderProcessNetsuiteSyncPayload";
  data: Scalars["JSONObject"]["output"];
};

export type ActivityOrderProcessPartialClose = {
  __typename?: "ActivityOrderProcessPartialClose";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessPartialClosePayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderProcessPartialClosePayload = {
  __typename?: "ActivityOrderProcessPartialClosePayload";
  data: Scalars["JSONObject"]["output"];
};

export type ActivityOrderProcessUpdate = {
  __typename?: "ActivityOrderProcessUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderProcessUpdatePayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderProcessUpdatePayload = {
  __typename?: "ActivityOrderProcessUpdatePayload";
  data: Scalars["JSONObject"]["output"];
};

export type ActivityOrderReturnCustomerCreate = {
  __typename?: "ActivityOrderReturnCustomerCreate";
  createdAt: Scalars["DateTime"]["output"];
  customer: Customer;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderReturn;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderReturnCustomerCreatePayload;
};

export type ActivityOrderReturnCustomerCreatePayload = {
  __typename?: "ActivityOrderReturnCustomerCreatePayload";
  orderId: Scalars["UUID"]["output"];
  returnCaseNumber: Scalars["Int"]["output"];
};

export type ActivityOrderReturnProcessApprove = {
  __typename?: "ActivityOrderReturnProcessApprove";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderReturn;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderReturnProcessApprovePayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderReturnProcessApprovePayload = {
  __typename?: "ActivityOrderReturnProcessApprovePayload";
  customerRefundAmount: Scalars["Int"]["output"];
  customerRefundCurrency: Currency;
  orderId: Scalars["UUID"]["output"];
  restockFeePercent: Scalars["Int"]["output"];
  returnCaseNumber: Scalars["Int"]["output"];
};

export type ActivityOrderReturnProcessCreate = {
  __typename?: "ActivityOrderReturnProcessCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderReturn;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderReturnProcessCreatePayload;
  processId: Scalars["String"]["output"];
};

export type ActivityOrderReturnProcessCreatePayload = {
  __typename?: "ActivityOrderReturnProcessCreatePayload";
  orderId: Scalars["UUID"]["output"];
  returnCaseNumber: Scalars["Int"]["output"];
};

export type ActivityOrderReturnUserApprove = {
  __typename?: "ActivityOrderReturnUserApprove";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderReturn;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderReturnUserApprovePayload;
  user: User;
};

export type ActivityOrderReturnUserApprovePayload = {
  __typename?: "ActivityOrderReturnUserApprovePayload";
  customerRefundAmount: Scalars["Int"]["output"];
  customerRefundCurrency: Currency;
  orderId: Scalars["UUID"]["output"];
  restockFeePercent: Scalars["Int"]["output"];
  returnCaseNumber: Scalars["Int"]["output"];
};

export type ActivityOrderReturnUserCreate = {
  __typename?: "ActivityOrderReturnUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderReturn;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderReturnUserCreatePayload;
  user: User;
};

export type ActivityOrderReturnUserCreatePayload = {
  __typename?: "ActivityOrderReturnUserCreatePayload";
  orderId: Scalars["UUID"]["output"];
  returnCaseNumber: Scalars["Int"]["output"];
};

export type ActivityOrderReturnUserReject = {
  __typename?: "ActivityOrderReturnUserReject";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrderReturn;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderReturnUserRejectPayload;
  user: User;
};

export type ActivityOrderReturnUserRejectPayload = {
  __typename?: "ActivityOrderReturnUserRejectPayload";
  orderId: Scalars["UUID"]["output"];
  returnCaseNumber: Scalars["Int"]["output"];
};

export type ActivityOrderUserCreate = {
  __typename?: "ActivityOrderUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderUserCreatePayload;
  user: User;
};

export type ActivityOrderUserCreatePayload = {
  __typename?: "ActivityOrderUserCreatePayload";
  orderNumber: Scalars["String"]["output"];
};

export type ActivityOrderUserMarkAsPaid = {
  __typename?: "ActivityOrderUserMarkAsPaid";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderUserMarkAsPaidPayload;
  user: User;
};

export type ActivityOrderUserMarkAsPaidPayload = {
  __typename?: "ActivityOrderUserMarkAsPaidPayload";
  orderNumber: Scalars["String"]["output"];
};

export type ActivityOrderUserPickAndFulfill = {
  __typename?: "ActivityOrderUserPickAndFulfill";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderUserPickAndFulfillPayload;
  user: User;
};

export type ActivityOrderUserPickAndFulfillPayload = {
  __typename?: "ActivityOrderUserPickAndFulfillPayload";
  operationProductQuantities: Scalars["JSONObject"]["output"];
  order: Scalars["UUID"]["output"];
  shippingCarrierId: Scalars["UUID"]["output"];
  trackingNumber: Scalars["String"]["output"];
};

export type ActivityOrderUserReopen = {
  __typename?: "ActivityOrderUserReopen";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityOrder;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityOrderUserReopenPayload;
  user: User;
};

export type ActivityOrderUserReopenPayload = {
  __typename?: "ActivityOrderUserReopenPayload";
  orderNumber: Scalars["String"]["output"];
};

export type ActivityPayloadUnion =
  | ActivityCheckoutProcessForceIntegrityPayload
  | ActivityCheckoutProcessUpdatePayload
  | ActivityCollectionUserCreatePayload
  | ActivityCustomerTaxExemptionCustomerAttachmentDeletePayload
  | ActivityCustomerTaxExemptionCustomerAttachmentUploadPayload
  | ActivityCustomerTaxExemptionUserAttachmentDeletePayload
  | ActivityCustomerTaxExemptionUserAttachmentUploadPayload
  | ActivityCustomerUserInvitePayload
  | ActivityDiscountUserDeletePayload
  | ActivityDiscountUserUpdatePayload
  | ActivityExchangeProcessCreatePayload
  | ActivityExchangeUserCreatePayload
  | ActivityGalleryItemUserCreatePayload
  | ActivityGalleryItemUserDeletePayload
  | ActivityGalleryItemUserUpdatePayload
  | ActivityOrderOperationTransactionCustomerCreatePayload
  | ActivityOrderOperationTransactionProcessAuthorizePayload
  | ActivityOrderOperationTransactionProcessCancelPayload
  | ActivityOrderOperationTransactionProcessCompletePayload
  | ActivityOrderOperationTransactionProcessFailPayload
  | ActivityOrderOperationTransactionProcessPartialCompletePayload
  | ActivityOrderOperationTransactionUserCreatePayload
  | ActivityOrderProcessCancelPayload
  | ActivityOrderProcessItemsCommitPayload
  | ActivityOrderProcessItemsDeliverPayload
  | ActivityOrderProcessItemsPickPayload
  | ActivityOrderProcessItemsShipPayload
  | ActivityOrderProcessNetsuiteCreatePayload
  | ActivityOrderProcessNetsuiteSyncPayload
  | ActivityOrderProcessPartialClosePayload
  | ActivityOrderProcessUpdatePayload
  | ActivityOrderReturnCustomerCreatePayload
  | ActivityOrderReturnProcessApprovePayload
  | ActivityOrderReturnProcessCreatePayload
  | ActivityOrderReturnUserApprovePayload
  | ActivityOrderReturnUserCreatePayload
  | ActivityOrderReturnUserRejectPayload
  | ActivityOrderUserCreatePayload
  | ActivityOrderUserMarkAsPaidPayload
  | ActivityOrderUserPickAndFulfillPayload
  | ActivityOrderUserReopenPayload
  | ActivityProductDocumentUserCreatePayload
  | ActivityProductDocumentUserDeletePayload
  | ActivityProductDocumentUserUpdatePayload
  | ActivityProductInventoryUserUpdatePayload
  | ActivityProductUserCreatePayload
  | ActivityProductUserUpdatePayload
  | ActivityProductVariantUserCreatePayload
  | ActivityProductVariantUserUpdatePayload
  | ActivityTaxIdValidationProcessCancelPayload
  | ActivityTaxIdValidationProcessCompletePayload
  | ActivityTaxIdValidationProcessRetryPayload
  | ActivityUserUserDeactivatePayload
  | ActivityUserUserDeletePayload
  | ActivityUserUserInvitePayload
  | ActivityUserUserUpdatePayload;

export type ActivityProductDocumentUserCreate = {
  __typename?: "ActivityProductDocumentUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProductDocument;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductDocumentUserCreatePayload;
  user: User;
};

export type ActivityProductDocumentUserCreatePayload = {
  __typename?: "ActivityProductDocumentUserCreatePayload";
  documentType: ProductDocumentType;
  name?: Maybe<Scalars["String"]["output"]>;
  productVariantId?: Maybe<Scalars["UUID"]["output"]>;
  url: Scalars["String"]["output"];
};

export type ActivityProductDocumentUserDelete = {
  __typename?: "ActivityProductDocumentUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProductDocument;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductDocumentUserDeletePayload;
  user: User;
};

export type ActivityProductDocumentUserDeletePayload = {
  __typename?: "ActivityProductDocumentUserDeletePayload";
  documentType: ProductDocumentType;
  name?: Maybe<Scalars["String"]["output"]>;
  productVariantId?: Maybe<Scalars["UUID"]["output"]>;
  url: Scalars["String"]["output"];
};

export type ActivityProductDocumentUserUpdate = {
  __typename?: "ActivityProductDocumentUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProductDocument;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductDocumentUserUpdatePayload;
  user: User;
};

export type ActivityProductDocumentUserUpdatePayload = {
  __typename?: "ActivityProductDocumentUserUpdatePayload";
  documentType: ProductDocumentType;
  name?: Maybe<Scalars["String"]["output"]>;
  productVariantId?: Maybe<Scalars["UUID"]["output"]>;
  url: Scalars["String"]["output"];
};

export type ActivityProductInventoryUserUpdate = {
  __typename?: "ActivityProductInventoryUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProductInventory;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductInventoryUserUpdatePayload;
  user: User;
};

export type ActivityProductInventoryUserUpdatePayload = {
  __typename?: "ActivityProductInventoryUserUpdatePayload";
  sku: Scalars["String"]["output"];
  warehouseId: Scalars["UUID"]["output"];
};

export type ActivityProductUserArchive = {
  __typename?: "ActivityProductUserArchive";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProduct;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityProductUserCreate = {
  __typename?: "ActivityProductUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProduct;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductUserCreatePayload;
  user: User;
};

export type ActivityProductUserCreatePayload = {
  __typename?: "ActivityProductUserCreatePayload";
  name: Scalars["String"]["output"];
};

export type ActivityProductUserDelete = {
  __typename?: "ActivityProductUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProduct;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityProductUserPublish = {
  __typename?: "ActivityProductUserPublish";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProduct;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityProductUserUpdate = {
  __typename?: "ActivityProductUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProduct;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductUserUpdatePayload;
  user: User;
};

export type ActivityProductUserUpdatePayload = {
  __typename?: "ActivityProductUserUpdatePayload";
  name: Scalars["String"]["output"];
};

export type ActivityProductVariantUserCreate = {
  __typename?: "ActivityProductVariantUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProductVariant;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductVariantUserCreatePayload;
  user: User;
};

export type ActivityProductVariantUserCreatePayload = {
  __typename?: "ActivityProductVariantUserCreatePayload";
  productId: Scalars["UUID"]["output"];
  title: Scalars["String"]["output"];
};

export type ActivityProductVariantUserUpdate = {
  __typename?: "ActivityProductVariantUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityProductVariant;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityProductVariantUserUpdatePayload;
  user: User;
};

export type ActivityProductVariantUserUpdatePayload = {
  __typename?: "ActivityProductVariantUserUpdatePayload";
  productId: Scalars["UUID"]["output"];
  title: Scalars["String"]["output"];
};

export type ActivityStoreUserUpdate = {
  __typename?: "ActivityStoreUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityStore;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityTaxIdValidationProcessCancel = {
  __typename?: "ActivityTaxIdValidationProcessCancel";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityTaxIdValidation;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityTaxIdValidationProcessCancelPayload;
  processId: Scalars["String"]["output"];
};

export type ActivityTaxIdValidationProcessCancelPayload = {
  __typename?: "ActivityTaxIdValidationProcessCancelPayload";
  reason: Scalars["String"]["output"];
};

export type ActivityTaxIdValidationProcessComplete = {
  __typename?: "ActivityTaxIdValidationProcessComplete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityTaxIdValidation;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityTaxIdValidationProcessCompletePayload;
  processId: Scalars["String"]["output"];
};

export type ActivityTaxIdValidationProcessCompletePayload = {
  __typename?: "ActivityTaxIdValidationProcessCompletePayload";
  validationResult: Scalars["String"]["output"];
};

export type ActivityTaxIdValidationProcessRetry = {
  __typename?: "ActivityTaxIdValidationProcessRetry";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityTaxIdValidation;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityTaxIdValidationProcessRetryPayload;
  processId: Scalars["String"]["output"];
};

export type ActivityTaxIdValidationProcessRetryPayload = {
  __typename?: "ActivityTaxIdValidationProcessRetryPayload";
  validationResult: Scalars["String"]["output"];
};

export type ActivityUserUserDeactivate = {
  __typename?: "ActivityUserUserDeactivate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityUser;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityUserUserDeactivatePayload;
  user: User;
};

export type ActivityUserUserDeactivatePayload = {
  __typename?: "ActivityUserUserDeactivatePayload";
  email: Scalars["EmailAddress"]["output"];
  slug: Scalars["String"]["output"];
  username?: Maybe<Scalars["String"]["output"]>;
};

export type ActivityUserUserDelete = {
  __typename?: "ActivityUserUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityUser;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityUserUserDeletePayload;
  user: User;
};

export type ActivityUserUserDeletePayload = {
  __typename?: "ActivityUserUserDeletePayload";
  email: Scalars["EmailAddress"]["output"];
  username: Scalars["String"]["output"];
};

export type ActivityUserUserInvite = {
  __typename?: "ActivityUserUserInvite";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityUser;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityUserUserInvitePayload;
  user: User;
};

export type ActivityUserUserInvitePayload = {
  __typename?: "ActivityUserUserInvitePayload";
  email: Scalars["EmailAddress"]["output"];
  slug: Scalars["String"]["output"];
  username?: Maybe<Scalars["String"]["output"]>;
};

export type ActivityUserUserUpdate = {
  __typename?: "ActivityUserUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityChanges: ActivityEntityChanges;
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityUser;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  payload: ActivityUserUserUpdatePayload;
  user: User;
};

export type ActivityUserUserUpdatePayload = {
  __typename?: "ActivityUserUserUpdatePayload";
  email: Scalars["EmailAddress"]["output"];
  slug: Scalars["String"]["output"];
  username?: Maybe<Scalars["String"]["output"]>;
};

export type ActivityWarehouseUserCreate = {
  __typename?: "ActivityWarehouseUserCreate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityWarehouse;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityWarehouseUserDelete = {
  __typename?: "ActivityWarehouseUserDelete";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityWarehouse;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type ActivityWarehouseUserUpdate = {
  __typename?: "ActivityWarehouseUserUpdate";
  createdAt: Scalars["DateTime"]["output"];
  entityId: Scalars["UUID"]["output"];
  entityType: ActivityEntityWarehouse;
  id: Scalars["UUID"]["output"];
  parentEntityId?: Maybe<Scalars["UUID"]["output"]>;
  parentEntityType?: Maybe<EntityType>;
  user: User;
};

export type AddWishlistItemInput = {
  /** Defaults to 1. */
  quantity?: InputMaybe<Scalars["PositiveInt"]["input"]>;
  sku: Scalars["TrimmedString"]["input"];
  wishlistIds: Array<Scalars["UUID"]["input"]>;
};

export type AddressInput = {
  additionalInfo?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  address1: Scalars["TrimmedString"]["input"];
  address2?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  businessName?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  city: Scalars["TrimmedString"]["input"];
  country: CountryCode;
  customerAddressId?: InputMaybe<Scalars["UUID"]["input"]>;
  firstName: Scalars["TrimmedString"]["input"];
  isAnyUsageType?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName: Scalars["TrimmedString"]["input"];
  neighborhood?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  phoneNumber: Scalars["TrimmedString"]["input"];
  postalCode?: InputMaybe<Scalars["UppercaseTrimmedString"]["input"]>;
  province?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  referenceNumber?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  stateRegistrationNumber?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  taxId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  type: AddressType;
  usageType?: InputMaybe<AddressUsageType>;
};

export enum AddressType {
  Business = "Business",
  Residential = "Residential",
}

export enum AddressUsageType {
  Billing = "Billing",
  Shipping = "Shipping",
}

export type AddressValidationAddressInput = {
  address1: Scalars["TrimmedString"]["input"];
  address2?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  city: Scalars["TrimmedString"]["input"];
  country: CountryCode;
  postalCode: Scalars["UppercaseTrimmedString"]["input"];
  province: Scalars["UppercaseTrimmedString"]["input"];
};

export type AddressValidationInput = {
  address: AddressValidationAddressInput;
  /** If provided, the address validation will be snapshot for the given checkout. */
  checkoutId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type AddressValidationResponse = {
  __typename?: "AddressValidationResponse";
  isValid: Scalars["Boolean"]["output"];
  suggestions: Array<AddressValidationSuggestion>;
};

export type AddressValidationSuggestion = {
  __typename?: "AddressValidationSuggestion";
  address1: Scalars["String"]["output"];
  address2?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  country: CountryCode;
  postalCode: Scalars["String"]["output"];
  province: Scalars["String"]["output"];
};

export enum AddressValidatorEntityType {
  StoreCarrier = "StoreCarrier",
}

export enum AdminPermission {
  CheckoutDelete = "CheckoutDelete",
  DiscountDelete = "DiscountDelete",
  ExchangeRateCreate = "ExchangeRateCreate",
  IntegrationCreate = "IntegrationCreate",
  IntegrationDelete = "IntegrationDelete",
  IntegrationEdit = "IntegrationEdit",
  LanguageDelete = "LanguageDelete",
  LanguagePublish = "LanguagePublish",
  LimitationDelete = "LimitationDelete",
  PaymentProviderCreate = "PaymentProviderCreate",
  PaymentProviderDelete = "PaymentProviderDelete",
  PaymentProviderEdit = "PaymentProviderEdit",
  ProductSalesCampaignRequestApprove = "ProductSalesCampaignRequestApprove",
  SlugRedirectCreate = "SlugRedirectCreate",
  SlugRedirectDelete = "SlugRedirectDelete",
  SlugRedirectEdit = "SlugRedirectEdit",
  StoreCarrierCreate = "StoreCarrierCreate",
  StoreCarrierDelete = "StoreCarrierDelete",
  StoreCarrierEdit = "StoreCarrierEdit",
  StoreEdit = "StoreEdit",
  UserDeactivate = "UserDeactivate",
  UserDelete = "UserDelete",
  UserEdit = "UserEdit",
  UserInvite = "UserInvite",
  WarehouseCreate = "WarehouseCreate",
  WarehouseDelete = "WarehouseDelete",
  WarehouseEdit = "WarehouseEdit",
}

export type AffiliateTransactionInput = {
  affiliateReference?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  visitorId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export enum AffiliateTransactionStatus {
  Accepted = "Accepted",
  Declined = "Declined",
  Pending = "Pending",
  Rejected = "Rejected",
}

export enum AffiliateTransactionType {
  Refund = "Refund",
  Sale = "Sale",
}

export type Aggregate = {
  __typename?: "Aggregate";
  /** The number of orders placed during the time period. */
  orderCount: Scalars["Int"]["output"];
  /** The number of returns during the time period. */
  returnCount: Scalars["Int"]["output"];
  /** The start of the aggregated time period (e.g., hour, day, month). */
  timestamp: Scalars["DateTime"]["output"];
  /** The total sales amount in USD during the time period. */
  totalSalesAmountUsd: Scalars["Int"]["output"];
};

export type AggregatesFilterDateRangeInput = {
  /** INCLUSIVE = aggregate.timestamp <= endDate */
  endDate: Scalars["DateTime"]["input"];
  /** INCLUSIVE = aggregate.timestamp >= startDate */
  startDate: Scalars["DateTime"]["input"];
  /**
   * User's timezone that is needed for daily aggregates which are aggregated in
   * the user's timezone.
   */
  timezone: Scalars["TimeZone"]["input"];
};

export type AggregatesFilterInput = {
  dateRange: AggregatesFilterDateRangeInput;
  storeIds: Array<StoreId>;
};

export type AggregatesInput = {
  filter: AggregatesFilterInput;
  unit: AggregationUnit;
};

export type AggregatesResult = {
  __typename?: "AggregatesResult";
  items: Array<Aggregate>;
  unit: AggregationUnit;
};

export enum AggregationUnit {
  Day = "Day",
  Hour = "Hour",
}

export type AllOrderDisplayStatusCount = {
  __typename?: "AllOrderDisplayStatusCount";
  fulfillment: Array<OrderFulfillmentDisplayStatusCountItem>;
  payment: Array<OrderTransactionDisplayStatusCountItem>;
  return: Array<OrderReturnDisplayStatusCountItem>;
};

export type AlternativeStoreCollectionInfo = {
  __typename?: "AlternativeStoreCollectionInfo";
  slug: Scalars["String"]["output"];
  storeId: StoreId;
};

export type AlternativeStoreCollectionMissingProductInfo = {
  __typename?: "AlternativeStoreCollectionMissingProductInfo";
  from: AlternativeStoreProductInfoDetail;
  storeId: StoreId;
  to: AlternativeStoreProductInfoDetail;
};

export type AlternativeStoreProductInfo = {
  __typename?: "AlternativeStoreProductInfo";
  details: AlternativeStoreProductInfoDetail;
  storeId: StoreId;
};

export type AlternativeStoreProductInfoDetail = {
  __typename?: "AlternativeStoreProductInfoDetail";
  slug: Scalars["String"]["output"];
};

export type ApActiveUser = {
  __typename?: "ApActiveUser";
  displayName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  picture?: Maybe<Scalars["String"]["output"]>;
};

export type ApActiveUsersInput = {
  pagePath: Scalars["LowercaseTrimmedString"]["input"];
};

export type ApAddReturnShipmentItemsInput = {
  addOperationProductId: Scalars["UUID"]["input"];
  quantity: Scalars["NonNegativeInt"]["input"];
};

export type ApAddReturnShipmentsInput = {
  id: Scalars["UUID"]["input"];
  /** Expected for Fedex returns */
  items: Array<ApAddReturnShipmentItemsInput>;
  /** Expected for UPS returns */
  shipmentCount?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
};

export type ApAffiliateCampaignProduct = {
  __typename?: "ApAffiliateCampaignProduct";
  campaignId: Scalars["String"]["output"];
  campaignName: Scalars["String"]["output"];
  productVariantId: Scalars["UUID"]["output"];
  storeId: StoreId;
};

export type ApAffiliateCampaignsInput = {
  affiliateCampaignsProducts: Array<ApAffiliateCampaignsProductInput>;
  campaignId: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type ApAffiliateCampaignsProductInput = {
  productVariantId: Scalars["UUID"]["input"];
  storeId: StoreId;
};

export type ApAggregatedEmailEvent = {
  __typename?: "ApAggregatedEmailEvent";
  clickEvents: Array<ApEmailClickEvent>;
  date: Scalars["DateTime"]["output"];
  openCount: TotalAndUniqueCount;
  resolution: EmailEventResolution;
  sentCount: Scalars["NonNegativeInt"]["output"];
  template: Scalars["String"]["output"];
};

export type ApApproveProductSalesCampaignRequestInput = {
  /** Required if not approved */
  deniedReason?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  id: Scalars["UUID"]["input"];
  isApproved: Scalars["Boolean"]["input"];
};

export type ApApproveProductSalesCampaignRequestResponse = {
  __typename?: "ApApproveProductSalesCampaignRequestResponse";
  approvedProductSalesCampaign?: Maybe<ApProductSalesCampaign>;
  productSalesCampaignRequest: ApProductSalesCampaignRequest;
};

export type ApApproveReturnInput = {
  availableRefundMethod: AvailableRefundMethod;
  id: Scalars["UUID"]["input"];
  items: Array<ApRefundReturnItemInput>;
  /**
   * Pass manual refund amount which will override refund amount calculated from
   * items array
   */
  manualRefundAmount?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  refundInitialShippingFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  restockFeePercent: Scalars["NonNegativeInt"]["input"];
};

export type ApAvailableEmailTemplatesResponse = {
  __typename?: "ApAvailableEmailTemplatesResponse";
  templates: Array<Scalars["String"]["output"]>;
};

export type ApBackInStock = {
  __typename?: "ApBackInStock";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  sku: Scalars["TrimmedString"]["output"];
  status: BackInStockStatus;
  storeId: StoreId;
};

export type ApBackInStockListFilterInput = {
  status?: InputMaybe<BackInStockStatus>;
  storeId?: InputMaybe<StoreId>;
};

export type ApBackInStockListInput = {
  filter?: InputMaybe<ApBackInStockListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
};

export type ApBackInStockListResponse = PageResponse & {
  __typename?: "ApBackInStockListResponse";
  items: Array<ApBackInStock>;
  pagination: PaginationResponse;
};

export type ApBackInStockSubscriptionCountInput = {
  skus?: InputMaybe<Array<Scalars["TrimmedString"]["input"]>>;
  storeIds: Array<StoreId>;
};

export type ApBackInStockSubscriptionCountResponse = {
  __typename?: "ApBackInStockSubscriptionCountResponse";
  count: Scalars["NonNegativeInt"]["output"];
  sku: Scalars["String"]["output"];
  storeId: StoreId;
};

export type ApBlock = {
  __typename?: "ApBlock";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  nodes: Array<ApBlockNode>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** AP node */
export type ApBlockNode = {
  __typename?: "ApBlockNode";
  content: ApBlockNodeContent;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  nodeType: BlockNodeType;
  parentNodeId?: Maybe<Scalars["UUID"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** AP node content field data */
export type ApBlockNodeContent = ApNodeTextblock;

export type ApBlockNodeInput = {
  /** Nested child nodes (backend derives parent relationships from tree structure) */
  children?: InputMaybe<Array<ApBlockNodeInput>>;
  id: Scalars["UUID"]["input"];
  nodeType: BlockNodeType;
  /** Optional content: must provide content that matches nodeType */
  textblockContent?: InputMaybe<ApNodeTextblockInput>;
};

export type ApBustCacheRecordEntryInput = {
  id: Scalars["TrimmedString"]["input"];
};

export type ApBustCacheRecordEntryResponse = {
  __typename?: "ApBustCacheRecordEntryResponse";
  error?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type ApBustCacheRecordInput = {
  entries: Array<ApBustCacheRecordEntryInput>;
};

export type ApBustCacheRecordResponse = {
  __typename?: "ApBustCacheRecordResponse";
  entries: Array<ApBustCacheRecordEntryResponse>;
};

export type ApCacheRecordEntry = {
  __typename?: "ApCacheRecordEntry";
  id: Scalars["String"]["output"];
  namespace: Scalars["String"]["output"];
  subNamespace: Scalars["String"]["output"];
};

export type ApCategory = {
  __typename?: "ApCategory";
  createdAt: Scalars["DateTime"]["output"];
  defaultTranslation: ApCategoryTranslation;
  filterIds: Array<Scalars["UUID"]["output"]>;
  hideAllCategory: Scalars["Boolean"]["output"];
  hideFiltersAndSort: Scalars["Boolean"]["output"];
  hideInHeader: Scalars["Boolean"]["output"];
  hideSubItems: Scalars["Boolean"]["output"];
  icon?: Maybe<Asset>;
  id: Scalars["UUID"]["output"];
  isAccessories: Scalars["Boolean"]["output"];
  items: Array<ApCategoryItem>;
  productLine: ProductLine;
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  storeFilterIds: Array<Scalars["UUID"]["output"]>;
  storeIds: Array<StoreId>;
  storeOnly: Scalars["Boolean"]["output"];
  translations: Array<ApCategoryTranslation>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApCategoryFilter = {
  __typename?: "ApCategoryFilter";
  createdAt: Scalars["DateTime"]["output"];
  defaultTranslation: ApCategoryFilterTranslation;
  dependsOnFilterId?: Maybe<Scalars["UUID"]["output"]>;
  filterType: CategoryFilterType;
  id: Scalars["UUID"]["output"];
  maxPostFix?: Maybe<Scalars["String"]["output"]>;
  measureUnit?: Maybe<Scalars["String"]["output"]>;
  productFilterIds: Array<Scalars["UUID"]["output"]>;
  showLabel: Scalars["Boolean"]["output"];
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  translations: Array<ApCategoryFilterTranslation>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApCategoryFilterListInput = {
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
};

export type ApCategoryFilterListResponse = PageResponse & {
  __typename?: "ApCategoryFilterListResponse";
  items: Array<ApCategoryFilter>;
  pagination: PaginationResponse;
};

export type ApCategoryFilterTranslation = Translation & {
  __typename?: "ApCategoryFilterTranslation";
  label?: Maybe<Scalars["String"]["output"]>;
  language: Language;
};

export type ApCategoryFilterTranslationInput = {
  label: Scalars["TrimmedString"]["input"];
  languageId: Scalars["UUID"]["input"];
};

export type ApCategoryItem = {
  __typename?: "ApCategoryItem";
  categoryId: Scalars["UUID"]["output"];
  collectionIds: Array<Scalars["UUID"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  defaultTranslation: ApCategoryItemTranslation;
  enableProductGroupingStoreIds: Array<StoreId>;
  filterIds: Array<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  storeIds: Array<StoreId>;
  storeLabel?: Maybe<ApCategoryItemStoreLabel>;
  storeOnly: Scalars["Boolean"]["output"];
  translations: Array<ApCategoryItemTranslation>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApCategoryItemStoreLabel = {
  __typename?: "ApCategoryItemStoreLabel";
  categoryItemId: Scalars["UUID"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  defaultTranslation: ApCategoryItemStoreLabelTranslation;
  id: Scalars["UUID"]["output"];
  storeIds: Array<StoreId>;
  translations: Array<ApCategoryItemStoreLabelTranslation>;
};

export type ApCategoryItemStoreLabelInput = {
  storeIds: Array<StoreId>;
  translations: Array<ApCategoryItemStoreLabelTranslationInput>;
};

export type ApCategoryItemStoreLabelTranslation = Translation & {
  __typename?: "ApCategoryItemStoreLabelTranslation";
  label?: Maybe<Scalars["String"]["output"]>;
  language: Language;
};

export type ApCategoryItemStoreLabelTranslationInput = {
  label: Scalars["TrimmedString"]["input"];
  languageId: Scalars["UUID"]["input"];
};

export type ApCategoryItemTranslation = Translation & {
  __typename?: "ApCategoryItemTranslation";
  label?: Maybe<Scalars["String"]["output"]>;
  language: Language;
};

export type ApCategoryItemTranslationInput = {
  label: Scalars["TrimmedString"]["input"];
  languageId: Scalars["UUID"]["input"];
};

export type ApCategoryListFilterInput = {
  productLine?: InputMaybe<ProductLine>;
};

export type ApCategoryListInput = {
  filter?: InputMaybe<ApCategoryListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
};

export type ApCategoryListResponse = PageResponse & {
  __typename?: "ApCategoryListResponse";
  items: Array<ApCategory>;
  pagination: PaginationResponse;
};

export type ApCategoryProductFilter = {
  __typename?: "ApCategoryProductFilter";
  createdAt: Scalars["DateTime"]["output"];
  defaultTranslation: ApCategoryProductFilterTranslation;
  id: Scalars["UUID"]["output"];
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  translations: Array<ApCategoryProductFilterTranslation>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApCategoryProductFilterListInput = {
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
};

export type ApCategoryProductFilterListResponse = PageResponse & {
  __typename?: "ApCategoryProductFilterListResponse";
  items: Array<ApCategoryProductFilter>;
  pagination: PaginationResponse;
};

export type ApCategoryProductFilterTranslation = Translation & {
  __typename?: "ApCategoryProductFilterTranslation";
  label?: Maybe<Scalars["String"]["output"]>;
  language: Language;
};

export type ApCategoryProductFilterTranslationInput = {
  label: Scalars["TrimmedString"]["input"];
  languageId: Scalars["UUID"]["input"];
};

export type ApCategorySlugRedirect = {
  __typename?: "ApCategorySlugRedirect";
  categoryId: Scalars["UUID"]["output"];
  fromSlug: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  toEntityId: Scalars["UUID"]["output"];
  toEntityType: CategorySlugRedirectEntityType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApCategorySlugRedirectListResponse = {
  __typename?: "ApCategorySlugRedirectListResponse";
  items: Array<ApCategorySlugRedirect>;
};

export type ApCategorySlugRedirectTargetInput = {
  entityId: Scalars["UUID"]["input"];
  entityType: CategorySlugRedirectEntityType;
};

export type ApCategoryTranslation = Translation & {
  __typename?: "ApCategoryTranslation";
  label?: Maybe<Scalars["String"]["output"]>;
  language: Language;
};

export type ApCategoryTranslationInput = {
  label: Scalars["TrimmedString"]["input"];
  languageId: Scalars["UUID"]["input"];
};

export type ApCollectionCategory = {
  __typename?: "ApCollectionCategory";
  features: Array<ApCollectionCategoryFeature>;
  galleries: Array<ApGallery>;
  id: Scalars["UUID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  products: Array<ApProduct>;
  type: CollectionCategoryType;
};

export type ApCollectionCategoryFeature = {
  __typename?: "ApCollectionCategoryFeature";
  icon: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  translations: Array<ApCollectionCategoryFeatureTranslation>;
};

export type ApCollectionCategoryFeatureTranslation = Translation & {
  __typename?: "ApCollectionCategoryFeatureTranslation";
  description?: Maybe<Scalars["String"]["output"]>;
  language: Language;
};

export type ApComment = {
  __typename?: "ApComment";
  attachments: Array<ProtectedAsset>;
  content: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  user: User;
};

export type ApCommentCreateInput = {
  content: Scalars["TrimmedString"]["input"];
  entityId: Scalars["UUID"]["input"];
  entityType: CommentEntityType;
};

export type ApCommentCreateResponse = {
  __typename?: "ApCommentCreateResponse";
  apComment: ApComment;
};

export type ApCommentDeleteInput = {
  id: Scalars["UUID"]["input"];
};

export type ApCommentDeleteResponse = {
  __typename?: "ApCommentDeleteResponse";
  id: Scalars["UUID"]["output"];
};

export type ApCommentsListFilterInput = {
  entityId: Scalars["UUID"]["input"];
  entityType: CommentEntityType;
};

export type ApCommentsListInput = {
  filter: ApCommentsListFilterInput;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
};

export type ApCommentsListResponse = PageResponse & {
  __typename?: "ApCommentsListResponse";
  items: Array<ApComment>;
  pagination: PaginationResponse;
};

export type ApCommonReturnResponse = {
  __typename?: "ApCommonReturnResponse";
  apOrderReturn: ApOrderReturn;
};

export type ApCreateCollectionCategoryDraftInput = {
  collectionId: Scalars["UUID"]["input"];
  type: CollectionCategoryType;
};

export type ApCreateCollectionCategoryDraftResponse = {
  __typename?: "ApCreateCollectionCategoryDraftResponse";
  collectionCategory: ApCollectionCategory;
};

export type ApCreateDraftFromOrderInput = {
  id: Scalars["UUID"]["input"];
};

export type ApCreateDraftFromOrderResponse = {
  __typename?: "ApCreateDraftFromOrderResponse";
  order: ApOrderDraft;
};

export type ApCreateInventoryPolicyGlobalInput = {
  storeId?: InputMaybe<StoreId>;
};

export type ApCreateInventoryPolicyGlobalResponse = {
  __typename?: "ApCreateInventoryPolicyGlobalResponse";
  inventoryPolicyGlobal: ApInventoryPolicyGlobal;
};

export type ApCreateInventoryPolicyOverrideInput = {
  title: Scalars["String"]["input"];
};

export type ApCreateInventoryPolicyOverrideResponse = {
  __typename?: "ApCreateInventoryPolicyOverrideResponse";
  inventoryPolicyOverride: ApInventoryPolicyOverride;
};

export type ApCreateOrderDraftInput = {
  billingAddress: AddressInput;
  cartItems: Array<ApOrderDraftCartItemInput>;
  discountCodeId?: InputMaybe<Scalars["UUID"]["input"]>;
  email: Scalars["TrimmedString"]["input"];
  expireDays: Scalars["NonNegativeInt"]["input"];
  invoiceNote?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  sendConfirmationEmail: Scalars["Boolean"]["input"];
  shippingAddress: AddressInput;
  storeCarrierServiceId: Scalars["UUID"]["input"];
  storeId: StoreId;
  storeShippingRateId: Scalars["UUID"]["input"];
};

export type ApCreateOrderInput = {
  billingAddress: AddressInput;
  cartItems: Array<ApOrderCartItemInput>;
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  discountCodeId?: InputMaybe<Scalars["UUID"]["input"]>;
  discountId?: InputMaybe<Scalars["UUID"]["input"]>;
  email: Scalars["LowercaseTrimmedString"]["input"];
  expireDays: Scalars["NonNegativeInt"]["input"];
  /** This will set the tax validation status to TaxIdValidationStatus.ForcedValid */
  forceTaxIdValidationSuccess: Scalars["Boolean"]["input"];
  invoiceNote?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  sendConfirmationEmail: Scalars["Boolean"]["input"];
  shippingAddress: AddressInput;
  storeCarrierServiceId: Scalars["UUID"]["input"];
  storeId: StoreId;
  storeShippingRateId: Scalars["UUID"]["input"];
};

export type ApCreateOrderResponse = {
  __typename?: "ApCreateOrderResponse";
  order: ApOrder;
};

export type ApCreatePaymentProviderInput = {
  accountId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  name: Scalars["TrimmedString"]["input"];
  publishableKey?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  secretKey?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  storeId: StoreId;
  type: PaymentProvider;
  /** Required for Razorpay */
  webhookSecretKey?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApCreatePaymentProviderPaymentMethodsInput = {
  create: Array<CreatePaymentProviderPaymentMethodInput>;
};

export type ApCreatePaymentProviderPaymentMethodsResponse = {
  __typename?: "ApCreatePaymentProviderPaymentMethodsResponse";
  created: Array<PaymentProviderPaymentMethod>;
};

export type ApCreatePaymentProviderResponse = {
  __typename?: "ApCreatePaymentProviderResponse";
  paymentProvider: ApPaymentProviderDetails;
};

export type ApCreateProductCompatibilityInput = {
  masterProductId: Scalars["UUID"]["input"];
};

export type ApCreateProductCompatibilityResponse = {
  __typename?: "ApCreateProductCompatibilityResponse";
  productCompatibility: ApProductCompatibility;
};

export type ApCreateProductFeatureInput = {
  assetId: Scalars["UUID"]["input"];
  canvasHeight: Scalars["Int"]["input"];
  canvasWidth: Scalars["Int"]["input"];
  dotX: Scalars["Float"]["input"];
  dotY: Scalars["Float"]["input"];
  lineRenderType: ProductFeatureLineRenderType;
  productId: Scalars["UUID"]["input"];
  scale: Scalars["Float"]["input"];
  tooltipX: Scalars["Float"]["input"];
  tooltipY: Scalars["Float"]["input"];
  translateX: Scalars["Int"]["input"];
  translateY: Scalars["Int"]["input"];
  translations: Array<ProductFeatureTranslationInput>;
};

export type ApCreateProductFeatureResponse = {
  __typename?: "ApCreateProductFeatureResponse";
  productFeature: ApProductFeature;
};

export type ApCreateProductSalesCampaignInput = {
  name: Scalars["TrimmedString"]["input"];
};

export type ApCreateReturnInput = {
  isTaxReturn: Scalars["Boolean"]["input"];
  orderId: Scalars["UUID"]["input"];
};

export type ApCreateSmartcatWebhookConfigInput = {
  callbackUrl: Scalars["TrimmedString"]["input"];
  events: Array<SmartcatWebhookEvent>;
  label: Scalars["TrimmedString"]["input"];
  projectId: Scalars["TrimmedString"]["input"];
};

export type ApCreateSmartcatWebhookConfigResult = {
  __typename?: "ApCreateSmartcatWebhookConfigResult";
  config: ApSmartcatWebhookConfig;
  /** Webhook secret. Only returned at creation time. Store it securely. */
  webhookSecret: Scalars["String"]["output"];
};

export type ApCreateSpecificationFeatureInput = {
  icon?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  label: Scalars["TrimmedString"]["input"];
  note?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  parentId?: InputMaybe<Scalars["UUID"]["input"]>;
  valueType: SpecificationSectionFeatureType;
};

export type ApCreateSpecificationSectionInput = {
  label: Scalars["TrimmedString"]["input"];
  type?: InputMaybe<SpecificationSectionType>;
};

export type ApCreateSpecificationTemplateInput = {
  title: Scalars["TrimmedString"]["input"];
};

export type ApCreateTariffInput = {
  activeFrom: Scalars["DateTime"]["input"];
  name: Scalars["TrimmedString"]["input"];
  productIds: Array<Scalars["UUID"]["input"]>;
  rate: Scalars["TrimmedString"]["input"];
  storeId: StoreId;
};

export type ApCreateTariffResponse = {
  __typename?: "ApCreateTariffResponse";
  tariff: ApTariff;
};

export type ApCreateTaxRateInput = {
  name: Scalars["TrimmedString"]["input"];
  productIds: Array<Scalars["UUID"]["input"]>;
  rate: Scalars["TrimmedString"]["input"];
  storeId: StoreId;
  type: TaxRateType;
};

export type ApCreateTaxRateResponse = {
  __typename?: "ApCreateTaxRateResponse";
  taxRate: ApTaxRate;
};

export type ApCustomerTaxExemption = {
  __typename?: "ApCustomerTaxExemption";
  attachments: Array<ProtectedAsset>;
  countryCode?: Maybe<CountryCode>;
  createdAt: Scalars["DateTime"]["output"];
  customerId: Scalars["UUID"]["output"];
  customerNote?: Maybe<Scalars["TrimmedString"]["output"]>;
  customerTaxId?: Maybe<Scalars["TrimmedString"]["output"]>;
  id: Scalars["UUID"]["output"];
  note?: Maybe<Scalars["TrimmedString"]["output"]>;
  regionCode: Array<Scalars["TrimmedString"]["output"]>;
  rejectReason?: Maybe<Scalars["TrimmedString"]["output"]>;
  status: TaxExemptionStatus;
  storeId: StoreId;
  taxExemptionEntity: TaxExemptionEntity;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApCustomerTaxExemptionEntity = {
  __typename?: "ApCustomerTaxExemptionEntity";
  entity: TaxExemptionEntity;
  requirements: Array<TaxExemptionEntityRequirement>;
};

export type ApCustomerTaxExemptionInput = {
  customerId: Scalars["UUID"]["input"];
};

export type ApCustomerTaxExemptionResponse = {
  __typename?: "ApCustomerTaxExemptionResponse";
  items: Array<ApCustomerTaxExemption>;
};

export type ApCustomersWithPendingTaxExemptionResponse = {
  __typename?: "ApCustomersWithPendingTaxExemptionResponse";
  count: Scalars["Int"]["output"];
};

export type ApDeleteCategoryFilterInput = {
  id: Scalars["UUID"]["input"];
};

export type ApDeleteCategoryFilterResponse = {
  __typename?: "ApDeleteCategoryFilterResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteCategoryInput = {
  id: Scalars["UUID"]["input"];
  /** Where to redirect all slugs (category + its items) after deletion. */
  redirectTarget: ApCategorySlugRedirectTargetInput;
};

export type ApDeleteCategoryItemInput = {
  id: Scalars["UUID"]["input"];
  /** Where to redirect the item's slugs after deletion. */
  redirectTarget: ApCategorySlugRedirectTargetInput;
};

export type ApDeleteCategoryItemResponse = {
  __typename?: "ApDeleteCategoryItemResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteCategoryProductFilterInput = {
  id: Scalars["UUID"]["input"];
};

export type ApDeleteCategoryProductFilterResponse = {
  __typename?: "ApDeleteCategoryProductFilterResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteCategoryResponse = {
  __typename?: "ApDeleteCategoryResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteCustomerTaxExemptionResponse = {
  __typename?: "ApDeleteCustomerTaxExemptionResponse";
  success: Scalars["Boolean"]["output"];
};

export type ApDeleteGalleryCategoryInput = {
  id: Scalars["UUID"]["input"];
};

export type ApDeleteGalleryCategoryResponse = {
  __typename?: "ApDeleteGalleryCategoryResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteInventoryPolicyGlobalResponse = {
  __typename?: "ApDeleteInventoryPolicyGlobalResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteInventoryPolicyOverrideResponse = {
  __typename?: "ApDeleteInventoryPolicyOverrideResponse";
  success: Scalars["Boolean"]["output"];
};

export type ApDeleteMockTaxIdValidationStatusesByTaxIdInput = {
  delete: Array<Scalars["TrimmedString"]["input"]>;
};

export type ApDeleteMockTaxIdValidationStatusesByTaxIdResponse = {
  __typename?: "ApDeleteMockTaxIdValidationStatusesByTaxIdResponse";
  deleted: Scalars["NonNegativeInt"]["output"];
};

export type ApDeleteNoticeInput = {
  id: Scalars["UUID"]["input"];
};

export type ApDeleteNoticeResponse = {
  __typename?: "ApDeleteNoticeResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeletePaymentProviderInput = {
  id: Scalars["UUID"]["input"];
};

export type ApDeletePaymentProviderPaymentMethodsInput = {
  delete: Array<DeletePaymentProviderPaymentMethodInput>;
};

export type ApDeletePaymentProviderPaymentMethodsResponse = {
  __typename?: "ApDeletePaymentProviderPaymentMethodsResponse";
  deleted: Scalars["Int"]["output"];
};

export type ApDeletePaymentProviderResponse = {
  __typename?: "ApDeletePaymentProviderResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteProductCompatibilityInput = {
  id: Scalars["UUID"]["input"];
};

export type ApDeleteProductCompatibilityResponse = {
  __typename?: "ApDeleteProductCompatibilityResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteProductFeatureResponse = {
  __typename?: "ApDeleteProductFeatureResponse";
  success: Scalars["Boolean"]["output"];
};

export type ApDeleteProductPriceManualOverrideInput = {
  id: Scalars["UUID"]["input"];
};

export type ApDeleteProtectedAssetResponse = {
  __typename?: "ApDeleteProtectedAssetResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteRelatedProductCategoryInput = {
  id: Scalars["UUID"]["input"];
};

export type ApDeleteRelatedProductCategoryResponse = {
  __typename?: "ApDeleteRelatedProductCategoryResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteStoreBankDetailsInput = {
  storeId: StoreId;
};

export type ApDeleteStoreBankDetailsResponse = {
  __typename?: "ApDeleteStoreBankDetailsResponse";
  storeId: StoreId;
};

export type ApDeleteStorefrontProductVariantPartNumberInput = {
  skus: Array<Scalars["TrimmedString"]["input"]>;
};

export type ApDeleteTagTemplateInput = {
  id: Scalars["UUID"]["input"];
};

export type ApDeleteTagTemplateResponse = {
  __typename?: "ApDeleteTagTemplateResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteTariffResponse = {
  __typename?: "ApDeleteTariffResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteTaxRateInput = {
  id: Scalars["UUID"]["input"];
};

export type ApDeleteTaxRateResponse = {
  __typename?: "ApDeleteTaxRateResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeleteUpsellProductCategoryInput = {
  id: Scalars["UUID"]["input"];
};

export type ApDeleteUpsellProductCategoryResponse = {
  __typename?: "ApDeleteUpsellProductCategoryResponse";
  id: Scalars["UUID"]["output"];
};

export type ApDeviceIdentifier = {
  __typename?: "ApDeviceIdentifier";
  id: Scalars["UUID"]["output"];
  items: Array<ApDeviceIdentifierItem>;
};

export type ApDeviceIdentifierItem = {
  __typename?: "ApDeviceIdentifierItem";
  isValid: Scalars["Boolean"]["output"];
  type: ApDeviceIdentifierType;
  value: Scalars["String"]["output"];
};

export enum ApDeviceIdentifierType {
  EsimEid = "EsimEid",
  Imei = "Imei",
  MacAddress = "MacAddress",
}

export type ApDiscountBundleProduct = {
  __typename?: "ApDiscountBundleProduct";
  discountBundleProductVariants: Array<ApDiscountBundleProductVariant>;
  id: Scalars["UUID"]["output"];
  productId: Scalars["UUID"]["output"];
};

export type ApDiscountBundleProductVariant = {
  __typename?: "ApDiscountBundleProductVariant";
  discountBundleProductId: Scalars["UUID"]["output"];
  fixedAmountCurrency: Currency;
  fixedAmountPrice: Scalars["NonNegativeInt"]["output"];
  productVariantId: Scalars["UUID"]["output"];
  storeDiscountBundleProductVariants?: Maybe<
    Array<ApStoreDiscountBundleProductVariant>
  >;
};

export type ApEmailClickEvent = {
  __typename?: "ApEmailClickEvent";
  count: TotalAndUniqueCount;
  url: Scalars["String"]["output"];
};

export type ApEmailEventsAggregatedInput = {
  endDate: Scalars["DateTime"]["input"];
  resolution: EmailEventResolution;
  startDate: Scalars["DateTime"]["input"];
  template?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApEmailEventsAggregatedResponse = {
  __typename?: "ApEmailEventsAggregatedResponse";
  events: Array<ApAggregatedEmailEvent>;
};

export type ApGallery = {
  __typename?: "ApGallery";
  id: Scalars["String"]["output"];
  items: Array<ApGalleryItem>;
  language?: Maybe<Language>;
  /** Url of the first image or thumbnail of an embed for the gallery */
  thumbnailUrl?: Maybe<Scalars["String"]["output"]>;
  type: GalleryTag;
};

export type ApGalleryCategory = {
  __typename?: "ApGalleryCategory";
  createdAt: Scalars["DateTime"]["output"];
  defaultTranslation: ApGalleryCategoryTranslation;
  id: Scalars["UUID"]["output"];
  translations: Array<ApGalleryCategoryTranslation>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApGalleryCategoryTranslation = Translation & {
  __typename?: "ApGalleryCategoryTranslation";
  language: Language;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ApGalleryCategoryTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  title: Scalars["TrimmedString"]["input"];
};

export type ApGalleryItem = {
  __typename?: "ApGalleryItem";
  data: GalleryItemUnion;
  defaultTranslation: ApGalleryItemTranslation;
  galleryCategoryId?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  isHidden: Scalars["Boolean"]["output"];
  translations: Array<ApGalleryItemTranslation>;
};

export type ApGalleryItemTranslation = Translation & {
  __typename?: "ApGalleryItemTranslation";
  language: Language;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ApGalleryItemTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  title: Scalars["TrimmedString"]["input"];
};

export type ApGetCreateOrderDataInput = {
  cartItems: Array<ApOrderCartItemInput>;
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  discountCode?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  email: Scalars["LowercaseTrimmedString"]["input"];
  forceTaxIdValidationSuccess: Scalars["Boolean"]["input"];
  shippingAddress: AddressInput;
  storeCarrierServiceId?: InputMaybe<Scalars["UUID"]["input"]>;
  storeId: StoreId;
  storeShippingRateId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type ApGetCreateOrderDataResponse = {
  __typename?: "ApGetCreateOrderDataResponse";
  availableShippingOptions: Array<ShippingOption>;
  discountCodeId?: Maybe<Scalars["UUID"]["output"]>;
  discountId?: Maybe<Scalars["UUID"]["output"]>;
  totals: ApGetCreateOrderDataTotals;
};

export type ApGetCreateOrderDataTotals = {
  __typename?: "ApGetCreateOrderDataTotals";
  discountFreeShipping: Scalars["Boolean"]["output"];
  isFree: Scalars["Boolean"]["output"];
  items: Totals;
  summary: Totals;
  taxCalculated: Scalars["Boolean"]["output"];
};

export type ApGetMockedTaxIdValidationInput = {
  taxId: Scalars["TrimmedString"]["input"];
};

export type ApGetMockedTaxIdValidationResponse = {
  __typename?: "ApGetMockedTaxIdValidationResponse";
  item?: Maybe<TaxIdMockValidation>;
};

export type ApGetProtectedAssetSignedUrlResponse = {
  __typename?: "ApGetProtectedAssetSignedUrlResponse";
  expiresAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  signedUrl: Scalars["String"]["output"];
};

export type ApHistoricalSlug = {
  __typename?: "ApHistoricalSlug";
  updatedAt: Scalars["DateTime"]["output"];
  value: Scalars["String"]["output"];
};

export type ApInsertStorefrontProductVariantPartNumberInput = {
  partNumber: Scalars["TrimmedString"]["input"];
  sku: Scalars["TrimmedString"]["input"];
};

export type ApIntegration = {
  __typename?: "ApIntegration";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  limits: Array<ApIntegrationSkuLimit>;
  name: Scalars["String"]["output"];
  permissions: Array<Scalars["TrimmedString"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApIntegrationSkuLimit = {
  __typename?: "ApIntegrationSkuLimit";
  id: Scalars["UUID"]["output"];
  sku: Scalars["String"]["output"];
  type: IntegrationLimitType;
};

export type ApInventoryPolicyGlobal = {
  __typename?: "ApInventoryPolicyGlobal";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  restockThreshold?: Maybe<Scalars["Int"]["output"]>;
  storeId?: Maybe<StoreId>;
  updatedAt: Scalars["DateTime"]["output"];
  visibleInventoryQty?: Maybe<Scalars["Int"]["output"]>;
};

export type ApInventoryPolicyOverride = {
  __typename?: "ApInventoryPolicyOverride";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  productIds: Array<Scalars["UUID"]["output"]>;
  restockThreshold?: Maybe<Scalars["Int"]["output"]>;
  storeOverrides: Array<ApInventoryPolicyStoreOverride>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  visibleInventoryQty?: Maybe<Scalars["Int"]["output"]>;
};

export type ApInventoryPolicyStoreOverride = {
  __typename?: "ApInventoryPolicyStoreOverride";
  id: Scalars["UUID"]["output"];
  inventoryPolicyOverrideId: Scalars["UUID"]["output"];
  restockThreshold?: Maybe<Scalars["Int"]["output"]>;
  storeId: StoreId;
  visibleInventoryQty?: Maybe<Scalars["Int"]["output"]>;
};

export type ApInventoryPolicyStoreOverrideInput = {
  restockThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  storeId: StoreId;
  visibleInventoryQty?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ApListMockedTaxIdValidationStatusesResponse = {
  __typename?: "ApListMockedTaxIdValidationStatusesResponse";
  items: Array<TaxIdMockValidation>;
};

export type ApListProductMeasurementInput = {
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApListProductMeasurementsResponse = PageResponse & {
  __typename?: "ApListProductMeasurementsResponse";
  items: Array<ApProductMeasurement>;
  pagination: PaginationResponse;
};

export type ApListSpecificationAssetsResponse = {
  __typename?: "ApListSpecificationAssetsResponse";
  protectedAssets: Array<ProtectedAsset>;
};

export type ApMarkOrderAsPaidResponse = {
  __typename?: "ApMarkOrderAsPaidResponse";
  order: ApOrder;
};

export type ApNodeTextblock = {
  __typename?: "ApNodeTextblock";
  /** Extra fields required for resolvers */
  blockNodeId: Scalars["UUID"]["output"];
  translations: Array<ApTextblockTranslation>;
};

export type ApNodeTextblockInput = {
  translations: Array<ApTextblockTranslationInput>;
};

export type ApNotice = {
  __typename?: "ApNotice";
  activeEndDate?: Maybe<Scalars["DateTime"]["output"]>;
  activeStartDate: Scalars["DateTime"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  defaultTranslation: ApNoticeTranslation;
  id: Scalars["UUID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  status: ApNoticeStatus;
  storeIds: Array<StoreId>;
  translations: Array<ApNoticeTranslation>;
  type: NoticeType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApNoticeListFilterInput = {
  status?: InputMaybe<ApNoticeStatus>;
  stores?: InputMaybe<Array<Scalars["String"]["input"]>>;
  type?: InputMaybe<NoticeType>;
};

export type ApNoticeListInput = {
  filter?: InputMaybe<ApNoticeListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<ApNoticeOrderBy>>;
};

export type ApNoticeListResponse = PageResponse & {
  __typename?: "ApNoticeListResponse";
  items: Array<ApNotice>;
  pagination: PaginationResponse;
};

export type ApNoticeOrderBy = {
  key: ApNoticeOrderByKey;
  order: SortOrder;
};

export enum ApNoticeOrderByKey {
  ActiveStartDate = "activeStartDate",
}

export enum ApNoticeStatus {
  Active = "Active",
  Disabled = "Disabled",
  Expired = "Expired",
  Scheduled = "Scheduled",
}

export type ApNoticeTranslation = Translation & {
  __typename?: "ApNoticeTranslation";
  description?: Maybe<Scalars["String"]["output"]>;
  language: Language;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ApNoticeTranslationInput = {
  description: Scalars["TrimmedString"]["input"];
  languageId: Scalars["UUID"]["input"];
  title: Scalars["TrimmedString"]["input"];
};

export type ApOrder = {
  __typename?: "ApOrder";
  /** Order activity timeline */
  activities: Array<ActivityAny>;
  /** Indicates which platform the order was created from when it's created from a native app. */
  appPlatform?: Maybe<DeviceTokenPlatform>;
  /** Could be the same as shipping address */
  billingAddress: OrderAddressUnion;
  /** Help identify from which checkout the order was created from */
  checkoutId?: Maybe<Scalars["UUID"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  currency: Currency;
  customCreated: Scalars["Boolean"]["output"];
  customCreatedByUser?: Maybe<User>;
  customer: Customer;
  discount?: Maybe<Discount>;
  discountCode?: Maybe<DiscountCode>;
  discountCodeName?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["EmailAddress"]["output"];
  /** Emails sent for this order */
  emails: Array<ApOrderEmail>;
  fulfillments: ApOrderFulfillmentSummary;
  id: Scalars["UUID"]["output"];
  /** Optional metadata if order was created via some integration */
  integration?: Maybe<ApOrderIntegrationMetadata>;
  invoiceLink?: Maybe<Scalars["String"]["output"]>;
  /** Stores that are configured to use the orderNumber as invoiceNumber [storeSpecific.invoice.orderNumberAsInvoiceNumber] will not have this value */
  invoiceNumber?: Maybe<Scalars["String"]["output"]>;
  /** The IP address from which the order was created. */
  ipAddress?: Maybe<Scalars["String"]["output"]>;
  isExpirable: Scalars["Boolean"]["output"];
  isReopenable: Scalars["Boolean"]["output"];
  /** Used to control if we can create a return from admin panel */
  isReturnable: Scalars["Boolean"]["output"];
  items: Array<ApOrderOperationProduct>;
  linkedCustomerTaxExemptionStatus?: Maybe<TaxExemptionStatus>;
  netsuiteCreateScheduledAt?: Maybe<Scalars["DateTime"]["output"]>;
  netsuiteId?: Maybe<Scalars["String"]["output"]>;
  netsuitePayload: Array<Scalars["JSONObject"]["output"]>;
  /** Order number generated from prefix + basis + suffix */
  orderNumber: Scalars["String"]["output"];
  payByInvoiceMetadata?: Maybe<OrderPayByInvoiceMetadata>;
  payment: ApOrderPayment;
  paymentExpireAt: Scalars["DateTime"]["output"];
  /**
   * Score between 0 and 1:
   * 0.0 -> Very likely a bot
   * 1.0 -> Very likely a human
   */
  recaptchaScore?: Maybe<Scalars["Float"]["output"]>;
  returns: Array<ApOrderReturn>;
  /** Indicates that shipments are actively tracked for this order */
  shipmentsAreBeingTracked: Scalars["Boolean"]["output"];
  shipping?: Maybe<ApOrderShipping>;
  shippingAddress: OrderAddressUnion;
  status: OrderStatus;
  statusLink: Scalars["String"]["output"];
  store: Store;
  storeCreditEarnings: Array<StoreCreditEarning>;
  tags: Array<OrderTag>;
  taxExempt: Scalars["Boolean"]["output"];
  taxReturnAllowed: Scalars["Boolean"]["output"];
  taxes: Array<OrderOperationProductTaxLine>;
  totals: OrderTotals;
  updatedAt: Scalars["DateTime"]["output"];
  vatNumberValidation?: Maybe<ApVatValidationResult>;
  wasLoggedIn: Scalars["Boolean"]["output"];
};

export type ApOrderCartItemInput = {
  productId: Scalars["UUID"]["input"];
  quantity: Scalars["NonNegativeInt"]["input"];
  sku: Scalars["TrimmedString"]["input"];
  storeProductVariantId: Scalars["UUID"]["input"];
};

export type ApOrderDraft = {
  __typename?: "ApOrderDraft";
  billingAddress?: Maybe<CheckoutAddressUnion>;
  createdAt: Scalars["DateTime"]["output"];
  customer: Customer;
  discount: ApOrderDraftDiscount;
  hasItemsReserved: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  invoiceLink?: Maybe<Scalars["String"]["output"]>;
  invoiceNote?: Maybe<Scalars["String"]["output"]>;
  itemReservationExpiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** NOTE: Loader for `items` does not support multiple stores (cannot use when listing) */
  items?: Maybe<Array<ApOrderDraftItem>>;
  /** Total quantity for all items */
  itemsQuantity: Scalars["NonNegativeInt"]["output"];
  /** Draft order number generated from prefix + basis + suffix */
  number: Scalars["String"]["output"];
  sendConfirmationEmail: Scalars["Boolean"]["output"];
  shippingAddress?: Maybe<CheckoutAddressUnion>;
  shippingOption?: Maybe<ApOrderDraftShippingOption>;
  store: Store;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApOrderDraftCartItemInput = {
  quantity: Scalars["NonNegativeInt"]["input"];
  storeProductVariantId: Scalars["UUID"]["input"];
};

export type ApOrderDraftDiscount = {
  __typename?: "ApOrderDraftDiscount";
  discountCodeId?: Maybe<Scalars["UUID"]["output"]>;
  discountCodeName?: Maybe<Scalars["String"]["output"]>;
  discountId?: Maybe<Scalars["UUID"]["output"]>;
};

export type ApOrderDraftInput = {
  id: Scalars["UUID"]["input"];
  language: Scalars["LowercaseTrimmedString"]["input"];
};

export type ApOrderDraftItem = {
  __typename?: "ApOrderDraftItem";
  image?: Maybe<Scalars["String"]["output"]>;
  price: Money;
  product: ApOrderDraftItemProduct;
  quantity: Scalars["NonNegativeInt"]["output"];
  variant: ApOrderDraftItemProductVariant;
};

export type ApOrderDraftItemProduct = {
  __typename?: "ApOrderDraftItemProduct";
  id: Scalars["UUID"]["output"];
  title: Scalars["String"]["output"];
};

export type ApOrderDraftItemProductVariant = {
  __typename?: "ApOrderDraftItemProductVariant";
  id: Scalars["UUID"]["output"];
  sku: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type ApOrderDraftListInput = {
  filter: ApOrderDraftListInputFilter;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<OrderDraftOrderBy>>;
};

export type ApOrderDraftListInputFilter = {
  storeIds?: InputMaybe<Array<StoreId>>;
};

export type ApOrderDraftListResult = PageResponse & {
  __typename?: "ApOrderDraftListResult";
  items: Array<ApOrderDraft>;
  pagination: PaginationResponse;
};

export type ApOrderDraftResponse = {
  __typename?: "ApOrderDraftResponse";
  order: ApOrderDraft;
};

export type ApOrderDraftShippingOption = {
  __typename?: "ApOrderDraftShippingOption";
  price: Money;
  storeCarrierServiceId: Scalars["UUID"]["output"];
  storeShippingRateId: Scalars["UUID"]["output"];
  tax: Money;
  total: Money;
};

export type ApOrderEmail = {
  __typename?: "ApOrderEmail";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  orderId: Scalars["UUID"]["output"];
  sentAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type ApOrderFulfillment = {
  __typename?: "ApOrderFulfillment";
  carrierCompanyName?: Maybe<Scalars["String"]["output"]>;
  carrierTrackingNumber?: Maybe<Scalars["String"]["output"]>;
  carrierTrackingUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  items: Array<ApOrderFulfillmentItem>;
  shipmentId?: Maybe<Scalars["UUID"]["output"]>;
  shippedAt?: Maybe<Scalars["DateTime"]["output"]>;
  shippingLabelLink?: Maybe<Scalars["String"]["output"]>;
  status: OrderFulfillmentStatus;
  trackings: Array<ApOrderFulfillmentTracking>;
};

export type ApOrderFulfillmentItem = {
  __typename?: "ApOrderFulfillmentItem";
  deviceIdentifiers: Array<ApDeviceIdentifier>;
  discountTotal: Money;
  galleryItemAsset?: Maybe<Asset>;
  hasTaxIncludedPrice: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  price: Money;
  productId: Scalars["String"]["output"];
  productSalesCampaignName?: Maybe<Scalars["String"]["output"]>;
  promoCodes: Array<Scalars["String"]["output"]>;
  quantity: Scalars["NonNegativeInt"]["output"];
  regularPrice?: Maybe<Money>;
  sku: Scalars["String"]["output"];
  /** Will be null if store product variant is deleted */
  storeProductVariantId?: Maybe<Scalars["UUID"]["output"]>;
  subtotal: Money;
  tariff: Money;
  tariffTotal: Money;
  taxCode?: Maybe<Scalars["String"]["output"]>;
  taxTotal: Money;
  title: Scalars["String"]["output"];
  total: Money;
  /** Combined with the variant if necessary */
  warehouse: Warehouse;
};

export type ApOrderFulfillmentSummary = {
  __typename?: "ApOrderFulfillmentSummary";
  fulfillmentLines: Array<ApOrderFulfillment>;
  status: OrderFulfillmentDisplayStatus;
};

export type ApOrderFulfillmentTracking = {
  __typename?: "ApOrderFulfillmentTracking";
  id: Scalars["UUID"]["output"];
  status: ShipmentStatus;
  trackingNumber: Scalars["String"]["output"];
};

export type ApOrderInput = {
  id: Scalars["UUID"]["input"];
  language: Scalars["LowercaseTrimmedString"]["input"];
};

export type ApOrderIntegrationMetadata = {
  __typename?: "ApOrderIntegrationMetadata";
  /** Help identify which integration created the checkout */
  integration: ApIntegration;
  /** JSON-like object of metadata provided by integration on the checkouts creation */
  metadata?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type ApOrderOperationProduct = {
  __typename?: "ApOrderOperationProduct";
  createdAt: Scalars["DateTime"]["output"];
  discountTotal: Money;
  hasRestockFeeApplied?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["UUID"]["output"];
  itemPrice: Money;
  parentOrderOperationProductId?: Maybe<Scalars["UUID"]["output"]>;
  product: ApProduct;
  quantity: Scalars["NonNegativeInt"]["output"];
  /** Available return after all ACCEPTED returns */
  returnAvailableQty: Scalars["NonNegativeInt"]["output"];
  sku: Scalars["String"]["output"];
  subtotal: Money;
  tariffTotal: Money;
  taxTotal: Money;
  total: Money;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApOrderOperationTransaction = {
  __typename?: "ApOrderOperationTransaction";
  cardBrand?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  disputes?: Maybe<ApOrderOperationTransactionDisputes>;
  externalUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  operationId: Scalars["UUID"]["output"];
  paymentProvider: PaymentProvider;
  paymentType?: Maybe<Scalars["String"]["output"]>;
  price: Money;
  providerCreatedAt: Scalars["DateTime"]["output"];
  received: Money;
  returnId?: Maybe<Scalars["UUID"]["output"]>;
  reviewStatus?: Maybe<OrderOperationTransactionReviewStatus>;
  /** @deprecated Use riskLevels instead */
  riskLevel?: Maybe<OrderOperationTransactionRiskLevel>;
  riskLevels: Array<OrderOperationTransactionRiskLevel>;
  status: OrderTransactionDisplayStatus;
  transactionId?: Maybe<Scalars["String"]["output"]>;
  type: OrderTransactionType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApOrderOperationTransactionDispute = {
  __typename?: "ApOrderOperationTransactionDispute";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  isRefundable: Scalars["Boolean"]["output"];
  orderOperationTransactionId: Scalars["UUID"]["output"];
  providerDisputeMetadata?: Maybe<Scalars["JSONObject"]["output"]>;
  respondedAt?: Maybe<Scalars["DateTime"]["output"]>;
  response?: Maybe<Scalars["JSONObject"]["output"]>;
  stage?: Maybe<OrderOperationTransactionDisputeStage>;
  status?: Maybe<OrderOperationTransactionDisputeStatus>;
};

export type ApOrderOperationTransactionDisputes = {
  __typename?: "ApOrderOperationTransactionDisputes";
  items: Array<ApOrderOperationTransactionDispute>;
  status: OrderOperationTransactionDisputeDisplayStatus;
};

export type ApOrderPayment = {
  __typename?: "ApOrderPayment";
  /** Available system refund amount after all ACCEPTED returns */
  availableSystemRefund: Money;
  /** All charges, including refunds */
  charges: Array<ApOrderOperationTransaction>;
  /** Order payment transaction */
  initialCharge?: Maybe<ApOrderOperationTransaction>;
  /** Derived value from all charge statuses */
  status: OrderTransactionDisplayStatus;
};

export type ApOrderPickAndFulfillItemsInput = {
  items: Array<ApOrderPickAndFulfillItemsInputItem>;
  orderId: Scalars["UUID"]["input"];
  shippingCarrierId: Scalars["UUID"]["input"];
  trackingNumber: Scalars["TrimmedString"]["input"];
};

export type ApOrderPickAndFulfillItemsInputItem = {
  operationProductId: Scalars["UUID"]["input"];
  quantity: Scalars["NonNegativeInt"]["input"];
};

export type ApOrderPickAndFulfillItemsResponse = {
  __typename?: "ApOrderPickAndFulfillItemsResponse";
  order: ApOrder;
};

export type ApOrderReturn = {
  __typename?: "ApOrderReturn";
  authorType: ReturnAuthorType;
  availableShippingCarrierType?: Maybe<ShippingCarrier>;
  caseNumber: Scalars["NonNegativeInt"]["output"];
  clientAmount?: Maybe<Money>;
  createdAt: Scalars["DateTime"]["output"];
  creditNoteLink?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  initialShippingFeeRefundableAmount: Money;
  isTaxReturn: Scalars["Boolean"]["output"];
  order: ApOrder;
  packingSlip?: Maybe<ProtectedAsset>;
  pickupAddress?: Maybe<OrderAddressUnion>;
  reason: ReturnReason;
  reasonDescription?: Maybe<Scalars["String"]["output"]>;
  requestedItems: Array<ApOrderReturnRequestItem>;
  resolution: ReturnResolution;
  resolvedAt?: Maybe<Scalars["DateTime"]["output"]>;
  resolvedBy?: Maybe<User>;
  restockFeeAmount?: Maybe<Money>;
  restockFeePercent: Scalars["NonNegativeInt"]["output"];
  returnOption?: Maybe<ReturnOption>;
  returnedItems: Array<ApOrderOperationProduct>;
  shipments: Array<ApOrderReturnShipment>;
  shippingAmount: Money;
  systemAmount?: Maybe<Money>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApOrderReturnBy = {
  key: ApOrderReturnByKey;
  order: SortOrder;
};

export enum ApOrderReturnByKey {
  CreatedAt = "createdAt",
}

export type ApOrderReturnFilterDateRangeInput = {
  /** EXCLUSIVE = order.created_at < startDate */
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** INCLUSIVE = order.created_at >= startDate */
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type ApOrderReturnInput = {
  id: Scalars["UUID"]["input"];
  language: Scalars["LowercaseTrimmedString"]["input"];
};

export type ApOrderReturnListFilterInput = {
  creationDateRange?: InputMaybe<ApOrderReturnFilterDateRangeInput>;
  isCaseOpen?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  shipmentStatus?: InputMaybe<ApOrderReturnShipmentFilterStatus>;
  storeIds?: InputMaybe<Array<StoreId>>;
};

export type ApOrderReturnListInput = {
  filter?: InputMaybe<ApOrderReturnListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<ApOrderReturnBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApOrderReturnListResponse = PageResponse & {
  __typename?: "ApOrderReturnListResponse";
  items: Array<ApOrderReturn>;
  pagination: PaginationResponse;
};

export type ApOrderReturnRequestItem = {
  __typename?: "ApOrderReturnRequestItem";
  addOrderOperationProduct: ApOrderOperationProduct;
  id: Scalars["UUID"]["output"];
  quantityRequested: Scalars["NonNegativeInt"]["output"];
};

export type ApOrderReturnShipment = {
  __typename?: "ApOrderReturnShipment";
  carrier: Scalars["String"]["output"];
  carrierService: Scalars["String"]["output"];
  charge: Money;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  labelUrl?: Maybe<Scalars["String"]["output"]>;
  receiptUrl?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<ShipmentStatus>;
  trackingNumber: Scalars["String"]["output"];
};

export enum ApOrderReturnShipmentFilterStatus {
  Delivered = "Delivered",
  PartiallyDelivered = "PartiallyDelivered",
}

export type ApOrderReturnTotalsInput = {
  availableRefundMethod: AvailableRefundMethod;
  items: Array<ApOrderReturnTotalsItemInput>;
  orderId: Scalars["UUID"]["input"];
  orderReturnId?: InputMaybe<Scalars["UUID"]["input"]>;
  refundInitialShippingFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  restockPercent: Scalars["NonNegativeInt"]["input"];
};

export type ApOrderReturnTotalsItemInput = {
  addOperationProductId: Scalars["UUID"]["input"];
  hasRestockFeeApplied: Scalars["Boolean"]["input"];
  quantity: Scalars["NonNegativeInt"]["input"];
};

export type ApOrderReturnTotalsItemResponse = {
  __typename?: "ApOrderReturnTotalsItemResponse";
  addOperationProductId: Scalars["UUID"]["output"];
  discount: Money;
  hasTaxIncludedPrice: Scalars["Boolean"]["output"];
  itemPrice: Money;
  subtotal: Money;
  tariff: Money;
  tax: Money;
  total: Money;
};

export type ApOrderReturnTotalsResponse = {
  __typename?: "ApOrderReturnTotalsResponse";
  items: Array<ApOrderReturnTotalsItemResponse>;
  summary: ApOrderReturnTotalsSummaryResponse;
};

export type ApOrderReturnTotalsSummaryResponse = {
  __typename?: "ApOrderReturnTotalsSummaryResponse";
  itemDiscount: Money;
  itemSubtotal: Money;
  itemTariff: Money;
  itemTax: Money;
  refundAvailable: Money;
  restockFee: Money;
  shipping: Money;
  subtotal: Money;
  total: Money;
  unsafeSubtotal: Money;
};

export type ApOrderShipping = {
  __typename?: "ApOrderShipping";
  createdAt: Scalars["DateTime"]["output"];
  delivery?: Maybe<ApOrderShippingDelivery>;
  id: Scalars["UUID"]["output"];
  isSignatureRequired: Scalars["Boolean"]["output"];
  storeCarrierService: StoreCarrierService;
  storeShippingOptionName: Scalars["String"]["output"];
  storeShippingRate: StoreShippingRateUnion;
  taxCode?: Maybe<Scalars["String"]["output"]>;
  taxes: Array<OrderOperationShippingTaxLine>;
  totals: Totals;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApOrderShippingDelivery = {
  __typename?: "ApOrderShippingDelivery";
  estimatedDeliveryDate: Scalars["DateTime"]["output"];
  providedPickupDate: Scalars["DateTime"]["output"];
  requestedPickupDate: Scalars["DateTime"]["output"];
};

export type ApPaymentProviderDetails = {
  __typename?: "ApPaymentProviderDetails";
  accountId?: Maybe<Scalars["String"]["output"]>;
  captureEnabled: Scalars["Boolean"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  daysToKeepAuthorized?: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["UUID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  publishableKey?: Maybe<Scalars["String"]["output"]>;
  type: PaymentProvider;
  updatedAt: Scalars["DateTime"]["output"];
  webhookId?: Maybe<Scalars["String"]["output"]>;
};

export type ApProduct = {
  __typename?: "ApProduct";
  affiliateCampaignProducts: Array<ApAffiliateCampaignProduct>;
  apGalleries: Array<ApGallery>;
  apSlugRedirects: Array<ApSlugRedirect>;
  assets: Array<Asset>;
  /** Source product ID for auto-managed products. Null if manually managed. */
  autoManagementSourceProductId?: Maybe<Scalars["UUID"]["output"]>;
  baseSku: Scalars["String"]["output"];
  countryOfOrigin?: Maybe<CountryCode>;
  createdAt: Scalars["DateTime"]["output"];
  /** Default collection used for automatic re-routes on SF */
  defaultCollectionId?: Maybe<Scalars["UUID"]["output"]>;
  defaultTranslation: ProductTranslation;
  /** Each product has one product variant with 'isDefault'=true */
  defaultVariant: ProductVariant;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  documents: Array<ProductDocument>;
  family?: Maybe<ProductFamily>;
  /** @deprecated Use apGalleries instead */
  galleries: Array<Gallery>;
  hsCode?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  kind: ProductKind;
  manufacturer?: Maybe<Scalars["String"]["output"]>;
  mediaSectionOrder: Array<GalleryTag>;
  organizationalCollectionId?: Maybe<Scalars["UUID"]["output"]>;
  proCollectionId?: Maybe<Scalars["UUID"]["output"]>;
  productCustomization?: Maybe<ApProductCustomization>;
  productFaq?: Maybe<ApProductFaq>;
  productGroup?: Maybe<ApProductGroup>;
  productInlineAccessoryGroup?: Maybe<ApProductInlineAccessoryGroup>;
  productNotes: Array<ProductNote>;
  productRegionalLimits: Array<ProductRegionalLimit>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  relatedProducts: ApRelatedProduct;
  searchFactor: Scalars["NonNegativeInt"]["output"];
  slug: Scalars["String"]["output"];
  specification?: Maybe<ApSpecificationEntity>;
  state: ProductState;
  tags: Array<ProductTag>;
  taxCode?: Maybe<Scalars["String"]["output"]>;
  trackQuantity: Scalars["Boolean"]["output"];
  translations: Array<ProductTranslation>;
  type?: Maybe<ProductType>;
  updatedAt: Scalars["DateTime"]["output"];
  upsellProducts: ApUpsellProduct;
  usedOptionValueIds: Array<Scalars["UUID"]["output"]>;
  /** Custom variants where 'isDefault'=false */
  variants: Array<ProductVariant>;
  variesBy: Array<ProductVariesBy>;
  variesByIsEarlyAccess: Scalars["Boolean"]["output"];
  variesByIsEnabled: Scalars["Boolean"]["output"];
  variesByIsVisibleInStore: Scalars["Boolean"]["output"];
  variesByPrice: Scalars["Boolean"]["output"];
  variesByStatus: Scalars["Boolean"]["output"];
  variesByWeight: Scalars["Boolean"]["output"];
};

export type ApProductCompatibility = {
  __typename?: "ApProductCompatibility";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  masterProduct: ApProduct;
  noteMoveToBottom: Scalars["Boolean"]["output"];
  noteRequireCollectionSection: Scalars["Boolean"]["output"];
  products: Array<ApProduct>;
  translations: Array<ApProductCompatibilityTranslation>;
};

export type ApProductCompatibilityListInput = {
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<ApProductCompatibilityOrderBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApProductCompatibilityListResponse = PageResponse & {
  __typename?: "ApProductCompatibilityListResponse";
  items: Array<ApProductCompatibility>;
  pagination: PaginationResponse;
};

export type ApProductCompatibilityOrderBy = {
  key: ApProductCompatibilityOrderByKey;
  order: SortOrder;
};

export enum ApProductCompatibilityOrderByKey {
  CreatedAt = "createdAt",
}

export type ApProductCompatibilityTranslation = Translation & {
  __typename?: "ApProductCompatibilityTranslation";
  language: Language;
  note?: Maybe<Scalars["String"]["output"]>;
};

export type ApProductCompatibilityTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  note: Scalars["TrimmedString"]["input"];
};

export type ApProductCustomization = {
  __typename?: "ApProductCustomization";
  groups: Array<ApProductCustomizationGroup>;
  isEnabled: Scalars["Boolean"]["output"];
};

export type ApProductCustomizationGroup = {
  __typename?: "ApProductCustomizationGroup";
  defaultTranslation: ApProductCustomizationGroupTranslation;
  id: Scalars["UUID"]["output"];
  matchVariants: Scalars["Boolean"]["output"];
  parentId?: Maybe<Scalars["UUID"]["output"]>;
  productIds: Array<Scalars["UUID"]["output"]>;
  showIncludedOption: Scalars["Boolean"]["output"];
  translations: Array<ApProductCustomizationGroupTranslation>;
};

export type ApProductCustomizationGroupTranslation = Translation & {
  __typename?: "ApProductCustomizationGroupTranslation";
  language: Language;
  subtitle?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ApProductFaq = {
  __typename?: "ApProductFaq";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  isHidden: Scalars["Boolean"]["output"];
  items: Array<ApProductFaqItem>;
  productId: Scalars["UUID"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApProductFaqItem = {
  __typename?: "ApProductFaqItem";
  answer?: Maybe<ApBlock>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  productFaqId: Scalars["UUID"]["output"];
  question: Array<ApProductFaqTranslation>;
  sortOrder: Scalars["Int"]["output"];
  /**
   * Null -> Applies to all stores
   * Store ID array -> Applies to specific stores, empty array means no stores are enabled
   */
  storeIds?: Maybe<Array<StoreId>>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApProductFaqTranslation = Translation & {
  __typename?: "ApProductFaqTranslation";
  language: Language;
  question?: Maybe<Scalars["String"]["output"]>;
};

export type ApProductFeature = {
  __typename?: "ApProductFeature";
  assetId: Scalars["UUID"]["output"];
  canvasHeight: Scalars["Int"]["output"];
  canvasWidth: Scalars["Int"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  dotX: Scalars["Float"]["output"];
  dotY: Scalars["Float"]["output"];
  id: Scalars["UUID"]["output"];
  lineRenderType: ProductFeatureLineRenderType;
  productId: Scalars["UUID"]["output"];
  scale: Scalars["Float"]["output"];
  tooltipX: Scalars["Float"]["output"];
  tooltipY: Scalars["Float"]["output"];
  translateX: Scalars["Int"]["output"];
  translateY: Scalars["Int"]["output"];
  translations: Array<ApProductFeatureTranslation>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApProductFeatureTranslation = Translation & {
  __typename?: "ApProductFeatureTranslation";
  body?: Maybe<Scalars["String"]["output"]>;
  language: Language;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ApProductGroup = {
  __typename?: "ApProductGroup";
  id: Scalars["UUID"]["output"];
  masterProductId: Scalars["UUID"]["output"];
  productIds: Array<Scalars["UUID"]["output"]>;
};

export type ApProductInlineAccessoryGroup = {
  __typename?: "ApProductInlineAccessoryGroup";
  id: Scalars["UUID"]["output"];
  label: Scalars["String"]["output"];
  products: Array<ApProductInlineAccessoryGroupProduct>;
  type: ProductInlineAccessoryGroupType;
};

export type ApProductInlineAccessoryGroupProduct = {
  __typename?: "ApProductInlineAccessoryGroupProduct";
  id: Scalars["UUID"]["output"];
  renderAsCard: Scalars["Boolean"]["output"];
};

export type ApProductMeasurement = {
  __typename?: "ApProductMeasurement";
  createdAt: Scalars["DateTime"]["output"];
  heightMm: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  lengthMm: Scalars["Int"]["output"];
  sku: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  weightG: Scalars["Int"]["output"];
  widthMm: Scalars["Int"]["output"];
};

export type ApProductPriceManualOverride = {
  __typename?: "ApProductPriceManualOverride";
  createdAt: Scalars["DateTime"]["output"];
  createdBy: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  price: Money;
  sku: Scalars["String"]["output"];
  storeId: StoreId;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApProductPricesInput = {
  filter: ApProductPricesInputFilter;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<ProductPriceOrderBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApProductPricesInputFilter = {
  allProducts?: InputMaybe<Scalars["Boolean"]["input"]>;
  storeId: StoreId;
};

export type ApProductPricesResult = PageResponse & {
  __typename?: "ApProductPricesResult";
  items: Array<ProductPriceListEntry>;
  pagination: PaginationResponse;
};

export type ApProductSalesCampaign = {
  __typename?: "ApProductSalesCampaign";
  activeEndDate: Scalars["DateTime"]["output"];
  activeStartDate: Scalars["DateTime"]["output"];
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  /** Is the campaign active for any used store and product? */
  isActive: Scalars["Boolean"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  storeIds: Array<StoreId>;
  updateRequests: Array<ApProductSalesCampaignRequest>;
  updatedAt: Scalars["DateTime"]["output"];
  variants: Array<ApProductSalesCampaignProductVariant>;
};

export type ApProductSalesCampaignProductVariant = {
  __typename?: "ApProductSalesCampaignProductVariant";
  price?: Maybe<Scalars["Int"]["output"]>;
  product: ApProduct;
  productVariantId: Scalars["String"]["output"];
  storeProductVariants: Array<ApProductSalesCampaignStoreProductVariant>;
};

export type ApProductSalesCampaignRequest = {
  __typename?: "ApProductSalesCampaignRequest";
  approvedByUser?: Maybe<User>;
  createdAt: Scalars["DateTime"]["output"];
  deniedByUser?: Maybe<User>;
  deniedReason?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  requestedByUser?: Maybe<User>;
  shortId: Scalars["String"]["output"];
  updateInputJSON: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApProductSalesCampaignStoreProductVariant = {
  __typename?: "ApProductSalesCampaignStoreProductVariant";
  isExcluded: Scalars["Boolean"]["output"];
  price?: Maybe<Scalars["Int"]["output"]>;
  store: Store;
  storeProductVariantId: Scalars["String"]["output"];
};

export type ApProductSalesCampaignsListInput = {
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
};

export type ApProductSalesCampaignsListResponse = PageResponse & {
  __typename?: "ApProductSalesCampaignsListResponse";
  items: Array<ApProductSalesCampaign>;
  pagination: PaginationResponse;
};

export type ApProductTaxRate = {
  __typename?: "ApProductTaxRate";
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  productId: Scalars["UUID"]["output"];
  rate: Scalars["String"]["output"];
  storeId: StoreId;
  type: TaxRateType;
};

export type ApRecalculateInventoryInput = {
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  storeId?: InputMaybe<StoreId>;
};

export type ApRefundReturnItemInput = {
  addOperationProductId: Scalars["UUID"]["input"];
  hasRestockFeeApplied: Scalars["Boolean"]["input"];
  quantity: Scalars["NonNegativeInt"]["input"];
};

export type ApRejectReturnInput = {
  id: Scalars["UUID"]["input"];
};

export type ApRelatedProduct = {
  __typename?: "ApRelatedProduct";
  appearsInProducts: Array<ApProduct>;
  relatedProductCategory?: Maybe<ApRelatedProductCategory>;
};

export type ApRelatedProductCategory = {
  __typename?: "ApRelatedProductCategory";
  createdAt: Scalars["DateTime"]["output"];
  defaultTranslation: RelatedProductCategoryTranslation;
  id: Scalars["UUID"]["output"];
  products: Array<ApProduct>;
  translations: Array<RelatedProductCategoryTranslation>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApRelatedProductCategoryInput = {
  products: Array<Scalars["UUID"]["input"]>;
  translations: Array<ApRelatedProductCategoryTranslationInput>;
};

export type ApRelatedProductCategoryResponse = {
  __typename?: "ApRelatedProductCategoryResponse";
  relatedProductCategory: ApRelatedProductCategory;
};

export type ApRelatedProductCategoryTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  title: Scalars["TrimmedString"]["input"];
};

export type ApReorderCategoriesInput = {
  categoryIds: Array<Scalars["UUID"]["input"]>;
};

export type ApReorderCategoriesResponse = {
  __typename?: "ApReorderCategoriesResponse";
  categoryIds: Array<Scalars["UUID"]["output"]>;
};

export type ApReorderCategoryFiltersInput = {
  filterIds: Array<Scalars["UUID"]["input"]>;
};

export type ApReorderCategoryFiltersResponse = {
  __typename?: "ApReorderCategoryFiltersResponse";
  filterIds: Array<Scalars["UUID"]["output"]>;
};

export type ApReorderCategoryItemsInput = {
  categoryId: Scalars["UUID"]["input"];
  itemIds: Array<Scalars["UUID"]["input"]>;
};

export type ApReorderCategoryItemsResponse = {
  __typename?: "ApReorderCategoryItemsResponse";
  itemIds: Array<Scalars["UUID"]["output"]>;
};

export type ApReorderCategoryProductFiltersInput = {
  filterIds: Array<Scalars["UUID"]["input"]>;
};

export type ApReorderCategoryProductFiltersResponse = {
  __typename?: "ApReorderCategoryProductFiltersResponse";
  filterIds: Array<Scalars["UUID"]["output"]>;
};

export type ApReorderGalleryCategoriesInput = {
  categoryIds: Array<Scalars["UUID"]["input"]>;
};

export type ApReorderGalleryCategoriesResponse = {
  __typename?: "ApReorderGalleryCategoriesResponse";
  categoryIds: Array<Scalars["UUID"]["output"]>;
};

export type ApReorderProductFeaturesInput = {
  productFeatureIds: Array<Scalars["UUID"]["input"]>;
  productId: Scalars["UUID"]["input"];
};

export type ApReorderProductFeaturesResponse = {
  __typename?: "ApReorderProductFeaturesResponse";
  productFeatureIds: Array<Scalars["UUID"]["output"]>;
};

export type ApSetStoreProductListItemsInput = {
  items: Array<ApStoreProductListItemInput>;
  storeProductListId: Scalars["UUID"]["input"];
};

export type ApSetStoreProductListItemsResponse = {
  __typename?: "ApSetStoreProductListItemsResponse";
  items: Array<ApStoreProductListItem>;
};

export type ApShippingHeavyItem = {
  __typename?: "ApShippingHeavyItem";
  countries: Array<ApShippingHeavyItemCountry>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  productId: Scalars["UUID"]["output"];
  shippingPriceAmount: Scalars["NonNegativeInt"]["output"];
  storeId: StoreId;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApShippingHeavyItemCountry = {
  __typename?: "ApShippingHeavyItemCountry";
  country: CountryCode;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  shippingPriceAmount: Scalars["NonNegativeInt"]["output"];
  zoneCode?: Maybe<Scalars["String"]["output"]>;
};

export type ApSlugRedirect = {
  __typename?: "ApSlugRedirect";
  fromEntityType: SlugRedirectEntityType;
  fromSlug: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  storeId: StoreId;
  toEntityType: SlugRedirectEntityType;
  toSlug: Scalars["String"]["output"];
};

export type ApSlugRedirectCreateInput = {
  slugRedirects: Array<ApSlugRedirectInput>;
};

export type ApSlugRedirectCreateResponse = {
  __typename?: "ApSlugRedirectCreateResponse";
  slugRedirects: Array<ApSlugRedirect>;
};

export type ApSlugRedirectDeleteInput = {
  fromSlug: Scalars["TrimmedString"]["input"];
};

export type ApSlugRedirectDeleteResponse = {
  __typename?: "ApSlugRedirectDeleteResponse";
  fromSlug: Scalars["String"]["output"];
};

export type ApSlugRedirectInput = {
  fromEntityType: SlugRedirectEntityType;
  fromSlug: Scalars["TrimmedString"]["input"];
  storeId: StoreId;
  toEntityType: SlugRedirectEntityType;
  toSlug: Scalars["TrimmedString"]["input"];
};

export type ApSlugRedirectListInput = {
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApSlugRedirectListResponse = PageResponse & {
  __typename?: "ApSlugRedirectListResponse";
  items: Array<ApSlugRedirect>;
  pagination: PaginationResponse;
};

export type ApSlugRedirectResponse = {
  __typename?: "ApSlugRedirectResponse";
  fromSlug: Scalars["String"]["output"];
  slugRedirects: Array<ApSlugRedirect>;
};

export type ApSmartcatDeliveryError = {
  __typename?: "ApSmartcatDeliveryError";
  code: Scalars["Int"]["output"];
  content: Scalars["String"]["output"];
  created: Scalars["DateTime"]["output"];
  reason: Scalars["String"]["output"];
  sourceIds: Array<Scalars["String"]["output"]>;
  url: Scalars["String"]["output"];
};

export type ApSmartcatWebhookConfig = {
  __typename?: "ApSmartcatWebhookConfig";
  callbackUrl: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  enabled: Scalars["Boolean"]["output"];
  events: Array<SmartcatWebhookEvent>;
  id: Scalars["UUID"]["output"];
  label: Scalars["String"]["output"];
  projectId: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  /** Masked preview of the webhook secret (e.g. "ab12...ef56"). */
  webhookSecretPreview: Scalars["String"]["output"];
};

export type ApSmartcatWebhookConfigsResult = {
  __typename?: "ApSmartcatWebhookConfigsResult";
  configs: Array<ApSmartcatWebhookConfig>;
  /** Whether Smartcat integration is enabled for this environment. */
  enabled: Scalars["Boolean"]["output"];
};

export type ApSpecificationEntity = {
  __typename?: "ApSpecificationEntity";
  features: Array<ApSpecificationEntityFeature>;
  id: Scalars["UUID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  template?: Maybe<ApSpecificationTemplate>;
};

export type ApSpecificationEntityFeature = {
  __typename?: "ApSpecificationEntityFeature";
  /** Text value when valueType is text */
  defaultTranslation: ApSpecificationEntityFeatureTranslation;
  /** Section and feature are tied together for entity value */
  feature: ApSpecificationFeature;
  id: Scalars["UUID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  /** Section and feature are tied together for entity value */
  section: ApSpecificationSection;
  specificationEntityId: Scalars["UUID"]["output"];
  translations: Array<ApSpecificationEntityFeatureTranslation>;
  /** Flag value when valueType is flag */
  valueFlag?: Maybe<SpecificationSectionFeatureFlag>;
};

export type ApSpecificationEntityFeatureTranslation = Translation & {
  __typename?: "ApSpecificationEntityFeatureTranslation";
  language: Language;
  note?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type ApSpecificationFeature = {
  __typename?: "ApSpecificationFeature";
  defaultTranslation: ApSpecificationFeatureTranslation;
  icon?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  parentId?: Maybe<Scalars["UUID"]["output"]>;
  slug: Scalars["String"]["output"];
  templates: Array<Scalars["UUID"]["output"]>;
  translations: Array<ApSpecificationFeatureTranslation>;
  valueType: SpecificationSectionFeatureType;
};

export type ApSpecificationFeatureTranslation = Translation & {
  __typename?: "ApSpecificationFeatureTranslation";
  label?: Maybe<Scalars["String"]["output"]>;
  language: Language;
  note?: Maybe<Scalars["String"]["output"]>;
};

export type ApSpecificationSection = {
  __typename?: "ApSpecificationSection";
  defaultTranslation: ApSpecificationSectionTranslation;
  id: Scalars["UUID"]["output"];
  slug: Scalars["String"]["output"];
  templates: Array<Scalars["UUID"]["output"]>;
  translations: Array<ApSpecificationSectionTranslation>;
  type: SpecificationSectionType;
};

export type ApSpecificationSectionTranslation = Translation & {
  __typename?: "ApSpecificationSectionTranslation";
  label?: Maybe<Scalars["String"]["output"]>;
  language: Language;
};

export type ApSpecificationTemplate = {
  __typename?: "ApSpecificationTemplate";
  collections: Array<ApSpecificationTemplateCollection>;
  commentsCount: Scalars["Int"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  groupTag?: Maybe<Scalars["String"]["output"]>;
  hasSummary: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  products: Array<ApSpecificationTemplateProduct>;
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  usedSections: Array<ApUsedSpecificationTemplateSection>;
};

export type ApSpecificationTemplateCollection = {
  __typename?: "ApSpecificationTemplateCollection";
  id: Scalars["UUID"]["output"];
  slug: Scalars["String"]["output"];
};

export type ApSpecificationTemplateProduct = {
  __typename?: "ApSpecificationTemplateProduct";
  baseSku: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
};

export type ApStoreBankDetails = {
  __typename?: "ApStoreBankDetails";
  createdAt: Scalars["DateTime"]["output"];
  data: StoreBankDetailsData;
  id: Scalars["UUID"]["output"];
  storeId: StoreId;
  type: StoreBankDetailsType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApStoreDiscountBundleProductVariant = {
  __typename?: "ApStoreDiscountBundleProductVariant";
  fixedAmountCurrency?: Maybe<Currency>;
  fixedAmountPrice?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  productVariantId: Scalars["UUID"]["output"];
  storeId: StoreId;
};

export type ApStoreProductList = {
  __typename?: "ApStoreProductList";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  itemCount: Scalars["NonNegativeInt"]["output"];
  storeId: StoreId;
  type: StoreProductListType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApStoreProductListItem = {
  __typename?: "ApStoreProductListItem";
  baseSku: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  productId: Scalars["UUID"]["output"];
  storeProductListId: Scalars["UUID"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApStoreProductListItemInput = {
  productId: Scalars["UUID"]["input"];
};

export type ApStoreProductListItemsFilterInput = {
  storeProductListId: Scalars["UUID"]["input"];
};

export type ApStoreProductListItemsInput = {
  filter: ApStoreProductListItemsFilterInput;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
};

export type ApStoreProductListItemsResponse = PageResponse & {
  __typename?: "ApStoreProductListItemsResponse";
  items: Array<ApStoreProductListItem>;
  pagination: PaginationResponse;
};

export type ApStoreProductListsFilterInput = {
  storeId?: InputMaybe<StoreId>;
  type?: InputMaybe<StoreProductListType>;
};

export type ApStoreProductListsInput = {
  filter?: InputMaybe<ApStoreProductListsFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
};

export type ApStoreProductListsResponse = PageResponse & {
  __typename?: "ApStoreProductListsResponse";
  items: Array<ApStoreProductList>;
  pagination: PaginationResponse;
};

export type ApStorefrontProductVariantPartNumber = {
  __typename?: "ApStorefrontProductVariantPartNumber";
  createdAt: Scalars["DateTime"]["output"];
  partNumber: Scalars["String"]["output"];
  sku: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApStorefrontProductVariantPartNumberListInput = {
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  orderBy?: InputMaybe<Array<ApStorefrontProductVariantPartNumberOrderBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApStorefrontProductVariantPartNumberListResponse = {
  __typename?: "ApStorefrontProductVariantPartNumberListResponse";
  pagination: PaginationResponse;
  storefrontProductVariantPartNumbers: Array<ApStorefrontProductVariantPartNumber>;
};

export type ApStorefrontProductVariantPartNumberOrderBy = {
  key: ApStorefrontProductVariantPartNumberOrderByKey;
  order: SortOrder;
};

export enum ApStorefrontProductVariantPartNumberOrderByKey {
  CreatedAt = "CreatedAt",
  PartNumber = "PartNumber",
  Sku = "Sku",
  UpdatedAt = "UpdatedAt",
}

export type ApSyncCollectionSpecificationInput = {
  slug: Scalars["TrimmedString"]["input"];
  specificationEntity: ApSyncSpecificationEntityInput;
};

export type ApSyncFeatureInput = {
  icon?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  /**
   * Required for sync to correctly match relations.
   * They might be virtual id, but should match relation.
   * Remapped in sync logic
   */
  id: Scalars["UUID"]["input"];
  /**
   * Required for sync to correctly match relations.
   * They might be virtual id, but should match relation.
   * Remapped in sync logic
   */
  parentId?: InputMaybe<Scalars["UUID"]["input"]>;
  slug: Scalars["TrimmedString"]["input"];
  translations: Array<ApSyncSectionFeatureTranslationInput>;
  valueType: SpecificationSectionFeatureType;
};

export type ApSyncProductSpecificationInput = {
  baseSku: Scalars["TrimmedString"]["input"];
  specificationEntity: ApSyncSpecificationEntityInput;
};

export type ApSyncSectionFeatureTranslationInput = {
  label: Scalars["TrimmedString"]["input"];
  languageId: Scalars["UUID"]["input"];
  note?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApSyncSectionInput = {
  slug: Scalars["TrimmedString"]["input"];
  translations: Array<ApSyncSectionTranslationInput>;
  type: SpecificationSectionType;
};

export type ApSyncSectionTranslationInput = {
  label: Scalars["TrimmedString"]["input"];
  languageId: Scalars["UUID"]["input"];
};

export type ApSyncSpecificationEntityInput = {
  features: Array<ApSyncSpecificationEntitySectionFeatureInput>;
  isEnabled: Scalars["Boolean"]["input"];
  template?: InputMaybe<ApSyncSpecificationEntityTemplateInput>;
};

export type ApSyncSpecificationEntitySectionFeatureFeatureInput = {
  slug: Scalars["TrimmedString"]["input"];
};

export type ApSyncSpecificationEntitySectionFeatureInput = {
  feature: ApSyncSpecificationEntitySectionFeatureFeatureInput;
  isEnabled: Scalars["Boolean"]["input"];
  /** Tie value to section+feature */
  section: ApSyncSpecificationEntitySectionFeatureSectionInput;
  /** Text value when valueType is text */
  translations: Array<ApSyncSpecificationEntitySectionFeatureTranslationInput>;
  /** Flag value when valueType is flag */
  valueFlag?: InputMaybe<SpecificationSectionFeatureFlag>;
};

export type ApSyncSpecificationEntitySectionFeatureSectionInput = {
  slug: Scalars["TrimmedString"]["input"];
};

export type ApSyncSpecificationEntitySectionFeatureTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  note?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  value?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApSyncSpecificationEntityTemplateInput = {
  slug: Scalars["TrimmedString"]["input"];
};

export type ApSyncSpecificationInput = {
  collections: Array<ApSyncCollectionSpecificationInput>;
  /** When not provided, won't sync and will keep existing features */
  features?: InputMaybe<Array<ApSyncFeatureInput>>;
  products: Array<ApSyncProductSpecificationInput>;
  /** When not provided, won't sync and will keep existing sections */
  sections?: InputMaybe<Array<ApSyncSectionInput>>;
  /** When not provided, won't sync and will keep existing templates */
  templates?: InputMaybe<Array<ApSyncTemplateInput>>;
};

export type ApSyncTemplateInput = {
  groupTag?: InputMaybe<Scalars["String"]["input"]>;
  hasSummary: Scalars["Boolean"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  slug: Scalars["TrimmedString"]["input"];
  title: Scalars["TrimmedString"]["input"];
  usedSections: Array<ApSyncTemplateUsedSectionInput>;
};

export type ApSyncTemplateUsedFeatureFeatureInput = {
  slug: Scalars["TrimmedString"]["input"];
};

export type ApSyncTemplateUsedSectionInput = {
  section: ApSyncTemplateUsedSectionSectionInput;
  usedFeatures: Array<ApSyncTemplateUsedSectionUsedFeatureInput>;
};

export type ApSyncTemplateUsedSectionSectionInput = {
  slug: Scalars["TrimmedString"]["input"];
};

export type ApSyncTemplateUsedSectionUsedFeatureInput = {
  feature: ApSyncTemplateUsedFeatureFeatureInput;
  isEnabled: Scalars["Boolean"]["input"];
  isUsedInCompare: Scalars["Boolean"]["input"];
  isUsedInSpecification: Scalars["Boolean"]["input"];
  isUsedInSummary: Scalars["Boolean"]["input"];
  isUsedInSummaryAsTrueFlag: Scalars["Boolean"]["input"];
  valueTypeOverride?: InputMaybe<SpecificationSectionFeatureType>;
};

export type ApTagTemplate = {
  __typename?: "ApTagTemplate";
  createdAt: Scalars["DateTime"]["output"];
  description: Scalars["String"]["output"];
  entityType: TagTemplateEntityType;
  id: Scalars["UUID"]["output"];
  names: Array<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApTagTemplateListFilterInput = {
  entityType?: InputMaybe<TagTemplateEntityType>;
};

export type ApTagTemplateListInput = {
  filter?: InputMaybe<ApTagTemplateListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<ApTagTemplateOrderBy>>;
  /** Searches by tag names and description */
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApTagTemplateListResponse = PageResponse & {
  __typename?: "ApTagTemplateListResponse";
  items: Array<ApTagTemplate>;
  pagination: PaginationResponse;
};

export type ApTagTemplateOrderBy = {
  key: ApTagTemplateOrderByKey;
  order: SortOrder;
};

export enum ApTagTemplateOrderByKey {
  CreatedAt = "createdAt",
}

export type ApTariff = {
  __typename?: "ApTariff";
  activeFrom: Scalars["DateTime"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  productIds: Array<Scalars["UUID"]["output"]>;
  rate: Scalars["String"]["output"];
  storeId: StoreId;
  type: TariffType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApTariffInput = {
  id: Scalars["UUID"]["input"];
};

export type ApTariffListFilterInput = {
  stores?: InputMaybe<Array<StoreId>>;
};

export type ApTariffListInput = {
  filter?: InputMaybe<ApTariffListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
};

export type ApTariffListResponse = PageResponse & {
  __typename?: "ApTariffListResponse";
  items: Array<ApTariff>;
  pagination: PaginationResponse;
};

export type ApTaxExemptionEntitiesByStoreId = {
  __typename?: "ApTaxExemptionEntitiesByStoreId";
  regions: Array<CountryZone>;
  storeId: StoreId;
  taxExemptionEntities: Array<ApCustomerTaxExemptionEntity>;
};

export type ApTaxExemptionEntitiesByStoreIdResponse = {
  __typename?: "ApTaxExemptionEntitiesByStoreIdResponse";
  items: Array<ApTaxExemptionEntitiesByStoreId>;
};

export type ApTaxRate = {
  __typename?: "ApTaxRate";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  productIds: Array<Scalars["UUID"]["output"]>;
  rate: Scalars["String"]["output"];
  storeId: StoreId;
  type: TaxRateType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApTaxRateListFilterInput = {
  stores?: InputMaybe<Array<StoreId>>;
  type?: InputMaybe<TaxRateType>;
};

export type ApTaxRateListInput = {
  filter?: InputMaybe<ApTaxRateListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
};

export type ApTaxRateListResponse = PageResponse & {
  __typename?: "ApTaxRateListResponse";
  items: Array<ApTaxRate>;
  pagination: PaginationResponse;
};

export type ApTextblockTranslation = {
  __typename?: "ApTextblockTranslation";
  contentHtml: Scalars["String"]["output"];
  language: Language;
};

export type ApTextblockTranslationInput = {
  contentHtml: Scalars["TrimmedString"]["input"];
  languageId: Scalars["UUID"]["input"];
};

export type ApTransitionOrderDraftToOrderInput = {
  /** This will set the tax validation status to TaxIdValidationStatus.ForcedValid */
  forceTaxIdValidationSuccess: Scalars["Boolean"]["input"];
  id: Scalars["UUID"]["input"];
};

export type ApUpdateDiscountBundleProductInput = {
  discountBundleProductVariants: Array<ApUpdateDiscountBundleProductVariantInput>;
  productId: Scalars["UUID"]["input"];
};

export type ApUpdateDiscountBundleProductVariantInput = {
  fixedAmountCurrency: Currency;
  fixedAmountPrice: Scalars["NonNegativeInt"]["input"];
  productId: Scalars["UUID"]["input"];
  productVariantId: Scalars["UUID"]["input"];
  storeDiscountBundleProductVariants?: InputMaybe<
    Array<ApUpdateStoreDiscountBundleProductVariantInput>
  >;
};

export type ApUpdateGalleryItemInput = {
  galleryCategoryId?: InputMaybe<Scalars["UUID"]["input"]>;
  id: Scalars["UUID"]["input"];
  isHidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  translations: Array<ApGalleryItemTranslationInput>;
};

export type ApUpdateGalleryItemResponse = {
  __typename?: "ApUpdateGalleryItemResponse";
  id: Scalars["UUID"]["output"];
};

export type ApUpdateInventoryPolicyGlobalInput = {
  id: Scalars["UUID"]["input"];
  restockThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  visibleInventoryQty?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ApUpdateInventoryPolicyGlobalResponse = {
  __typename?: "ApUpdateInventoryPolicyGlobalResponse";
  inventoryPolicyGlobal: ApInventoryPolicyGlobal;
};

export type ApUpdateInventoryPolicyOverrideInput = {
  id: Scalars["UUID"]["input"];
  productIds: Array<Scalars["UUID"]["input"]>;
  restockThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  storeOverrides: Array<ApInventoryPolicyStoreOverrideInput>;
  title: Scalars["String"]["input"];
  visibleInventoryQty?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ApUpdateInventoryPolicyOverrideResponse = {
  __typename?: "ApUpdateInventoryPolicyOverrideResponse";
  inventoryPolicyOverride: ApInventoryPolicyOverride;
};

export type ApUpdateOrderAddressInput = {
  address: AddressInput;
  id: Scalars["UUID"]["input"];
  type: AddressUsageType;
};

export type ApUpdateOrderAddressResponse = {
  __typename?: "ApUpdateOrderAddressResponse";
  orderAddress: OrderAddressUnion;
};

export type ApUpdateOrderDraftInput = {
  billingAddress: AddressInput;
  cartItems: Array<ApOrderDraftCartItemInput>;
  discountCodeId?: InputMaybe<Scalars["UUID"]["input"]>;
  email: Scalars["TrimmedString"]["input"];
  expireDays?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  id: Scalars["UUID"]["input"];
  invoiceNote?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  sendConfirmationEmail: Scalars["Boolean"]["input"];
  shippingAddress: AddressInput;
  storeCarrierServiceId: Scalars["UUID"]["input"];
  storeShippingRateId: Scalars["UUID"]["input"];
};

export type ApUpdatePaymentProviderInput = {
  captureEnabled: Scalars["Boolean"]["input"];
  daysToKeepAuthorized?: InputMaybe<Scalars["Float"]["input"]>;
  id: Scalars["UUID"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  name: Scalars["TrimmedString"]["input"];
  type: PaymentProvider;
  webhookId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApUpdatePaymentProviderResponse = {
  __typename?: "ApUpdatePaymentProviderResponse";
  paymentProvider: ApPaymentProviderDetails;
};

export type ApUpdateProductCompatibilityInput = {
  id: Scalars["UUID"]["input"];
  noteMoveToBottom: Scalars["Boolean"]["input"];
  noteRequireCollectionSection: Scalars["Boolean"]["input"];
  /** Sort order is determined by the input order */
  productIds: Array<Scalars["UUID"]["input"]>;
  translations: Array<ApProductCompatibilityTranslationInput>;
};

export type ApUpdateProductCompatibilityResponse = {
  __typename?: "ApUpdateProductCompatibilityResponse";
  productCompatibility: ApProductCompatibility;
};

export type ApUpdateProductFaqsResponse = {
  __typename?: "ApUpdateProductFaqsResponse";
  productFaq: ApProductFaq;
};

export type ApUpdateProductFeatureInput = {
  canvasHeight: Scalars["Int"]["input"];
  canvasWidth: Scalars["Int"]["input"];
  dotX: Scalars["Float"]["input"];
  dotY: Scalars["Float"]["input"];
  id: Scalars["UUID"]["input"];
  lineRenderType: ProductFeatureLineRenderType;
  scale: Scalars["Float"]["input"];
  tooltipX: Scalars["Float"]["input"];
  tooltipY: Scalars["Float"]["input"];
  translateX: Scalars["Int"]["input"];
  translateY: Scalars["Int"]["input"];
  translations: Array<ProductFeatureTranslationInput>;
};

export type ApUpdateProductFeatureResponse = {
  __typename?: "ApUpdateProductFeatureResponse";
  productFeature: ApProductFeature;
};

export type ApUpdateProductInventoryInput = {
  id: Scalars["UUID"]["input"];
  quantityAdjustment: Scalars["Int"]["input"];
  sku: Scalars["TrimmedString"]["input"];
  warehouseId: Scalars["UUID"]["input"];
};

export type ApUpdateProductInventoryResponse = {
  __typename?: "ApUpdateProductInventoryResponse";
  product: ApProduct;
};

export type ApUpdateProductSalesCampaignInput = {
  activeEndDate: Scalars["DateTime"]["input"];
  activeStartDate: Scalars["DateTime"]["input"];
  id: Scalars["UUID"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  name: Scalars["TrimmedString"]["input"];
  productIds: Array<Scalars["UUID"]["input"]>;
  storeIds: Array<StoreId>;
  variants: Array<ApUpdateProductSalesCampaignVariantInput>;
};

export type ApUpdateProductSalesCampaignStoreProductVariantInput = {
  currency: Currency;
  isExcluded: Scalars["Boolean"]["input"];
  price?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  storeProductVariantId: Scalars["UUID"]["input"];
};

export type ApUpdateProductSalesCampaignVariantInput = {
  price?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  productVariantId: Scalars["UUID"]["input"];
  storeProductVariants: Array<ApUpdateProductSalesCampaignStoreProductVariantInput>;
};

export type ApUpdateRelatedProductCategoryInput = {
  data: ApRelatedProductCategoryInput;
  id: Scalars["UUID"]["input"];
};

export type ApUpdateSmartcatWebhookConfigInput = {
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  events?: InputMaybe<Array<SmartcatWebhookEvent>>;
  projectId: Scalars["TrimmedString"]["input"];
};

export type ApUpdateSpecificationFeatureInput = {
  icon?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  id: Scalars["UUID"]["input"];
  label: Scalars["TrimmedString"]["input"];
  note?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  valueType: SpecificationSectionFeatureType;
};

export type ApUpdateSpecificationSectionInput = {
  id: Scalars["UUID"]["input"];
  label: Scalars["TrimmedString"]["input"];
  type: SpecificationSectionType;
};

export type ApUpdateSpecificationTemplateInput = {
  collectionIds: Array<Scalars["UUID"]["input"]>;
  groupTag?: InputMaybe<Scalars["String"]["input"]>;
  hasSummary: Scalars["Boolean"]["input"];
  id: Scalars["UUID"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  productIds: Array<Scalars["UUID"]["input"]>;
  title: Scalars["TrimmedString"]["input"];
  usedSections: Array<ApUpdateUsedSpecificationTemplateSection>;
};

export type ApUpdateStoreDiscountBundleProductVariantInput = {
  fixedAmountCurrency?: InputMaybe<Currency>;
  fixedAmountPrice?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  storeId: StoreId;
};

export type ApUpdateStorefrontProductVariantPartNumberInput = {
  partNumber: Scalars["TrimmedString"]["input"];
  sku: Scalars["TrimmedString"]["input"];
};

export type ApUpdateTariffInput = {
  activeFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  id: Scalars["UUID"]["input"];
  name?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  productIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  rate?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApUpdateTariffResponse = {
  __typename?: "ApUpdateTariffResponse";
  tariff: ApTariff;
};

export type ApUpdateTaxRateInput = {
  id: Scalars["UUID"]["input"];
  name?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  productIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  rate?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  type?: InputMaybe<TaxRateType>;
};

export type ApUpdateTaxRateResponse = {
  __typename?: "ApUpdateTaxRateResponse";
  taxRate: ApTaxRate;
};

export type ApUpdateUpsellProductCategoryInput = {
  data: ApUpsellProductCategoryInput;
  id: Scalars["UUID"]["input"];
};

export type ApUpdateUsedSpecificationTemplateSection = {
  specificationSectionId: Scalars["UUID"]["input"];
  usedFeatures: Array<ApUpdateUsedSpecificationTemplateSectionFeature>;
};

export type ApUpdateUsedSpecificationTemplateSectionFeature = {
  id: Scalars["UUID"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  isUsedInCompare: Scalars["Boolean"]["input"];
  isUsedInSpecification: Scalars["Boolean"]["input"];
  isUsedInSummary: Scalars["Boolean"]["input"];
  isUsedInSummaryAsTrueFlag: Scalars["Boolean"]["input"];
  movedFromSectionId?: InputMaybe<Scalars["UUID"]["input"]>;
  valueTypeOverride?: InputMaybe<SpecificationSectionFeatureType>;
};

export type ApUploadProtectedAssetInput = {
  entityId: Scalars["UUID"]["input"];
  entityType: ProtectedAssetEntityType;
  file: Scalars["Upload"]["input"];
};

export type ApUploadProtectedAssetResponse = {
  __typename?: "ApUploadProtectedAssetResponse";
  protectedAsset: ProtectedAsset;
};

export type ApUpsellProduct = {
  __typename?: "ApUpsellProduct";
  alwaysUpsell: Scalars["Boolean"]["output"];
  appearsInProducts: Array<ApProduct>;
  upsellProductCategory?: Maybe<ApUpsellProductCategory>;
};

export type ApUpsellProductCategory = {
  __typename?: "ApUpsellProductCategory";
  createdAt: Scalars["DateTime"]["output"];
  defaultTranslation: UpsellProductCategoryTranslation;
  id: Scalars["UUID"]["output"];
  products: Array<ApProduct>;
  translations: Array<UpsellProductCategoryTranslation>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ApUpsellProductCategoryInput = {
  products: Array<Scalars["UUID"]["input"]>;
  translations: Array<ApUpsellProductCategoryTranslationInput>;
};

export type ApUpsellProductCategoryResponse = {
  __typename?: "ApUpsellProductCategoryResponse";
  upsellProductCategory: ApUpsellProductCategory;
};

export type ApUpsellProductCategoryTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  title: Scalars["TrimmedString"]["input"];
};

export type ApUpsertCategoryFilterInput = {
  dependsOnFilterId?: InputMaybe<Scalars["UUID"]["input"]>;
  filterType: CategoryFilterType;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  maxPostFix?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  measureUnit?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  productFilterIds: Array<Scalars["UUID"]["input"]>;
  showLabel: Scalars["Boolean"]["input"];
  slug: Scalars["TrimmedString"]["input"];
  translations: Array<ApCategoryFilterTranslationInput>;
};

export type ApUpsertCategoryFilterResponse = {
  __typename?: "ApUpsertCategoryFilterResponse";
  filter: ApCategoryFilter;
};

export type ApUpsertCategoryInput = {
  /** When hideAllCategory becomes true, optionally redirect `all-{slug}` to this target. */
  allCategoryRedirectTarget?: InputMaybe<ApCategorySlugRedirectTargetInput>;
  filterIds: Array<Scalars["UUID"]["input"]>;
  hideAllCategory: Scalars["Boolean"]["input"];
  hideFiltersAndSort: Scalars["Boolean"]["input"];
  hideInHeader: Scalars["Boolean"]["input"];
  hideSubItems: Scalars["Boolean"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isAccessories: Scalars["Boolean"]["input"];
  productLine: ProductLine;
  slug: Scalars["TrimmedString"]["input"];
  storeFilterIds: Array<Scalars["UUID"]["input"]>;
  storeIds: Array<StoreId>;
  storeOnly: Scalars["Boolean"]["input"];
  translations: Array<ApCategoryTranslationInput>;
};

export type ApUpsertCategoryItemInput = {
  categoryId: Scalars["UUID"]["input"];
  collectionIds: Array<Scalars["UUID"]["input"]>;
  enableProductGroupingStoreIds: Array<StoreId>;
  filterIds: Array<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  slug: Scalars["TrimmedString"]["input"];
  storeIds: Array<StoreId>;
  storeLabel?: InputMaybe<ApCategoryItemStoreLabelInput>;
  storeOnly: Scalars["Boolean"]["input"];
  translations: Array<ApCategoryItemTranslationInput>;
};

export type ApUpsertCategoryItemResponse = {
  __typename?: "ApUpsertCategoryItemResponse";
  item: ApCategoryItem;
};

export type ApUpsertCategoryProductFilterInput = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  slug: Scalars["TrimmedString"]["input"];
  translations: Array<ApCategoryProductFilterTranslationInput>;
};

export type ApUpsertCategoryProductFilterResponse = {
  __typename?: "ApUpsertCategoryProductFilterResponse";
  filter: ApCategoryProductFilter;
};

export type ApUpsertCategoryResponse = {
  __typename?: "ApUpsertCategoryResponse";
  category: ApCategory;
};

export type ApUpsertChinaBankDetailsInput = {
  accountHolderName: Scalars["TrimmedString"]["input"];
  accountNumber: Scalars["TrimmedString"]["input"];
  bankBranch?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  bankName: Scalars["TrimmedString"]["input"];
};

/** Create or update a customer tax exemption */
export type ApUpsertCustomerTaxExemptionInput = {
  countryCode?: InputMaybe<CountryCode>;
  customerId: Scalars["UUID"]["input"];
  customerTaxId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  note?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  /** Used when admin creates an already Active (approved) exemption manually */
  notifyCustomerOnManualCreate: Scalars["Boolean"]["input"];
  /** Values should match CountryZone.code */
  regionCode: Array<Scalars["TrimmedString"]["input"]>;
  rejectReason?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  status: TaxExemptionStatus;
  storeId: StoreId;
  taxExemptionEntity: TaxExemptionEntity;
};

export type ApUpsertCustomerTaxExemptionResponse = {
  __typename?: "ApUpsertCustomerTaxExemptionResponse";
  customerTaxExemption: ApCustomerTaxExemption;
};

export type ApUpsertGalleryCategoryInput = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  translations: Array<ApGalleryCategoryTranslationInput>;
};

export type ApUpsertGalleryCategoryResponse = {
  __typename?: "ApUpsertGalleryCategoryResponse";
  galleryCategory: ApGalleryCategory;
};

export type ApUpsertMockTaxIdValidationStatusesInput = {
  upsert: Array<MockTaxIUdValidationUpsertItem>;
};

export type ApUpsertMockTaxIdValidationStatusesResponse = {
  __typename?: "ApUpsertMockTaxIdValidationStatusesResponse";
  upserted: Array<TaxIdMockValidation>;
};

export type ApUpsertNoticeInput = {
  activeEndDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  activeStartDate: Scalars["DateTime"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isEnabled: Scalars["Boolean"]["input"];
  storeIds: Array<StoreId>;
  translations: Array<ApNoticeTranslationInput>;
  type?: InputMaybe<NoticeType>;
};

export type ApUpsertNoticeResponse = {
  __typename?: "ApUpsertNoticeResponse";
  notice: ApNotice;
};

export type ApUpsertProductPriceManualOverrideInput = {
  price: Scalars["NonNegativeInt"]["input"];
  sku: Scalars["UppercaseTrimmedString"]["input"];
  storeId: StoreId;
};

export type ApUpsertProductPriceManualOverrideResponse = {
  __typename?: "ApUpsertProductPriceManualOverrideResponse";
  override: ApProductPriceManualOverride;
};

export type ApUpsertProductSalesCampaignRequestInput = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  updateInput: ApUpdateProductSalesCampaignInput;
};

export type ApUpsertShippingHeavyItemCountryInput = {
  country: CountryCode;
  shippingPriceAmount: Scalars["NonNegativeInt"]["input"];
  zoneCode?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApUpsertShippingHeavyItemInput = {
  /** Will override all existing if non-nullish */
  countries?: InputMaybe<Array<ApUpsertShippingHeavyItemCountryInput>>;
  productId: Scalars["UUID"]["input"];
  shippingPriceAmount: Scalars["NonNegativeInt"]["input"];
  storeId: StoreId;
};

export type ApUpsertStoreBankDetailsInput = {
  chinaBankDetails?: InputMaybe<ApUpsertChinaBankDetailsInput>;
  storeId: StoreId;
  type: StoreBankDetailsType;
};

export type ApUpsertStoreBankDetailsResponse = {
  __typename?: "ApUpsertStoreBankDetailsResponse";
  storeBankDetails: ApStoreBankDetails;
};

export type ApUpsertStoreProductListInput = {
  isEnabled: Scalars["Boolean"]["input"];
  storeId: StoreId;
  type: StoreProductListType;
};

export type ApUpsertStoreProductListResponse = {
  __typename?: "ApUpsertStoreProductListResponse";
  storeProductList: ApStoreProductList;
};

export type ApUpsertTagTemplateInput = {
  description: Scalars["TrimmedString"]["input"];
  entityType: TagTemplateEntityType;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  names: Array<Scalars["TrimmedString"]["input"]>;
};

export type ApUpsertTagTemplateResponse = {
  __typename?: "ApUpsertTagTemplateResponse";
  apTagTemplate: ApTagTemplate;
};

export type ApUsedSpecificationTemplateFeature = {
  __typename?: "ApUsedSpecificationTemplateFeature";
  feature: ApSpecificationFeature;
  isEnabled: Scalars["Boolean"]["output"];
  isUsedInCompare: Scalars["Boolean"]["output"];
  isUsedInSpecification: Scalars["Boolean"]["output"];
  isUsedInSummary: Scalars["Boolean"]["output"];
  isUsedInSummaryAsTrueFlag: Scalars["Boolean"]["output"];
  valueTypeOverride?: Maybe<SpecificationSectionFeatureType>;
};

export type ApUsedSpecificationTemplateSection = {
  __typename?: "ApUsedSpecificationTemplateSection";
  section: ApSpecificationSection;
  usedFeatures: Array<ApUsedSpecificationTemplateFeature>;
};

export type ApVatValidationResult = {
  __typename?: "ApVatValidationResult";
  metadata?: Maybe<Scalars["JSONObject"]["output"]>;
  status: TaxIdValidationStatus;
};

export type ApiProductListFilterInput = {
  displayCurrency?: InputMaybe<Currency>;
  family?: InputMaybe<ProductFamily>;
  language: Scalars["LowercaseTrimmedString"]["input"];
  /** Defaults to true */
  returnInvisibleProducts?: InputMaybe<Scalars["Boolean"]["input"]>;
  skus?: InputMaybe<Array<Scalars["LowercaseTrimmedString"]["input"]>>;
  state?: InputMaybe<Array<ProductState>>;
  storeId: StoreId;
};

export type ApiProductListInput = {
  filter: ApiProductListFilterInput;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<ApiProductOrderBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ApiProductListResponse = PageResponse & {
  __typename?: "ApiProductListResponse";
  items: Array<StorefrontProduct>;
  pagination: PaginationResponse;
};

export type ApiProductOrderBy = {
  key: ApiProductOrderByKey;
  order: SortOrder;
};

export enum ApiProductOrderByKey {
  BaseSku = "baseSku",
  Family = "family",
  State = "state",
  Type = "type",
}

export type AppliedItemDiscount = {
  __typename?: "AppliedItemDiscount";
  mode: DiscountMode;
  /** The product of which the discount applies to */
  productId: Scalars["UUID"]["output"];
  quantity?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  /** The variant of which the discount applies to */
  storeProductVariantId: Scalars["UUID"]["output"];
  /** Pre tax discount total */
  total: Money;
  /** For hasTaxIncludedPrice checkouts, this will be present */
  totalWithTaxRate?: Maybe<Money>;
};

export type ArchiveProductInput = {
  id: Scalars["UUID"]["input"];
};

export type ArchiveProductResponse = {
  __typename?: "ArchiveProductResponse";
  product: ApProduct;
};

export type Asset = BaseAsset & {
  __typename?: "Asset";
  /** The alternative asset ID this asset links to (e.g., same angle in different color) */
  alternativeAssetId?: Maybe<Scalars["UUID"]["output"]>;
  childAssetType?: Maybe<AssetChildAssetType>;
  childAssets: Array<Asset>;
  createdAt: Scalars["DateTime"]["output"];
  filename: Scalars["String"]["output"];
  filenameOriginal: Scalars["String"]["output"];
  height: Scalars["Int"]["output"];
  id: Scalars["UUID"]["output"];
  md5Checksum: Scalars["String"]["output"];
  mimeType: Scalars["String"]["output"];
  parentAssetId?: Maybe<Scalars["UUID"]["output"]>;
  parentEmbedId?: Maybe<Scalars["UUID"]["output"]>;
  size: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  url: Scalars["String"]["output"];
  width: Scalars["Int"]["output"];
  zones: Array<AssetZone>;
};

export enum AssetChildAssetType {
  FullSize = "FullSize",
  Thumbnail = "Thumbnail",
}

export enum AssetEntityType {
  Category = "Category",
  Collection = "Collection",
  CollectionCategory = "CollectionCategory",
  Product = "Product",
}

export type AssetModelVariant = {
  __typename?: "AssetModelVariant";
  assetId: Scalars["UUID"]["output"];
  /** Camera FOV in degrees */
  cameraFov: Scalars["Float"]["output"];
  /** Vertical angle in degrees, default 75 */
  cameraPhi: Scalars["Int"]["output"];
  /** Camera distance in meters from the center of the object, default 0.5 */
  cameraRadius: Scalars["Float"]["output"];
  /** Horizontal angle in degrees, default 0 */
  cameraTheta: Scalars["Int"]["output"];
  /** The name of the glb file material */
  name: Scalars["String"]["output"];
  /** Exposure setting for the specific material */
  sceneBrightness: Scalars["Float"]["output"];
};

export type AssetZone = CategoryAssetZone | ProductAssetZone;

export enum AssetZoneEntityType {
  Categories = "categories",
  Products = "products",
}

export enum AssetZoneIconPosition {
  Center = "Center",
  Left = "Left",
  Right = "Right",
}

export type AvaTaxErrorReason = {
  __typename?: "AvaTaxErrorReason";
  /** Avalara given error */
  message: Scalars["String"]["output"];
  type: AvaTaxErrorType;
};

/**
 * https://help.avalara.com/Avalara_AvaTax_Update/Fix_transaction_import_errors
 * https://developer.avalara.com/avatax/common-errors
 */
export enum AvaTaxErrorType {
  /** The ZIP or postal code exists, but there aren't any streets that begin with the same letter in that ZIP or postal code. */
  AddressNoStreetError = "AddressNoStreetError",
  /** The address was found, but the street number was not between the low and high range of the post office database. */
  AddressRangeError = "AddressRangeError",
  /** An exact street name match could not be found. Phonetically matching the street name resulted in either no matches or matches to more than one street name. */
  AddressUnknownStreetError = "AddressUnknownStreetError",
  /** The city name or code isn't recognized. */
  CityError = "CityError",
  /** The company used in the transaction does not exist. */
  CompanyNotFoundError = "CompanyNotFoundError",
  /** The country name or code isn't recognized. */
  CountryError = "CountryError",
  /** The currency code is either invalid or missing. */
  CurrencyCodeError = "CurrencyCodeError",
  /** A date is missing or invalid. */
  DateError = "DateError",
  /** No jurisdictions were found for the destination address. */
  DestinationJurisdictionError = "DestinationJurisdictionError",
  /** The process code for a transaction you're trying to import is invalid. This often happens because a transaction with an identical doc code already exists. */
  DocStatusInvalid = "DocStatusInvalid",
  /** One or more line numbers are duplicates. */
  DuplicateLineNoError = "DuplicateLineNoError",
  /** The zip passed is not in this state. Please pass a zipcode that is in the state. */
  InvalidZipForStateError = "InvalidZipForStateError",
  /** Unable to determine the taxing jurisdictions. */
  JurisdictionNotFoundError = "JurisdictionNotFoundError",
  /** A field in the GetTax request exceeded exceeds its character limit. */
  LengthError = "LengthError",
  /** The physical location exists, but there are no homes on this street. One reason might be railroad tracks or rivers running alongside this street, as they would prevent construction of homes in this location. */
  NonDeliverableAddressError = "NonDeliverableAddressError",
  /** The ZIP or postal code doesn't exist or couldn't be determined for the city/municipality and state/province. This often happens when Excel removes a leading zero from ZIP or postal codes. */
  PostalCodeError = "PostalCodeError",
  /** A value of one field in the GetTax request was outside its required range. */
  RangeError = "RangeError",
  /** The two-digit code was not specified or was invalid. */
  RegionCodeError = "RegionCodeError",
  /** A required field is missing from the import template. */
  RequiredError = "RequiredError",
  /** SST requires an audit trail of the mapping of item codes (SKUs) to system tax codes. You have to put an item description if you are making it non-taxable. */
  SstItemError = "SSTItemError",
  /** An address is incomplete or invalid. */
  TaxAddressError = "TaxAddressError",
  /** The value of TaxIncluded—whether to include tax in the total sale amount for a line item—isn't valid due to some combination of caps, thresholds, base tax rules, or custom tax rules. */
  TaxIncludedError = "TaxIncludedError",
  /** A tax override is invalid or applied incorrectly. */
  TaxOverrideError = "TaxOverrideError",
  /** The tax region provided in the import file is incorrect. */
  TaxRegionError = "TaxRegionError",
  /** Committed transactions cannot be modified by this API. */
  TransactionIsCommitted = "TransactionIsCommitted",
  /** Custom type to catch all that are not specified */
  Unknown = "Unknown",
  /** Tax calculation cannot be determined. Zip is not valid for the state. */
  ZipNotValidError = "ZipNotValidError",
}

export type AvailabilityRequirement = Requirement & {
  __typename?: "AvailabilityRequirement";
  meetsRequirement: Scalars["Boolean"]["output"];
};

export enum AvailableRefundMethod {
  Admin = "Admin",
  Customer = "Customer",
}

export type AvailableStoreCarrierServicesInput = {
  carrierId?: InputMaybe<Scalars["UUID"]["input"]>;
  storeId: StoreId;
};

export enum BackInStockStatus {
  /** Subscribed to back in stock notifications */
  Pending = "Pending",
  /** Moved to email sender job queue */
  Sent = "Sent",
}

export type BackInStockSubscribedInput = {
  skus: Array<Scalars["TrimmedString"]["input"]>;
  storeId: StoreId;
};

export type BackInStockSubscribedResponse = {
  __typename?: "BackInStockSubscribedResponse";
  /** Customer can subscribe if logged in and satisfies product limits */
  canSubscribe: Scalars["Boolean"]["output"];
  isSubscribed: Scalars["Boolean"]["output"];
  sku: Scalars["String"]["output"];
  storeId: StoreId;
};

/**
 * Metadata for BadLoginError error to help frontends show actionable feedback to customer based on BadLoginError
 * Note: Not all BadLoginErrorCode will be passed to return url's
 */
export enum BadLoginErrorCode {
  /** Fallback code */
  Generic = "Generic",
  /** Invalid or unsupported redirect_uri */
  InvalidRedirectUri = "InvalidRedirectUri",
  /** Malformed request like invalid_grant or missing checks.state */
  MalformedRequest = "MalformedRequest",
  /** Missing some critical user data */
  MissingData = "MissingData",
  /** Not an Ubiquiti employee */
  NotUiEmployee = "NotUiEmployee",
  /** Customer not verified */
  NotVerified = "NotVerified",
  /** Received error from SSO */
  SsoError = "SsoError",
  /** Received error from SSO, act as warning */
  SsoWarning = "SsoWarning",
}

export type BankTransferInstructions = {
  __typename?: "BankTransferInstructions";
  data: BankTransferInstructionsData;
  id: Scalars["UUID"]["output"];
  reference?: Maybe<Scalars["String"]["output"]>;
  type: BankTransferType;
};

export type BankTransferInstructionsData =
  | ChinaBankInstructions
  | StripeAba
  | StripeIban
  | StripeSortCode
  | StripeSpei
  | StripeSwift
  | StripeZengin;

export enum BankTransferType {
  ChinaBank = "ChinaBank",
  StripeAba = "StripeAba",
  StripeIban = "StripeIban",
  StripeSortCode = "StripeSortCode",
  StripeSpei = "StripeSpei",
  StripeSwift = "StripeSwift",
  StripeZengin = "StripeZengin",
}

/** Base interface for all asset types with common fields */
export type BaseAsset = {
  childAssetType?: Maybe<AssetChildAssetType>;
  childAssets: Array<Asset>;
  createdAt: Scalars["DateTime"]["output"];
  filename: Scalars["String"]["output"];
  filenameOriginal: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  md5Checksum: Scalars["String"]["output"];
  mimeType: Scalars["String"]["output"];
  parentAssetId?: Maybe<Scalars["UUID"]["output"]>;
  parentEmbedId?: Maybe<Scalars["UUID"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  url: Scalars["String"]["output"];
};

export type Block = {
  __typename?: "Block";
  id: Scalars["UUID"]["output"];
  languageId: Scalars["UUID"]["output"];
  nodes: Array<BlockNode>;
};

export type BlockInput = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  nodes: Array<ApBlockNodeInput>;
};

export type BlockNode = {
  __typename?: "BlockNode";
  content: BlockNodeContent;
  id: Scalars["UUID"]["output"];
  languageId: Scalars["UUID"]["output"];
  parentNodeId?: Maybe<Scalars["UUID"]["output"]>;
};

/** BlockNode content */
export type BlockNodeContent = NodeTextblock;

/** BlockNode type */
export enum BlockNodeType {
  Textblock = "Textblock",
}

export type BundleDiscountRequirement =
  | AvailabilityRequirement
  | BundleQuantityRatioUsageRequirement
  | BundleQuantityUsageRequirement
  | LoginRequirement;

export type BundleQuantityRatioUsageRequirement = Requirement & {
  __typename?: "BundleQuantityRatioUsageRequirement";
  maxProductQty?: Maybe<Scalars["Int"]["output"]>;
  meetsRequirement: Scalars["Boolean"]["output"];
  parentRatio: Scalars["Int"]["output"];
  /** If maxProductQty is present. If null no limits, if int remaining redeems */
  remainingRedeemQty?: Maybe<Scalars["Int"]["output"]>;
};

export type BundleQuantityUsageRequirement = Requirement & {
  __typename?: "BundleQuantityUsageRequirement";
  maxProductQty?: Maybe<Scalars["Int"]["output"]>;
  meetsRequirement: Scalars["Boolean"]["output"];
  minProductQty: Scalars["Int"]["output"];
};

export type BusinessAddress = {
  additionalInfo?: Maybe<Scalars["String"]["output"]>;
  address1: Scalars["String"]["output"];
  address2?: Maybe<Scalars["String"]["output"]>;
  businessName?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  country: CountryCode;
  createdAt: Scalars["DateTime"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  lastName: Scalars["String"]["output"];
  neighborhood?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
  province?: Maybe<Scalars["String"]["output"]>;
  stateRegistrationNumber?: Maybe<Scalars["String"]["output"]>;
  taxId?: Maybe<Scalars["String"]["output"]>;
  type: AddressType;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum CalculatedInventoryIssuer {
  /** On order auto close */
  AutoClose = "AutoClose",
  /** On netsuite order cancel sync */
  Cancel = "Cancel",
  /** On custom checkout (order draft) creation/update */
  Checkout = "Checkout",
  /** On custom checkout (order draft) expiration */
  CheckoutAutoExpire = "CheckoutAutoExpire",
  /** On netsuite order close sync */
  Close = "Close",
  /** On netsuite order committed payload */
  Committed = "Committed",
  /** Custom made change. !!Not yet implemented!! */
  Custom = "Custom",
  /** On customer order cancel */
  CustomerCancel = "CustomerCancel",
  /** On netsuite inventory sync */
  Inventory = "Inventory",
  /** On manual inventory sync */
  Manual = "Manual",
  /** On manual order committed */
  ManualCommitted = "ManualCommitted",
  /** On order creation */
  Order = "Order",
  /** Recalculate inventory */
  Recalculate = "Recalculate",
  /** Inventory sync on refund restock */
  RefundRestockSync = "RefundRestockSync",
  /** Uncommitted item recalculation on refund restock */
  RefundRestockUncommitted = "RefundRestockUncommitted",
  /** On unpaid order reserved item release */
  UnpaidOrderReservedItemRelease = "UnpaidOrderReservedItemRelease",
}

export type CampaignDiscountMetadata = {
  __typename?: "CampaignDiscountMetadata";
  benefit: DiscountBenefit;
  meetsAllRequirements: Scalars["Boolean"]["output"];
  requirements: Array<CampaignDiscountRequirement>;
};

export type CampaignDiscountRequirement =
  | AvailabilityRequirement
  | CampaignQuantityUsageRequirement
  | LoginRequirement;

export type CampaignQuantityUsageRequirement = Requirement & {
  __typename?: "CampaignQuantityUsageRequirement";
  maxProductQty?: Maybe<Scalars["Int"]["output"]>;
  meetsRequirement: Scalars["Boolean"]["output"];
  minProductQty: Scalars["Int"]["output"];
  /** If maxProductQty is present. If null no limits, if int remaining redeems */
  remainingRedeemQty?: Maybe<Scalars["Int"]["output"]>;
};

export type CancelStorefrontOrderResponse = {
  __typename?: "CancelStorefrontOrderResponse";
  error?: Maybe<OrderCancelErrorCode>;
  success: Scalars["Boolean"]["output"];
};

export type CarrierServicesInput = {
  carrierType: ShippingCarrier;
  storeId: StoreId;
};

export type CarrierServicesResponse = {
  __typename?: "CarrierServicesResponse";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  type: ShippingMethodType;
};

export type CartItem = {
  quantity: Scalars["NonNegativeInt"]["input"];
  storeProductVariantId: Scalars["UUID"]["input"];
};

export type CategoriesResponse = {
  __typename?: "CategoriesResponse";
  categories: Array<Category>;
  filters: Array<CategoryFilterDefinition>;
  redirects: Array<CategoryRedirect>;
};

export type Category = {
  __typename?: "Category";
  /**
   * Inverse of DB store_ids: stores where this category should NOT appear.
   * Empty array means enabled for all stores.
   */
  disabledStores: Array<StoreId>;
  filterDependencies: Array<CategoryFilterDependency>;
  /** References CategoryFilterDefinition.slug (link_type = Filter) */
  filterSlugs: Array<Scalars["String"]["output"]>;
  /** When true, storefront should NOT generate the synthetic "all-{id}" subcategory. */
  hideAllCategory: Scalars["Boolean"]["output"];
  hideFiltersAndSort: Scalars["Boolean"]["output"];
  hideInHeader: Scalars["Boolean"]["output"];
  hideSubItems: Scalars["Boolean"]["output"];
  icon?: Maybe<CategoryIcon>;
  /** Unique slug identifier (not a UUID). Used as-is for storefront routing. */
  id: Scalars["String"]["output"];
  isAccessories: Scalars["Boolean"]["output"];
  items: Array<CategoryItem>;
  productLine: ProductLine;
  /** References CategoryFilterDefinition.slug (link_type = StoreFilter) */
  storeFilterSlugs: Array<Scalars["String"]["output"]>;
  storeOnly: Scalars["Boolean"]["output"];
  translations: Array<CategoryTranslation>;
};

export type CategoryAssetZone = {
  __typename?: "CategoryAssetZone";
  assetId: Scalars["UUID"]["output"];
  category: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  iconPosition: AssetZoneIconPosition;
  id: Scalars["UUID"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  x0: Scalars["Int"]["output"];
  x1: Scalars["Int"]["output"];
  y0: Scalars["Int"]["output"];
  y1: Scalars["Int"]["output"];
};

export type CategoryFilterDefinition = {
  __typename?: "CategoryFilterDefinition";
  /** References another CategoryFilterDefinition.slug that must be active before this filter is shown. */
  dependsOnFilterSlug?: Maybe<Scalars["String"]["output"]>;
  filterType: CategoryFilterType;
  maxPostFix?: Maybe<Scalars["String"]["output"]>;
  measureUnit?: Maybe<Scalars["String"]["output"]>;
  /** Ordered product filter slugs belonging to this filter group. */
  productFilterSlugs: Array<Scalars["String"]["output"]>;
  /** Product filters with translated labels. */
  productFilters: Array<CategoryFilterProductItem>;
  /** Whether the storefront should display the translated label as a group heading. */
  showLabel: Scalars["Boolean"]["output"];
  /** Unique slug identifier used as filter ID throughout storefront. */
  slug: Scalars["String"]["output"];
  translations: Array<CategoryTranslation>;
};

export type CategoryFilterDependency = {
  __typename?: "CategoryFilterDependency";
  /** Filter slugs that must be active before this filter is shown */
  dependsOnFilterSlugs: Array<Scalars["String"]["output"]>;
  /** References CategoryFilterDefinition.slug */
  filterSlug: Scalars["String"]["output"];
};

export type CategoryFilterProductItem = {
  __typename?: "CategoryFilterProductItem";
  slug: Scalars["String"]["output"];
  translations: Array<CategoryTranslation>;
};

export enum CategoryFilterType {
  Checkbox = "Checkbox",
  Radio = "Radio",
  RadioSlider = "RadioSlider",
  Slider = "Slider",
}

export type CategoryIcon = {
  __typename?: "CategoryIcon";
  height: Scalars["Int"]["output"];
  url: Scalars["String"]["output"];
  width: Scalars["Int"]["output"];
};

export type CategoryItem = {
  __typename?: "CategoryItem";
  collectionSlugs: Array<Scalars["String"]["output"]>;
  /**
   * Inverse of DB store_ids: stores where this item should NOT appear.
   * Empty array means enabled for all stores.
   */
  disabledStores: Array<StoreId>;
  /**
   * Store IDs where product grouping is enabled.
   * Empty array = disabled, populated = enabled for those stores.
   */
  enableProductGroupingStoreIds: Array<StoreId>;
  /** References CategoryFilterDefinition.slug */
  filterSlugs: Array<Scalars["String"]["output"]>;
  /** Unique slug identifier (not a UUID). Used as-is for storefront routing. */
  id: Scalars["String"]["output"];
  /**
   * Per-store label overrides. Each entry carries the same storeIds but a
   * different locale/label, keeping the JSON flat without nesting.
   */
  storeLabelTranslations: Array<CategoryItemStoreLabelTranslation>;
  storeOnly: Scalars["Boolean"]["output"];
  translations: Array<CategoryTranslation>;
};

export type CategoryItemStoreLabelTranslation = {
  __typename?: "CategoryItemStoreLabelTranslation";
  label: Scalars["String"]["output"];
  locale: Scalars["String"]["output"];
  storeIds: Array<StoreId>;
};

export type CategoryRedirect = {
  __typename?: "CategoryRedirect";
  from: Scalars["String"]["output"];
  to: Scalars["String"]["output"];
};

export enum CategorySlugRedirectEntityType {
  Category = "Category",
  CategoryItem = "CategoryItem",
}

export type CategoryTranslation = {
  __typename?: "CategoryTranslation";
  label: Scalars["String"]["output"];
  locale: Scalars["String"]["output"];
};

export type ChangeCustomerPreferencesInput = {
  acceptsMarketing?: InputMaybe<Scalars["Boolean"]["input"]>;
  locale?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ChangeCustomerPreferencesResponse = {
  __typename?: "ChangeCustomerPreferencesResponse";
  customer: Customer;
};

export type Checkout = {
  __typename?: "Checkout";
  abandonedEmailSentAt?: Maybe<Scalars["DateTime"]["output"]>;
  acceptsMarketing: Scalars["Boolean"]["output"];
  /** Could be the same as shipping address */
  billingAddress?: Maybe<CheckoutAddressUnion>;
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  customer?: Maybe<Customer>;
  discount?: Maybe<Discount>;
  discountCode?: Maybe<DiscountCode>;
  /** Not set until the information step */
  email?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  initiatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  items: Array<CheckoutItem>;
  language: Language;
  /** Completed checkout order */
  order?: Maybe<ApOrder>;
  /** Checkout secret for URL generation */
  secret: Scalars["String"]["output"];
  shippingAddress?: Maybe<CheckoutAddressUnion>;
  /** Virtual status based on the other fields */
  status?: Maybe<CheckoutStatus>;
  store: Store;
  updatedAt: Scalars["DateTime"]["output"];
};

export type CheckoutAddressUnion =
  | CheckoutBusinessAddress
  | CheckoutResidentialAddress;

export type CheckoutAllowedStep = {
  __typename?: "CheckoutAllowedStep";
  allowed: Scalars["Boolean"]["output"];
  step: CheckoutStep;
};

export type CheckoutBusinessAddress = BusinessAddress & {
  __typename?: "CheckoutBusinessAddress";
  additionalInfo?: Maybe<Scalars["String"]["output"]>;
  address1: Scalars["String"]["output"];
  address2?: Maybe<Scalars["String"]["output"]>;
  businessName?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  country: CountryCode;
  createdAt: Scalars["DateTime"]["output"];
  customerAddressId?: Maybe<Scalars["UUID"]["output"]>;
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  lastName: Scalars["String"]["output"];
  neighborhood?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
  province?: Maybe<Scalars["String"]["output"]>;
  referenceNumber?: Maybe<Scalars["String"]["output"]>;
  saveForFutureUse: Scalars["Boolean"]["output"];
  stateRegistrationNumber?: Maybe<Scalars["String"]["output"]>;
  taxId?: Maybe<Scalars["String"]["output"]>;
  type: AddressType;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum CheckoutErrorCode {
  /** Checkout already completed */
  CheckoutAlreadyCompleted = "CheckoutAlreadyCompleted",
}

export type CheckoutExternalItem = {
  __typename?: "CheckoutExternalItem";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  quantity: Scalars["NonNegativeInt"]["output"];
  sku: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type CheckoutExternalItemInput = {
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  quantity: Scalars["NonNegativeInt"]["input"];
  sku: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
};

export type CheckoutItem = {
  __typename?: "CheckoutItem";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  product: ApProduct;
  quantity: Scalars["NonNegativeInt"]["output"];
  sku: Scalars["String"]["output"];
  storeHistoryPrice: Money;
  storeProductVariant: StoreProductVariant;
  updatedAt: Scalars["DateTime"]["output"];
};

export type CheckoutListFilterInput = {
  emails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  excludeIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  ids?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  statuses?: InputMaybe<Array<CheckoutStatus>>;
  stores?: InputMaybe<Array<StoreId>>;
};

export type CheckoutListInput = {
  filter?: InputMaybe<CheckoutListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type CheckoutListResponse = PageResponse & {
  __typename?: "CheckoutListResponse";
  items: Array<Checkout>;
  pagination: PaginationResponse;
};

export type CheckoutResidentialAddress = ResidentialAddress & {
  __typename?: "CheckoutResidentialAddress";
  additionalInfo?: Maybe<Scalars["String"]["output"]>;
  address1: Scalars["String"]["output"];
  address2?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  country: CountryCode;
  createdAt: Scalars["DateTime"]["output"];
  customerAddressId?: Maybe<Scalars["UUID"]["output"]>;
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  lastName: Scalars["String"]["output"];
  neighborhood?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
  province?: Maybe<Scalars["String"]["output"]>;
  saveForFutureUse: Scalars["Boolean"]["output"];
  taxId?: Maybe<Scalars["String"]["output"]>;
  type: AddressType;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum CheckoutStatus {
  /** Checkout was abandoned */
  Abandoned = "Abandoned",
  /** Checkout is completed */
  Completed = "Completed",
  /** Essentially is a cart */
  Draft = "Draft",
  /** Checkout is initiated */
  Initiated = "Initiated",
}

export enum CheckoutStep {
  Cart = "Cart",
  Info = "Info",
  Login = "Login",
  Payment = "Payment",
  Shipping = "Shipping",
}

export type CheckoutTotals = {
  __typename?: "CheckoutTotals";
  isFree: Scalars["Boolean"]["output"];
  items: Totals;
  summary: Totals;
};

export type ChinaBankDetails = {
  __typename?: "ChinaBankDetails";
  accountHolderName: Scalars["String"]["output"];
  accountNumber: Scalars["String"]["output"];
  bankBranch?: Maybe<Scalars["String"]["output"]>;
  bankName: Scalars["String"]["output"];
  type: StoreBankDetailsType;
};

export type ChinaBankInstructions = {
  __typename?: "ChinaBankInstructions";
  accountHolderName: Scalars["String"]["output"];
  accountNumber: Scalars["String"]["output"];
  bankBranch?: Maybe<Scalars["String"]["output"]>;
  bankName: Scalars["String"]["output"];
  type: BankTransferType;
};

export type ClearOrderPayByInvoiceInput = {
  /** Order ID */
  id: Scalars["UUID"]["input"];
};

export type ClearOrderPayByInvoiceResponse = {
  __typename?: "ClearOrderPayByInvoiceResponse";
  /** Order ID */
  id: Scalars["UUID"]["output"];
};

export type Collection = {
  __typename?: "Collection";
  apGalleries: Array<ApGallery>;
  apSlugRedirects: Array<ApSlugRedirect>;
  categories: Array<ApCollectionCategory>;
  collectionSections: Array<ApCollectionSection>;
  createdAt: Scalars["DateTime"]["output"];
  defaultIsVisible: Scalars["Boolean"]["output"];
  defaultTranslation: CollectionTranslation;
  /** @deprecated Use apGalleries instead */
  galleries: Array<Gallery>;
  id: Scalars["UUID"]["output"];
  isDraft: Scalars["Boolean"]["output"];
  products: Array<ApProduct>;
  slug: Scalars["String"]["output"];
  sortBy: CollectionSort;
  specification?: Maybe<ApSpecificationEntity>;
  storeCollections: Array<StoreCollection>;
  tags: Array<CollectionTag>;
  totalProducts: Scalars["NonNegativeInt"]["output"];
  translations: Array<CollectionTranslation>;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum CollectionCategoryType {
  Enterprise = "Enterprise",
  Professional = "Professional",
  Starter = "Starter",
  UltraValue = "UltraValue",
}

export type CollectionListFilterInput = {
  ids?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by products that are in the look-up collection */
  products?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  slugs?: InputMaybe<Array<Scalars["LowercaseTrimmedString"]["input"]>>;
  stores?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type CollectionListInput = {
  filter?: InputMaybe<CollectionListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<CollectionOrderBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type CollectionListResponse = PageResponse & {
  __typename?: "CollectionListResponse";
  items: Array<Collection>;
  pagination: PaginationResponse;
};

export type CollectionOrderBy = {
  key: CollectionOrderByKey;
  order: SortOrder;
};

export enum CollectionOrderByKey {
  DefaultTranslation = "defaultTranslation",
  TotalProducts = "totalProducts",
  UpdatedAt = "updatedAt",
}

export type CollectionSection = {
  __typename?: "CollectionSection";
  id: Scalars["UUID"]["output"];
  productTags: Array<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
};

export type CollectionSectionTranslation = Translation & {
  __typename?: "CollectionSectionTranslation";
  language: Language;
  title?: Maybe<Scalars["String"]["output"]>;
};

export enum CollectionSort {
  AlphaAsc = "AlphaAsc",
  AlphaDesc = "AlphaDesc",
  Created = "Created",
  CreatedDesc = "CreatedDesc",
  Default = "Default",
  Inventory = "Inventory",
  Manual = "Manual",
  PriceAsc = "PriceAsc",
  PriceDesc = "PriceDesc",
}

export type CollectionTag = {
  __typename?: "CollectionTag";
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
};

export type CollectionTranslation = Translation & {
  __typename?: "CollectionTranslation";
  description?: Maybe<Scalars["String"]["output"]>;
  heroTitle?: Maybe<Scalars["String"]["output"]>;
  language: Language;
  seoDescription?: Maybe<Scalars["String"]["output"]>;
  seoTitle?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export enum CommentEntityType {
  Customers = "customers",
  Discounts = "discounts",
  OrderDrafts = "orderDrafts",
  Orders = "orders",
  ProductFaq = "productFaq",
  ProductSalesCampaigns = "productSalesCampaigns",
  Products = "products",
  Returns = "returns",
  SpecificationTemplates = "specificationTemplates",
}

/**
 * (Optional) If present, overrides the GlobalConfig.flags entry for the matching key.
 *
 * API will ensure that if some store has the flag on, then global flag will be ON. So global flag is essentially
 * `storesWithFeature.some((store) => store.isEnabled)`.
 *
 * Examples:
 * ✅ Feature enabled in all regions
 * {
 *   config: {
 *     global: {
 *       flags: [
 *         { key: "myFeature", isEnabled: true }
 *       ]
 *     },
 *     store: [
 *       // No store overrides
 *     ]
 *   }
 * }
 *
 * ✅ Feature enabled in some regions (e.g. EU-disabled)
 * {
 *   config: {
 *     global: {
 *       flags: [
 *         { key: "myFeature", isEnabled: true }
 *       ]
 *     },
 *     store: [{
 *       storeId: "eu",
 *       flags: [
 *         { key: "myFeature", isEnabled: false }
 *       ]
 *     }]
 *   }
 * }
 *
 * ✅ Feature not enable in any region
 * {
 *   config: {
 *     global: {
 *       flags: [
 *         { key: "myFeature", isEnabled: false }
 *       ]
 *     },
 *     store: [
 *       // No store overrides
 *     ]
 *   }
 * }
 *
 * ❌ Invalid response
 * {
 *   config: {
 *     global: {
 *       flags: [
 *         { key: "myFeature", isEnabled: false } // Invalid: global flag is false, but store flag is true
 *       ]
 *     },
 *     store: [
 *       {
 *         storeId: "us",
 *         flags: [{ key: "myFeature", isEnabled: true }]
 *       },
 *       {
 *         storeId: "eu",
 *         flags: [{ key: "myFeature", isEnabled: true }]
 *       }
 *     ]
 *   }
 * }
 *
 * 📦 Copy-pasteable implementation usage:
 * export const isFeatureFlagEnabled = (
 *   config: Config,
 *   featureKey: string,
 *   storeId?: StoreId,
 * ): boolean => {
 *   // 1. Prioritize store specific override, if provided
 *   const storeConfig = config.store.find((s) => s.storeId === storeId);
 *   const storeOverride = storeConfig
 *     ? storeConfig.flags.find((f) => f.key === featureKey)
 *     : undefined;
 *   if (storeOverride !== undefined) {
 *     return storeOverride.isEnabled;
 *   }
 *
 *   // 2. If no store-specific overrides, use global setting
 *   const globalConfig = config.global.flags.find((f) => f.key === featureKey);
 *   if (globalConfig !== undefined) {
 *     return globalConfig.isEnabled;
 *   }
 *
 *   //3. If feature flag is not found, return false by default
 *   return false;
 * };
 */
export type Config = {
  __typename?: "Config";
  global: GlobalConfig;
  store: Array<StoreConfig>;
};

export enum ContentManagerPermission {
  ActivityView = "ActivityView",
  BackInStockView = "BackInStockView",
  CategoryDelete = "CategoryDelete",
  CategoryEdit = "CategoryEdit",
  CategoryView = "CategoryView",
  CollectionCreate = "CollectionCreate",
  CollectionDelete = "CollectionDelete",
  CollectionEdit = "CollectionEdit",
  CollectionPublish = "CollectionPublish",
  CustomerEdit = "CustomerEdit",
  ExchangeRateView = "ExchangeRateView",
  LanguageCreate = "LanguageCreate",
  LanguageEdit = "LanguageEdit",
  NoticeDelete = "NoticeDelete",
  NoticeEdit = "NoticeEdit",
  NoticeView = "NoticeView",
  OptionCreate = "OptionCreate",
  OptionDelete = "OptionDelete",
  OptionEdit = "OptionEdit",
  OptionView = "OptionView",
  PaymentProviderView = "PaymentProviderView",
  ProductArchive = "ProductArchive",
  ProductCreate = "ProductCreate",
  ProductDelete = "ProductDelete",
  ProductEdit = "ProductEdit",
  ProductPublish = "ProductPublish",
  ProductSalesCampaignManage = "ProductSalesCampaignManage",
  ProductSalesCampaignView = "ProductSalesCampaignView",
  ReportView = "ReportView",
  SpecificationEdit = "SpecificationEdit",
  StoreSeoEdit = "StoreSeoEdit",
  StoreSeoView = "StoreSeoView",
  StorefrontProductVariantPartNumberEdit = "StorefrontProductVariantPartNumberEdit",
  StorefrontProductVariantPartNumberView = "StorefrontProductVariantPartNumberView",
  TagTemplateDelete = "TagTemplateDelete",
  TagTemplateEdit = "TagTemplateEdit",
  UserView = "UserView",
  WarehouseView = "WarehouseView",
}

/**
 * Non-geographical accurate list of available continents. Grouped by "most sense" for shipping zone configuration
 * purposes. Does not include Antarctica as we don't ship there.
 */
export enum ContinentCode {
  /** Africa */
  Africa = "Africa",
  /** Asia */
  Asia = "Asia",
  /** Central America */
  CentralAmerica = "CentralAmerica",
  /** Europe */
  Europe = "Europe",
  /** North America */
  NorthAmerica = "NorthAmerica",
  /** Australia/Oceania */
  Oceania = "Oceania",
  /**
   * Other - some territories such as "French Southern Territories" and "South Georgia & South Sandwich Islands" don't
   * belong to specific continent and we consider them as "Other"
   */
  Other = "Other",
  /** South America */
  SouthAmerica = "SouthAmerica",
}

export enum CookiePrefix {
  /**
   * Order payor access session
   * Example `order_payor_sid_<order_id>`
   */
  OrderPayorSid = "order_payor_sid_",
  /**
   * Order guest access session
   * Example `order_sid_<order_id>`
   */
  OrderSid = "order_sid_",
  /**
   * User session
   * Example `ui_store_sid_prod`
   */
  UiStoreSid = "ui_store_sid_",
}

export type Country = {
  __typename?: "Country";
  code: CountryCode;
  continent: ContinentCode;
  /** Human readable name for country */
  name: Scalars["String"]["output"];
  /** Phone number prefix without + */
  phoneNumberPrefix: Scalars["Int"]["output"];
  provinceKey: CountryProvinceKey;
  zones: Array<CountryZone>;
};

/** ISO 3166-1 alpha-2 */
export enum CountryCode {
  /** Andorra */
  Ad = "AD",
  /** United Arab Emirates */
  Ae = "AE",
  /** Afghanistan */
  Af = "AF",
  /** Antigua and Barbuda */
  Ag = "AG",
  /** Anguilla */
  Ai = "AI",
  /** Albania */
  Al = "AL",
  /** Armenia */
  Am = "AM",
  /** Netherlands Antilles */
  An = "AN",
  /** Angola */
  Ao = "AO",
  /** Antarctica */
  Aq = "AQ",
  /** Argentina */
  Ar = "AR",
  /** American Samoa */
  As = "AS",
  /** Austria */
  At = "AT",
  /** Australia */
  Au = "AU",
  /** Aruba */
  Aw = "AW",
  /** Åland Islands */
  Ax = "AX",
  /** Azerbaijan */
  Az = "AZ",
  /** Bosnia and Herzegovina */
  Ba = "BA",
  /** Barbados */
  Bb = "BB",
  /** Bangladesh */
  Bd = "BD",
  /** Belgium */
  Be = "BE",
  /** Burkina Faso */
  Bf = "BF",
  /** Bulgaria */
  Bg = "BG",
  /** Bahrain */
  Bh = "BH",
  /** Burundi */
  Bi = "BI",
  /** Benin */
  Bj = "BJ",
  /** Bermuda */
  Bm = "BM",
  /** Brunei Darussalam */
  Bn = "BN",
  /** Bolivia */
  Bo = "BO",
  /** Brazil */
  Br = "BR",
  /** Bahamas */
  Bs = "BS",
  /** Bhutan */
  Bt = "BT",
  /** Bouvet Island */
  Bv = "BV",
  /** Botswana */
  Bw = "BW",
  /** Belarus */
  By = "BY",
  /** Belize */
  Bz = "BZ",
  /** Canada */
  Ca = "CA",
  /** Cocos (Keeling) Islands */
  Cc = "CC",
  /** Congo, The Democratic Republic of the */
  Cd = "CD",
  /** Central African Republic */
  Cf = "CF",
  /** Congo */
  Cg = "CG",
  /** Switzerland */
  Ch = "CH",
  /** Cote D'Ivoire */
  Ci = "CI",
  /** Cook Islands */
  Ck = "CK",
  /** Chile */
  Cl = "CL",
  /** Cameroon */
  Cm = "CM",
  /** China */
  Cn = "CN",
  /** Colombia */
  Co = "CO",
  /** Costa Rica */
  Cr = "CR",
  /** Cuba */
  Cu = "CU",
  /** Cape Verde */
  Cv = "CV",
  /** Christmas Island */
  Cx = "CX",
  /** Cyprus */
  Cy = "CY",
  /** Czech Republic */
  Cz = "CZ",
  /** Germany */
  De = "DE",
  /** Djibouti */
  Dj = "DJ",
  /** Denmark */
  Dk = "DK",
  /** Dominica */
  Dm = "DM",
  /** Dominican Republic */
  Do = "DO",
  /** Algeria */
  Dz = "DZ",
  /** Ecuador */
  Ec = "EC",
  /** Estonia */
  Ee = "EE",
  /** Egypt */
  Eg = "EG",
  /** Western Sahara */
  Eh = "EH",
  /** Eritrea */
  Er = "ER",
  /** Spain */
  Es = "ES",
  /** Ethiopia */
  Et = "ET",
  /** Finland */
  Fi = "FI",
  /** Fiji */
  Fj = "FJ",
  /** Falkland Islands (Malvinas) */
  Fk = "FK",
  /** Micronesia, Federated States of */
  Fm = "FM",
  /** Faroe Islands */
  Fo = "FO",
  /** France */
  Fr = "FR",
  /** Gabon */
  Ga = "GA",
  /** United Kingdom */
  Gb = "GB",
  /** Grenada */
  Gd = "GD",
  /** Georgia */
  Ge = "GE",
  /** French Guiana */
  Gf = "GF",
  /** Guernsey */
  Gg = "GG",
  /** Ghana */
  Gh = "GH",
  /** Gibraltar */
  Gi = "GI",
  /** Greenland */
  Gl = "GL",
  /** Gambia */
  Gm = "GM",
  /** Guinea */
  Gn = "GN",
  /** Guadeloupe */
  Gp = "GP",
  /** Equatorial Guinea */
  Gq = "GQ",
  /** Greece */
  Gr = "GR",
  /** South Georgia and the South Sandwich Islands */
  Gs = "GS",
  /** Guatemala */
  Gt = "GT",
  /** Guam */
  Gu = "GU",
  /** Guinea-Bissau */
  Gw = "GW",
  /** Guyana */
  Gy = "GY",
  /** Hong Kong */
  Hk = "HK",
  /** Heard Island and Mcdonald Islands */
  Hm = "HM",
  /** Honduras */
  Hn = "HN",
  /** Croatia */
  Hr = "HR",
  /** Haiti */
  Ht = "HT",
  /** Hungary */
  Hu = "HU",
  /** Indonesia */
  Id = "ID",
  /** Ireland */
  Ie = "IE",
  /** Israel */
  Il = "IL",
  /** Isle of Man */
  Im = "IM",
  /** India */
  In = "IN",
  /** British Indian Ocean Territory */
  Io = "IO",
  /** Iraq */
  Iq = "IQ",
  /** Iran, Islamic Republic Of */
  Ir = "IR",
  /** Iceland */
  Is = "IS",
  /** Italy */
  It = "IT",
  /** Jersey */
  Je = "JE",
  /** Jamaica */
  Jm = "JM",
  /** Jordan */
  Jo = "JO",
  /** Japan */
  Jp = "JP",
  /** Kenya */
  Ke = "KE",
  /** Kyrgyzstan */
  Kg = "KG",
  /** Cambodia */
  Kh = "KH",
  /** Kiribati */
  Ki = "KI",
  /** Comoros */
  Km = "KM",
  /** Saint Kitts and Nevis */
  Kn = "KN",
  /** Korea, Democratic People'S Republic of */
  Kp = "KP",
  /** Korea, Republic of */
  Kr = "KR",
  /** Kuwait */
  Kw = "KW",
  /** Cayman Islands */
  Ky = "KY",
  /** Kazakhstan */
  Kz = "KZ",
  /** Lao People'S Democratic Republic */
  La = "LA",
  /** Lebanon */
  Lb = "LB",
  /** Saint Lucia */
  Lc = "LC",
  /** Liechtenstein */
  Li = "LI",
  /** Sri Lanka */
  Lk = "LK",
  /** Liberia */
  Lr = "LR",
  /** Lesotho */
  Ls = "LS",
  /** Lithuania */
  Lt = "LT",
  /** Luxembourg */
  Lu = "LU",
  /** Latvia */
  Lv = "LV",
  /** Libyan Arab Jamahiriya */
  Ly = "LY",
  /** Morocco */
  Ma = "MA",
  /** Monaco */
  Mc = "MC",
  /** Moldova, Republic of */
  Md = "MD",
  /** Montenegro */
  Me = "ME",
  /** Madagascar */
  Mg = "MG",
  /** Marshall Islands */
  Mh = "MH",
  /** Macedonia, The Former Yugoslav Republic of */
  Mk = "MK",
  /** Mali */
  Ml = "ML",
  /** Myanmar */
  Mm = "MM",
  /** Mongolia */
  Mn = "MN",
  /** Macao */
  Mo = "MO",
  /** Northern Mariana Islands */
  Mp = "MP",
  /** Martinique */
  Mq = "MQ",
  /** Mauritania */
  Mr = "MR",
  /** Montserrat */
  Ms = "MS",
  /** Malta */
  Mt = "MT",
  /** Mauritius */
  Mu = "MU",
  /** Maldives */
  Mv = "MV",
  /** Malawi */
  Mw = "MW",
  /** Mexico */
  Mx = "MX",
  /** Malaysia */
  My = "MY",
  /** Mozambique */
  Mz = "MZ",
  /** Namibia */
  Na = "NA",
  /** New Caledonia */
  Nc = "NC",
  /** Niger */
  Ne = "NE",
  /** Norfolk Island */
  Nf = "NF",
  /** Nigeria */
  Ng = "NG",
  /** Nicaragua */
  Ni = "NI",
  /** Netherlands */
  Nl = "NL",
  /** Norway */
  No = "NO",
  /** Nepal */
  Np = "NP",
  /** Nauru */
  Nr = "NR",
  /** Niue */
  Nu = "NU",
  /** New Zealand */
  Nz = "NZ",
  /** Oman */
  Om = "OM",
  /** Panama */
  Pa = "PA",
  /** Peru */
  Pe = "PE",
  /** French Polynesia */
  Pf = "PF",
  /** Papua New Guinea */
  Pg = "PG",
  /** Philippines */
  Ph = "PH",
  /** Pakistan */
  Pk = "PK",
  /** Poland */
  Pl = "PL",
  /** Saint Pierre and Miquelon */
  Pm = "PM",
  /** Pitcairn */
  Pn = "PN",
  /** Puerto Rico */
  Pr = "PR",
  /** Palestinian Territory, Occupied */
  Ps = "PS",
  /** Portugal */
  Pt = "PT",
  /** Palau */
  Pw = "PW",
  /** Paraguay */
  Py = "PY",
  /** Qatar */
  Qa = "QA",
  /** Reunion */
  Re = "RE",
  /** Romania */
  Ro = "RO",
  /** Serbia */
  Rs = "RS",
  /** Russian Federation */
  Ru = "RU",
  /** RWANDA */
  Rw = "RW",
  /** Saudi Arabia */
  Sa = "SA",
  /** Solomon Islands */
  Sb = "SB",
  /** Seychelles */
  Sc = "SC",
  /** Sudan */
  Sd = "SD",
  /** Sweden */
  Se = "SE",
  /** Singapore */
  Sg = "SG",
  /** Saint Helena */
  Sh = "SH",
  /** Slovenia */
  Si = "SI",
  /** Svalbard and Jan Mayen */
  Sj = "SJ",
  /** Slovakia */
  Sk = "SK",
  /** Sierra Leone */
  Sl = "SL",
  /** San Marino */
  Sm = "SM",
  /** Senegal */
  Sn = "SN",
  /** Somalia */
  So = "SO",
  /** Suriname */
  Sr = "SR",
  /** Sao Tome and Principe */
  St = "ST",
  /** El Salvador */
  Sv = "SV",
  /** Syrian Arab Republic */
  Sy = "SY",
  /** Swaziland */
  Sz = "SZ",
  /** Turks and Caicos Islands */
  Tc = "TC",
  /** Chad */
  Td = "TD",
  /** French Southern Territories */
  Tf = "TF",
  /** Togo */
  Tg = "TG",
  /** Thailand */
  Th = "TH",
  /** Tajikistan */
  Tj = "TJ",
  /** Tokelau */
  Tk = "TK",
  /** Timor-Leste */
  Tl = "TL",
  /** Turkmenistan */
  Tm = "TM",
  /** Tunisia */
  Tn = "TN",
  /** Tonga */
  To = "TO",
  /** Turkey */
  Tr = "TR",
  /** Trinidad and Tobago */
  Tt = "TT",
  /** Tuvalu */
  Tv = "TV",
  /** Taiwan, Province of China */
  Tw = "TW",
  /** Tanzania, United Republic of */
  Tz = "TZ",
  /** Ukraine */
  Ua = "UA",
  /** Uganda */
  Ug = "UG",
  /** United States Minor Outlying Islands */
  Um = "UM",
  /** United States */
  Us = "US",
  /** Uruguay */
  Uy = "UY",
  /** Uzbekistan */
  Uz = "UZ",
  /** Holy See (Vatican City State) */
  Va = "VA",
  /** Saint Vincent and the Grenadines */
  Vc = "VC",
  /** Venezuela */
  Ve = "VE",
  /** Virgin Islands, British */
  Vg = "VG",
  /** Virgin Islands, U.S. */
  Vi = "VI",
  /** Viet Nam */
  Vn = "VN",
  /** Vanuatu */
  Vu = "VU",
  /** Wallis and Futuna */
  Wf = "WF",
  /** Samoa */
  Ws = "WS",
  /** Kosovo */
  Xk = "XK",
  /** Yemen */
  Ye = "YE",
  /** Mayotte */
  Yt = "YT",
  /** South Africa */
  Za = "ZA",
  /** Zambia */
  Zm = "ZM",
  /** Zimbabwe */
  Zw = "ZW",
}

/** Describes naming type for provinces in countries */
export enum CountryProvinceKey {
  County = "County",
  Emirate = "Emirate",
  Governorate = "Governorate",
  Prefecture = "Prefecture",
  Province = "Province",
  Region = "Region",
  State = "State",
  StateAndTerritory = "StateAndTerritory",
}

export type CountryZone = {
  __typename?: "CountryZone";
  /** Zone code - pattern varies by country */
  code: Scalars["String"]["output"];
  /** Human readable name for zone */
  name: Scalars["String"]["output"];
};

export type CreateAndDownloadDatasheetPdfInput = {
  productId: Scalars["String"]["input"];
};

export type CreateAndDownloadDatasheetPdfResponse = {
  __typename?: "CreateAndDownloadDatasheetPdfResponse";
  errorCode?: Maybe<DatasheetPdfErrorCode>;
  pdfData?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
  timestamp?: Maybe<Scalars["String"]["output"]>;
};

export type CreateCollectionDraftInput = {
  name: Scalars["TrimmedString"]["input"];
};

export type CreateCollectionDraftResponse = {
  __typename?: "CreateCollectionDraftResponse";
  collection: Collection;
};

export type CreateCustomerAddressInput = {
  additionalInfo?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  address1: Scalars["TrimmedString"]["input"];
  address2?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  businessName?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  city: Scalars["TrimmedString"]["input"];
  country: CountryCode;
  firstName: Scalars["TrimmedString"]["input"];
  isAnyUsageType?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDefault: Scalars["Boolean"]["input"];
  lastName: Scalars["TrimmedString"]["input"];
  neighborhood?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  phoneNumber: Scalars["TrimmedString"]["input"];
  postalCode?: InputMaybe<Scalars["UppercaseTrimmedString"]["input"]>;
  province?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  stateRegistrationNumber?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  taxId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  type: AddressType;
  usageType: AddressUsageType;
};

export type CreateCustomerInput = {
  email: Scalars["EmailAddress"]["input"];
};

export type CreateCustomerPayByInvoiceMetadataInput = {
  contactEmail: Scalars["EmailAddress"]["input"];
  contactName: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  referenceNumber: Scalars["String"]["input"];
};

export type CreateCustomerResponse = {
  __typename?: "CreateCustomerResponse";
  customer: Customer;
};

export type CreateDiscountInput = {
  mode: DiscountMode;
};

export type CreateDiscountResponse = {
  __typename?: "CreateDiscountResponse";
  discount: Discount;
};

export type CreateEmbedInput = {
  entityId: Scalars["UUID"]["input"];
  entityType: EmbedEntityType;
  galleryCategoryId?: InputMaybe<Scalars["UUID"]["input"]>;
  galleryTag?: InputMaybe<GalleryTag>;
  galleryTranslations?: InputMaybe<Array<ApGalleryItemTranslationInput>>;
  isHidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  languageId?: InputMaybe<Scalars["UUID"]["input"]>;
  serviceId: Scalars["TrimmedString"]["input"];
  serviceType: ServiceType;
};

export type CreateEmbedResponse = {
  __typename?: "CreateEmbedResponse";
  embed: Embed;
};

export type CreateExchangeRateInput = {
  from: Currency;
  rate: Scalars["TrimmedString"]["input"];
  to: Currency;
};

export type CreateExchangeRateResponse = {
  __typename?: "CreateExchangeRateResponse";
  exchangeRate: ExchangeRate;
};

export type CreateIntegrationInput = {
  isEnabled: Scalars["Boolean"]["input"];
  name: Scalars["TrimmedString"]["input"];
  secret: Scalars["TrimmedString"]["input"];
};

export type CreateIntegrationResponse = {
  __typename?: "CreateIntegrationResponse";
  integration: ApIntegration;
};

export type CreateLanguageInput = {
  locale: Scalars["TrimmedString"]["input"];
  name: Scalars["TrimmedString"]["input"];
};

export type CreateLanguageResponse = {
  __typename?: "CreateLanguageResponse";
  language: Language;
};

export type CreateLimitationInput = {
  name: Scalars["TrimmedString"]["input"];
};

export type CreateLimitationResponse = {
  __typename?: "CreateLimitationResponse";
  limitation: Limitation;
};

export type CreateOptionInput = {
  slug: Scalars["TrimmedString"]["input"];
  translations: Array<CreateOptionTranslationInput>;
  values: Array<CreateOptionValueInput>;
};

export type CreateOptionResponse = {
  __typename?: "CreateOptionResponse";
  option: Option;
};

export type CreateOptionTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  title: Scalars["TrimmedString"]["input"];
};

export type CreateOptionValueInput = {
  slug: Scalars["TrimmedString"]["input"];
  translations: Array<CreateOptionTranslationInput>;
};

export type CreateOrderInput = {
  affiliateTransaction?: InputMaybe<AffiliateTransactionInput>;
  /** Indicates which platform the order was created from when it's created from a native app. */
  appPlatform?: InputMaybe<DeviceTokenPlatform>;
  checkoutId: Scalars["UUID"]["input"];
  checkoutSecret?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  /** Custom return url for redirect-based payment methods. Currently used only in cases when storefront is in embedded mode and we have to redirect user back to the page that the storefront is embedded in. */
  customReturnUrl?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  /** Session ID for Kount fraud assessment. */
  kountSessionId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  language?: InputMaybe<Scalars["LowercaseTrimmedString"]["input"]>;
  /** Used for non-customer invoice payments */
  payByInvoice?: InputMaybe<OrderPayByInvoiceInput>;
  paymentMethod?: InputMaybe<OrderTransactionPaymentMethod>;
  /** (optional) Specify which payment provider order will be attempted to paid with, fallback's to first (random-order) enabled store provider */
  paymentProviderId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  recaptchaToken?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type CreateOrderResponse = {
  __typename?: "CreateOrderResponse";
  email: Scalars["LowercaseTrimmedString"]["output"];
  id: Scalars["UUID"]["output"];
  orderNumber: Scalars["TrimmedString"]["output"];
  /** Not set when free order */
  paymentExpireAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Not set when free order */
  paymentId?: Maybe<Scalars["UUID"]["output"]>;
  /** Not set when free order */
  paymentProvider?: Maybe<PaymentProvider>;
  /**
   * Not set when free order
   * Only certain payment providers will return this field
   */
  paymentSecret?: Maybe<Scalars["String"]["output"]>;
  /**
   * Not set when free order
   * Set for providers which create an order-like entity first (instead of providing payment id right away).
   */
  providerOrderId?: Maybe<Scalars["String"]["output"]>;
  /**
   * Not set when free order
   * Will be empty for PaymentProvider=Paypal
   */
  providerPaymentId?: Maybe<Scalars["String"]["output"]>;
  /**
   * Not set when free order.
   * At the time of writing this, only PagBrasil payment provider will return this field.
   */
  providerPaymentLink?: Maybe<Scalars["String"]["output"]>;
  total: Money;
};

export type CreatePaymentProviderPaymentMethodInput = {
  accountId: Scalars["String"]["input"];
  paymentMethod: OrderTransactionPaymentMethod;
  paymentProviderId: Scalars["UUID"]["input"];
};

export type CreateProductBundleInput = {
  bundledProductIsStandalone: Scalars["Boolean"]["input"];
  bundledProductRatio: Scalars["NonNegativeInt"]["input"];
  bundledProductSku: Scalars["TrimmedString"]["input"];
  countries: Array<CountryCode>;
  productRatio: Scalars["NonNegativeInt"]["input"];
  productSku: Scalars["TrimmedString"]["input"];
  storeId: StoreId;
  strictMax: Scalars["Boolean"]["input"];
  strictMin: Scalars["Boolean"]["input"];
  syncAvailability: Scalars["Boolean"]["input"];
  translations?: InputMaybe<Array<ProductBundleTranslationInput>>;
};

export type CreateProductDocumentsInput = {
  name?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  productId: Scalars["UUID"]["input"];
  productVariantIds: Array<Scalars["UUID"]["input"]>;
  type: ProductDocumentType;
  url: Scalars["TrimmedString"]["input"];
};

export type CreateProductDocumentsResponse = {
  __typename?: "CreateProductDocumentsResponse";
  documents: Array<ProductDocument>;
};

export type CreateProductDraftInput = {
  baseSku: Scalars["TrimmedString"]["input"];
};

export type CreateProductDraftResponse = {
  __typename?: "CreateProductDraftResponse";
  product: ApProduct;
};

export type CreateProductRegionalLimitCountryInput = {
  countries: Array<ProductRegionalLimitCountryInput>;
  productRegionalLimitId: Scalars["UUID"]["input"];
};

export type CreateReturnAddress = {
  fields: AddressInput;
  options: CustomerAddressReferenceOptionInput;
};

export type CreateReturnInput = {
  /** In case of service product return, there might be no pickup address */
  address?: InputMaybe<CreateReturnAddress>;
  items: Array<CreateReturnInputItem>;
  orderId: Scalars["UUID"]["input"];
  reason: ReturnReason;
  reasonDescription?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  returnOption: ReturnOption;
};

export type CreateReturnInputItem = {
  addOperationProductId: Scalars["UUID"]["input"];
  quantity: Scalars["NonNegativeInt"]["input"];
};

export type CreateReturnResponse = {
  __typename?: "CreateReturnResponse";
  /** Was shipping label sent to customer */
  isLabelSent: Scalars["Boolean"]["output"];
  /** Do customer need to send products */
  isShipmentRequired: Scalars["Boolean"]["output"];
  orderReturn: OrderReturn;
};

export type CreateSearchResultActionInput = {
  productId: Scalars["UUID"]["input"];
  searchTerm: Scalars["LowercaseTrimmedString"]["input"];
  storeId: StoreId;
  type: ProductSearchResultActionType;
};

export type CreateStoreCarrierInput = {
  accountNumber: Scalars["TrimmedString"]["input"];
  apiKey: Scalars["TrimmedString"]["input"];
  apiSecret: Scalars["TrimmedString"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  name: Scalars["TrimmedString"]["input"];
  services: Array<StoreCarrierServiceInput>;
  storeId: StoreId;
  type: ShippingCarrier;
  upsLicenseNumber?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type CreateStoreCarrierResponse = {
  __typename?: "CreateStoreCarrierResponse";
  carrier: StoreCarrier;
};

export type CreateStoreShippingRateInput = {
  customMaxPrice?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  customMinPrice?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  customRateName?: InputMaybe<Scalars["String"]["input"]>;
  customRatePrice?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  isApOnly: Scalars["Boolean"]["input"];
  isBusinessTypeRate: Scalars["Boolean"]["input"];
  isResidentialTypeRate: Scalars["Boolean"]["input"];
  storeCarrierId: Scalars["UUID"]["input"];
  storeCarrierServiceId?: InputMaybe<Scalars["UUID"]["input"]>;
  storeId: StoreId;
  storeShippingZoneId: Scalars["UUID"]["input"];
  type: StoreShippingRateType;
};

export type CreateStoreShippingRateResponse = {
  __typename?: "CreateStoreShippingRateResponse";
  storeShippingRate: StoreShippingRateUnion;
};

export type CreateStoreShippingZoneInput = {
  name: Scalars["String"]["input"];
  storeId: StoreId;
  zones: Array<StoreShippingZoneCountryInput>;
};

export type CreateStoreShippingZoneResponse = {
  __typename?: "CreateStoreShippingZoneResponse";
  storeShippingZone: StoreShippingZone;
};

export type CreateUserInput = {
  email: Scalars["EmailAddress"]["input"];
};

export type CreateUserResponse = {
  __typename?: "CreateUserResponse";
  user: User;
};

export type CreateWarehouseInput = {
  address1: Scalars["TrimmedString"]["input"];
  address2?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  attentionName: Scalars["TrimmedString"]["input"];
  city: Scalars["TrimmedString"]["input"];
  country: CountryCode;
  email: Scalars["EmailAddress"]["input"];
  name: Scalars["TrimmedString"]["input"];
  netsuiteId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  postalCode?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  province?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  storeId: StoreId;
};

export type CreateWarehouseResponse = {
  __typename?: "CreateWarehouseResponse";
  warehouse: Warehouse;
};

export type CreateWishlistInput = {
  /** Defaults to false. Max 1 default per customer+store. */
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Defaults to false. */
  isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["TrimmedString"]["input"];
  storeId: StoreId;
};

/** ISO 4217 */
export enum Currency {
  /** United Arab Emirates Dirham */
  Aed = "AED",
  /** Afghanistan Afghani */
  Afn = "AFN",
  /** Albania Lek */
  All = "ALL",
  /** Armenia Dram */
  Amd = "AMD",
  /** Netherlands Antilles Guilder */
  Ang = "ANG",
  /** Angola Kwanza */
  Aoa = "AOA",
  /** Argentina Peso */
  Ars = "ARS",
  /** Australia Dollar */
  Aud = "AUD",
  /** Aruba Guilder */
  Awg = "AWG",
  /** Azerbaijan New Manat */
  Azn = "AZN",
  /** Bosnia and Herzegovina Convertible Marka */
  Bam = "BAM",
  /** Barbados Dollar */
  Bbd = "BBD",
  /** Bangladesh Taka */
  Bdt = "BDT",
  /** Bulgaria Lev */
  Bgn = "BGN",
  /** Bahrain Dinar */
  Bhd = "BHD",
  /** Burundi Franc */
  Bif = "BIF",
  /** Bermuda Dollar */
  Bmd = "BMD",
  /** Brunei Darussalam Dollar */
  Bnd = "BND",
  /** Bolivia Bolíviano */
  Bob = "BOB",
  /** Brazil Real */
  Brl = "BRL",
  /** Bahamas Dollar */
  Bsd = "BSD",
  /** Bhutan Ngultrum */
  Btn = "BTN",
  /** Botswana Pula */
  Bwp = "BWP",
  /** Belarus Ruble */
  Byr = "BYR",
  /** Belize Dollar */
  Bzd = "BZD",
  /** Canada Dollar */
  Cad = "CAD",
  /** Congo/Kinshasa Franc */
  Cdf = "CDF",
  /** Switzerland Franc */
  Chf = "CHF",
  /** Chile Peso */
  Clp = "CLP",
  /** China Yuan Renminbi */
  Cny = "CNY",
  /** Colombia Peso */
  Cop = "COP",
  /** Costa Rica Colon */
  Crc = "CRC",
  /** Cuba Convertible Peso */
  Cuc = "CUC",
  /** Cuba Peso */
  Cup = "CUP",
  /** Cape Verde Escudo */
  Cve = "CVE",
  /** Czech Republic Koruna */
  Czk = "CZK",
  /** Djibouti Franc */
  Djf = "DJF",
  /** Denmark Krone */
  Dkk = "DKK",
  /** Dominican Republic Peso */
  Dop = "DOP",
  /** Algeria Dinar */
  Dzd = "DZD",
  /** Egypt Pound */
  Egp = "EGP",
  /** Eritrea Nakfa */
  Ern = "ERN",
  /** Ethiopia Birr */
  Etb = "ETB",
  /** Euro Member Countries */
  Eur = "EUR",
  /** Fiji Dollar */
  Fjd = "FJD",
  /** Falkland Islands (Malvinas) Pound */
  Fkp = "FKP",
  /** United Kingdom Pound */
  Gbp = "GBP",
  /** Georgia Lari */
  Gel = "GEL",
  /** Guernsey Pound */
  Ggp = "GGP",
  /** Ghana Cedi */
  Ghs = "GHS",
  /** Gibraltar Pound */
  Gip = "GIP",
  /** Gambia Dalasi */
  Gmd = "GMD",
  /** Guinea Franc */
  Gnf = "GNF",
  /** Guatemala Quetzal */
  Gtq = "GTQ",
  /** Guyana Dollar */
  Gyd = "GYD",
  /** Hong Kong Dollar */
  Hkd = "HKD",
  /** Honduras Lempira */
  Hnl = "HNL",
  /** Croatia Kuna */
  Hrk = "HRK",
  /** Haiti Gourde */
  Htg = "HTG",
  /** Hungary Forint */
  Huf = "HUF",
  /** Indonesia Rupiah */
  Idr = "IDR",
  /** Israel Shekel */
  Ils = "ILS",
  /** Isle of Man Pound */
  Imp = "IMP",
  /** India Rupee */
  Inr = "INR",
  /** Iraq Dinar */
  Iqd = "IQD",
  /** Iran Rial */
  Irr = "IRR",
  /** Iceland Krona */
  Isk = "ISK",
  /** Jersey Pound */
  Jep = "JEP",
  /** Jamaica Dollar */
  Jmd = "JMD",
  /** Jordan Dinar */
  Jod = "JOD",
  /** Japan Yen */
  Jpy = "JPY",
  /** Kenya Shilling */
  Kes = "KES",
  /** Kyrgyzstan Som */
  Kgs = "KGS",
  /** Cambodia Riel */
  Khr = "KHR",
  /** Comoros Franc */
  Kmf = "KMF",
  /** Korea (North) Won */
  Kpw = "KPW",
  /** Korea (South) Won */
  Krw = "KRW",
  /** Kuwait Dinar */
  Kwd = "KWD",
  /** Cayman Islands Dollar */
  Kyd = "KYD",
  /** Kazakhstan Tenge */
  Kzt = "KZT",
  /** Laos Kip */
  Lak = "LAK",
  /** Lebanon Pound */
  Lbp = "LBP",
  /** Sri Lanka Rupee */
  Lkr = "LKR",
  /** Liberia Dollar */
  Lrd = "LRD",
  /** Lesotho Loti */
  Lsl = "LSL",
  /** Libya Dinar */
  Lyd = "LYD",
  /** Morocco Dirham */
  Mad = "MAD",
  /** Moldova Leu */
  Mdl = "MDL",
  /** Madagascar Ariary */
  Mga = "MGA",
  /** Macedonia Denar */
  Mkd = "MKD",
  /** Myanmar (Burma) Kyat */
  Mmk = "MMK",
  /** Mongolia Tughrik */
  Mnt = "MNT",
  /** Macau Pataca */
  Mop = "MOP",
  /** Mauritania Ouguiya */
  Mro = "MRO",
  /** Mauritius Rupee */
  Mur = "MUR",
  /** Maldives (Maldive Islands) Rufiyaa */
  Mvr = "MVR",
  /** Malawi Kwacha */
  Mwk = "MWK",
  /** Mexico Peso */
  Mxn = "MXN",
  /** Malaysia Ringgit */
  Myr = "MYR",
  /** Mozambique Metical */
  Mzn = "MZN",
  /** Namibia Dollar */
  Nad = "NAD",
  /** Nigeria Naira */
  Ngn = "NGN",
  /** Nicaragua Cordoba */
  Nio = "NIO",
  /** Norway Krone */
  Nok = "NOK",
  /** Nepal Rupee */
  Npr = "NPR",
  /** New Zealand Dollar */
  Nzd = "NZD",
  /** Oman Rial */
  Omr = "OMR",
  /** Panama Balboa */
  Pab = "PAB",
  /** Peru Sol */
  Pen = "PEN",
  /** Papua New Guinea Kina */
  Pgk = "PGK",
  /** Philippines Peso */
  Php = "PHP",
  /** Pakistan Rupee */
  Pkr = "PKR",
  /** Poland Zloty */
  Pln = "PLN",
  /** Paraguay Guarani */
  Pyg = "PYG",
  /** Qatar Riyal */
  Qar = "QAR",
  /** Romania New Leu */
  Ron = "RON",
  /** Serbia Dinar */
  Rsd = "RSD",
  /** Russia Ruble */
  Rub = "RUB",
  /** Rwanda Franc */
  Rwf = "RWF",
  /** Saudi Arabia Riyal */
  Sar = "SAR",
  /** Solomon Islands Dollar */
  Sbd = "SBD",
  /** Seychelles Rupee */
  Scr = "SCR",
  /** Sudan Pound */
  Sdg = "SDG",
  /** Sweden Krona */
  Sek = "SEK",
  /** Singapore Dollar */
  Sgd = "SGD",
  /** Saint Helena Pound */
  Shp = "SHP",
  /** Sierra Leone Leone */
  Sll = "SLL",
  /** Somalia Shilling */
  Sos = "SOS",
  /** Seborga Luigino */
  Spl = "SPL",
  /** Suriname Dollar */
  Srd = "SRD",
  /** São Tomé and Príncipe Dobra */
  Std = "STD",
  /** El Salvador Colon */
  Svc = "SVC",
  /** Syria Pound */
  Syp = "SYP",
  /** Swaziland Lilangeni */
  Szl = "SZL",
  /** Thailand Baht */
  Thb = "THB",
  /** Tajikistan Somoni */
  Tjs = "TJS",
  /** Turkmenistan Manat */
  Tmt = "TMT",
  /** Tunisia Dinar */
  Tnd = "TND",
  /** Tonga Pa'anga */
  Top = "TOP",
  /** Turkey Lira */
  Try = "TRY",
  /** Trinidad and Tobago Dollar */
  Ttd = "TTD",
  /** Tuvalu Dollar */
  Tvd = "TVD",
  /** Taiwan New Dollar */
  Twd = "TWD",
  /** Tanzania Shilling */
  Tzs = "TZS",
  /** Ukraine Hryvnia */
  Uah = "UAH",
  /** Uganda Shilling */
  Ugx = "UGX",
  /** United States Dollar */
  Usd = "USD",
  /** Uruguay Peso */
  Uyu = "UYU",
  /** Uzbekistan Som */
  Uzs = "UZS",
  /** Venezuela Bolivar */
  Vef = "VEF",
  /** Viet Nam Dong */
  Vnd = "VND",
  /** Vanuatu Vatu */
  Vuv = "VUV",
  /** Samoa Tala */
  Wst = "WST",
  /** Communauté Financière Africaine (BEAC) CFA Franc BEAC */
  Xaf = "XAF",
  /** East Caribbean Dollar */
  Xcd = "XCD",
  /** International Monetary Fund (IMF) Special Drawing Rights */
  Xdr = "XDR",
  /** Communauté Financière Africaine (BCEAO) Franc */
  Xof = "XOF",
  /** Comptoirs Français du Pacifique (CFP) Franc */
  Xpf = "XPF",
  /** Yemen Rial */
  Yer = "YER",
  /** South Africa Rand */
  Zar = "ZAR",
  /** Zambia Kwacha */
  Zmw = "ZMW",
  /** Zimbabwe Dollar */
  Zwd = "ZWD",
}

export type CustomStoreShippingRate = {
  __typename?: "CustomStoreShippingRate";
  id: Scalars["UUID"]["output"];
  isApOnly: Scalars["Boolean"]["output"];
  isBusinessTypeRate: Scalars["Boolean"]["output"];
  isResidentialTypeRate: Scalars["Boolean"]["output"];
  maxPrice?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  minPrice: Scalars["NonNegativeInt"]["output"];
  name: Scalars["String"]["output"];
  ratePrice: Scalars["NonNegativeInt"]["output"];
  storeCarrier: StoreCarrier;
  storeCarrierService: StoreCarrierService;
  type: StoreShippingRateType;
};

export type Customer = {
  __typename?: "Customer";
  acceptsMarketing: Scalars["Boolean"]["output"];
  activeCheckouts: Array<ActiveCheckout>;
  activeStoreCheckout?: Maybe<ActiveCheckout>;
  additionalPaymentMethods: Array<CustomerAdditionalPaymentMethod>;
  addresses: Array<CustomerAddressUnion>;
  createdAt: Scalars["DateTime"]["output"];
  /**
   * Dynamic property that attempts to return the customer's full name.
   * In the case it doesn't exist fallbacks to username and then email.
   * firstName + lastName | username | email (for guests)
   */
  displayName: Scalars["String"]["output"];
  email: Scalars["EmailAddress"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** Indicates that this customer has at least one disputed payment */
  hasDisputes: Scalars["Boolean"]["output"];
  hasEarlyAccess: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  insights?: Maybe<CustomerInsights>;
  isDeactivated: Scalars["Boolean"]["output"];
  isGuest: Scalars["Boolean"]["output"];
  lastKnownIp?: Maybe<Scalars["String"]["output"]>;
  lastLogoutAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  lastOnlineAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Locale used for app */
  locale?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  picture?: Maybe<Scalars["String"]["output"]>;
  slug?: Maybe<Scalars["String"]["output"]>;
  ssoCreatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  ssoId?: Maybe<Scalars["UUID"]["output"]>;
  /** Paginated store credit history for customer in a specific store */
  storeCreditHistory: CustomerStoreCreditHistory;
  /** Store credit summaries for customer in all stores where this feature is enabled */
  storeCreditSummaries: Array<CustomerStoreCreditSummary>;
  tags: Array<CustomerTag>;
  updatedAt: Scalars["DateTime"]["output"];
  username?: Maybe<Scalars["String"]["output"]>;
};

export type CustomerActiveStoreCheckoutArgs = {
  storeId: StoreId;
};

export type CustomerStoreCreditHistoryArgs = {
  input: CustomerStoreCreditHistoryInput;
};

export enum CustomerAdditionalPaymentMethod {
  Ach = "Ach",
  Sepa = "Sepa",
}

export type CustomerAddressReferenceOptionInput = {
  customerAddressId?: InputMaybe<Scalars["UUID"]["input"]>;
  saveForFutureUse?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CustomerAddressUnion =
  | CustomerBusinessAddress
  | CustomerResidentialAddress;

export type CustomerBusinessAddress = BusinessAddress & {
  __typename?: "CustomerBusinessAddress";
  additionalInfo?: Maybe<Scalars["String"]["output"]>;
  address1: Scalars["String"]["output"];
  address2?: Maybe<Scalars["String"]["output"]>;
  businessName?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  country: CountryCode;
  createdAt: Scalars["DateTime"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  isAnyUsageType: Scalars["Boolean"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  lastName: Scalars["String"]["output"];
  neighborhood?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
  province?: Maybe<Scalars["String"]["output"]>;
  stateRegistrationNumber?: Maybe<Scalars["String"]["output"]>;
  taxId?: Maybe<Scalars["String"]["output"]>;
  type: AddressType;
  updatedAt: Scalars["DateTime"]["output"];
  usageType: AddressUsageType;
};

export type CustomerInsights = {
  __typename?: "CustomerInsights";
  previousPurchases: CustomerPreviousPurchases;
};

export type CustomerListFilterInput = {
  hasEarlyAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasPendingTaxExemption?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGuest?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CustomerListInput = {
  filter?: InputMaybe<CustomerListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<CustomerOrderBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type CustomerListResponse = PageResponse & {
  __typename?: "CustomerListResponse";
  items: Array<Customer>;
  pagination: PaginationResponse;
};

export type CustomerOrderBy = {
  key: CustomerOrderByKey;
  order: SortOrder;
};

export enum CustomerOrderByKey {
  DisplayName = "displayName",
}

export type CustomerPayByInvoiceMetadata = {
  __typename?: "CustomerPayByInvoiceMetadata";
  contactEmail: Scalars["EmailAddress"]["output"];
  contactName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastUsedAt?: Maybe<Scalars["DateTime"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  referenceNumber: Scalars["String"]["output"];
};

export type CustomerPreviousPurchases = {
  __typename?: "CustomerPreviousPurchases";
  /** Indicates which product families the customer has purchased from */
  byFamily: Array<ProductFamily>;
};

export type CustomerResidentialAddress = ResidentialAddress & {
  __typename?: "CustomerResidentialAddress";
  additionalInfo?: Maybe<Scalars["String"]["output"]>;
  address1: Scalars["String"]["output"];
  address2?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  country: CountryCode;
  createdAt: Scalars["DateTime"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  isAnyUsageType: Scalars["Boolean"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  lastName: Scalars["String"]["output"];
  neighborhood?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
  province?: Maybe<Scalars["String"]["output"]>;
  taxId?: Maybe<Scalars["String"]["output"]>;
  type: AddressType;
  updatedAt: Scalars["DateTime"]["output"];
  usageType: AddressUsageType;
};

/** @deprecated */
export type CustomerStoreCredit = {
  __typename?: "CustomerStoreCredit";
  customerId: Scalars["UUID"]["output"];
  history: Array<StoreCreditHistoryItem>;
  storeId: StoreId;
  summary: StoreCreditSummary;
};

export type CustomerStoreCreditHistory = PageResponse & {
  __typename?: "CustomerStoreCreditHistory";
  items: Array<StoreCreditHistoryItem>;
  pagination: PaginationResponse;
};

export type CustomerStoreCreditHistoryInput = {
  limit?: InputMaybe<Scalars["PaginationLimit"]["input"]>;
  offset?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  storeId: StoreId;
};

export type CustomerStoreCreditSummary = {
  __typename?: "CustomerStoreCreditSummary";
  customerId: Scalars["UUID"]["output"];
  storeId: StoreId;
  summary: StoreCreditSummary;
};

export type CustomerTag = {
  __typename?: "CustomerTag";
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
};

export type CustomerTaxExemption = {
  __typename?: "CustomerTaxExemption";
  attachments: Array<ProtectedAsset>;
  createdAt: Scalars["DateTime"]["output"];
  customerNote?: Maybe<Scalars["TrimmedString"]["output"]>;
  customerTaxId?: Maybe<Scalars["TrimmedString"]["output"]>;
  id: Scalars["UUID"]["output"];
  regionCode: Array<Scalars["TrimmedString"]["output"]>;
  rejectReason?: Maybe<Scalars["TrimmedString"]["output"]>;
  requestedAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: TaxExemptionStatus;
  storeId: StoreId;
  taxExemptionEntity: TaxExemptionEntity;
  updatedAt: Scalars["DateTime"]["output"];
};

export type CustomerTaxExemptionEntity = {
  __typename?: "CustomerTaxExemptionEntity";
  entity: TaxExemptionEntityStorefront;
  requirements: Array<TaxExemptionEntityRequirement>;
};

export type CustomerTaxExemptionListResponse = {
  __typename?: "CustomerTaxExemptionListResponse";
  items: Array<CustomerTaxExemption>;
};

export type Datasheet = {
  __typename?: "Datasheet";
  /** @deprecated No longer supported */
  createdAt: Scalars["DateTime"]["output"];
  html: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  /** @deprecated No longer supported */
  sku: Scalars["String"]["output"];
  /** @deprecated No longer supported */
  updatedAt: Scalars["DateTime"]["output"];
};

export enum DatasheetPdfErrorCode {
  MissingFamily = "MISSING_FAMILY",
  MissingFamilyLogo = "MISSING_FAMILY_LOGO",
  MissingLegalInfo = "MISSING_LEGAL_INFO",
  MissingProduct = "MISSING_PRODUCT",
  MissingProductImage = "MISSING_PRODUCT_IMAGE",
  MissingProductTranslations = "MISSING_PRODUCT_TRANSLATIONS",
  NoSpecificationsFound = "NO_SPECIFICATIONS_FOUND",
  NoSpecificationSections = "NO_SPECIFICATION_SECTIONS",
  PdfGenerationFailed = "PDF_GENERATION_FAILED",
  Timeout = "TIMEOUT",
}

export type DeactivateUserInput = {
  id: Scalars["UUID"]["input"];
};

export type DeactivateUserResponse = {
  __typename?: "DeactivateUserResponse";
  user: User;
};

export type DeleteAssetZoneInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteAssetZoneResponse = {
  __typename?: "DeleteAssetZoneResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteChildAssetInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteChildAssetResponse = {
  __typename?: "DeleteChildAssetResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteCollectionInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteCollectionResponse = {
  __typename?: "DeleteCollectionResponse";
  id: Scalars["UUID"]["output"];
  storeCollections: Array<DeleteStoreCollectionResponse>;
};

export type DeleteCustomerAddressInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteCustomerAddressResponse = {
  __typename?: "DeleteCustomerAddressResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteDiscountInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteDiscountResponse = {
  __typename?: "DeleteDiscountResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteGalleryItemInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteGalleryItemResponse = {
  __typename?: "DeleteGalleryItemResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteIntegrationInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteIntegrationResponse = {
  __typename?: "DeleteIntegrationResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteLanguageInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteLanguageResponse = {
  __typename?: "DeleteLanguageResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteLimitationInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteLimitationResponse = {
  __typename?: "DeleteLimitationResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteOptionInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteOptionResponse = {
  __typename?: "DeleteOptionResponse";
  id: Scalars["UUID"]["output"];
  values: Array<DeleteValueResponse>;
};

export type DeletePaymentProviderPaymentMethodInput = {
  paymentMethod: OrderTransactionPaymentMethod;
  paymentProviderId: Scalars["UUID"]["input"];
};

export type DeleteProductBundleResult = {
  __typename?: "DeleteProductBundleResult";
  id: Scalars["UUID"]["output"];
};

export type DeleteProductDocumentInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteProductDocumentResponse = {
  __typename?: "DeleteProductDocumentResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteProductInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteProductResponse = {
  __typename?: "DeleteProductResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteProtectedAssetResponse = {
  __typename?: "DeleteProtectedAssetResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteStoreCarrierInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteStoreCarrierResponse = {
  __typename?: "DeleteStoreCarrierResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteStoreCollectionResponse = {
  __typename?: "DeleteStoreCollectionResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteStoreShippingRateInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteStoreShippingRateResponse = {
  __typename?: "DeleteStoreShippingRateResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteStoreShippingZoneInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteStoreShippingZoneResponse = {
  __typename?: "DeleteStoreShippingZoneResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteValueResponse = {
  __typename?: "DeleteValueResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteWarehouseInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteWarehouseResponse = {
  __typename?: "DeleteWarehouseResponse";
  id: Scalars["UUID"]["output"];
};

export type DeleteWishlistInput = {
  id: Scalars["UUID"]["input"];
};

export type DeviceToken = {
  __typename?: "DeviceToken";
  /** Semver version of mobile app */
  appVersion?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  customer?: Maybe<Customer>;
  id: Scalars["UUID"]["output"];
  lastFailedAt?: Maybe<Scalars["DateTime"]["output"]>;
  platform: DeviceTokenPlatform;
  status: DeviceTokenStatus;
};

export type DeviceTokenDataInput = {
  platform: DeviceTokenPlatform;
  token: Scalars["TrimmedString"]["input"];
};

export enum DeviceTokenPlatform {
  Android = "Android",
  IOs = "iOS",
}

export enum DeviceTokenStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export type Discount = {
  __typename?: "Discount";
  activeEndDate?: Maybe<Scalars["DateTime"]["output"]>;
  activeStartDate: Scalars["DateTime"]["output"];
  appliedToOrders: Array<ApOrder>;
  createdAt: Scalars["DateTime"]["output"];
  /** Customers can be assigned to customer eligible discounts */
  customers: Array<Customer>;
  discountBundleProducts: Array<ApDiscountBundleProduct>;
  discountCodes: Array<DiscountCode>;
  discountProducts: Array<DiscountProduct>;
  eligibility: DiscountEligibility;
  fixedAmount?: Maybe<Money>;
  hasAllProducts: Scalars["Boolean"]["output"];
  hasCustomerLimit: Scalars["Boolean"]["output"];
  hasShippingIncluded: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  isAutoApplied: Scalars["Boolean"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  isVisible: Scalars["Boolean"]["output"];
  limitPerCode?: Maybe<Scalars["Int"]["output"]>;
  maxAmount?: Maybe<Money>;
  maxProductQty?: Maybe<Scalars["Int"]["output"]>;
  minAmount?: Maybe<Money>;
  minProductQty?: Maybe<Scalars["Int"]["output"]>;
  mode: DiscountMode;
  name: Scalars["String"]["output"];
  parentRatio?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  percentageAmount?: Maybe<Scalars["PositivePercentage"]["output"]>;
  requirementType?: Maybe<DiscountRequirementType>;
  /** @deprecated use slugGroup */
  slug?: Maybe<Scalars["String"]["output"]>;
  slugGroup?: Maybe<Scalars["String"]["output"]>;
  status: DiscountStatus;
  storeDiscounts: Array<StoreDiscount>;
  type: DiscountType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type DiscountBenefit = FixedDiscountBenefit | PercentDiscountBenefit;

export type DiscountBundleMetadata = {
  __typename?: "DiscountBundleMetadata";
  benefit: DiscountBenefit;
  bundledProductId: Scalars["UUID"]["output"];
  bundledProductVariantId: Scalars["UUID"]["output"];
  bundledStoreProductVariantId: Scalars["UUID"]["output"];
  meetsAllRequirements: Scalars["Boolean"]["output"];
  requirements: Array<BundleDiscountRequirement>;
};

export type DiscountCode = {
  __typename?: "DiscountCode";
  code: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
};

export enum DiscountCodeValidationErrorCode {
  CartCostTooHigh = "CartCostTooHigh",
  CartCostTooLow = "CartCostTooLow",
  CodeAlreadyUsedByCustomer = "CodeAlreadyUsedByCustomer",
  CodeExpired = "CodeExpired",
  CodeNotAllowedForCustomer = "CodeNotAllowedForCustomer",
  CodeNotFound = "CodeNotFound",
  CodeUsedUp = "CodeUsedUp",
  NeedsCustomer = "NeedsCustomer",
  NeedsEmail = "NeedsEmail",
  NoApplicableProducts = "NoApplicableProducts",
  NoApplicableVariants = "NoApplicableVariants",
  NotYetValid = "NotYetValid",
}

export enum DiscountEligibility {
  /** Specific customers only */
  Customer = "Customer",
  /** All customers and guests */
  Everyone = "Everyone",
}

export type DiscountListFilterInput = {
  discountMode?: InputMaybe<Array<DiscountMode>>;
  status?: InputMaybe<DiscountStatus>;
  stores?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type DiscountListInput = {
  filter?: InputMaybe<DiscountListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  options?: InputMaybe<DiscountListOptionsInput>;
  order?: InputMaybe<Array<DiscountOrderBy>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type DiscountListOptionsInput = {
  includeDiscountCodeInSearch?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DiscountListResponse = PageResponse & {
  __typename?: "DiscountListResponse";
  items: Array<Discount>;
  pagination: PaginationResponse;
};

export enum DiscountMode {
  Bundle = "Bundle",
  Campaign = "Campaign",
  GiftCode = "GiftCode",
}

export type DiscountOrderBy = {
  key: DiscountOrderByKey;
  order: SortOrder;
};

export enum DiscountOrderByKey {
  Name = "name",
}

export type DiscountProduct = {
  __typename?: "DiscountProduct";
  discountProductVariants: Array<DiscountProductVariant>;
  id: Scalars["UUID"]["output"];
  includeProspectiveVariants: Scalars["Boolean"]["output"];
  product: ApProduct;
};

export type DiscountProductVariant = {
  __typename?: "DiscountProductVariant";
  id: Scalars["UUID"]["output"];
  isNew: Scalars["Boolean"]["output"];
  isSelected: Scalars["Boolean"]["output"];
  productVariant: ProductVariant;
};

export enum DiscountRedeemStatus {
  Created = "Created",
  Redeemed = "Redeemed",
  Returned = "Returned",
}

export enum DiscountRequirementType {
  Amount = "Amount",
  Quantity = "Quantity",
  QuantityRatio = "QuantityRatio",
}

export type DiscountSlugGroup = {
  __typename?: "DiscountSlugGroup";
  count: Scalars["Int"]["output"];
  items: Array<DiscountSlugGroupDiscountEntry>;
  slug: Scalars["String"]["output"];
};

export type DiscountSlugGroupDiscountEntry = {
  __typename?: "DiscountSlugGroupDiscountEntry";
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
};

export type DiscountSlugGroupsInput = {
  slugs?: InputMaybe<Array<Scalars["TrimmedString"]["input"]>>;
};

export enum DiscountStatus {
  Active = "Active",
  Disabled = "Disabled",
  Expired = "Expired",
  Scheduled = "Scheduled",
  Used = "Used",
}

export enum DiscountType {
  Fixed = "Fixed",
  Percent = "Percent",
  Shipping = "Shipping",
}

export enum DisplayProductStatus {
  Available = "Available",
  Backorder = "Backorder",
  ComingSoon = "ComingSoon",
  RegionNotAvailable = "RegionNotAvailable",
  SoldOut = "SoldOut",
  Unavailable = "Unavailable",
}

export enum DisplayReturnReason {
  ArrivedBroken = "ArrivedBroken",
  /** @deprecated No longer supported */
  Broken = "Broken",
  DamagedDuringShipping = "DamagedDuringShipping",
  DifferentProduct = "DifferentProduct",
  Incompatibility = "Incompatibility",
  LateDelivery = "LateDelivery",
  MissingItem = "MissingItem",
  /** @deprecated No longer supported */
  NotDelivered = "NotDelivered",
  /** @deprecated No longer supported */
  NotWanted = "NotWanted",
  NotWorking = "NotWorking",
  Other = "Other",
  Quality = "Quality",
  SetupIssues = "SetupIssues",
  SoftwareFirmwareIssues = "SoftwareFirmwareIssues",
  /** @deprecated No longer supported */
  TechnicalProblemHardware = "TechnicalProblemHardware",
  /** @deprecated No longer supported */
  TechnicalProblemSoftware = "TechnicalProblemSoftware",
  /** @deprecated No longer supported */
  TookTooLong = "TookTooLong",
  WrongAddress = "WrongAddress",
  WrongItem = "WrongItem",
}

export type DynamicStoreShippingRate = {
  __typename?: "DynamicStoreShippingRate";
  id: Scalars["UUID"]["output"];
  isApOnly: Scalars["Boolean"]["output"];
  isBusinessTypeRate: Scalars["Boolean"]["output"];
  isResidentialTypeRate: Scalars["Boolean"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  storeCarrier: StoreCarrier;
  storeCarrierService?: Maybe<StoreCarrierService>;
  type: StoreShippingRateType;
};

export enum EmailEventResolution {
  /** Events are grouped by day */
  Day = "Day",
  /** Events are grouped by month */
  Month = "Month",
  /** Events are grouped as a total value */
  Total = "Total",
}

export enum EmailEventType {
  /** AWS SNS email link click event */
  Click = "Click",
  /** AWS SNS email open event */
  Open = "Open",
  /** AWS SNS email send event */
  Send = "Send",
}

export enum EmailRejectType {
  Complaint = "Complaint",
  Hard = "Hard",
  Soft = "Soft",
}

export type Embed = {
  __typename?: "Embed";
  childAssets: Array<Asset>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  md5Checksum: Scalars["String"]["output"];
  serviceId: Scalars["String"]["output"];
  serviceType: ServiceType;
  thumbnailHeight: Scalars["Int"]["output"];
  thumbnailUrl: Scalars["String"]["output"];
  thumbnailWidth: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  url: Scalars["String"]["output"];
};

export enum EmbedEntityType {
  Collection = "Collection",
  CollectionCategory = "CollectionCategory",
  Product = "Product",
}

export enum EntityType {
  Checkout = "checkout",
  Collection = "collection",
  CollectionCategory = "collectionCategory",
  Customer = "customer",
  CustomerTaxExemption = "customerTaxExemption",
  Discount = "discount",
  Exchange = "exchange",
  GalleryItem = "galleryItem",
  Integration = "integration",
  Language = "language",
  Notice = "notice",
  Order = "order",
  OrderOperationTransaction = "orderOperationTransaction",
  OrderProduct = "orderProduct",
  OrderReturn = "orderReturn",
  Product = "product",
  ProductDocument = "productDocument",
  ProductInventory = "productInventory",
  ProductVariant = "productVariant",
  Store = "store",
  StoreProductVariant = "storeProductVariant",
  TaxIdValidation = "taxIdValidation",
  User = "user",
  Warehouse = "warehouse",
}

export enum ErpSystem {
  ChinaSap = "ChinaSap",
  Internal = "Internal",
  Netsuite = "Netsuite",
}

export type ExchangeRate = {
  __typename?: "ExchangeRate";
  date: Scalars["DateTime"]["output"];
  extracted: ExtractedRate;
  from: Currency;
  id: Scalars["UUID"]["output"];
  rate: Scalars["String"]["output"];
  to: Currency;
};

export type ExchangeRateInput = {
  from: Currency;
  to: Currency;
};

export type ExchangeRateListInput = {
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<ExchangeRateOrderBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ExchangeRateListResponse = PageResponse & {
  __typename?: "ExchangeRateListResponse";
  items: Array<ExchangeRate>;
  pagination: PaginationResponse;
};

export type ExchangeRateOrderBy = {
  key: ExchangeRateOrderByKey;
  order: SortOrder;
};

export enum ExchangeRateOrderByKey {
  Date = "date",
  From = "from",
  To = "to",
}

export type ExtractedRate = {
  __typename?: "ExtractedRate";
  amount: Scalars["Int"]["output"];
  scale: Scalars["Int"]["output"];
};

export type FailedLimitReason = {
  __typename?: "FailedLimitReason";
  /** To which store product variant group (AND) limit applies to. Will contain only input items */
  appliesTo: Array<Scalars["UUID"]["output"]>;
  /** True if limit is PerClientIndefinitely */
  isPerClient: Scalars["Boolean"]["output"];
  /** Allowed quantity of appliesTo items */
  quantityAllowed: Scalars["Int"]["output"];
  /** Given quantity of appliesTo items */
  quantityGiven: Scalars["Int"]["output"];
  /**
   * Pass array of store product variant ids which are required for limitation to pass.
   * Will contain data only if limitation type is conditional
   */
  requires: Array<Scalars["UUID"]["output"]>;
  type: LimitationType;
};

export type Feature = BaseAsset & {
  __typename?: "Feature";
  childAssetType?: Maybe<AssetChildAssetType>;
  childAssets: Array<Asset>;
  createdAt: Scalars["DateTime"]["output"];
  featureValues: FeatureValues;
  filename: Scalars["String"]["output"];
  filenameOriginal: Scalars["String"]["output"];
  height: Scalars["Int"]["output"];
  id: Scalars["UUID"]["output"];
  md5Checksum: Scalars["String"]["output"];
  mimeType: Scalars["String"]["output"];
  parentAssetId?: Maybe<Scalars["UUID"]["output"]>;
  parentEmbedId?: Maybe<Scalars["UUID"]["output"]>;
  size: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  url: Scalars["String"]["output"];
  width: Scalars["Int"]["output"];
};

export type FeatureFlag = {
  __typename?: "FeatureFlag";
  isEnabled: Scalars["Boolean"]["output"];
  /**
   * Name of the feature flag (using camelCase convention e.g. "myFeatureFlag").
   *
   * Not type enforced for not requiring schema changes on new flags.
   *
   * List of available feature flags:
   *   - storeCredit
   */
  key: Scalars["String"]["output"];
};

export type FeatureValues = {
  __typename?: "FeatureValues";
  body?: Maybe<Scalars["String"]["output"]>;
  canvasHeight: Scalars["Int"]["output"];
  canvasWidth: Scalars["Int"]["output"];
  dotX: Scalars["Float"]["output"];
  dotY: Scalars["Float"]["output"];
  id: Scalars["UUID"]["output"];
  lineRenderType: ProductFeatureLineRenderType;
  scale: Scalars["Float"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  tooltipX: Scalars["Float"]["output"];
  tooltipY: Scalars["Float"]["output"];
  translateX: Scalars["Int"]["output"];
  translateY: Scalars["Int"]["output"];
};

export type FixedDiscountBenefit = {
  __typename?: "FixedDiscountBenefit";
  storePrice: Money;
};

export enum FullAccessToOrder {
  /** Admin user has order view permission */
  Admin = "Admin",
  /** Customer has ownership access */
  Customer = "Customer",
  /** Visitor has guest access */
  Guest = "Guest",
  /** Integration user has access */
  Integration = "Integration",
  /** Visitor has payor access */
  Payor = "Payor",
}

export type Gallery = {
  __typename?: "Gallery";
  id: Scalars["String"]["output"];
  items: Array<GalleryItem>;
  language?: Maybe<Language>;
  /** Url of the first image or thumbnail of an embed for the gallery */
  thumbnailUrl?: Maybe<Scalars["String"]["output"]>;
  type: GalleryTag;
};

export type GalleryCategory = {
  __typename?: "GalleryCategory";
  id: Scalars["UUID"]["output"];
  sortOrder: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
};

export enum GalleryEntityType {
  Collection = "Collection",
  CollectionCategory = "CollectionCategory",
  Product = "Product",
}

export type GalleryItem = {
  __typename?: "GalleryItem";
  data: GalleryItemUnion;
  galleryCategory?: Maybe<GalleryCategory>;
  id: Scalars["UUID"]["output"];
  /** Indicates if gallery item is available for all product variants */
  isGlobal: Scalars["Boolean"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type GalleryItemUnion = Asset | Embed | Feature | Model;

export enum GalleryTag {
  CollectionCategoryHero = "CollectionCategoryHero",
  CollectionHero = "CollectionHero",
  ProductCarrierSetup = "ProductCarrierSetup",
  ProductCroppedThumbnail = "ProductCroppedThumbnail",
  ProductCustomization = "ProductCustomization",
  ProductDeployment = "ProductDeployment",
  /** ProductFeature tag is virtual, only used for storefrontProduct */
  ProductFeature = "ProductFeature",
  ProductInstallation = "ProductInstallation",
  ProductMedia = "ProductMedia",
  ProductModel = "ProductModel",
  ProductPerformanceMedia = "ProductPerformanceMedia",
  ProductTechSpec = "ProductTechSpec",
  ProductTopology = "ProductTopology",
  ProductWhatsInTheBox = "ProductWhatsInTheBox",
}

export type GetProtectedAssetSignedUrlResponse = {
  __typename?: "GetProtectedAssetSignedUrlResponse";
  expiresAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  signedUrl: Scalars["String"]["output"];
};

export type GlobalConfig = {
  __typename?: "GlobalConfig";
  flags: Array<FeatureFlag>;
};

/**
 * Combination enum of built-in Apollo errors + custom app errors so consumers of the API can more easily create type-safe
 * error handling
 */
export enum GraphQlErrorCode {
  /** AssertionError */
  AssertError = "ASSERT_ERROR",
  /** AvaTaxError */
  AvaTaxError = "AVA_TAX_ERROR",
  /** BadLoginError (see also BadLoginErrorCode for subcode) */
  BadLogin = "BAD_LOGIN",
  /**
   * An error occurred before your server could attempt to parse the given GraphQL operation.
   * Seems to be unused by us, leaving it as Apollo can throw it
   */
  BadRequest = "BAD_REQUEST",
  /**
   * The GraphQL operation includes an invalid value for a field argument.
   * InputValidationError, also Apollo can throw it
   */
  BadUserInput = "BAD_USER_INPUT",
  /** BlacklistedOrderReturn */
  BlacklistedOrderReturn = "BLACKLISTED_ORDER_RETURN",
  /** CheckoutError */
  CheckoutError = "CHECKOUT_ERROR",
  /** DuplicateError */
  Conflict = "CONFLICT",
  /** DataloaderError */
  DataloaderError = "DATALOADER_ERROR",
  /** DiscountCodeError */
  DiscountCodeError = "DISCOUNT_CODE_ERROR",
  /** EarlyAccessError */
  EarlyAccess = "EARLY_ACCESS",
  /** EntityOutdatedError */
  EntityOutdatedError = "ENTITY_OUTDATED_ERROR",
  /**
   * ForbiddenError (ex built-in as of Apollo v3)
   * https://www.apollographql.com/docs/apollo-server/migration/#built-in-error-classes
   */
  Forbidden = "FORBIDDEN",
  /**
   * The GraphQL operation string contains a syntax error.
   * Seems to be unused by us, leaving it as Apollo can throw it
   */
  GraphqlParseFailed = "GRAPHQL_PARSE_FAILED",
  /**
   * The GraphQL operation is not valid against the server's schema.
   * Seems to be unused by us, leaving it as Apollo can throw it
   */
  GraphqlValidationFailed = "GRAPHQL_VALIDATION_FAILED",
  /** InputValidationError */
  InputValidationError = "INPUT_VALIDATION_ERROR",
  /**
   * An unspecified error occurred.
   * Fallback error code when we obscuring original error thus not parking it as production safe, but can also be thrown
   * Apollo
   */
  InternalServerError = "INTERNAL_SERVER_ERROR",
  /** JsonBodyParseError */
  JsonBodyParseError = "JSON_BODY_PARSE_ERROR",
  /** LimitationError */
  LimitationError = "LIMITATION_ERROR",
  /** LockedEntityError */
  LockedEntity = "LOCKED_ENTITY",
  /** EntityNotFoundError */
  NotFound = "NOT_FOUND",
  /**
   * The request was parsed successfully and is valid against the server's schema, but the server couldn't resolve which operation to run.
   * Seems to be unused by us, leaving it as Apollo can throw it
   */
  OperationResolutionFailure = "OPERATION_RESOLUTION_FAILURE",
  /** OrderCancelError */
  OrderCancelError = "ORDER_CANCEL_ERROR",
  /**
   * A client sent the hash of a query string to execute via automatic persisted queries, but the query was not in the APQ
   * cache.
   * Seems to be unused by us, leaving it as Apollo can throw it
   */
  PersistedQueryNotFound = "PERSISTED_QUERY_NOT_FOUND",
  /**
   * A client sent the hash of a query string to execute via automatic persisted queries, but the server has disabled APQ.
   * Seems to be unused by us, leaving it as Apollo can throw it
   */
  PersistedQueryNotSupported = "PERSISTED_QUERY_NOT_SUPPORTED",
  /** RateLimitError */
  RateLimitError = "RATE_LIMIT_ERROR",
  /** SanitizedAxiosError */
  SanitizedAxiosError = "SANITIZED_AXIOS_ERROR",
}

export enum InactiveReason {
  ChangingEnv = "ChangingEnv",
  CustomerPromotedToken = "CustomerPromotedToken",
  DeliveryFailed = "DeliveryFailed",
  InvalidPlatformToken = "InvalidPlatformToken",
  Logout = "Logout",
  LogoutAllApps = "LogoutAllApps",
  Unknown = "Unknown",
}

export enum IntegrationLimitType {
  Backorder = "Backorder",
}

export enum IntegrationPermission {
  Gdpr = "Gdpr",
}

export type IntegrationSkuLimitInput = {
  sku: Scalars["TrimmedString"]["input"];
  type: IntegrationLimitType;
};

export type InventoryHistoryInput = {
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  sku: Scalars["TrimmedString"]["input"];
  warehouseId: Scalars["UUID"]["input"];
};

export type InventoryHistoryResponse = PageResponse & {
  __typename?: "InventoryHistoryResponse";
  items: Array<StoreProductVariantInventoryCalculated>;
  pagination: PaginationResponse;
};

export type InventoryState = {
  __typename?: "InventoryState";
  netsuiteWarehouseId?: Maybe<Scalars["String"]["output"]>;
  quantityAvailable: Scalars["Int"]["output"];
  quantityAvailableRaw: Scalars["Int"]["output"];
  quantityCommitted: Scalars["Int"]["output"];
  quantityDraft: Scalars["Int"]["output"];
  quantityNetsuite: Scalars["Int"]["output"];
  quantityPublic: Scalars["Int"]["output"];
  quantityUncommitted: Scalars["Int"]["output"];
  restockThreshold?: Maybe<Scalars["Int"]["output"]>;
  sku: Scalars["String"]["output"];
  skuNormalized: Scalars["String"]["output"];
  storeId: StoreId;
  warehouseId: Scalars["UUID"]["output"];
};

export type InventoryStateFilter = {
  excludeNonNetsuiteWarehouse?: InputMaybe<Scalars["Boolean"]["input"]>;
  fromTimestampUtc?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type InventoryStateInput = {
  filter: InventoryStateFilter;
};

export enum ItemReturnability {
  ContactSupport = "ContactSupport",
  Flow = "Flow",
}

export type Language = {
  __typename?: "Language";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  isPublished: Scalars["Boolean"]["output"];
  /** ISO 639-1 */
  locale: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type LastPrReportResponse = {
  __typename?: "LastPrReportResponse";
  items: Array<PrReportMetadata>;
  lastRefreshAt: Scalars["DateTime"]["output"];
};

export type Limitation = {
  __typename?: "Limitation";
  applyType: LimitationApplyType;
  conditionalMinQuantity: Scalars["Int"]["output"];
  conditionalProducts: Array<LimitationConditionalProduct>;
  createdAt: Scalars["DateTime"]["output"];
  hasAllProducts: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  isVisible: Scalars["Boolean"]["output"];
  maxQuantity: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  products: Array<ApProduct>;
  storeLimitations: Array<StoreLimitation>;
  type: LimitationType;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum LimitationApplyType {
  PerClientIndefinitely = "PerClientIndefinitely",
  PerOrder = "PerOrder",
}

export type LimitationConditionalProduct = {
  __typename?: "LimitationConditionalProduct";
  id: Scalars["UUID"]["output"];
  includeProspectiveVariants: Scalars["Boolean"]["output"];
  limitationConditionalProductVariants: Array<LimitationConditionalProductVariant>;
  product: ApProduct;
};

export type LimitationConditionalProductVariant = {
  __typename?: "LimitationConditionalProductVariant";
  id: Scalars["UUID"]["output"];
  isNew: Scalars["Boolean"]["output"];
  isSelected: Scalars["Boolean"]["output"];
  productVariant: ProductVariant;
};

export type LimitationListFilterInput = {
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  stores?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type LimitationListInput = {
  filter?: InputMaybe<LimitationListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<LimitationOrderBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type LimitationListResponse = PageResponse & {
  __typename?: "LimitationListResponse";
  items: Array<Limitation>;
  pagination: PaginationResponse;
};

export type LimitationOrderBy = {
  key: LimitationOrderByKey;
  order: SortOrder;
};

export enum LimitationOrderByKey {
  Name = "name",
}

export enum LimitationType {
  Conditional = "Conditional",
  PerProduct = "PerProduct",
  PerVariant = "PerVariant",
  Regional = "Regional",
  Total = "Total",
}

export type ListProductRegionalLimitInput = {
  productIds: Array<Scalars["UUID"]["input"]>;
  storeId: StoreId;
};

export type LoginRequirement = Requirement & {
  __typename?: "LoginRequirement";
  meetsRequirement: Scalars["Boolean"]["output"];
};

export type MainCategory = {
  __typename?: "MainCategory";
  id: Scalars["String"]["output"];
  isFallback: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  productUrl: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
};

export type MarkOrderSubmittedInput = {
  /** orderId to identify order */
  orderId: Scalars["TrimmedString"]["input"];
  /** Set provider payment id if provided after submission */
  providerPaymentId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type MarkOrderSubmittedResponse = {
  __typename?: "MarkOrderSubmittedResponse";
  id: Scalars["UUID"]["output"];
};

export type MaterialVariantInput = {
  isDefault: Scalars["Boolean"]["input"];
  materialVariantName: Scalars["String"]["input"];
};

export type MockTaxIUdValidationUpsertItem = {
  taxId: Scalars["TrimmedString"]["input"];
  validationStatus: TaxIdValidationStatus;
};

export type Model = BaseAsset & {
  __typename?: "Model";
  childAssetType?: Maybe<AssetChildAssetType>;
  childAssets: Array<Asset>;
  createdAt: Scalars["DateTime"]["output"];
  filename: Scalars["String"]["output"];
  filenameOriginal: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  md5Checksum: Scalars["String"]["output"];
  mimeType: Scalars["String"]["output"];
  modelVariantSettings: Array<ModelVariantSettings>;
  parentAssetId?: Maybe<Scalars["UUID"]["output"]>;
  parentEmbedId?: Maybe<Scalars["UUID"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  url: Scalars["String"]["output"];
};

export type ModelVariantSettings = {
  __typename?: "ModelVariantSettings";
  setting: AssetModelVariant;
  usedBy: Array<ModelVariantUsedBy>;
};

export type ModelVariantUsedBy = {
  __typename?: "ModelVariantUsedBy";
  isDefault: Scalars["Boolean"]["output"];
  variantId: Scalars["UUID"]["output"];
};

export type Money = {
  __typename?: "Money";
  amount: Scalars["NonNegativeInt"]["output"];
  currency: Currency;
};

export type Mutation = {
  __typename?: "Mutation";
  /**
   * **Public Endpoint:**
   * Add a product variant to one or more wishlists.
   */
  addWishlistItem: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ apAddReturnShipments mutation needs OrderReturnResolve permission ⚠️
   */
  apAddReturnShipments: ApCommonReturnResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Mutation needs ProductSalesCampaignRequestApprove permission ⚠️
   */
  apApproveProductSalesCampaignRequest: ApApproveProductSalesCampaignRequestResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apApproveReturn mutation needs OrderReturnResolve permission ⚠️
   */
  apApproveReturn: ApCommonReturnResponse;
  /** **Private Endpoint:** */
  apBustCacheRecord: ApBustCacheRecordResponse;
  apBustCollectionCache: Scalars["Boolean"]["output"];
  apBustProductCache: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ apCommentCreate mutation needs CommentCreate permission ⚠️
   */
  apCommentCreate: ApCommentCreateResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apCommentDelete mutation needs CommentCreate permission ⚠️
   */
  apCommentDelete: ApCommentDeleteResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateCustomer mutation needs CustomerInvite permission ⚠️
   */
  apCreateCustomer: CreateCustomerResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apCreateOrderDraft mutation needs OrderDraftCreate permission ⚠️
   */
  apCreateDraftFromOrder: ApCreateDraftFromOrderResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apCreateInventoryPolicyGlobal: ApCreateInventoryPolicyGlobalResponse;
  apCreateInventoryPolicyOverride: ApCreateInventoryPolicyOverrideResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apCreateOrder mutation needs OrderDraftCreate permission ⚠️
   */
  apCreateOrder: ApCreateOrderResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apCreateOrderDraft mutation needs OrderDraftCreate permission ⚠️
   */
  apCreateOrderDraft: ApOrderDraftResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreatePaymentProvider mutation needs PaymentProviderCreate permission ⚠️
   */
  apCreatePaymentProvider: ApCreatePaymentProviderResponse;
  /**
   * **Private Endpoint:**
   * ⚠️  apCreatePaymentProviderPaymentMethods mutation needs PaymentProviderEdit permission ⚠️
   */
  apCreatePaymentProviderPaymentMethods: ApCreatePaymentProviderPaymentMethodsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Create product bundle mutation needs ProductEdit permission ⚠️
   */
  apCreateProductBundle: ProductBundle;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apCreateProductCompatibility: ApCreateProductCompatibilityResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apCreateProductFeature: ApCreateProductFeatureResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Mutation needs ProductSalesCampaignManage permission ⚠️
   */
  apCreateProductSalesCampaign: ApProductSalesCampaign;
  /** **Private Endpoint:** */
  apCreateReturn: ApCommonReturnResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apCreateSlugRedirect mutation needs SlugRedirectCreate permission ⚠️
   */
  apCreateSlugRedirect: ApSlugRedirectCreateResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Mutation needs StoreEdit permission ⚠️
   *
   * Create or re-register a Smartcat webhook config for a project.
   * Generates a secret, registers with Smartcat API, and stores config in DB.
   * Returns the secret — only available at creation time.
   */
  apCreateSmartcatWebhookConfig: ApCreateSmartcatWebhookConfigResult;
  apCreateSpecificationFeature: ApSpecificationFeature;
  apCreateSpecificationSection: ApSpecificationSection;
  apCreateSpecificationTemplate: ApSpecificationTemplate;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apCreateTariff: ApCreateTariffResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires TaxRateCreate permission ⚠️
   */
  apCreateTaxRate: ApCreateTaxRateResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApDeleteCategory mutation needs CategoryDelete permission ⚠️
   */
  apDeleteCategory: ApDeleteCategoryResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApDeleteCategoryFilter mutation needs CategoryDelete permission ⚠️
   */
  apDeleteCategoryFilter: ApDeleteCategoryFilterResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApDeleteCategoryItem mutation needs CategoryDelete permission ⚠️
   */
  apDeleteCategoryItem: ApDeleteCategoryItemResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApDeleteCategoryProductFilter mutation needs CategoryDelete permission ⚠️
   */
  apDeleteCategoryProductFilter: ApDeleteCategoryProductFilterResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apDeleteCustomerTaxExemption mutation needs CustomerEdit permission ⚠️
   */
  apDeleteCustomerTaxExemption: ApDeleteCustomerTaxExemptionResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apDeleteGalleryCategory: ApDeleteGalleryCategoryResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apDeleteInventoryPolicyGlobal: Scalars["Boolean"]["output"];
  apDeleteInventoryPolicyOverride: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ ApDeleteMockTaxIdValidationStatusesByTaxId mutation needs signed in user ⚠️
   * ⚠️ ApDeleteMockTaxIdValidationStatusesByTaxId is only available in configured environments ⚠️
   */
  apDeleteMockTaxIdValidationStatusesByTaxId: ApDeleteMockTaxIdValidationStatusesByTaxIdResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApDeleteNotice mutation needs NoticeDelete permission ⚠️
   */
  apDeleteNotice: ApDeleteNoticeResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apDeleteOrderDraft mutation needs OrderDraftEdit permission ⚠️
   */
  apDeleteOrderDraft: ApOrderDraftResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApDeletePaymentProvider mutation needs PaymentProviderDelete permission ⚠️
   */
  apDeletePaymentProvider: ApDeletePaymentProviderResponse;
  /**
   * **Private Endpoint:**
   * ⚠️  apDeletePaymentProviderPaymentMethods mutation needs PaymentProviderEdit permission ⚠️
   */
  apDeletePaymentProviderPaymentMethods: ApDeletePaymentProviderPaymentMethodsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Delete product bundle mutation needs ProductEdit permission ⚠️
   */
  apDeleteProductBundle: DeleteProductBundleResult;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apDeleteProductCompatibility: ApDeleteProductCompatibilityResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apDeleteProductFeature: ApDeleteProductFeatureResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apDeleteProductPriceManualOverride: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ Requires specific permissions based on entity type  ⚠️
   */
  apDeleteProtectedAsset: ApDeleteProtectedAssetResponse;
  apDeleteShippingHeavyItem: Scalars["UUID"]["output"];
  apDeleteShippingHeavyItemsByProductId: Array<Scalars["UUID"]["output"]>;
  /**
   * **Private Endpoint:**
   * ⚠️ apDeleteSlugRedirect mutation needs SlugRedirectDelete permission ⚠️
   */
  apDeleteSlugRedirect: ApSlugRedirectDeleteResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Mutation needs StoreEdit permission ⚠️
   *
   * Delete a Smartcat webhook config by project ID.
   * Removes callback from Smartcat API and deletes config from DB.
   */
  apDeleteSmartcatWebhookConfig: Scalars["Boolean"]["output"];
  apDeleteSpecificationFeature: Scalars["Boolean"]["output"];
  apDeleteSpecificationSection: Scalars["Boolean"]["output"];
  apDeleteSpecificationTemplate: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ ApDeleteStoreBankDetails mutation needs StoreEdit permission ⚠️
   */
  apDeleteStoreBankDetails: ApDeleteStoreBankDetailsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires StorefrontProductVariantPartNumberEdit permission ⚠️
   */
  apDeleteStorefrontProductVariantPartNumber: ApStorefrontProductVariantPartNumber;
  /**
   * **Private Endpoint:**
   * ⚠️ ApDeleteTagTemplate mutation needs TagTemplateDelete permission ⚠️
   */
  apDeleteTagTemplate: ApDeleteTagTemplateResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apDeleteTariff: ApDeleteTariffResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires TaxRateDelete permission ⚠️
   */
  apDeleteTaxRate: ApDeleteTaxRateResponse;
  /** **Private Endpoint:** */
  apExpireUnpaidOrder: Scalars["Boolean"]["output"];
  apImportShopifyOrder: Scalars["Boolean"]["output"];
  apImportTaxExemptionCustomers: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ Requires StorefrontProductVariantPartNumberEdit permission ⚠️
   */
  apInsertStorefrontProductVariantPartNumber: ApStorefrontProductVariantPartNumber;
  /**
   * **Private Endpoint:**
   * ⚠️ apMarkOrderAsPaid query needs OrderManualPaymentCreate permission ⚠️
   */
  apMarkOrderAsPaid: ApMarkOrderAsPaidResponse;
  apMemoizeCollection: Scalars["Boolean"]["output"];
  apMemoizeProduct: Scalars["Boolean"]["output"];
  apMoveSpecificationTemplateFeature: ApSpecificationTemplate;
  /**
   * **Private Endpoint:**
   * ⚠️ apOrderPickAndFulfillItems mutation needs OrderPickAndFulfill permission ⚠️
   */
  apOrderPickAndFulfillItems: ApOrderPickAndFulfillItemsResponse;
  apRecalculateCustomerSearch: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * Recalculate inventory for specific store / product (if provided)
   */
  apRecalculateInventory: Scalars["Boolean"]["output"];
  apRecalculateOrderSearch: Scalars["Boolean"]["output"];
  apRecalculateProductSearch: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ apRejectReturn mutation needs OrderReturnResolve permission ⚠️
   */
  apRejectReturn: ApCommonReturnResponse;
  /** **Private Endpoint:** */
  apReopenExpiredOrder: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ ApReorderCategories mutation needs CategoryEdit permission ⚠️
   */
  apReorderCategories: ApReorderCategoriesResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApReorderCategoryFilters mutation needs CategoryEdit permission ⚠️
   */
  apReorderCategoryFilters: ApReorderCategoryFiltersResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApReorderCategoryItems mutation needs CategoryEdit permission ⚠️
   */
  apReorderCategoryItems: ApReorderCategoryItemsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApReorderCategoryProductFilters mutation needs CategoryEdit permission ⚠️
   */
  apReorderCategoryProductFilters: ApReorderCategoryProductFiltersResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apReorderGalleryCategories: ApReorderGalleryCategoriesResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apReorderProductFeatures: ApReorderProductFeaturesResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Mutation needs ProductSalesCampaignManage permission ⚠️
   */
  apRequestProductSalesCampaignRequest: ApProductSalesCampaignRequest;
  apSendPendingEmails: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apSetStoreProductListItems: ApSetStoreProductListItemsResponse;
  apSyncSpecifications?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * **Private Endpoint:**
   * ⚠️ apTransitionOrderDraftToOrder mutation needs OrderDraftCreate permission ⚠️
   */
  apTransitionOrderDraftToOrder: ApCreateOrderResponse;
  /** **Private Endpoint:** */
  apTriggerCompleteOrders: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ Activity query needs ActivityView permission ⚠️
   */
  apTriggerPrReport: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apUpdateGalleryItem: ApUpdateGalleryItemResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apUpdateInventoryPolicyGlobal: ApUpdateInventoryPolicyGlobalResponse;
  apUpdateInventoryPolicyOverride: ApUpdateInventoryPolicyOverrideResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apUpdateOrderAddress mutation allowed only in IN store ⚠️
   */
  apUpdateOrderAddress: ApUpdateOrderAddressResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apUpdateOrderDraft mutation needs OrderDraftEdit permission ⚠️
   */
  apUpdateOrderDraft: ApOrderDraftResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdatePaymentProvider mutation needs PaymentProviderEdit permission ⚠️
   */
  apUpdatePaymentProvider: ApUpdatePaymentProviderResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Update product bundle mutation needs ProductEdit permission ⚠️
   */
  apUpdateProductBundle: ProductBundle;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apUpdateProductCompatibility: ApUpdateProductCompatibilityResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   * Update all FAQs for a product
   */
  apUpdateProductFaqs: ApUpdateProductFaqsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apUpdateProductFeature: ApUpdateProductFeatureResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateProductInventory mutation needs ProductInventoryEdit permission ⚠️
   */
  apUpdateProductInventory: ApUpdateProductInventoryResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Mutation needs StoreEdit permission ⚠️
   *
   * Update Smartcat webhook config settings (enable/disable, change events).
   */
  apUpdateSmartcatWebhookConfig: ApSmartcatWebhookConfig;
  apUpdateSpecificationFeature: ApSpecificationFeature;
  apUpdateSpecificationSection: ApSpecificationSection;
  apUpdateSpecificationTemplate: ApSpecificationTemplate;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires StorefrontProductVariantPartNumberEdit permission ⚠️
   */
  apUpdateStorefrontProductVariantPartNumber: ApStorefrontProductVariantPartNumber;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apUpdateTariff: ApUpdateTariffResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires TaxRateEdit permission ⚠️
   */
  apUpdateTaxRate: ApUpdateTaxRateResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires specific permissions based on entity type  ⚠️
   */
  apUploadProtectedAsset: ApUploadProtectedAssetResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApUpsertCategory mutation needs CategoryEdit permission ⚠️
   */
  apUpsertCategory: ApUpsertCategoryResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApUpsertCategoryFilter mutation needs CategoryEdit permission ⚠️
   */
  apUpsertCategoryFilter: ApUpsertCategoryFilterResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApUpsertCategoryItem mutation needs CategoryEdit permission ⚠️
   */
  apUpsertCategoryItem: ApUpsertCategoryItemResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApUpsertCategoryProductFilter mutation needs CategoryEdit permission ⚠️
   */
  apUpsertCategoryProductFilter: ApUpsertCategoryProductFilterResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apUpsertCustomerTaxExemption mutation needs CustomerEdit permission ⚠️
   */
  apUpsertCustomerTaxExemption: ApUpsertCustomerTaxExemptionResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apUpsertGalleryCategory: ApUpsertGalleryCategoryResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApUpsertMockTaxIdValidationStatuses mutation needs signed in user ⚠️
   * ⚠️ ApUpsertMockTaxIdValidationStatuses is only available in configured environments ⚠️
   */
  apUpsertMockTaxIdValidationStatuses: ApUpsertMockTaxIdValidationStatusesResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApUpsertNotice mutation needs NoticeEdit permission ⚠️
   */
  apUpsertNotice: ApUpsertNoticeResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apUpsertProductPriceManualOverride: ApUpsertProductPriceManualOverrideResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Mutation needs ProductSalesCampaignManage permission ⚠️
   */
  apUpsertProductSalesCampaignRequest: ApProductSalesCampaignRequest;
  apUpsertShippingHeavyItem: ApShippingHeavyItem;
  /**
   * **Private Endpoint:**
   * ⚠️ ApUpsertStoreBankDetails mutation needs StoreEdit permission ⚠️
   */
  apUpsertStoreBankDetails: ApUpsertStoreBankDetailsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permission ⚠️
   */
  apUpsertStoreProductList: ApUpsertStoreProductListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApUpsertTagTemplate mutation needs TagTemplateEdit permission ⚠️
   */
  apUpsertTagTemplate: ApUpsertTagTemplateResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ArchiveProduct mutation needs ProductArchive permission ⚠️
   */
  archiveProduct: ArchiveProductResponse;
  /**
   * **Public Endpoint:**
   * Cancels the whole order
   */
  cancelStorefrontOrder: CancelStorefrontOrderResponse;
  changeCustomerPreferences: ChangeCustomerPreferencesResponse;
  /** **Public Endpoint:** */
  clearOrderPayByInvoice: ClearOrderPayByInvoiceResponse;
  /**
   * **Private Endpoint:**
   * Download PDF datasheet for a product
   */
  createAndDownloadDatasheetPdf: CreateAndDownloadDatasheetPdfResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateCollectionCategoryDraft mutation needs CollectionEdit permission ⚠️
   */
  createCollectionCategoryDraft: ApCreateCollectionCategoryDraftResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateCollectionDraft mutation needs CollectionCreate permission ⚠️
   */
  createCollectionDraft: CreateCollectionDraftResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateCustomerAddress mutation needs valid customer session ⚠️
   */
  createCustomerAddress: UpsertCustomerAddressResponse;
  /** **Public Endpoint:** */
  createCustomerPayByInvoiceMetadata: CustomerPayByInvoiceMetadata;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateDiscount mutation needs DiscountCreate permission ⚠️
   */
  createDiscount: CreateDiscountResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateEmbed mutation needs ProductEdit permission ⚠️
   */
  createEmbed: CreateEmbedResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateExchangeRate mutation needs ExchangeRateCreate permission ⚠️
   */
  createExchangeRate: CreateExchangeRateResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateIntegration mutation needs IntegrationCreate permission ⚠️
   */
  createIntegration: CreateIntegrationResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateLanguage mutation needs LanguageCreate permission ⚠️
   */
  createLanguage: CreateLanguageResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateLimitation mutation needs LimitationCreate permission ⚠️
   */
  createLimitation: CreateLimitationResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateOption mutation needs OptionCreate permission ⚠️
   */
  createOption: CreateOptionResponse;
  /** **Public Endpoint:** */
  createOrder: CreateOrderResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateProductDocuments mutation needs ProductEdit permission ⚠️
   */
  createProductDocuments: CreateProductDocumentsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateProductDraft mutation needs ProductCreate permission ⚠️
   */
  createProductDraft: CreateProductDraftResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateRelatedProductCategory mutation needs ProductEdit permission ⚠️
   */
  createRelatedProductCategory: ApRelatedProductCategoryResponse;
  /**
   * **Public Endpoint:**
   * SF
   */
  createReturn: CreateReturnResponse;
  /** **Public Endpoint:** */
  createSearchResultAction: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ CreateStoreCarrier mutation needs StoreCarrierCreate permission ⚠️
   */
  createStoreCarrier: CreateStoreCarrierResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateStoreShippingRate mutation needs StoreCarrierCreate permission ⚠️
   */
  createStoreShippingRate: CreateStoreShippingRateResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateStoreShippingZone mutation needs StoreCarrierCreate permission ⚠️
   */
  createStoreShippingZone: CreateStoreShippingZoneResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateUpsellProductCategory mutation needs ProductEdit permission ⚠️
   */
  createUpsellProductCategory: ApUpsellProductCategoryResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateUser mutation needs UserInvite permission ⚠️
   */
  createUser: CreateUserResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ CreateWarehouse mutation needs WarehouseCreate permission ⚠️
   */
  createWarehouse: CreateWarehouseResponse;
  /**
   * **Public Endpoint:**
   * Create a new wishlist.
   */
  createWishlist: Wishlist;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateUser mutation needs UserDeactivate permission ⚠️
   */
  deactivateUser: DeactivateUserResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permissions  ⚠️
   */
  deleteAssetZone: DeleteAssetZoneResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteChildAsset mutation needs ProductEdit permission ⚠️
   */
  deleteChildAsset: DeleteChildAssetResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteCollection mutation needs CollectionDelete permission ⚠️
   */
  deleteCollection: DeleteCollectionResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteCustomerAddress mutation needs valid customer session ⚠️
   */
  deleteCustomerAddress: DeleteCustomerAddressResponse;
  /** **Public Endpoint:** */
  deleteCustomerPayByInvoiceMetadata: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteDiscount mutation needs DiscountDelete permission ⚠️
   */
  deleteDiscount: DeleteDiscountResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteGalleryItem mutation needs ProductEdit permission ⚠️
   */
  deleteGalleryItem: DeleteGalleryItemResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteIntegration mutation needs IntegrationDelete permission ⚠️
   */
  deleteIntegration: DeleteIntegrationResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteLanguage mutation needs LanguageDelete permission ⚠️
   */
  deleteLanguage: DeleteLanguageResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteLimitation mutation needs LimitationDelete permission ⚠️
   */
  deleteLimitation: DeleteLimitationResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteOption mutation needs OptionDelete permission ⚠️
   */
  deleteOption: DeleteOptionResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteProduct mutation needs ProductDelete permission ⚠️
   */
  deleteProduct: DeleteProductResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteProductDocument mutation needs ProductEdit permission ⚠️
   */
  deleteProductDocument: DeleteProductDocumentResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires specific permissions based on entity type  ⚠️
   */
  deleteProtectedAsset: DeleteProtectedAssetResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteRelatedProductCategory mutation needs ProductEdit permission ⚠️
   */
  deleteRelatedProductCategory: ApDeleteRelatedProductCategoryResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteStoreCarrier mutation needs StoreCarrierDelete permission ⚠️
   */
  deleteStoreCarrier: DeleteStoreCarrierResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ deleteStoreRate mutation needs StoreCarrierDelete permission ⚠️
   */
  deleteStoreShippingRate: DeleteStoreShippingRateResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteStoreShippingZone mutation needs StoreCarrierDelete permission ⚠️
   */
  deleteStoreShippingZone: DeleteStoreShippingZoneResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteUpsellProductCategory mutation needs ProductEdit permission ⚠️
   */
  deleteUpsellProductCategory: ApDeleteUpsellProductCategoryResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ deleteWarehouse mutation needs WarehouseDelete permission ⚠️
   */
  deleteWarehouse: DeleteWarehouseResponse;
  /**
   * **Public Endpoint:**
   * Delete a wishlist. Cannot delete the default wishlist.
   */
  deleteWishlist: Scalars["Boolean"]["output"];
  /** **Public Endpoint:** */
  markOrderSubmitted: MarkOrderSubmittedResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ PublishCollection mutation needs CollectionPublish permission ⚠️
   */
  publishCollection: PublishCollectionResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ PublishLanguage mutation needs LanguagePublish permission ⚠️
   */
  publishLanguage: PublishLanguageResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ PublishProduct mutation needs ProductPublish permission ⚠️
   */
  publishProduct: PublishProductResponse;
  registerDeviceToken: RegisterDeviceTokenResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ReorderGallery mutation needs ProductEdit permission ⚠️
   */
  reorderGallery: ReorderGalleryResponse;
  /**
   * **Public Endpoint**
   * Used for both creating a new request and re-applying for an existing (rejected) one
   */
  requestCustomerTaxExemption: RequestCustomerTaxExemptionResponse;
  /**
   * **Public Endpoint:**
   * Share a wishlist with specific emails.
   */
  shareWishlist: Scalars["Boolean"]["output"];
  /** **Public Endpoint:** */
  storefrontCreateCheckout: StorefrontCreateCheckoutResponse;
  /** **Public Endpoint:** */
  storefrontCreateCheckoutFromOrder: StorefrontCreateCheckoutFromOrderResponse;
  /** **Public Endpoint:** */
  storefrontUpdateCheckout: StorefrontUpdateCheckoutResponse;
  unregisterDeviceToken: UnregisterDeviceTokenResponse;
  /**
   * **Public Endpoint:**
   * Remove shares from a wishlist.
   */
  unshareWishlist: Scalars["Boolean"]["output"];
  /**
   * Update the alternative asset link for an existing asset
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit or CollectionEdit permission based on asset entity type ⚠️
   */
  updateAssetAlternativeLink: UpdateAssetAlternativeLinkPayload;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires specific ProductEdit or CollectionEdit permissions based on `input.entity` type  ⚠️
   */
  updateAssetModelVariant?: Maybe<UpdateAssetModelVariantResponse>;
  /** **Public Endpoint:** */
  updateBackInStockSubscription: UpdateBackInStockSubscriptionResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateCollection mutation needs CollectionEdit permission ⚠️
   */
  updateCollection: UpdateCollectionResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateCustomer mutation needs CustomerEdit permission ⚠️
   */
  updateCustomer: UpdateCustomerResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateCustomerAddress mutation needs valid customer session ⚠️
   */
  updateCustomerAddress: UpsertCustomerAddressResponse;
  /** **Public Endpoint:** */
  updateCustomerPayByInvoiceMetadata: CustomerPayByInvoiceMetadata;
  /**
   * **Private Endpoint:**
   * @deprecated Use changeCustomerPreferences instead
   */
  updateCustomersOwnMarketing: UpdateCustomersOwnMarketingResponse;
  /**
   * **Private Endpoint:**
   * Calling this endpoint
   * ⚠️ Calling this endpoint will change isDefault to true on warehouse and change isDefault to false for other warehouses in the same store ⚠️
   * ⚠️ UpdateDefaultWarehouse mutation needs WarehouseEdit permission ⚠️
   */
  updateDefaultWarehouse: UpdateDefaultWarehouseResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateDiscount mutation needs DiscountEdit permission ⚠️
   */
  updateDiscount: UpdateDiscountResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateIntegration mutation needs IntegrationEdit permission ⚠️
   */
  updateIntegration: UpdateIntegrationResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateLanguage mutation needs LanguageEdit permission ⚠️
   */
  updateLanguage: UpdateLanguageResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateLimitation mutation needs LimitationEdit permission ⚠️
   */
  updateLimitation: UpdateLimitationResponse;
  updateNotifications: NotificationSettings;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateOption mutation needs OptionEdit permission ⚠️
   */
  updateOption: UpdateOptionResponse;
  /** **Public Endpoint:** */
  updateOrderBillingAddress: UpdateOrderBillingAddressResponse;
  /** **Public Endpoint:** */
  updateOrderDetails: UpdateOrderDetailsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateProduct mutation needs ProductEdit permission ⚠️
   */
  updateProduct: UpdateProductResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateProductDocument mutation needs ProductEdit permission ⚠️
   */
  updateProductDocument: UpdateProductDocumentResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteRelatedProductCategory mutation needs ProductEdit permission ⚠️
   */
  updateRelatedProductCategory: ApRelatedProductCategoryResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateStore mutation needs StoreEdit permission ⚠️
   */
  updateStore: UpdateStoreResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateStoreCarrier mutation needs StoreCarrierEdit permission ⚠️
   */
  updateStoreCarrier: UpdateStoreCarrierResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateStoreSeo mutation needs StoreSeoEdit permission ⚠️
   */
  updateStoreSeo: UpdateStoreSeoResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateStoreShippingRate mutation needs StoreCarrierEdit permission ⚠️
   */
  updateStoreShippingRate: UpdateStoreShippingRateResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateStoreCarrier mutation needs StoreCarrierEdit permission ⚠️
   */
  updateStoreShippingZone: UpdateStoreShippingZoneResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ DeleteUpsellProductCategory mutation needs ProductEdit permission ⚠️
   */
  updateUpsellProductCategory: ApUpsellProductCategoryResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateUser mutation needs UserEdit permission ⚠️
   */
  updateUser: UpdateUserResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpdateWarehouse mutation needs WarehouseEdit permission ⚠️
   */
  updateWarehouse: UpdateWarehouseResponse;
  /**
   * **Public Endpoint:**
   * Update an existing wishlist.
   */
  updateWishlist: Wishlist;
  /**
   * **Public Endpoint:**
   * Update one or more wishlist items. Quantity acts as delta (e.g., +1 or -1). If resulting quantity is 0, item is removed.
   */
  updateWishlistItem: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ Requires specific ProductEdit or CollectionEdit permissions based on `input.entity` type  ⚠️
   */
  uploadImage: UploadResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires specific ProductEdit or CollectionEdit permissions based on `input.entity` type  ⚠️
   */
  uploadModel: UploadModelResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires specific permissions based on entity type  ⚠️
   */
  uploadProtectedAsset: UploadProtectedAssetResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires specific ProductEdit or CollectionEdit permissions based on `input.entity` type  ⚠️
   */
  uploadVideo: UploadResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductEdit permissions  ⚠️
   */
  upsertAssetZone: UpsertAssetZoneResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpsertCollectionTag mutation needs CollectionEdit permission ⚠️
   */
  upsertCollectionTag: UpsertCollectionTagResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpsertCustomerTag mutation needs CustomerEdit permission ⚠️
   */
  upsertCustomerTag: UpsertCustomerTagResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpsertOrderTag mutation needs OrderTagEdit permission ⚠️
   */
  upsertOrderTag: UpsertOrderTagResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpsertProductTag mutation needs ProductEdit permission ⚠️
   */
  upsertProductTag: UpsertProductTagResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ validateAddress mutation needs a valid customer session ⚠️
   */
  validateAddress: AddressValidationResponse;
};

export type MutationAddWishlistItemArgs = {
  input: AddWishlistItemInput;
};

export type MutationApAddReturnShipmentsArgs = {
  input: ApAddReturnShipmentsInput;
};

export type MutationApApproveProductSalesCampaignRequestArgs = {
  input: ApApproveProductSalesCampaignRequestInput;
};

export type MutationApApproveReturnArgs = {
  input: ApApproveReturnInput;
};

export type MutationApBustCacheRecordArgs = {
  input: ApBustCacheRecordInput;
};

export type MutationApBustCollectionCacheArgs = {
  storeId: StoreId;
};

export type MutationApBustProductCacheArgs = {
  storeId: StoreId;
};

export type MutationApCommentCreateArgs = {
  input: ApCommentCreateInput;
};

export type MutationApCommentDeleteArgs = {
  input: ApCommentDeleteInput;
};

export type MutationApCreateCustomerArgs = {
  input: CreateCustomerInput;
};

export type MutationApCreateDraftFromOrderArgs = {
  input: ApCreateDraftFromOrderInput;
};

export type MutationApCreateInventoryPolicyGlobalArgs = {
  input: ApCreateInventoryPolicyGlobalInput;
};

export type MutationApCreateInventoryPolicyOverrideArgs = {
  input: ApCreateInventoryPolicyOverrideInput;
};

export type MutationApCreateOrderArgs = {
  input: ApCreateOrderInput;
};

export type MutationApCreateOrderDraftArgs = {
  input: ApCreateOrderDraftInput;
};

export type MutationApCreatePaymentProviderArgs = {
  input: ApCreatePaymentProviderInput;
};

export type MutationApCreatePaymentProviderPaymentMethodsArgs = {
  input: ApCreatePaymentProviderPaymentMethodsInput;
};

export type MutationApCreateProductBundleArgs = {
  input: CreateProductBundleInput;
};

export type MutationApCreateProductCompatibilityArgs = {
  input: ApCreateProductCompatibilityInput;
};

export type MutationApCreateProductFeatureArgs = {
  input: ApCreateProductFeatureInput;
};

export type MutationApCreateProductSalesCampaignArgs = {
  input: ApCreateProductSalesCampaignInput;
};

export type MutationApCreateReturnArgs = {
  input: ApCreateReturnInput;
};

export type MutationApCreateSlugRedirectArgs = {
  input: ApSlugRedirectCreateInput;
};

export type MutationApCreateSmartcatWebhookConfigArgs = {
  input: ApCreateSmartcatWebhookConfigInput;
};

export type MutationApCreateSpecificationFeatureArgs = {
  input: ApCreateSpecificationFeatureInput;
};

export type MutationApCreateSpecificationSectionArgs = {
  input: ApCreateSpecificationSectionInput;
};

export type MutationApCreateSpecificationTemplateArgs = {
  input: ApCreateSpecificationTemplateInput;
};

export type MutationApCreateTariffArgs = {
  input: ApCreateTariffInput;
};

export type MutationApCreateTaxRateArgs = {
  input: ApCreateTaxRateInput;
};

export type MutationApDeleteCategoryArgs = {
  input: ApDeleteCategoryInput;
};

export type MutationApDeleteCategoryFilterArgs = {
  input: ApDeleteCategoryFilterInput;
};

export type MutationApDeleteCategoryItemArgs = {
  input: ApDeleteCategoryItemInput;
};

export type MutationApDeleteCategoryProductFilterArgs = {
  input: ApDeleteCategoryProductFilterInput;
};

export type MutationApDeleteCustomerTaxExemptionArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApDeleteGalleryCategoryArgs = {
  input: ApDeleteGalleryCategoryInput;
};

export type MutationApDeleteInventoryPolicyGlobalArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApDeleteInventoryPolicyOverrideArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApDeleteMockTaxIdValidationStatusesByTaxIdArgs = {
  input: ApDeleteMockTaxIdValidationStatusesByTaxIdInput;
};

export type MutationApDeleteNoticeArgs = {
  input: ApDeleteNoticeInput;
};

export type MutationApDeleteOrderDraftArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApDeletePaymentProviderArgs = {
  input: ApDeletePaymentProviderInput;
};

export type MutationApDeletePaymentProviderPaymentMethodsArgs = {
  input: ApDeletePaymentProviderPaymentMethodsInput;
};

export type MutationApDeleteProductBundleArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApDeleteProductCompatibilityArgs = {
  input: ApDeleteProductCompatibilityInput;
};

export type MutationApDeleteProductFeatureArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApDeleteProductPriceManualOverrideArgs = {
  input: ApDeleteProductPriceManualOverrideInput;
};

export type MutationApDeleteProtectedAssetArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApDeleteShippingHeavyItemArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApDeleteShippingHeavyItemsByProductIdArgs = {
  productId: Scalars["UUID"]["input"];
};

export type MutationApDeleteSlugRedirectArgs = {
  input: ApSlugRedirectDeleteInput;
};

export type MutationApDeleteSmartcatWebhookConfigArgs = {
  projectId: Scalars["TrimmedString"]["input"];
};

export type MutationApDeleteSpecificationFeatureArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApDeleteSpecificationSectionArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApDeleteSpecificationTemplateArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApDeleteStoreBankDetailsArgs = {
  input: ApDeleteStoreBankDetailsInput;
};

export type MutationApDeleteStorefrontProductVariantPartNumberArgs = {
  input: ApDeleteStorefrontProductVariantPartNumberInput;
};

export type MutationApDeleteTagTemplateArgs = {
  input: ApDeleteTagTemplateInput;
};

export type MutationApDeleteTariffArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApDeleteTaxRateArgs = {
  input: ApDeleteTaxRateInput;
};

export type MutationApExpireUnpaidOrderArgs = {
  orderId: Scalars["UUID"]["input"];
};

export type MutationApImportShopifyOrderArgs = {
  json: Scalars["Upload"]["input"];
};

export type MutationApImportTaxExemptionCustomersArgs = {
  json: Scalars["Upload"]["input"];
};

export type MutationApInsertStorefrontProductVariantPartNumberArgs = {
  input: ApInsertStorefrontProductVariantPartNumberInput;
};

export type MutationApMarkOrderAsPaidArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApMemoizeCollectionArgs = {
  storeIds: Array<StoreId>;
};

export type MutationApMemoizeProductArgs = {
  productIds: Array<Scalars["UUID"]["input"]>;
  storeIds: Array<StoreId>;
};

export type MutationApMoveSpecificationTemplateFeatureArgs = {
  fromFeatureId: Scalars["UUID"]["input"];
  fromSectionId: Scalars["UUID"]["input"];
  templateId: Scalars["UUID"]["input"];
  toSectionId: Scalars["UUID"]["input"];
};

export type MutationApOrderPickAndFulfillItemsArgs = {
  input: ApOrderPickAndFulfillItemsInput;
};

export type MutationApRecalculateInventoryArgs = {
  input: ApRecalculateInventoryInput;
};

export type MutationApRejectReturnArgs = {
  input: ApRejectReturnInput;
};

export type MutationApReopenExpiredOrderArgs = {
  expireDays: Scalars["NonNegativeInt"]["input"];
  orderId: Scalars["UUID"]["input"];
};

export type MutationApReorderCategoriesArgs = {
  input: ApReorderCategoriesInput;
};

export type MutationApReorderCategoryFiltersArgs = {
  input: ApReorderCategoryFiltersInput;
};

export type MutationApReorderCategoryItemsArgs = {
  input: ApReorderCategoryItemsInput;
};

export type MutationApReorderCategoryProductFiltersArgs = {
  input: ApReorderCategoryProductFiltersInput;
};

export type MutationApReorderGalleryCategoriesArgs = {
  input: ApReorderGalleryCategoriesInput;
};

export type MutationApReorderProductFeaturesArgs = {
  input: ApReorderProductFeaturesInput;
};

export type MutationApRequestProductSalesCampaignRequestArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationApSendPendingEmailsArgs = {
  input: SendPendingEmailInput;
};

export type MutationApSetStoreProductListItemsArgs = {
  input: ApSetStoreProductListItemsInput;
};

export type MutationApSyncSpecificationsArgs = {
  input: ApSyncSpecificationInput;
};

export type MutationApTransitionOrderDraftToOrderArgs = {
  input: ApTransitionOrderDraftToOrderInput;
};

export type MutationApTriggerPrReportArgs = {
  endDate: Scalars["DateTime"]["input"];
  startDate: Scalars["DateTime"]["input"];
};

export type MutationApUpdateGalleryItemArgs = {
  input: ApUpdateGalleryItemInput;
};

export type MutationApUpdateInventoryPolicyGlobalArgs = {
  input: ApUpdateInventoryPolicyGlobalInput;
};

export type MutationApUpdateInventoryPolicyOverrideArgs = {
  input: ApUpdateInventoryPolicyOverrideInput;
};

export type MutationApUpdateOrderAddressArgs = {
  input: ApUpdateOrderAddressInput;
};

export type MutationApUpdateOrderDraftArgs = {
  input: ApUpdateOrderDraftInput;
};

export type MutationApUpdatePaymentProviderArgs = {
  input: ApUpdatePaymentProviderInput;
};

export type MutationApUpdateProductBundleArgs = {
  input: UpdateProductBundleInput;
};

export type MutationApUpdateProductCompatibilityArgs = {
  input: ApUpdateProductCompatibilityInput;
};

export type MutationApUpdateProductFaqsArgs = {
  input: UpdateProductFaqsInput;
};

export type MutationApUpdateProductFeatureArgs = {
  input: ApUpdateProductFeatureInput;
};

export type MutationApUpdateProductInventoryArgs = {
  input: ApUpdateProductInventoryInput;
};

export type MutationApUpdateSmartcatWebhookConfigArgs = {
  input: ApUpdateSmartcatWebhookConfigInput;
};

export type MutationApUpdateSpecificationFeatureArgs = {
  input: ApUpdateSpecificationFeatureInput;
};

export type MutationApUpdateSpecificationSectionArgs = {
  input: ApUpdateSpecificationSectionInput;
};

export type MutationApUpdateSpecificationTemplateArgs = {
  input: ApUpdateSpecificationTemplateInput;
};

export type MutationApUpdateStorefrontProductVariantPartNumberArgs = {
  input: ApUpdateStorefrontProductVariantPartNumberInput;
};

export type MutationApUpdateTariffArgs = {
  input: ApUpdateTariffInput;
};

export type MutationApUpdateTaxRateArgs = {
  input: ApUpdateTaxRateInput;
};

export type MutationApUploadProtectedAssetArgs = {
  input: ApUploadProtectedAssetInput;
};

export type MutationApUpsertCategoryArgs = {
  input: ApUpsertCategoryInput;
};

export type MutationApUpsertCategoryFilterArgs = {
  input: ApUpsertCategoryFilterInput;
};

export type MutationApUpsertCategoryItemArgs = {
  input: ApUpsertCategoryItemInput;
};

export type MutationApUpsertCategoryProductFilterArgs = {
  input: ApUpsertCategoryProductFilterInput;
};

export type MutationApUpsertCustomerTaxExemptionArgs = {
  input: ApUpsertCustomerTaxExemptionInput;
};

export type MutationApUpsertGalleryCategoryArgs = {
  input: ApUpsertGalleryCategoryInput;
};

export type MutationApUpsertMockTaxIdValidationStatusesArgs = {
  input: ApUpsertMockTaxIdValidationStatusesInput;
};

export type MutationApUpsertNoticeArgs = {
  input: ApUpsertNoticeInput;
};

export type MutationApUpsertProductPriceManualOverrideArgs = {
  input: ApUpsertProductPriceManualOverrideInput;
};

export type MutationApUpsertProductSalesCampaignRequestArgs = {
  input: ApUpsertProductSalesCampaignRequestInput;
};

export type MutationApUpsertShippingHeavyItemArgs = {
  input: ApUpsertShippingHeavyItemInput;
};

export type MutationApUpsertStoreBankDetailsArgs = {
  input: ApUpsertStoreBankDetailsInput;
};

export type MutationApUpsertStoreProductListArgs = {
  input: ApUpsertStoreProductListInput;
};

export type MutationApUpsertTagTemplateArgs = {
  input: ApUpsertTagTemplateInput;
};

export type MutationArchiveProductArgs = {
  input: ArchiveProductInput;
};

export type MutationCancelStorefrontOrderArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationChangeCustomerPreferencesArgs = {
  input: ChangeCustomerPreferencesInput;
};

export type MutationClearOrderPayByInvoiceArgs = {
  input: ClearOrderPayByInvoiceInput;
};

export type MutationCreateAndDownloadDatasheetPdfArgs = {
  input: CreateAndDownloadDatasheetPdfInput;
};

export type MutationCreateCollectionCategoryDraftArgs = {
  input: ApCreateCollectionCategoryDraftInput;
};

export type MutationCreateCollectionDraftArgs = {
  input: CreateCollectionDraftInput;
};

export type MutationCreateCustomerAddressArgs = {
  input: CreateCustomerAddressInput;
};

export type MutationCreateCustomerPayByInvoiceMetadataArgs = {
  input: CreateCustomerPayByInvoiceMetadataInput;
};

export type MutationCreateDiscountArgs = {
  input: CreateDiscountInput;
};

export type MutationCreateEmbedArgs = {
  input: CreateEmbedInput;
};

export type MutationCreateExchangeRateArgs = {
  input: CreateExchangeRateInput;
};

export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};

export type MutationCreateLanguageArgs = {
  input: CreateLanguageInput;
};

export type MutationCreateLimitationArgs = {
  input: CreateLimitationInput;
};

export type MutationCreateOptionArgs = {
  input: CreateOptionInput;
};

export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};

export type MutationCreateProductDocumentsArgs = {
  input: CreateProductDocumentsInput;
};

export type MutationCreateProductDraftArgs = {
  input: CreateProductDraftInput;
};

export type MutationCreateRelatedProductCategoryArgs = {
  input: ApRelatedProductCategoryInput;
};

export type MutationCreateReturnArgs = {
  input: CreateReturnInput;
};

export type MutationCreateSearchResultActionArgs = {
  input: CreateSearchResultActionInput;
};

export type MutationCreateStoreCarrierArgs = {
  input: CreateStoreCarrierInput;
};

export type MutationCreateStoreShippingRateArgs = {
  input: CreateStoreShippingRateInput;
};

export type MutationCreateStoreShippingZoneArgs = {
  input: CreateStoreShippingZoneInput;
};

export type MutationCreateUpsellProductCategoryArgs = {
  input: ApUpsellProductCategoryInput;
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationCreateWarehouseArgs = {
  input: CreateWarehouseInput;
};

export type MutationCreateWishlistArgs = {
  input: CreateWishlistInput;
};

export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};

export type MutationDeleteAssetZoneArgs = {
  input: DeleteAssetZoneInput;
};

export type MutationDeleteChildAssetArgs = {
  input: DeleteChildAssetInput;
};

export type MutationDeleteCollectionArgs = {
  input: DeleteCollectionInput;
};

export type MutationDeleteCustomerAddressArgs = {
  input: DeleteCustomerAddressInput;
};

export type MutationDeleteCustomerPayByInvoiceMetadataArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationDeleteDiscountArgs = {
  input: DeleteDiscountInput;
};

export type MutationDeleteGalleryItemArgs = {
  input: DeleteGalleryItemInput;
};

export type MutationDeleteIntegrationArgs = {
  input: DeleteIntegrationInput;
};

export type MutationDeleteLanguageArgs = {
  input: DeleteLanguageInput;
};

export type MutationDeleteLimitationArgs = {
  input: DeleteLimitationInput;
};

export type MutationDeleteOptionArgs = {
  input: DeleteOptionInput;
};

export type MutationDeleteProductArgs = {
  input: DeleteProductInput;
};

export type MutationDeleteProductDocumentArgs = {
  input: DeleteProductDocumentInput;
};

export type MutationDeleteProtectedAssetArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationDeleteRelatedProductCategoryArgs = {
  input: ApDeleteRelatedProductCategoryInput;
};

export type MutationDeleteStoreCarrierArgs = {
  input: DeleteStoreCarrierInput;
};

export type MutationDeleteStoreShippingRateArgs = {
  input: DeleteStoreShippingRateInput;
};

export type MutationDeleteStoreShippingZoneArgs = {
  input: DeleteStoreShippingZoneInput;
};

export type MutationDeleteUpsellProductCategoryArgs = {
  input: ApDeleteUpsellProductCategoryInput;
};

export type MutationDeleteWarehouseArgs = {
  input: DeleteWarehouseInput;
};

export type MutationDeleteWishlistArgs = {
  input: DeleteWishlistInput;
};

export type MutationMarkOrderSubmittedArgs = {
  input: MarkOrderSubmittedInput;
};

export type MutationPublishCollectionArgs = {
  input: PublishCollectionInput;
};

export type MutationPublishLanguageArgs = {
  input: PublishLanguageInput;
};

export type MutationPublishProductArgs = {
  input: PublishProductInput;
};

export type MutationRegisterDeviceTokenArgs = {
  input: RegisterDeviceTokenInput;
};

export type MutationReorderGalleryArgs = {
  input: ReorderGalleryInput;
};

export type MutationRequestCustomerTaxExemptionArgs = {
  input: RequestCustomerTaxExemptionInput;
};

export type MutationShareWishlistArgs = {
  input: ShareWishlistInput;
};

export type MutationStorefrontCreateCheckoutArgs = {
  input: StorefrontCreateCheckoutInput;
};

export type MutationStorefrontCreateCheckoutFromOrderArgs = {
  input: StorefrontCreateCheckoutFromOrderInput;
};

export type MutationStorefrontUpdateCheckoutArgs = {
  input: StorefrontUpdateCheckoutInput;
};

export type MutationUnregisterDeviceTokenArgs = {
  input: UnregisterDeviceTokenInput;
};

export type MutationUnshareWishlistArgs = {
  input: UnshareWishlistInput;
};

export type MutationUpdateAssetAlternativeLinkArgs = {
  input: UpdateAssetAlternativeLinkInput;
};

export type MutationUpdateAssetModelVariantArgs = {
  input: Array<UpdateAssetModelVariantInput>;
};

export type MutationUpdateBackInStockSubscriptionArgs = {
  input: UpdateBackInStockSubscriptionInput;
};

export type MutationUpdateCollectionArgs = {
  input: UpdateCollectionInput;
};

export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};

export type MutationUpdateCustomerAddressArgs = {
  input: UpdateCustomerAddressInput;
};

export type MutationUpdateCustomerPayByInvoiceMetadataArgs = {
  input: UpdateCustomerPayByInvoiceMetadataInput;
};

export type MutationUpdateCustomersOwnMarketingArgs = {
  input: UpdateCustomersOwnMarketingInput;
};

export type MutationUpdateDefaultWarehouseArgs = {
  input: UpdateDefaultWarehouseInput;
};

export type MutationUpdateDiscountArgs = {
  input: UpdateDiscountInput;
};

export type MutationUpdateIntegrationArgs = {
  input: UpdateIntegrationInput;
};

export type MutationUpdateLanguageArgs = {
  input: UpdateLanguageInput;
};

export type MutationUpdateLimitationArgs = {
  input: UpdateLimitationInput;
};

export type MutationUpdateNotificationsArgs = {
  input: UpdateNotificationsInput;
};

export type MutationUpdateOptionArgs = {
  input: UpdateOptionInput;
};

export type MutationUpdateOrderBillingAddressArgs = {
  input: UpdateOrderBillingAddressInput;
};

export type MutationUpdateOrderDetailsArgs = {
  input: UpdateOrderDetailsInput;
};

export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};

export type MutationUpdateProductDocumentArgs = {
  input: UpdateProductDocumentInput;
};

export type MutationUpdateRelatedProductCategoryArgs = {
  input: ApUpdateRelatedProductCategoryInput;
};

export type MutationUpdateStoreArgs = {
  input: UpdateStoreInput;
};

export type MutationUpdateStoreCarrierArgs = {
  input: UpdateStoreCarrierInput;
};

export type MutationUpdateStoreSeoArgs = {
  input: UpdateStoreSeoInput;
};

export type MutationUpdateStoreShippingRateArgs = {
  input: UpdateStoreShippingRateInput;
};

export type MutationUpdateStoreShippingZoneArgs = {
  input: UpdateStoreShippingZoneInput;
};

export type MutationUpdateUpsellProductCategoryArgs = {
  input: ApUpdateUpsellProductCategoryInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationUpdateWarehouseArgs = {
  input: UpdateWarehouseInput;
};

export type MutationUpdateWishlistArgs = {
  input: UpdateWishlistInput;
};

export type MutationUpdateWishlistItemArgs = {
  input: UpdateWishlistItemInput;
};

export type MutationUploadImageArgs = {
  input: UploadImageInput;
};

export type MutationUploadModelArgs = {
  input: UploadModelInput;
};

export type MutationUploadProtectedAssetArgs = {
  input: UploadProtectedAssetInput;
};

export type MutationUploadVideoArgs = {
  input: UploadVideoInput;
};

export type MutationUpsertAssetZoneArgs = {
  input: UpsertAssetZoneInput;
};

export type MutationUpsertCollectionTagArgs = {
  input: UpsertCollectionTagInput;
};

export type MutationUpsertCustomerTagArgs = {
  input: UpsertCustomerTagInput;
};

export type MutationUpsertOrderTagArgs = {
  input: UpsertOrderTagInput;
};

export type MutationUpsertProductTagArgs = {
  input: UpsertProductTagInput;
};

export type MutationValidateAddressArgs = {
  input: AddressValidationInput;
};

export enum NetsuiteItemStatus {
  Picked = "Picked",
  Shipped = "Shipped",
}

export enum NetsuiteOrderStatus {
  Cancelled = "Cancelled",
  Closed = "Closed",
}

export type NodeTextblock = {
  __typename?: "NodeTextblock";
  blockNodeId: Scalars["UUID"]["output"];
  contentHtml: Scalars["String"]["output"];
  /** Extra fields required for resolvers */
  languageId: Scalars["UUID"]["output"];
};

export type Notice = {
  __typename?: "Notice";
  createdAt: Scalars["DateTime"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  title: Scalars["String"]["output"];
  type: NoticeType;
};

export enum NoticeType {
  Shipping = "Shipping",
  Store = "Store",
}

export type NoticesInput = {
  language: Scalars["LowercaseTrimmedString"]["input"];
  storeId: StoreId;
};

export type NotificationSetting = {
  __typename?: "NotificationSetting";
  createdAt: Scalars["DateTime"]["output"];
  /** Nullable because notificationType may not be supported for given channel */
  email?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Nullable because notificationType may not be supported for given channel */
  mobilePush?: Maybe<Scalars["Boolean"]["output"]>;
  /** Localized name of the notification type, defaults to english if not set */
  name: Scalars["String"]["output"];
  notificationType: NotificationType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type NotificationSettingInput = {
  deviceToken?: InputMaybe<DeviceTokenDataInput>;
  locale?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type NotificationSettings = {
  __typename?: "NotificationSettings";
  notifications: Array<NotificationSetting>;
};

export enum NotificationType {
  BackInStock = "BackInStock",
  OrderStatus = "OrderStatus",
  ProductLaunch = "ProductLaunch",
}

export type NotificationUpdateInput = {
  /** Nullable because notificationType may not be supported for given channel */
  email?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Nullable because notificationType may not be supported for given channel */
  mobilePush?: InputMaybe<Scalars["Boolean"]["input"]>;
  notificationType: NotificationType;
};

export type Option = {
  __typename?: "Option";
  createdAt: Scalars["DateTime"]["output"];
  defaultTranslation: OptionTranslation;
  id: Scalars["UUID"]["output"];
  productVariants: Array<ProductVariant>;
  slug: Scalars["String"]["output"];
  translations: Array<OptionTranslation>;
  updatedAt: Scalars["DateTime"]["output"];
  values: Array<OptionValue>;
};

export type OptionTranslation = Translation & {
  __typename?: "OptionTranslation";
  language: Language;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type OptionValue = {
  __typename?: "OptionValue";
  createdAt: Scalars["DateTime"]["output"];
  defaultTranslation: OptionTranslation;
  id: Scalars["UUID"]["output"];
  option: Option;
  productIds: Array<Scalars["UUID"]["output"]>;
  slug: Scalars["String"]["output"];
  translations: Array<OptionTranslation>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type OrderAddressUnion = OrderBusinessAddress | OrderResidentialAddress;

export type OrderBusinessAddress = BusinessAddress & {
  __typename?: "OrderBusinessAddress";
  additionalInfo?: Maybe<Scalars["String"]["output"]>;
  address1: Scalars["String"]["output"];
  address2?: Maybe<Scalars["String"]["output"]>;
  businessName?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  country: CountryCode;
  createdAt: Scalars["DateTime"]["output"];
  customerAddressId?: Maybe<Scalars["UUID"]["output"]>;
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  lastName: Scalars["String"]["output"];
  lat?: Maybe<Scalars["String"]["output"]>;
  long?: Maybe<Scalars["String"]["output"]>;
  neighborhood?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
  province?: Maybe<Scalars["String"]["output"]>;
  referenceNumber?: Maybe<Scalars["String"]["output"]>;
  stateRegistrationNumber?: Maybe<Scalars["String"]["output"]>;
  taxId?: Maybe<Scalars["String"]["output"]>;
  type: AddressType;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum OrderCancelErrorCode {
  NotSupported = "NotSupported",
  OrderAlreadyCanceled = "OrderAlreadyCanceled",
  OrderAlreadyCompleted = "OrderAlreadyCompleted",
  OrderAlreadyProcessing = "OrderAlreadyProcessing",
}

export enum OrderCancelOption {
  /** Order can be cancelled fully */
  Full = "Full",
  /** Order cannot be cancelled */
  None = "None",
  /** Order can be cancelled partially (eg, some items can be cancelled, some cannot) */
  Partial = "Partial",
  /** Unknown when we cannot determine the cancel option (eg, ERP system timeout) */
  Unknown = "Unknown",
}

export type OrderDisplayStatus = {
  __typename?: "OrderDisplayStatus";
  fulfillment: OrderFulfillmentDisplayStatus;
  payment: OrderTransactionDisplayStatus;
  return?: Maybe<OrderReturnDisplayStatus>;
};

export type OrderDraftOrderBy = {
  key: OrderDraftOrderByKey;
  order: SortOrder;
};

export enum OrderDraftOrderByKey {
  CreatedAt = "createdAt",
}

export enum OrderFulfillmentDisplayStatus {
  Cancelled = "Cancelled",
  Delivered = "Delivered",
  PartiallyDelivered = "PartiallyDelivered",
  PartiallyProcessed = "PartiallyProcessed",
  PartiallyShipped = "PartiallyShipped",
  PendingProcessing = "PendingProcessing",
  Processing = "Processing",
  Shipped = "Shipped",
}

export type OrderFulfillmentDisplayStatusCountItem = {
  __typename?: "OrderFulfillmentDisplayStatusCountItem";
  count: Scalars["NonNegativeInt"]["output"];
  status: OrderFulfillmentDisplayStatus;
};

export enum OrderFulfillmentStatus {
  /** TBD, ignore */
  Cancelled = "Cancelled",
  /** All items have been delivered */
  Delivered = "Delivered",
  /** Some items have been delivered */
  PartiallyDelivered = "PartiallyDelivered",
  /** Default status */
  PendingProcessing = "PendingProcessing",
  /** Items picked in netsuite */
  Processing = "Processing",
  /** Serviceable goods that are as is */
  Service = "Service",
  /** Netsuite has accepted items for shipping */
  Shipped = "Shipped",
}

export type OrderListFilterDateRangeInput = {
  /** EXCLUSIVE = order.created_at < startDate */
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** INCLUSIVE = order.created_at >= startDate */
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type OrderListFilterInput = {
  addressType?: InputMaybe<AddressType>;
  appPlatforms?: InputMaybe<Array<DeviceTokenPlatform>>;
  checkoutIntegrationIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  creationDateRange?: InputMaybe<OrderListFilterDateRangeInput>;
  customers?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  excludeIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  /**
   * If true, only return orders that have all products committed.
   * If false, only return orders that have at least one product not committed.
   */
  fullyCommitted?: InputMaybe<Scalars["Boolean"]["input"]>;
  fullyShipped?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  payByInvoice?: InputMaybe<Scalars["Boolean"]["input"]>;
  skus?: InputMaybe<Array<Scalars["TrimmedString"]["input"]>>;
  state?: InputMaybe<OrderState>;
  storeIds?: InputMaybe<Array<StoreId>>;
  taxExempt?: InputMaybe<Scalars["Boolean"]["input"]>;
  transactionStatuses?: InputMaybe<Array<OrderTransactionStatus>>;
};

export type OrderListInput = {
  filter?: InputMaybe<OrderListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<OrderOrderBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type OrderListResponse = PageResponse & {
  __typename?: "OrderListResponse";
  items: Array<ApOrder>;
  pagination: PaginationResponse;
};

export type OrderOperationProductTaxLine = TaxLine & {
  __typename?: "OrderOperationProductTaxLine";
  createdAt: Scalars["DateTime"]["output"];
  currency: Currency;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  orderOperationProduct: ApOrderOperationProduct;
  taxRate: Scalars["String"]["output"];
  taxTotal: Scalars["NonNegativeInt"]["output"];
  type: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type OrderOperationShippingTaxLine = TaxLine & {
  __typename?: "OrderOperationShippingTaxLine";
  createdAt: Scalars["DateTime"]["output"];
  currency: Currency;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  taxRate: Scalars["String"]["output"];
  taxTotal: Scalars["NonNegativeInt"]["output"];
  type: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export enum OrderOperationTransactionDisputeDisplayStatus {
  Closed = "Closed",
  Lost = "Lost",
  Mixed = "Mixed",
  NeedsResponse = "NeedsResponse",
  Open = "Open",
  UnderReview = "UnderReview",
  Won = "Won",
}

export enum OrderOperationTransactionDisputeStage {
  /**
   * Dispute stage
   * Stripe: customer has been refunded and we can either accept it or try to counter
   */
  Dispute = "Dispute",
  /**
   * Preliminary stage
   * Stripe: customers bank has requested transaction clarification
   */
  Inquiry = "Inquiry",
}

/** Each dispute stage can have its own status (depends both on the dispute stage and payment provider) */
export enum OrderOperationTransactionDisputeStatus {
  Closed = "Closed",
  Lost = "Lost",
  NeedsResponse = "NeedsResponse",
  Open = "Open",
  UnderReview = "UnderReview",
  Won = "Won",
}

export enum OrderOperationTransactionReviewStatus {
  Approved = "Approved",
  Pending = "Pending",
  Rejected = "Rejected",
}

export type OrderOperationTransactionRiskLevel = {
  __typename?: "OrderOperationTransactionRiskLevel";
  provider: RiskLevelProvider;
  riskLevel?: Maybe<Scalars["String"]["output"]>;
  riskScore?: Maybe<Scalars["NonNegativeInt"]["output"]>;
};

export enum OrderOperationType {
  Add = "Add",
  Return = "Return",
}

export type OrderOrderBy = {
  key: OrderOrderByKey;
  order: SortOrder;
};

export enum OrderOrderByKey {
  CreatedAt = "createdAt",
  OrderNumber = "orderNumber",
}

export type OrderPayByInvoiceInput = {
  contactEmail: Scalars["EmailAddress"]["input"];
  contactName: Scalars["TrimmedString"]["input"];
  customerMetadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  note?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  referenceNumber: Scalars["TrimmedString"]["input"];
};

export type OrderPayByInvoiceMetadata = {
  __typename?: "OrderPayByInvoiceMetadata";
  contactEmail: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  referenceNumber: Scalars["String"]["output"];
};

export type OrderResidentialAddress = ResidentialAddress & {
  __typename?: "OrderResidentialAddress";
  additionalInfo?: Maybe<Scalars["String"]["output"]>;
  address1: Scalars["String"]["output"];
  address2?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  country: CountryCode;
  createdAt: Scalars["DateTime"]["output"];
  customerAddressId?: Maybe<Scalars["UUID"]["output"]>;
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  lastName: Scalars["String"]["output"];
  lat?: Maybe<Scalars["String"]["output"]>;
  long?: Maybe<Scalars["String"]["output"]>;
  neighborhood?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
  province?: Maybe<Scalars["String"]["output"]>;
  taxId?: Maybe<Scalars["String"]["output"]>;
  type: AddressType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type OrderReturn = {
  __typename?: "OrderReturn";
  id: Scalars["UUID"]["output"];
  reason: DisplayReturnReason;
  reasonDescription?: Maybe<Scalars["String"]["output"]>;
  resolution: ReturnResolution;
  resolvedAt?: Maybe<Scalars["DateTime"]["output"]>;
  restockFeePercent: Scalars["Int"]["output"];
  shippingCarrier?: Maybe<ShippingCarrier>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type OrderReturnAuthor = Customer | User;

export enum OrderReturnDisplayStatus {
  Accepted = "Accepted",
  Pending = "Pending",
  Rejected = "Rejected",
}

export type OrderReturnDisplayStatusCountItem = {
  __typename?: "OrderReturnDisplayStatusCountItem";
  count: Scalars["NonNegativeInt"]["output"];
  status: OrderReturnDisplayStatus;
};

export type OrderReturnInput = {
  id: Scalars["UUID"]["input"];
};

export type OrderReturnSummary = {
  __typename?: "OrderReturnSummary";
  returns: Array<OrderReturn>;
  status: OrderReturnDisplayStatus;
};

export type OrderReturnTotalsInput = {
  items: Array<OrderReturnTotalsItemInput>;
  orderId: Scalars["UUID"]["input"];
  returnOption?: InputMaybe<ReturnOption>;
  shipping?: InputMaybe<ShippingOptionsInput>;
};

export type OrderReturnTotalsItemInput = {
  addOperationProductId: Scalars["UUID"]["input"];
  quantity: Scalars["NonNegativeInt"]["input"];
};

export type OrderReturnTotalsItemResponse = {
  __typename?: "OrderReturnTotalsItemResponse";
  addOperationProductId: Scalars["UUID"]["output"];
  hasTaxIncludedPrice: Scalars["Boolean"]["output"];
  itemPrice: Money;
  tariffTotal: Money;
  total: Money;
};

export type OrderReturnTotalsResponse = {
  __typename?: "OrderReturnTotalsResponse";
  /**
   * Wether shipment will be required for return
   * null when there is not enough information to understand
   */
  isShipmentRequired?: Maybe<Scalars["Boolean"]["output"]>;
  items: Array<OrderReturnTotalsItemResponse>;
  summary: OrderReturnTotalsSummaryResponse;
};

export type OrderReturnTotalsSummaryResponse = {
  __typename?: "OrderReturnTotalsSummaryResponse";
  hasCalculatedMoreThanAvailable: Scalars["Boolean"]["output"];
  restockFee: Money;
  restockFeePercent: Scalars["NonNegativeInt"]["output"];
  shipping?: Maybe<Money>;
  tariffTotal: Money;
  total: Money;
};

export type OrderReturnsInput = {
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
};

export type OrderReturnsResponse = PageResponse & {
  __typename?: "OrderReturnsResponse";
  items: Array<OrderReturn>;
  pagination: PaginationResponse;
};

export type OrderShippingOption = {
  __typename?: "OrderShippingOption";
  /** Protected field - requires full-access to order to view it */
  delivery?: Maybe<ShippingOptionDelivery>;
  discountFreeShipping: Scalars["Boolean"]["output"];
  hasTaxIncludedPrice: Scalars["Boolean"]["output"];
  isSignatureRequired: Scalars["Boolean"]["output"];
  /** Protected field - requires full-access to order to view it */
  name?: Maybe<Scalars["String"]["output"]>;
  totals: Totals;
};

export enum OrderState {
  Closed = "Closed",
  Completed = "Completed",
  Open = "Open",
  Paid = "Paid",
  Unpaid = "Unpaid",
}

export enum OrderStatus {
  Canceled = "Canceled",
  Completed = "Completed",
  Open = "Open",
}

export type OrderTag = {
  __typename?: "OrderTag";
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
};

export type OrderTotals = {
  __typename?: "OrderTotals";
  items: Totals;
  refund: Money;
  refundRestockFee: Money;
  refundShippingFee: Money;
  refundTax: Money;
  summary: Totals;
};

export enum OrderTransactionCardBrand {
  AmericanExpress = "AmericanExpress",
  Amex = "Amex",
  Diners = "Diners",
  Discover = "Discover",
  Elo = "Elo",
  Hipercard = "Hipercard",
  Jcb = "Jcb",
  Maestro = "Maestro",
  Mastercard = "Mastercard",
  RuPay = "RuPay",
  Unionpay = "Unionpay",
  Visa = "Visa",
}

/** Used as all payment charges derived status */
export enum OrderTransactionDisplayStatus {
  Authorized = "Authorized",
  Cancelled = "Cancelled",
  CaptureFailed = "CaptureFailed",
  Completed = "Completed",
  Created = "Created",
  Failed = "Failed",
  Free = "Free",
  PartiallyCompleted = "PartiallyCompleted",
  PartiallyPaid = "PartiallyPaid",
  PartiallyRefunded = "PartiallyRefunded",
  Processing = "Processing",
  Refunded = "Refunded",
  RequiresAction = "RequiresAction",
  Submitted = "Submitted",
}

export type OrderTransactionDisplayStatusCountItem = {
  __typename?: "OrderTransactionDisplayStatusCountItem";
  count: Scalars["NonNegativeInt"]["output"];
  status: OrderTransactionDisplayStatus;
};

export enum OrderTransactionPaymentMethod {
  /** Stripe */
  Ach = "Ach",
  /** Stripe */
  ApplePay = "ApplePay",
  /** PagBrasil */
  BankSlip = "BankSlip",
  /** Stripe */
  BankTransfer = "BankTransfer",
  /** Stripe/Razorpay/Hitrust/Dlocal */
  Card = "Card",
  /** Razorpay/PagBrasil */
  CreditCard = "CreditCard",
  /** Razorpay/PagBrasil */
  DebitCard = "DebitCard",
  /** Razorpay */
  Emi = "Emi",
  /** Alipay (Desktop web browser payment) */
  FastPay = "FastPay",
  /** Dlocal */
  GCash = "GCash",
  /** Stripe */
  GooglePay = "GooglePay",
  /** Dlocal */
  GrabPay = "GrabPay",
  /** Stripe */
  Ideal = "Ideal",
  /** Hitrust */
  LinePay = "LinePay",
  /** Stripe */
  Link = "Link",
  /** Manual bank transfer (no payment provider involved) */
  ManualBankTransfer = "ManualBankTransfer",
  /** Dlocal */
  Maya = "Maya",
  /** Razorpay */
  Netbanking = "Netbanking",
  /** Stripe/Paypal */
  Paypal = "Paypal",
  /** PagBrasil */
  Pix = "Pix",
  /** Stripe */
  Sepa = "Sepa",
  /** Used by all payment providers in cases when the selected payment method is not known yet */
  Unknown = "Unknown",
  /** Razorpay */
  Upi = "Upi",
  /** Razorpay */
  Wallet = "Wallet",
  /** Alipay (Mobile web browser payment) */
  WapPay = "WapPay",
}

/** @see: https://docs.stripe.com/payments/paymentintents/lifecycle */
export enum OrderTransactionStatus {
  Authorized = "Authorized",
  /** End state e.g. can't use same payment intent */
  Cancelled = "Cancelled",
  CaptureFailed = "CaptureFailed",
  Completed = "Completed",
  Created = "Created",
  /** e.g. Failed to capture funds */
  Failed = "Failed",
  /**
   * Partially completed status is a dead-end that could never transition to a
   * "Completed" status. Currently, it's used only by PagBrasil bank slip (Boleto)
   * payments in some edge cases where the transaction isn't fully paid.
   */
  PartiallyCompleted = "PartiallyCompleted",
  /**
   * In some cases payment can be made in multiple installments (theoretically).
   * Currently supported only by Stripe (bank transfer).
   */
  PartiallyPaid = "PartiallyPaid",
  Processing = "Processing",
  RequiresAction = "RequiresAction",
  Submitted = "Submitted",
}

export enum OrderTransactionType {
  Payment = "Payment",
  Refund = "Refund",
}

export type PageResponse = {
  pagination: PaginationResponse;
};

export type PaginationResponse = {
  __typename?: "PaginationResponse";
  limit: Scalars["PaginationLimit"]["output"];
  offset: Scalars["NonNegativeInt"]["output"];
  total: Scalars["NonNegativeInt"]["output"];
};

export enum PaymentProvider {
  Alipay = "Alipay",
  Dlocal = "Dlocal",
  Hitrust = "Hitrust",
  PagBrasil = "PagBrasil",
  Paypal = "Paypal",
  Paystack = "Paystack",
  Razorpay = "Razorpay",
  StoreManual = "StoreManual",
  Stripe = "Stripe",
}

export type PaymentProviderDetails = {
  __typename?: "PaymentProviderDetails";
  accountId?: Maybe<Scalars["String"]["output"]>;
  captureEnabled: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  paymentMethods: Array<OrderTransactionPaymentMethod>;
  publishableKey?: Maybe<Scalars["String"]["output"]>;
  type: PaymentProvider;
};

export type PaymentProviderPaymentMethod = {
  __typename?: "PaymentProviderPaymentMethod";
  accountId: Scalars["String"]["output"];
  paymentMethod: OrderTransactionPaymentMethod;
  paymentProviderId: Scalars["String"]["output"];
};

export type PercentDiscountBenefit = {
  __typename?: "PercentDiscountBenefit";
  percent: Scalars["NonNegativeInt"]["output"];
};

/** Represents physical carriers used by warehouse */
export enum PhysicalCarrier {
  Bluedart = "Bluedart",
  /** BR Shipping */
  CamiloDosSantos = "CamiloDosSantos",
  /** BR Shipping */
  CorreiosPac = "CorreiosPac",
  /** BR Shipping */
  CorreiosSedex = "CorreiosSedex",
  /** TW Shipping */
  CtcExpress = "CtcExpress",
  Dtdc = "DTDC",
  DelhiveryCourier = "DelhiveryCourier",
  Dhl = "Dhl",
  /** BR Shipping */
  Dialogo = "Dialogo",
  Dpd = "Dpd",
  Ekart = "Ekart",
  Evri = "Evri",
  Fedex = "Fedex",
  /** BR Shipping */
  JamefStandard = "JamefStandard",
  /** CN Shipping */
  KyExpress = "KyExpress",
  /** BR Shipping */
  PlatinumTransportes = "PlatinumTransportes",
  Purolator = "Purolator",
  /** BR Shipping */
  R3Express = "R3Express",
  RoyalMail = "RoyalMail",
  /** JP Shipping */
  Sagawajp = "Sagawajp",
  /** CN Shipping */
  SfExpress = "SfExpress",
  Smartr = "Smartr",
  /** BR Shipping */
  Total = "Total",
  /** BR Shipping */
  TotalExpressB2B = "TotalExpressB2B",
  Translovato = "Translovato",
  Ups = "Ups",
}

export enum PostPurchasePromoType {
  SiteSupport = "SiteSupport",
}

export type PrReportMetadata = {
  __typename?: "PrReportMetadata";
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  failedAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastMessage?: Maybe<Scalars["String"]["output"]>;
  prReportEndDate: Scalars["String"]["output"];
  prReportStartDate: Scalars["String"]["output"];
  progress: Scalars["Int"]["output"];
  taskId: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type ProductAssetZone = {
  __typename?: "ProductAssetZone";
  assetId: Scalars["UUID"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  iconPosition: AssetZoneIconPosition;
  id: Scalars["UUID"]["output"];
  productId: Scalars["UUID"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  /** Optional variant SKU for product asset zones; null for non-variant zones */
  variantSku?: Maybe<Scalars["String"]["output"]>;
  x0: Scalars["Int"]["output"];
  x1: Scalars["Int"]["output"];
  y0: Scalars["Int"]["output"];
  y1: Scalars["Int"]["output"];
};

export type ProductBundle = {
  __typename?: "ProductBundle";
  bundledProductIsStandalone: Scalars["Boolean"]["output"];
  bundledProductRatio: Scalars["NonNegativeInt"]["output"];
  bundledProductSku: Scalars["String"]["output"];
  countries: Array<CountryCode>;
  id: Scalars["UUID"]["output"];
  productRatio: Scalars["NonNegativeInt"]["output"];
  productSku: Scalars["String"]["output"];
  storeId: StoreId;
  strictMax: Scalars["Boolean"]["output"];
  strictMin: Scalars["Boolean"]["output"];
  syncAvailability: Scalars["Boolean"]["output"];
  translations: Array<ProductBundleTranslation>;
};

export type ProductBundleIssue = {
  __typename?: "ProductBundleIssue";
  bundledProductSku: Scalars["String"]["output"];
  hasMatchedBundledProductSku: Scalars["Boolean"]["output"];
  hasMatchedProductSku: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  productSku: Scalars["String"]["output"];
  storeId: StoreId;
};

export type ProductBundleListInput = {
  filter: ProductBundleListInputFilter;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<ProductBundleListOrderBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ProductBundleListInputFilter = {
  storeId?: InputMaybe<StoreId>;
};

export type ProductBundleListOrderBy = {
  key: ProductBundleListOrderByKey;
  order: SortOrder;
};

export enum ProductBundleListOrderByKey {
  BundledProductSku = "bundledProductSku",
  ProductSku = "productSku",
}

export type ProductBundleListResult = PageResponse & {
  __typename?: "ProductBundleListResult";
  items: Array<ProductBundle>;
  pagination: PaginationResponse;
};

export type ProductBundleNote = {
  __typename?: "ProductBundleNote";
  childStoreProductVariantId: Scalars["UUID"]["output"];
  note: Scalars["String"]["output"];
};

export type ProductBundleStoreIssue = {
  __typename?: "ProductBundleStoreIssue";
  issues: Scalars["NonNegativeInt"]["output"];
  storeId: StoreId;
};

export type ProductBundleTranslation = Translation & {
  __typename?: "ProductBundleTranslation";
  language: Language;
  productNote?: Maybe<Scalars["String"]["output"]>;
};

export type ProductBundleTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  productNote: Scalars["TrimmedString"]["input"];
};

export type ProductCompatibility = {
  __typename?: "ProductCompatibility";
  id: Scalars["UUID"]["output"];
  masterProductId: Scalars["UUID"]["output"];
  productIds: Array<Scalars["UUID"]["output"]>;
};

export type ProductDocument = {
  __typename?: "ProductDocument";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  productVariantId?: Maybe<Scalars["UUID"]["output"]>;
  type: ProductDocumentType;
  updatedAt: Scalars["DateTime"]["output"];
  url: Scalars["String"]["output"];
};

export enum ProductDocumentType {
  Datasheet = "Datasheet",
  InstallationGuide = "InstallationGuide",
  MountingTemplate = "MountingTemplate",
  QuickStartGuide = "QuickStartGuide",
  WiringGuide = "WiringGuide",
}

export enum ProductFamily {
  AirFiber = "AirFiber",
  AirMax = "AirMax",
  Amplifi = "Amplifi",
  EdgeMax = "EdgeMax",
  Ingram = "Ingram",
  Ltu = "Ltu",
  SunMax = "SunMax",
  UFiber = "UFiber",
  Ubiquiti = "Ubiquiti",
  Uisp = "Uisp",
  Unifi = "Unifi",
  Wave = "Wave",
}

export type ProductFaq = {
  __typename?: "ProductFaq";
  id: Scalars["UUID"]["output"];
  items: Array<ProductFaqItem>;
  languageId: Scalars["UUID"]["output"];
};

export type ProductFaqItem = {
  __typename?: "ProductFaqItem";
  answer: Block;
  id: Scalars["UUID"]["output"];
  languageId: Scalars["UUID"]["output"];
  question: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
};

export type ProductFaqItemInput = {
  answer: BlockInput;
  id: Scalars["UUID"]["input"];
  question: Array<ProductFaqQuestionTranslationInput>;
  sortOrder: Scalars["Int"]["input"];
  storeIds?: InputMaybe<Array<StoreId>>;
};

export type ProductFaqQuestionTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  text: Scalars["TrimmedString"]["input"];
};

export enum ProductFeatureLineRenderType {
  Diagonal = "Diagonal",
  Orthogonal = "Orthogonal",
}

export type ProductFeatureTranslationInput = {
  body: Scalars["TrimmedString"]["input"];
  languageId: Scalars["UUID"]["input"];
  title: Scalars["TrimmedString"]["input"];
};

export type ProductGroup = {
  __typename?: "ProductGroup";
  id: Scalars["UUID"]["output"];
  masterProductId: Scalars["UUID"]["output"];
  productIds: Array<Scalars["UUID"]["output"]>;
};

export type ProductInlineAccessoryGroup = {
  __typename?: "ProductInlineAccessoryGroup";
  id: Scalars["UUID"]["output"];
  label: Scalars["String"]["output"];
  /** @deprecated Use products[].id instead */
  productIds: Array<Scalars["UUID"]["output"]>;
  products: Array<ProductInlineAccessoryGroupProduct>;
  type: ProductInlineAccessoryGroupType;
};

export type ProductInlineAccessoryGroupProduct = {
  __typename?: "ProductInlineAccessoryGroupProduct";
  id: Scalars["UUID"]["output"];
  renderAsCard: Scalars["Boolean"]["output"];
};

export enum ProductInlineAccessoryGroupType {
  Multiple = "Multiple",
}

export enum ProductKind {
  /** Physical goods (e.g., UDM Pro) */
  Physical = "Physical",
  /** Serviceable goods (e.g., UI Care) */
  Service = "Service",
}

export enum ProductLine {
  Amplifi = "Amplifi",
  Uisp = "Uisp",
  Unifi = "Unifi",
}

export type ProductListFilterInput = {
  availability?: InputMaybe<Array<ProductStatus>>;
  baseSkus?: InputMaybe<Array<Scalars["UppercaseTrimmedString"]["input"]>>;
  excludeIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  families?: InputMaybe<Array<ProductFamily>>;
  ids?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  state?: InputMaybe<ProductState>;
  stores?: InputMaybe<Array<Scalars["String"]["input"]>>;
  tagNames?: InputMaybe<Array<Scalars["LowercaseTrimmedString"]["input"]>>;
  types?: InputMaybe<Array<ProductType>>;
};

export type ProductListInput = {
  filter?: InputMaybe<ProductListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<ProductOrderBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ProductListResponse = PageResponse & {
  __typename?: "ProductListResponse";
  items: Array<ApProduct>;
  pagination: PaginationResponse;
};

export type ProductNote = {
  __typename?: "ProductNote";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  productId: Scalars["UUID"]["output"];
  /**
   * Null -> Applies to all stores
   * Store ID array -> Applies to specific stores
   */
  storeIds?: Maybe<Array<StoreId>>;
  translations: Array<ProductNoteTranslation>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ProductNoteTranslation = Translation & {
  __typename?: "ProductNoteTranslation";
  language: Language;
  note?: Maybe<Scalars["String"]["output"]>;
};

export type ProductNoteTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  note?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ProductOrderBy = {
  key: ProductOrderByKey;
  order: SortOrder;
};

export enum ProductOrderByKey {
  DeletedAt = "deletedAt",
  Family = "family",
  FaqIsHidden = "faqIsHidden",
  Name = "name",
  State = "state",
  Type = "type",
}

export type ProductPriceIssue = {
  __typename?: "ProductPriceIssue";
  sku: Scalars["String"]["output"];
  /** State may not be known, if sku is unlinked */
  state?: Maybe<ProductState>;
  storeId: StoreId;
};

export type ProductPriceListEntry = {
  __typename?: "ProductPriceListEntry";
  hasProduct: Scalars["Boolean"]["output"];
  hasProductPrice: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** Price might not be set for this sku for the store */
  price?: Maybe<Money>;
  sku: Scalars["String"]["output"];
  /** State may not be known, if sku is unlinked */
  state?: Maybe<ProductState>;
  store: Store;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedBy?: Maybe<Scalars["String"]["output"]>;
};

export type ProductPriceOrderBy = {
  key: ProductPriceOrderByKey;
  order: SortOrder;
};

export enum ProductPriceOrderByKey {
  HasProduct = "hasProduct",
  HasProductPrice = "hasProductPrice",
  Price = "price",
  Sku = "sku",
  UpdatedAt = "updatedAt",
}

export type ProductPriceStoreIssue = {
  __typename?: "ProductPriceStoreIssue";
  issues: Scalars["NonNegativeInt"]["output"];
  storeId: StoreId;
};

export type ProductRegionalLimit = {
  __typename?: "ProductRegionalLimit";
  id: Scalars["UUID"]["output"];
  productId: Scalars["UUID"]["output"];
  productRegionalLimitCountries: Array<ProductRegionalLimitCountry>;
  productRegionalLimitServices: Array<ProductRegionalLimitService>;
  storeId: StoreId;
};

export type ProductRegionalLimitCountry = {
  __typename?: "ProductRegionalLimitCountry";
  country: CountryCode;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  zoneCode?: Maybe<Scalars["String"]["output"]>;
};

export type ProductRegionalLimitCountryInput = {
  country: CountryCode;
  zoneCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProductRegionalLimitService = {
  __typename?: "ProductRegionalLimitService";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  serviceCode: Scalars["String"]["output"];
  shippingCarrier: ShippingCarrier;
};

export type ProductRegionalLimitServiceInput = {
  serviceCode: Scalars["String"]["input"];
  shippingCarrier: ShippingCarrier;
};

export enum ProductSearchResultActionType {
  AddToCart = "AddToCart",
  View = "View",
}

export enum ProductState {
  Archived = "Archived",
  Draft = "Draft",
  Published = "Published",
}

export enum ProductStatus {
  Available = "Available",
  ComingSoon = "ComingSoon",
  RegionNotAvailable = "RegionNotAvailable",
  SoldOut = "SoldOut",
  Unavailable = "Unavailable",
}

export type ProductTag = {
  __typename?: "ProductTag";
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
};

export type ProductTranslation = Translation & {
  __typename?: "ProductTranslation";
  callout?: Maybe<Scalars["String"]["output"]>;
  datasheet?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  gridDescription?: Maybe<Scalars["String"]["output"]>;
  keyFeatures?: Maybe<Scalars["String"]["output"]>;
  keywords?: Maybe<Scalars["String"]["output"]>;
  language: Language;
  seoDescription?: Maybe<Scalars["String"]["output"]>;
  seoTitle?: Maybe<Scalars["String"]["output"]>;
  shortDescription?: Maybe<Scalars["String"]["output"]>;
  shortTitle?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export enum ProductType {
  Access = "Access",
  Accessories = "Accessories",
  Apparel = "Apparel",
  Connect = "Connect",
  Led = "LED",
  MultiPoint = "MultiPoint",
  PtPBridging = "PtPBridging",
  RoutersAndMesh = "RoutersAndMesh",
  Routing = "Routing",
  Server = "Server",
  Service = "Service",
  Solar = "Solar",
  Surveillance = "Surveillance",
  UniFiOsGateways = "UniFiOSGateways",
  VoIp = "VoIP",
  WiredTechnologies = "WiredTechnologies",
  Wireless = "Wireless",
}

export enum ProductUiCareManagement {
  Automatic = "Automatic",
  Manual = "Manual",
}

export type ProductVariant = {
  __typename?: "ProductVariant";
  assetModelSettings: Array<ProductVariantAssetModelSetting>;
  backorderLimit?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  galleryItemIds: Array<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  isEarlyAccess?: Maybe<Scalars["Boolean"]["output"]>;
  isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  isVisibleInStore?: Maybe<Scalars["Boolean"]["output"]>;
  optionValues: Array<OptionValue>;
  order: Scalars["Int"]["output"];
  price?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  product: ApProduct;
  sku?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<ProductStatus>;
  storeProductVariants: Array<StoreProductVariant>;
  uiCareManagement?: Maybe<ProductUiCareManagement>;
  uiCarePriceOverride?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  /** Acts as bigint string */
  weight?: Maybe<Scalars["String"]["output"]>;
};

export type ProductVariantAssetModelSetting = {
  __typename?: "ProductVariantAssetModelSetting";
  assetId: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  materialVariantName: Scalars["String"]["output"];
  productVariantId: Scalars["UUID"]["output"];
};

export enum ProductVariesBy {
  IsEarlyAccess = "isEarlyAccess",
  IsEnabled = "isEnabled",
  IsVisibleInStore = "isVisibleInStore",
  Price = "price",
  Status = "status",
  UiCareManagement = "uiCareManagement",
  Weight = "weight",
}

export type ProtectedAsset = {
  __typename?: "ProtectedAsset";
  createdAt: Scalars["DateTime"]["output"];
  filename: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  mimeType: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export enum ProtectedAssetEntityType {
  Comment = "Comment",
  CustomerTaxExemption = "CustomerTaxExemption",
  OrderReturnPackingSlip = "OrderReturnPackingSlip",
  SpecificationEntity = "SpecificationEntity",
}

export type PublishCollectionInput = {
  id: Scalars["UUID"]["input"];
};

export type PublishCollectionResponse = {
  __typename?: "PublishCollectionResponse";
  collection: Collection;
};

export type PublishLanguageInput = {
  id: Scalars["UUID"]["input"];
};

export type PublishLanguageResponse = {
  __typename?: "PublishLanguageResponse";
  language: Language;
};

export type PublishProductInput = {
  id: Scalars["UUID"]["input"];
};

export type PublishProductResponse = {
  __typename?: "PublishProductResponse";
  product: ApProduct;
};

export type Query = {
  __typename?: "Query";
  /**
   * **Private Endpoint:**
   * ⚠️ ExchangeRate query needs ExchangeRateView permission ⚠️
   */
  activeExchangeRates: ExchangeRateListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Activities query needs ActivityView permission ⚠️
   */
  activities: ActivityListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Activity query needs ActivityView permission ⚠️
   */
  activity?: Maybe<ActivityAny>;
  /**
   * **Private Endpoint:**
   * ⚠️ Aggregates query needs AnalyticsView permission ⚠️
   */
  aggregates: AggregatesResult;
  /** **Private Endpoint:** */
  apActiveUsers: Array<ApActiveUser>;
  /**
   * **Private Endpoint:**
   * ⚠️  apAvailableEmailTemplates query needs ReportView permission ⚠️
   *   Returns list of abailble email templates
   */
  apAvailableEmailTemplates: ApAvailableEmailTemplatesResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apBackInStock query needs BackInStockView permission ⚠️
   */
  apBackInStock: ApBackInStockListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apBackInStockSubscriptionCount query needs BackInStockView permission ⚠️
   */
  apBackInStockSubscriptionCount: Array<ApBackInStockSubscriptionCountResponse>;
  /** **Private Endpoint:** */
  apCacheRecordEntries: Array<ApCacheRecordEntry>;
  /**
   * **Private Endpoint:**
   * ⚠️ ApCategories query needs CategoryView permission ⚠️
   */
  apCategories: ApCategoryListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApCategory query needs CategoryView permission ⚠️
   */
  apCategory?: Maybe<ApCategory>;
  /**
   * **Private Endpoint:**
   * ⚠️ ApCategoryFilter query needs CategoryView permission ⚠️
   */
  apCategoryFilter?: Maybe<ApCategoryFilter>;
  /**
   * **Private Endpoint:**
   * ⚠️ ApCategoryFilters query needs CategoryView permission ⚠️
   */
  apCategoryFilters: ApCategoryFilterListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApCategoryProductFilter query needs CategoryView permission ⚠️
   */
  apCategoryProductFilter?: Maybe<ApCategoryProductFilter>;
  /**
   * **Private Endpoint:**
   * ⚠️ ApCategoryProductFilters query needs CategoryView permission ⚠️
   */
  apCategoryProductFilters: ApCategoryProductFilterListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apCategorySlugRedirects query needs CategoryView permission ⚠️
   */
  apCategorySlugRedirects: ApCategorySlugRedirectListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apComments query needs CommentView permission ⚠️
   */
  apComments: ApCommentsListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs CustomerView permission ⚠️
   */
  apCustomerTaxExemptions: ApCustomerTaxExemptionResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apCustomersWithPendingTaxExemption query needs CustomerView permission ⚠️
   */
  apCustomersWithPendingTaxExemption: ApCustomersWithPendingTaxExemptionResponse;
  /**
   * **Private Endpoint:**
   * ⚠️  apEmailEventsAggregated query needs ReportView permission ⚠️
   *   Returns statistics about email tracking events
   */
  apEmailEventsAggregated: ApEmailEventsAggregatedResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductView permission ⚠️
   */
  apGalleryCategories: Array<ApGalleryCategory>;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductView permission ⚠️
   */
  apGalleryCategory?: Maybe<ApGalleryCategory>;
  /**
   * **Private Endpoint:**
   * ⚠️ apGetCreateOrderShippingOptions query needs OrderDraftCreate permission ⚠️
   */
  apGetCreateOrderData: ApGetCreateOrderDataResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApGetMockedTaxIdValidationStatus mutation needs signed in user ⚠️
   * ⚠️ ApGetMockedTaxIdValidationStatus is only available in configured environments ⚠️
   */
  apGetMockedTaxIdValidationStatus: ApGetMockedTaxIdValidationResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires specific permissions based on entity type  ⚠️
   */
  apGetProtectedAssetSignedUrl: ApGetProtectedAssetSignedUrlResponse;
  /** Returns list of all previous slugs that the given entity has been assigned to. */
  apHistoricalSlugs: Array<ApHistoricalSlug>;
  /** **Private Endpoint:** */
  apInventoryPolicyGlobal?: Maybe<ApInventoryPolicyGlobal>;
  /** **Private Endpoint:** */
  apInventoryPolicyGlobals: Array<ApInventoryPolicyGlobal>;
  apInventoryPolicyOverride?: Maybe<ApInventoryPolicyOverride>;
  apInventoryPolicyOverrides: Array<ApInventoryPolicyOverride>;
  /**
   * **Private Endpoint:**
   * ⚠️ ApListMockedTaxIdValidationStatuses mutation needs signed in user ⚠️
   * ⚠️ ApListMockedTaxIdValidationStatuses is only available in configured environments ⚠️
   */
  apListMockedTaxIdValidationStatuses: ApListMockedTaxIdValidationStatusesResponse;
  /** **Private Endpoint:** */
  apListProductMeasurements: ApListProductMeasurementsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires specific permissions based on entity type  ⚠️
   */
  apListSpecificationAssets: ApListSpecificationAssetsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ ApNotice query needs NoticeView permission ⚠️
   */
  apNotice?: Maybe<ApNotice>;
  /**
   * **Private Endpoint:**
   * ⚠️ Notices query needs NoticeView permission ⚠️
   */
  apNotices: ApNoticeListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apOldestPendingOrderReturn query needs OrderView permission ⚠️
   */
  apOldestPendingOrderReturn?: Maybe<ApOrderReturn>;
  /**
   * **Private Endpoint:**
   * ⚠️ Draft order query needs OrderView permission ⚠️
   */
  apOrderDraft?: Maybe<ApOrderDraft>;
  /**
   * **Private Endpoint:**
   * ⚠️ Draft order list query needs OrderView permission ⚠️
   */
  apOrderDrafts: ApOrderDraftListResult;
  /**
   * **Private Endpoint:**
   * ⚠️ apOrderReturn query needs OrderView permission ⚠️
   */
  apOrderReturn?: Maybe<ApOrderReturn>;
  /**
   * **Private Endpoint:**
   * ⚠️ apOrderReturnTotals query needs OrderView permission ⚠️
   */
  apOrderReturnTotals: ApOrderReturnTotalsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apOrderReturns query needs OrderView permission ⚠️
   */
  apOrderReturns: ApOrderReturnListResponse;
  /** Returns a payment provider for the given id */
  apPaymentProvider?: Maybe<ApPaymentProviderDetails>;
  /**
   * **Private Endpoint:**
   * ⚠️  apPaymentProviderPaymentMethods query needs PaymentProviderView permission ⚠️
   *   Returns a paymentProviderPaymentMethod for the given paymentProvider id
   */
  apPaymentProviderPaymentMethods: Array<PaymentProviderPaymentMethod>;
  /** Returns list of payment providers for the given store */
  apPaymentProviders: Array<ApPaymentProviderDetails>;
  /** Return list of latest PR report triggers from lambda */
  apPrReports: LastPrReportResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Product bundle query needs ProductView permission ⚠️
   */
  apProductBundle?: Maybe<ProductBundle>;
  apProductBundleIssues: Array<ProductBundleIssue>;
  apProductBundleStoreIssues: Array<ProductBundleStoreIssue>;
  /**
   * **Private Endpoint:**
   * ⚠️ Product bundles query needs ProductView permission ⚠️
   */
  apProductBundles: ProductBundleListResult;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductView permission ⚠️
   */
  apProductCompatibilities: ApProductCompatibilityListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductView permission ⚠️
   */
  apProductCompatibility?: Maybe<ApProductCompatibility>;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductView permission ⚠️
   */
  apProductFaqs?: Maybe<ApProductFaq>;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductView permission ⚠️
   */
  apProductFeatures: Array<ApProductFeature>;
  apProductPriceIssues: Array<ProductPriceIssue>;
  apProductPriceStoreIssues: Array<ProductPriceStoreIssue>;
  apProductPrices: ApProductPricesResult;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs ProductSalesCampaignView permission ⚠️
   */
  apProductSalesCampaign?: Maybe<ApProductSalesCampaign>;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs ProductSalesCampaignView permission ⚠️
   */
  apProductSalesCampaigns: ApProductSalesCampaignsListResponse;
  /** **Private Endpoint:** */
  apProductTaxRates: Array<ApProductTaxRate>;
  /** **Private Endpoint:** */
  apProductsTaxRates: Array<ApProductTaxRate>;
  apShippingHeavyItems: Array<ApShippingHeavyItem>;
  /**
   * **Private Endpoint:**
   * ⚠️ apSlugRedirect query needs SlugRedirectView permission ⚠️
   */
  apSlugRedirect: ApSlugRedirectResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ apSlugRedirects query needs SlugRedirectView permission ⚠️
   */
  apSlugRedirects: ApSlugRedirectListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs StoreEdit permission ⚠️
   */
  apSmartcatDeliveryErrors: Array<ApSmartcatDeliveryError>;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs StoreEdit permission ⚠️
   */
  apSmartcatWebhookConfigs: ApSmartcatWebhookConfigsResult;
  apSpecificationFeature?: Maybe<ApSpecificationFeature>;
  apSpecificationFeatures: Array<ApSpecificationFeature>;
  apSpecificationFeaturesBySlug: Array<ApSpecificationFeature>;
  apSpecificationSection?: Maybe<ApSpecificationSection>;
  apSpecificationSections: Array<ApSpecificationSection>;
  apSpecificationSectionsById: Array<ApSpecificationSection>;
  apSpecificationSectionsBySlug: Array<ApSpecificationSection>;
  apSpecificationTemplate?: Maybe<ApSpecificationTemplate>;
  apSpecificationTemplates: Array<ApSpecificationTemplate>;
  apSpecificationTemplatesById: Array<ApSpecificationTemplate>;
  apSpecificationTemplatesBySlug: Array<ApSpecificationTemplate>;
  /**
   * **Private Endpoint:**
   * ⚠️ ApStoreBankDetails query needs StoreEdit permission ⚠️
   */
  apStoreBankDetails?: Maybe<ApStoreBankDetails>;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductView permission ⚠️
   */
  apStoreProductListItems: ApStoreProductListItemsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires ProductView permission ⚠️
   */
  apStoreProductLists: ApStoreProductListsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires StorefrontProductVariantPartNumberView permission ⚠️
   */
  apStorefrontProductVariantPartNumberList: ApStorefrontProductVariantPartNumberListResponse;
  /** **Private Endpoint:** */
  apTagTemplates: ApTagTemplateListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires admin session ⚠️
   */
  apTariff?: Maybe<ApTariff>;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires admin session ⚠️
   */
  apTariffs: ApTariffListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs CustomerView permission ⚠️
   */
  apTaxExemptionEntitiesByStoreId: ApTaxExemptionEntitiesByStoreIdResponse;
  /** **Private Endpoint:** */
  apTaxRate?: Maybe<ApTaxRate>;
  /** **Private Endpoint:** */
  apTaxRates: ApTaxRateListResponse;
  /** **Private Endpoint:** */
  apTranslationJobStatus: TranslationJobStatusResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs api user login ⚠️
   */
  apiProducts: ApiProductListResponse;
  /**
   * **Private Endpoint:**
   * If there are validation errors, it throws
   */
  apiValidateCart: Scalars["Boolean"]["output"];
  /**
   * **Private Endpoint:**
   * ⚠️ Asset query requires user ⚠️
   */
  asset?: Maybe<Asset>;
  /**
   * **Private Endpoint:**
   * ⚠️ AssetModelVariantsByAssetId query requires user ⚠️
   */
  assetModelVariantsByAssetId: Array<AssetModelVariant>;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs admin user login ⚠️
   */
  availableCountries: Array<Country>;
  /**
   * **Private Endpoint:**
   * ⚠️ storeCarrierServices query needs StoreCarrierView permission ⚠️
   */
  availableStoreCarrierServices: Array<StoreCarrierService>;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs admin user login ⚠️
   */
  availableTimezones: Array<TimeZoneData>;
  /** **Public Endpoint:** */
  backInStockSubscribed: Array<BackInStockSubscribedResponse>;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs admin user login ⚠️
   */
  carrierServices: Array<CarrierServicesResponse>;
  /**
   * **Public Endpoint:**
   * Returns all categories with all translations and filter definitions.
   * No input required — returns data for all stores and languages.
   */
  categoryMapping: CategoriesResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Checkout query needs CheckoutView permission ⚠️
   */
  checkout?: Maybe<Checkout>;
  /**
   * **Private Endpoint:**
   * ⚠️ Checkouts query needs CheckoutView permission ⚠️
   */
  checkouts: CheckoutListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Collection query needs CollectionView permission ⚠️
   */
  collection?: Maybe<Collection>;
  /**
   * **Private Endpoint:**
   * ⚠️ CollectionBySlug query needs CollectionView permission ⚠️
   */
  collectionBySlug?: Maybe<Collection>;
  /**
   * **Private Endpoint:**
   * ⚠️ CollectionCategory query needs CollectionView permission ⚠️
   */
  collectionCategory?: Maybe<ApCollectionCategory>;
  collectionTag?: Maybe<CollectionTag>;
  collectionTags: Array<CollectionTag>;
  /**
   * **Private Endpoint:**
   * ⚠️ Collections query needs CollectionView permission ⚠️
   */
  collections: CollectionListResponse;
  config: Config;
  /**
   * **Private Endpoint:**
   * ⚠️ Customer query needs CustomerView permission ⚠️
   */
  customer?: Maybe<Customer>;
  /**
   * **Private Endpoint:**
   * ⚠️ customerAddress query needs valid customer session ⚠️
   */
  customerAddress?: Maybe<CustomerAddressUnion>;
  /**
   * **Private Endpoint:**
   * ⚠️ CustomerAddresses query needs valid customer session ⚠️
   */
  customerAddresses: Array<CustomerAddressUnion>;
  /**
   * **Private Endpoint:**
   * ⚠️ Customer query needs CustomerView permission ⚠️
   * Using TrimmedString for input because customers can have an email address with uppercase letters (historical reasons)
   */
  customerByEmail?: Maybe<Customer>;
  /** **Public Endpoint:** */
  customerPayByInvoiceMetadata: Array<CustomerPayByInvoiceMetadata>;
  /**
   * **Private Endpoint:**
   * ⚠️ CustomerTag query needs CustomerView permission ⚠️
   */
  customerTag?: Maybe<CustomerTag>;
  /**
   * **Private Endpoint:**
   * ⚠️ CustomerTags query needs CustomerView permission ⚠️
   */
  customerTags: Array<CustomerTag>;
  /** **Public Endpoint** */
  customerTaxExemptions: CustomerTaxExemptionListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Customers query needs CustomerView permission ⚠️
   */
  customers: CustomerListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs DiscountView permission ⚠️
   */
  discount?: Maybe<Discount>;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs DiscountView permission ⚠️
   */
  discountSlugGroups: Array<DiscountSlugGroup>;
  /**
   * **Private Endpoint:**
   * ⚠️ Query needs DiscountView permission ⚠️
   */
  discounts: DiscountListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Embed query requires user ⚠️
   */
  embed?: Maybe<Embed>;
  /**
   * **Private Endpoint:**
   * ⚠️ ExchangeRate query needs ExchangeRateView permission ⚠️
   */
  exchangeRate?: Maybe<ExchangeRate>;
  /**
   * **Private Endpoint:**
   * ⚠️ ExchangeRateBetweenStores query needs ExchangeRateView permission ⚠️
   */
  exchangeRateBetweenStores: Array<ExchangeRate>;
  /**
   * **Private Endpoint:**
   * ⚠️ ExchangeRate query needs ExchangeRateView permission ⚠️
   */
  exchangeRates: Array<ExchangeRate>;
  /** **Public Endpoint:** */
  getCountryTaxRate: TaxRateResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Requires specific permissions based on entity type  ⚠️
   */
  getProtectedAssetSignedUrl: GetProtectedAssetSignedUrlResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ Integration query needs IntegrationView permission ⚠️
   */
  integration?: Maybe<ApIntegration>;
  /**
   * **Private Endpoint:**
   * ⚠️ Integrations query needs IntegrationView permission ⚠️
   */
  integrations: Array<ApIntegration>;
  /**
   * **Private Endpoint:**
   * Returns inventory history for the SKU/Warehouse
   */
  inventoryHistory: InventoryHistoryResponse;
  /** **Private Endpoint:** */
  inventoryState: Array<InventoryState>;
  /** **Private Endpoint:** */
  language?: Maybe<Language>;
  /** **Private Endpoint:** */
  languages: Array<Language>;
  /**
   * **Private Endpoint:**
   * ⚠️ Limitation query needs LimitationView permission ⚠️
   */
  limitation?: Maybe<Limitation>;
  /**
   * **Private Endpoint:**
   * ⚠️ Limitations query needs LimitationView permission ⚠️
   */
  limitations: LimitationListResponse;
  /** **Public Endpoint:** */
  me?: Maybe<User>;
  /** **Public Endpoint:** */
  meCustomer?: Maybe<Customer>;
  /**
   * **Private Endpoint:**
   * ⚠️ Asset query requires user ⚠️
   */
  model?: Maybe<Model>;
  /** **Public Endpoint:** */
  notices: Array<Notice>;
  notificationSettings: NotificationSettings;
  /**
   * **Private Endpoint:**
   * ⚠️ Option query needs OptionView permission ⚠️
   */
  option?: Maybe<Option>;
  /**
   * **Private Endpoint:**
   * ⚠️ Options query needs OptionView permission ⚠️
   */
  options: Array<Option>;
  /**
   * **Private Endpoint:**
   * ⚠️ Order query needs OrderView permission ⚠️
   */
  order?: Maybe<ApOrder>;
  /**
   * **Public Endpoint:**
   * Returns order return belonging to the current logged-in customer
   */
  orderReturn: OrderReturn;
  /** **Public Endpoint:** */
  orderReturnTotals: OrderReturnTotalsResponse;
  /**
   * **Public Endpoint:**
   * Returns order returns belonging to the current logged-in customer
   */
  orderReturns: OrderReturnsResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ OrderTag query needs OrderView permission ⚠️
   */
  orderTag?: Maybe<OrderTag>;
  /**
   * **Private Endpoint:**
   * ⚠️ OrderTags query needs OrderView permission ⚠️
   */
  orderTags: Array<OrderTag>;
  /**
   * **Private Endpoint:**
   * ⚠️ Orders query needs OrderView permission ⚠️
   */
  orders: OrderListResponse;
  /** Returns a payment provider for the given id */
  paymentProvider?: Maybe<PaymentProviderDetails>;
  /** Returns list of enabled payment providers for the given store */
  paymentProviders: Array<PaymentProviderDetails>;
  /**
   * **Private Endpoint:**
   * ⚠️ Product query needs ProductView permission ⚠️
   */
  product?: Maybe<ApProduct>;
  /**
   * **Private Endpoint:**
   * ⚠️ ProductByBaseSku query needs ProductView permission ⚠️
   */
  productByBaseSku?: Maybe<ApProduct>;
  /** **Public Endpoint:** */
  productFaqs?: Maybe<ProductFaq>;
  /** Returns Regional Limits where product is not available for purchase or is limited to particular shipping carrier services */
  productRegionalLimits?: Maybe<Array<Maybe<ProductRegionalLimit>>>;
  /**
   * **Private Endpoint:**
   * ⚠️ ProductTag query needs ProductView permission ⚠️
   */
  productTag?: Maybe<ProductTag>;
  /**
   * **Private Endpoint:**
   * ⚠️ ProductTags query needs ProductView permission ⚠️
   */
  productTags: Array<ProductTag>;
  /**
   * **Private Endpoint:**
   * ⚠️ Products query needs ProductView permission ⚠️
   */
  products: ProductListResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ RelatedProductCategories query needs RelatedProductCategoryView permission ⚠️
   */
  relatedProductCategories: Array<ApRelatedProductCategory>;
  /**
   * **Private Endpoint:**
   * ⚠️ RelatedProductCategory query needs RelatedProductCategoryView permission ⚠️
   */
  relatedProductCategory?: Maybe<ApRelatedProductCategory>;
  /**
   * **Public Endpoint:**
   * Returns wishlists shared with the authenticated customer.
   */
  sharedWishlists: Array<Wishlist>;
  /**
   * **Private Endpoint:**
   * ⚠️ SsoUser query needs SsoUserView permission ⚠️
   */
  ssoUser?: Maybe<SsoUser>;
  /**
   * **Private Endpoint:**
   * ⚠️ Store query needs StoreView permission ⚠️
   */
  store?: Maybe<Store>;
  /**
   * **Private Endpoint:**
   * ⚠️ storeCarrier query needs StoreCarrierView permission ⚠️
   */
  storeCarrier?: Maybe<StoreCarrier>;
  /**
   * **Private Endpoint:**
   * ⚠️ storeCarriers query needs StoreCarrierView permission ⚠️
   */
  storeCarriers: Array<StoreCarrier>;
  /** **Public Endpoint:** */
  storeCountries: StoreCountriesResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ StoreSeoSettings query needs StoreSeoView permission ⚠️
   */
  storeSeoSettings: Array<StoreSeo>;
  /**
   * **Private Endpoint:**
   * ⚠️ storeShippingRate query needs StoreCarrierView permission ⚠️
   */
  storeShippingRate?: Maybe<StoreShippingRateUnion>;
  /**
   * **Private Endpoint:**
   * ⚠️ storeShippingZone query needs StoreCarrierView permission ⚠️
   */
  storeShippingZone?: Maybe<StoreShippingZone>;
  /**
   * **Private Endpoint:**
   * Returns list of all warehouses for a given store
   */
  storeWarehouses: Array<Warehouse>;
  /** **Public Endpoint:** */
  storefrontCheckout: StorefrontCheckoutResponse;
  /** **Public Endpoint:** */
  storefrontCollection: StorefrontCollection;
  /** **Public Endpoint:** */
  storefrontCollections: StorefrontCollectionListResponse;
  /**
   * **Public Endpoint:**
   * Returns historical orders belonging to the current logged-in customer
   */
  storefrontHistoricalOrders: StorefrontHistoricalOrdersListResponse;
  /**
   * **Public Endpoint:**
   * Returns order belonging to the current logged-in customer
   */
  storefrontOrder: StorefrontOrder;
  /**
   * **Public Endpoint:**
   * Returns orders belonging to the current logged-in customer
   */
  storefrontOrders: StorefrontOrdersResponse;
  /** **Public Endpoint:** */
  storefrontProduct?: Maybe<StorefrontProduct>;
  /** **Public Endpoint:** */
  storefrontProducts: StorefrontProductListResponse;
  /** **Public Endpoint:** */
  storefrontProductsById: Array<StorefrontProduct>;
  /** **Public Endpoint:** */
  storefrontProductsUrls: Array<StorefrontProductUrls>;
  /** **Public Endpoint:** */
  storefrontRecommendedProducts: Array<StorefrontProduct>;
  /** **Public Endpoint:** */
  storefrontStore: StorefrontStore;
  /**
   * **Private Endpoint:**
   * ⚠️ Stores query needs StoreView permission ⚠️
   */
  stores: Array<Store>;
  /** **Public Endpoint** */
  taxExemptionEntitiesByStoreId: TaxExemptionEntitiesByStoreIdResponse;
  /**
   * **Private Endpoint:**
   * ⚠️ UpsellProductCategories query needs UpsellProductCategoryView permission ⚠️
   */
  upsellProductCategories: Array<ApUpsellProductCategory>;
  /**
   * **Private Endpoint:**
   * ⚠️ UpsellProductCategory query needs UpsellProductCategoryView permission ⚠️
   */
  upsellProductCategory?: Maybe<ApUpsellProductCategory>;
  /**
   * **Private Endpoint:**
   * ⚠️ User query needs UserView permission ⚠️
   */
  user?: Maybe<User>;
  /**
   * **Private Endpoint:**
   * ⚠️ User query needs UserView permission ⚠️
   */
  users: Array<User>;
  /**
   * **Public Endpoint:**
   * If there are validation errors, it throws
   */
  validateCart: Scalars["Boolean"]["output"];
  /**
   * **Public Endpoint**
   * Used to validate tax id
   */
  validateTaxId?: Maybe<TaxIdValidationResponse>;
  /**
   * **Private Endpoint:**
   * Returns warehouse
   */
  warehouse?: Maybe<Warehouse>;
  /**
   * **Private Endpoint:**
   * Returns list of all warehouses
   */
  warehouses: Array<Warehouse>;
  /**
   * **Public Endpoint:**
   * Returns a single wishlist by ID (owner/public) or shareToken (invited).
   */
  wishlist?: Maybe<Wishlist>;
  /**
   * **Public Endpoint:**
   * Returns the authenticated customer's wishlists for a store.
   */
  wishlists: Array<Wishlist>;
};

export type QueryActiveExchangeRatesArgs = {
  input: ExchangeRateListInput;
};

export type QueryActivitiesArgs = {
  input: ActivityListInput;
};

export type QueryActivityArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryAggregatesArgs = {
  input: AggregatesInput;
};

export type QueryApActiveUsersArgs = {
  input: ApActiveUsersInput;
};

export type QueryApBackInStockArgs = {
  input: ApBackInStockListInput;
};

export type QueryApBackInStockSubscriptionCountArgs = {
  input: ApBackInStockSubscriptionCountInput;
};

export type QueryApCategoriesArgs = {
  input: ApCategoryListInput;
};

export type QueryApCategoryArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApCategoryFilterArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApCategoryFiltersArgs = {
  input: ApCategoryFilterListInput;
};

export type QueryApCategoryProductFilterArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApCategoryProductFiltersArgs = {
  input: ApCategoryProductFilterListInput;
};

export type QueryApCategorySlugRedirectsArgs = {
  toEntityId: Scalars["UUID"]["input"];
  toEntityType: CategorySlugRedirectEntityType;
};

export type QueryApCommentsArgs = {
  input: ApCommentsListInput;
};

export type QueryApCustomerTaxExemptionsArgs = {
  input: ApCustomerTaxExemptionInput;
};

export type QueryApEmailEventsAggregatedArgs = {
  input: ApEmailEventsAggregatedInput;
};

export type QueryApGalleryCategoryArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApGetCreateOrderDataArgs = {
  input: ApGetCreateOrderDataInput;
};

export type QueryApGetMockedTaxIdValidationStatusArgs = {
  input: ApGetMockedTaxIdValidationInput;
};

export type QueryApGetProtectedAssetSignedUrlArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApHistoricalSlugsArgs = {
  entityId: Scalars["UUID"]["input"];
  entityType: SlugHistoryEntity;
};

export type QueryApInventoryPolicyGlobalArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApInventoryPolicyOverrideArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApListProductMeasurementsArgs = {
  input: ApListProductMeasurementInput;
};

export type QueryApNoticeArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApNoticesArgs = {
  input: ApNoticeListInput;
};

export type QueryApOldestPendingOrderReturnArgs = {
  orderId: Scalars["UUID"]["input"];
};

export type QueryApOrderDraftArgs = {
  input: ApOrderDraftInput;
};

export type QueryApOrderDraftsArgs = {
  input: ApOrderDraftListInput;
};

export type QueryApOrderReturnArgs = {
  input: ApOrderReturnInput;
};

export type QueryApOrderReturnTotalsArgs = {
  input: ApOrderReturnTotalsInput;
};

export type QueryApOrderReturnsArgs = {
  input: ApOrderReturnListInput;
};

export type QueryApPaymentProviderArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApPaymentProviderPaymentMethodsArgs = {
  providerId: Scalars["UUID"]["input"];
};

export type QueryApPaymentProvidersArgs = {
  storeId: StoreId;
};

export type QueryApPrReportsArgs = {
  refresh: Scalars["Boolean"]["input"];
};

export type QueryApProductBundleArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApProductBundlesArgs = {
  input: ProductBundleListInput;
};

export type QueryApProductCompatibilitiesArgs = {
  input: ApProductCompatibilityListInput;
};

export type QueryApProductCompatibilityArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApProductFaqsArgs = {
  productId: Scalars["UUID"]["input"];
};

export type QueryApProductFeaturesArgs = {
  productId: Scalars["UUID"]["input"];
};

export type QueryApProductPricesArgs = {
  input: ApProductPricesInput;
};

export type QueryApProductSalesCampaignArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApProductSalesCampaignsArgs = {
  input: ApProductSalesCampaignsListInput;
};

export type QueryApProductTaxRatesArgs = {
  productId: Scalars["UUID"]["input"];
};

export type QueryApProductsTaxRatesArgs = {
  productIds: Array<Scalars["UUID"]["input"]>;
};

export type QueryApSlugRedirectArgs = {
  fromSlug: Scalars["TrimmedString"]["input"];
};

export type QueryApSlugRedirectsArgs = {
  input: ApSlugRedirectListInput;
};

export type QueryApSmartcatDeliveryErrorsArgs = {
  limit?: InputMaybe<Scalars["PositiveInt"]["input"]>;
};

export type QueryApSpecificationFeatureArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApSpecificationFeaturesBySlugArgs = {
  slugs: Array<Scalars["TrimmedString"]["input"]>;
};

export type QueryApSpecificationSectionArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApSpecificationSectionsByIdArgs = {
  ids: Array<Scalars["UUID"]["input"]>;
};

export type QueryApSpecificationSectionsBySlugArgs = {
  slugs: Array<Scalars["TrimmedString"]["input"]>;
};

export type QueryApSpecificationTemplateArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApSpecificationTemplatesByIdArgs = {
  ids: Array<Scalars["UUID"]["input"]>;
};

export type QueryApSpecificationTemplatesBySlugArgs = {
  slugs: Array<Scalars["TrimmedString"]["input"]>;
};

export type QueryApStoreBankDetailsArgs = {
  storeId: StoreId;
};

export type QueryApStoreProductListItemsArgs = {
  input: ApStoreProductListItemsInput;
};

export type QueryApStoreProductListsArgs = {
  input: ApStoreProductListsInput;
};

export type QueryApStorefrontProductVariantPartNumberListArgs = {
  input: ApStorefrontProductVariantPartNumberListInput;
};

export type QueryApTagTemplatesArgs = {
  input: ApTagTemplateListInput;
};

export type QueryApTariffArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApTariffsArgs = {
  input: ApTariffListInput;
};

export type QueryApTaxRateArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryApTaxRatesArgs = {
  input: ApTaxRateListInput;
};

export type QueryApiProductsArgs = {
  input: ApiProductListInput;
};

export type QueryApiValidateCartArgs = {
  country?: InputMaybe<CountryCode>;
  email?: InputMaybe<Scalars["LowercaseTrimmedString"]["input"]>;
  items: Array<CartItem>;
  ssoId?: InputMaybe<Scalars["UUID"]["input"]>;
  storeId: StoreId;
};

export type QueryAssetArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryAssetModelVariantsByAssetIdArgs = {
  assetId: Scalars["UUID"]["input"];
};

export type QueryAvailableStoreCarrierServicesArgs = {
  input: AvailableStoreCarrierServicesInput;
};

export type QueryBackInStockSubscribedArgs = {
  input: BackInStockSubscribedInput;
};

export type QueryCarrierServicesArgs = {
  input: CarrierServicesInput;
};

export type QueryCheckoutArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryCheckoutsArgs = {
  input: CheckoutListInput;
};

export type QueryCollectionArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryCollectionBySlugArgs = {
  slug: Scalars["LowercaseTrimmedString"]["input"];
};

export type QueryCollectionCategoryArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryCollectionTagArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryCollectionsArgs = {
  input: CollectionListInput;
};

export type QueryCustomerArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryCustomerAddressArgs = {
  addressId: Scalars["UUID"]["input"];
};

export type QueryCustomerByEmailArgs = {
  email: Scalars["TrimmedString"]["input"];
};

export type QueryCustomerTagArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryCustomersArgs = {
  input: CustomerListInput;
};

export type QueryDiscountArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryDiscountSlugGroupsArgs = {
  input: DiscountSlugGroupsInput;
};

export type QueryDiscountsArgs = {
  input: DiscountListInput;
};

export type QueryEmbedArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryExchangeRateArgs = {
  input: ExchangeRateInput;
};

export type QueryExchangeRatesArgs = {
  input: ExchangeRateInput;
};

export type QueryGetCountryTaxRateArgs = {
  country: CountryCode;
  storeId: StoreId;
};

export type QueryGetProtectedAssetSignedUrlArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryIntegrationArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryInventoryHistoryArgs = {
  input: InventoryHistoryInput;
};

export type QueryInventoryStateArgs = {
  input: InventoryStateInput;
};

export type QueryLanguageArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryLimitationArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryLimitationsArgs = {
  input: LimitationListInput;
};

export type QueryModelArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryNoticesArgs = {
  input: NoticesInput;
};

export type QueryNotificationSettingsArgs = {
  input: NotificationSettingInput;
};

export type QueryOptionArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryOrderArgs = {
  input: ApOrderInput;
};

export type QueryOrderReturnArgs = {
  input: OrderReturnInput;
};

export type QueryOrderReturnTotalsArgs = {
  input: OrderReturnTotalsInput;
};

export type QueryOrderReturnsArgs = {
  input: OrderReturnsInput;
};

export type QueryOrderTagArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryOrdersArgs = {
  input: OrderListInput;
};

export type QueryPaymentProviderArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryPaymentProvidersArgs = {
  storeId: StoreId;
};

export type QueryProductArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryProductByBaseSkuArgs = {
  baseSku: Scalars["String"]["input"];
};

export type QueryProductFaqsArgs = {
  locale: Scalars["TrimmedString"]["input"];
  productId: Scalars["UUID"]["input"];
  storeId: StoreId;
};

export type QueryProductRegionalLimitsArgs = {
  input: ListProductRegionalLimitInput;
};

export type QueryProductTagArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryProductsArgs = {
  input: ProductListInput;
};

export type QueryRelatedProductCategoryArgs = {
  id: Scalars["UUID"]["input"];
};

export type QuerySharedWishlistsArgs = {
  input: SharedWishlistsInput;
};

export type QuerySsoUserArgs = {
  email: Scalars["EmailAddress"]["input"];
};

export type QueryStoreArgs = {
  id: StoreId;
};

export type QueryStoreCarrierArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryStoreCarriersArgs = {
  input: StoreCarriersInput;
};

export type QueryStoreCountriesArgs = {
  language?: InputMaybe<Scalars["LowercaseTrimmedString"]["input"]>;
  storeId: StoreId;
};

export type QueryStoreShippingRateArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryStoreShippingZoneArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryStoreWarehousesArgs = {
  storeId: StoreId;
};

export type QueryStorefrontCheckoutArgs = {
  input: StorefrontCheckoutInput;
};

export type QueryStorefrontCollectionArgs = {
  displayCurrency?: InputMaybe<Currency>;
  language: Scalars["LowercaseTrimmedString"]["input"];
  slug: Scalars["LowercaseTrimmedString"]["input"];
  storeId: StoreId;
};

export type QueryStorefrontCollectionsArgs = {
  input: StorefrontCollectionListInput;
};

export type QueryStorefrontHistoricalOrdersArgs = {
  input: StorefrontHistoricalOrdersListInput;
};

export type QueryStorefrontOrderArgs = {
  input: StorefrontOrderInput;
};

export type QueryStorefrontOrdersArgs = {
  input: StorefrontOrdersInput;
};

export type QueryStorefrontProductArgs = {
  displayCurrency?: InputMaybe<Currency>;
  language: Scalars["LowercaseTrimmedString"]["input"];
  slug: Scalars["LowercaseTrimmedString"]["input"];
  storeId: StoreId;
};

export type QueryStorefrontProductsArgs = {
  input: StorefrontProductListInput;
};

export type QueryStorefrontProductsByIdArgs = {
  displayCurrency?: InputMaybe<Currency>;
  filter?: InputMaybe<StorefrontProductByIdFilterInput>;
  ids: Array<Scalars["UUID"]["input"]>;
  language: Scalars["LowercaseTrimmedString"]["input"];
  storeId: StoreId;
};

export type QueryStorefrontRecommendedProductsArgs = {
  input: StorefrontRecommendedProductsInput;
};

export type QueryStorefrontStoreArgs = {
  id: StoreId;
};

export type QueryUpsellProductCategoryArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryUserArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryValidateCartArgs = {
  checkoutId?: InputMaybe<Scalars["UUID"]["input"]>;
  items: Array<CartItem>;
  storeId: StoreId;
};

export type QueryValidateTaxIdArgs = {
  countryCode: CountryCode;
  province?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  taxId: Scalars["String"]["input"];
};

export type QueryWarehouseArgs = {
  id: Scalars["UUID"]["input"];
};

export type QueryWishlistArgs = {
  input: WishlistInput;
};

export type QueryWishlistsArgs = {
  input: WishlistsInput;
};

export type RegisterDeviceTokenInput = {
  appVersion?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  deviceId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  deviceName?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  locale: Scalars["TrimmedString"]["input"];
  platform: DeviceTokenPlatform;
  token: Scalars["TrimmedString"]["input"];
};

export type RegisterDeviceTokenResponse = {
  __typename?: "RegisterDeviceTokenResponse";
  deviceToken: DeviceToken;
};

export type RelatedProductCategory = {
  __typename?: "RelatedProductCategory";
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  productIds: Array<Scalars["UUID"]["output"]>;
};

export type RelatedProductCategoryTranslation = Translation & {
  __typename?: "RelatedProductCategoryTranslation";
  language: Language;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ReorderGalleryInput = {
  entityId: Scalars["UUID"]["input"];
  entityType: GalleryEntityType;
  items: Array<Scalars["UUID"]["input"]>;
};

export type ReorderGalleryResponse = {
  __typename?: "ReorderGalleryResponse";
  items: Array<Scalars["UUID"]["output"]>;
};

export type RequestCustomerTaxExemptionInput = {
  checkoutId?: InputMaybe<Scalars["UUID"]["input"]>;
  customerNote?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  customerTaxId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  regionCode: Array<Scalars["TrimmedString"]["input"]>;
  storeId: StoreId;
  taxExemptionEntity: TaxExemptionEntityStorefront;
};

export type RequestCustomerTaxExemptionResponse = {
  __typename?: "RequestCustomerTaxExemptionResponse";
  customerTaxExemption: CustomerTaxExemption;
};

export type Requirement = {
  meetsRequirement: Scalars["Boolean"]["output"];
};

export type ResidentialAddress = {
  additionalInfo?: Maybe<Scalars["String"]["output"]>;
  address1: Scalars["String"]["output"];
  address2?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  country: CountryCode;
  createdAt: Scalars["DateTime"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  lastName: Scalars["String"]["output"];
  neighborhood?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
  province?: Maybe<Scalars["String"]["output"]>;
  taxId?: Maybe<Scalars["String"]["output"]>;
  type: AddressType;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum ReturnAuthorType {
  Customer = "Customer",
  Integration = "Integration",
  Netsuite = "Netsuite",
  Provider = "Provider",
  System = "System",
  User = "User",
}

export enum ReturnOption {
  Opened = "Opened",
  Rma = "Rma",
  Unopened = "Unopened",
}

/** Includes ReturnReason and extra system reasons */
export enum ReturnReason {
  ArrivedBroken = "ArrivedBroken",
  /** @deprecated No longer supported */
  Broken = "Broken",
  /** Netsuite issued return */
  Cancelled = "Cancelled",
  DamagedDuringShipping = "DamagedDuringShipping",
  DifferentProduct = "DifferentProduct",
  /** Stripe dashboard refund reason */
  Duplicate = "Duplicate",
  /** Stripe dashboard refund reason */
  ExpiredUncapturedCharge = "ExpiredUncapturedCharge",
  /** Stripe dashboard refund reason */
  Fraudulent = "Fraudulent",
  Incompatibility = "Incompatibility",
  LateDelivery = "LateDelivery",
  MissingItem = "MissingItem",
  /** @deprecated No longer supported */
  NotDelivered = "NotDelivered",
  /** @deprecated No longer supported */
  NotWanted = "NotWanted",
  NotWorking = "NotWorking",
  Other = "Other",
  Quality = "Quality",
  /** Stripe dashboard refund reason */
  RequestedByCustomer = "RequestedByCustomer",
  SetupIssues = "SetupIssues",
  SoftwareFirmwareIssues = "SoftwareFirmwareIssues",
  /** @deprecated No longer supported */
  TechnicalProblemHardware = "TechnicalProblemHardware",
  /** @deprecated No longer supported */
  TechnicalProblemSoftware = "TechnicalProblemSoftware",
  /** @deprecated No longer supported */
  TookTooLong = "TookTooLong",
  /** Stripe dashboard refund reason */
  Unknown = "Unknown",
  WrongAddress = "WrongAddress",
  WrongItem = "WrongItem",
}

export enum ReturnResolution {
  Accepted = "Accepted",
  Pending = "Pending",
  Rejected = "Rejected",
}

export type ReturnedItem = {
  __typename?: "ReturnedItem";
  productId: Scalars["UUID"]["output"];
  quantity: Scalars["NonNegativeInt"]["output"];
  returnId: Scalars["UUID"]["output"];
  sku: Scalars["String"]["output"];
  /** Will be null if store product variant is deleted */
  storeProductVariantId?: Maybe<Scalars["UUID"]["output"]>;
};

export enum RiskLevelProvider {
  Kount = "Kount",
  Stripe = "Stripe",
}

export type SendPendingEmailInput = {
  days: Scalars["Int"]["input"];
};

export enum ServiceType {
  Youtube = "Youtube",
}

export type ShareWishlistInput = {
  accessLevel: WishlistShareAccessLevel;
  emails: Array<Scalars["EmailAddress"]["input"]>;
  wishlistId: Scalars["UUID"]["input"];
};

export type SharedWishlistsInput = {
  storeId: StoreId;
};

export enum ShipmentDisplayStatus {
  Delivered = "Delivered",
  PartiallyDelivered = "PartiallyDelivered",
  Pending = "Pending",
  Shipped = "Shipped",
}

export enum ShipmentStatus {
  Canceled = "Canceled",
  Delivered = "Delivered",
  InTransit = "InTransit",
  LabelCreated = "LabelCreated",
  Shipped = "Shipped",
  Unknown = "Unknown",
}

export type ShipmentStatusHistoryItem = {
  __typename?: "ShipmentStatusHistoryItem";
  date: Scalars["DateTime"]["output"];
  location?: Maybe<Scalars["String"]["output"]>;
  metadata?: Maybe<UpsTrackingMetadata>;
  provider: ShippingCarrier;
  status: ShipmentStatus;
};

/** Carriers used for storefront rates/returns */
export enum ShippingCarrier {
  BasicShipper = "BasicShipper",
  Bluedart = "Bluedart",
  Dtdc = "DTDC",
  DelhiveryCourier = "DelhiveryCourier",
  DhlExpress = "DhlExpress",
  Ekart = "Ekart",
  Fedex = "Fedex",
  /** China */
  KyExpress = "KyExpress",
  PlatinumLog = "PlatinumLog",
  /** China */
  SfExpress = "SfExpress",
  Smartr = "Smartr",
  Ups = "Ups",
  Ups2 = "Ups2",
}

export enum ShippingMethodType {
  Air = "Air",
  Ground = "Ground",
  Unknown = "Unknown",
}

export type ShippingOption = {
  __typename?: "ShippingOption";
  delivery?: Maybe<ShippingOptionDelivery>;
  hasTaxIncludedPrice: Scalars["Boolean"]["output"];
  isNextDay: Scalars["Boolean"]["output"];
  isSignatureRequired: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  storeCarrierServiceId: Scalars["UUID"]["output"];
  storeShippingRateId: Scalars["UUID"]["output"];
  totals: Totals;
};

export type ShippingOptionDelivery = {
  __typename?: "ShippingOptionDelivery";
  estimatedDeliveryDate: Scalars["DateTime"]["output"];
  estimatedHeavyItemsDeliveryDate?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ShippingOptionsInput = {
  address1: Scalars["TrimmedString"]["input"];
  address2?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  cityName: Scalars["TrimmedString"]["input"];
  countryCode: CountryCode;
  postalCode?: InputMaybe<Scalars["UppercaseTrimmedString"]["input"]>;
  price: ShippingOptionsPriceInput;
  province?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  storeId: StoreId;
  vatId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type ShippingOptionsPriceInput = {
  amount: Scalars["NonNegativeInt"]["input"];
  currency: Currency;
};

export enum SlugHistoryEntity {
  Category = "Category",
  CategoryItem = "CategoryItem",
  Collection = "Collection",
  Product = "Product",
}

export type SlugRedirectEntity = {
  __typename?: "SlugRedirectEntity";
  fromEntityType: SlugRedirectEntityType;
  fromSlug: Scalars["String"]["output"];
  storeRedirects: Array<SlugStoreRedirect>;
  toEntityType: SlugRedirectEntityType;
};

export enum SlugRedirectEntityType {
  Category = "Category",
  Collection = "Collection",
  Product = "Product",
}

export type SlugStoreRedirect = {
  __typename?: "SlugStoreRedirect";
  storeId: StoreId;
  toSlug: Scalars["String"]["output"];
};

/** Smartcat webhook event types that can trigger translation sync. */
export enum SmartcatWebhookEvent {
  /** Triggered when a document status changes in the Smartcat project. */
  DocumentStatus = "DocumentStatus",
  /** Triggered when the overall project translation status changes. */
  ProjectStatus = "ProjectStatus",
}

export enum SortOrder {
  Asc = "Asc",
  Desc = "Desc",
}

export type SpecificationEntity = {
  __typename?: "SpecificationEntity";
  hasCompareData: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  sections?: Maybe<Array<SpecificationEntitySection>>;
  template: SpecificationTemplate;
};

export type SpecificationEntityInput = {
  /**
   * Filter out section types
   * @default [Standard]
   */
  sections?: InputMaybe<Array<SpecificationSectionType>>;
  /**
   * Type of returned specification content
   * @default All
   */
  type?: InputMaybe<SpecificationEntityInputType>;
};

export enum SpecificationEntityInputType {
  All = "All",
  /** Selects only compare data */
  Compare = "Compare",
  /** Selects only specification data */
  Specification = "Specification",
  /** Specific use-case in techspecs.ui.com */
  Summary = "Summary",
}

export type SpecificationEntitySection = {
  __typename?: "SpecificationEntitySection";
  /** Ordered flat list for building nested structure */
  features: Array<SpecificationEntitySectionFeature>;
  id: Scalars["UUID"]["output"];
  section: SpecificationSection;
};

export type SpecificationEntitySectionFeature =
  | SpecificationEntitySectionFeatureEntryFlag
  | SpecificationEntitySectionFeatureEntryText
  | SpecificationEntitySectionFeatureGroup;

export type SpecificationEntitySectionFeatureEntryFlag = {
  __typename?: "SpecificationEntitySectionFeatureEntryFlag";
  feature: SpecificationSectionFeature;
  flag: SpecificationSectionFeatureFlag;
  id: Scalars["UUID"]["output"];
  isUsedInCompare: Scalars["Boolean"]["output"];
  isUsedInSpecification: Scalars["Boolean"]["output"];
  isUsedInSummary: Scalars["Boolean"]["output"];
  isUsedInSummaryAsTrueFlag: Scalars["Boolean"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
};

export type SpecificationEntitySectionFeatureEntryText = {
  __typename?: "SpecificationEntitySectionFeatureEntryText";
  feature: SpecificationSectionFeature;
  id: Scalars["UUID"]["output"];
  isUsedInCompare: Scalars["Boolean"]["output"];
  isUsedInSpecification: Scalars["Boolean"]["output"];
  isUsedInSummary: Scalars["Boolean"]["output"];
  isUsedInSummaryAsTrueFlag: Scalars["Boolean"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  value: Scalars["String"]["output"];
};

export type SpecificationEntitySectionFeatureGroup = {
  __typename?: "SpecificationEntitySectionFeatureGroup";
  feature: SpecificationSectionFeature;
  id: Scalars["UUID"]["output"];
};

export type SpecificationSection = {
  __typename?: "SpecificationSection";
  id: Scalars["UUID"]["output"];
  label: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  type: SpecificationSectionType;
};

export type SpecificationSectionFeature = {
  __typename?: "SpecificationSectionFeature";
  icon?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** @deprecated Because of structural changes this might be incorrect and will always be false. Use same flags, but level higher. */
  isUsedInSummary: Scalars["Boolean"]["output"];
  /** @deprecated Because of structural changes this might be incorrect and will always be false. Use same flags, but level higher. */
  isUsedInSummaryAsTrueFlag: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  parentId?: Maybe<Scalars["UUID"]["output"]>;
  slug: Scalars["String"]["output"];
};

export enum SpecificationSectionFeatureFlag {
  Empty = "Empty",
  False = "False",
  Hyphen = "Hyphen",
  True = "True",
}

export enum SpecificationSectionFeatureType {
  Flag = "Flag",
  Text = "Text",
}

export enum SpecificationSectionType {
  Compliance = "Compliance",
  Overview = "Overview",
  Standard = "Standard",
}

export type SpecificationTemplate = {
  __typename?: "SpecificationTemplate";
  groups: Array<SpecificationTemplateGroup>;
  id: Scalars["UUID"]["output"];
  title: Scalars["String"]["output"];
};

export type SpecificationTemplateGroup = {
  __typename?: "SpecificationTemplateGroup";
  id: Scalars["String"]["output"];
  templates: Array<SpecificationTemplate>;
};

export type SsoUser = {
  __typename?: "SsoUser";
  createdAt: Scalars["String"]["output"];
  displayName: Scalars["String"]["output"];
  email: Scalars["EmailAddress"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  isInvited: Scalars["Boolean"]["output"];
  isVerified: Scalars["Boolean"]["output"];
  language?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  picture?: Maybe<Scalars["String"]["output"]>;
  timezone?: Maybe<Scalars["TimeZone"]["output"]>;
  username: Scalars["String"]["output"];
};

export type Store = {
  __typename?: "Store";
  address1: Scalars["String"]["output"];
  address2?: Maybe<Scalars["String"]["output"]>;
  businessName: Scalars["String"]["output"];
  city: Scalars["String"]["output"];
  contactEmail: Scalars["EmailAddress"]["output"];
  country: CountryCode;
  createdAt: Scalars["DateTime"]["output"];
  /** ISO 4217 */
  currency: Currency;
  hasCustomTaxRate: Scalars["Boolean"]["output"];
  hasFreeOrderReturn: Scalars["Boolean"]["output"];
  /** Manual payments for customer created orders */
  hasManualCustomerOrderPayments: Scalars["Boolean"]["output"];
  hasManualInventoryManagement: Scalars["Boolean"]["output"];
  /** Manual payments for manually created orders */
  hasManualOrderPayments: Scalars["Boolean"]["output"];
  hasOrderReturn: Scalars["Boolean"]["output"];
  /** Expired orders can be reopened */
  hasReopenExpiredOrders: Scalars["Boolean"]["output"];
  hasTaxIncludedPrice: Scalars["Boolean"]["output"];
  /** The store offers UI Care */
  hasUiCare: Scalars["Boolean"]["output"];
  id: StoreId;
  inventoryAlternativeStoreIds: Array<StoreId>;
  isUsingExternalInvoices: Scalars["Boolean"]["output"];
  languages: Array<Language>;
  name: Scalars["String"]["output"];
  orderPostfix?: Maybe<Scalars["String"]["output"]>;
  orderPrefix?: Maybe<Scalars["String"]["output"]>;
  orderReturnRestockFeePercent: Scalars["NonNegativeInt"]["output"];
  ordersExpireAfter: Scalars["String"]["output"];
  paymentsExpireAfter: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
  province?: Maybe<Scalars["String"]["output"]>;
  storeCarriers: Array<StoreCarrier>;
  storeShippingZones: Array<StoreShippingZone>;
  supportEmail: Scalars["EmailAddress"]["output"];
  terms: Scalars["String"]["output"];
  timezone: Scalars["TimeZone"]["output"];
  unit: UnitSystem;
  updatedAt: Scalars["DateTime"]["output"];
  warehouses: Array<Warehouse>;
};

export type StoreBankDetailsData = ChinaBankDetails;

export enum StoreBankDetailsType {
  ChinaBank = "ChinaBank",
}

export type StoreCarrier = {
  __typename?: "StoreCarrier";
  accountNumber?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  maskedApiKey?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  shippingCarrier: ShippingCarrier;
  storeServices: Array<StoreCarrierService>;
};

export type StoreCarrierService = {
  __typename?: "StoreCarrierService";
  externalServiceId: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  serviceName: Scalars["String"]["output"];
  type: ShippingMethodType;
};

export type StoreCarrierServiceInput = {
  id: Scalars["String"]["input"];
  name: Scalars["TrimmedString"]["input"];
  type: ShippingMethodType;
};

export type StoreCarriersInput = {
  storeId: StoreId;
};

export type StoreCollection = {
  __typename?: "StoreCollection";
  collection: Collection;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  isVisible?: Maybe<Scalars["Boolean"]["output"]>;
  store: Store;
  updatedAt: Scalars["DateTime"]["output"];
};

export type StoreConfig = {
  __typename?: "StoreConfig";
  flags: Array<FeatureFlag>;
  storeId: StoreId;
};

export type StoreCountriesResponse = {
  __typename?: "StoreCountriesResponse";
  countries: Array<Country>;
  storeCountries: Array<Country>;
};

export type StoreCreditEarning = {
  __typename?: "StoreCreditEarning";
  amount: Money;
  availableAt?: Maybe<Scalars["DateTime"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  customerId: Scalars["UUID"]["output"];
  displayStatus: StoreCreditEarningDisplayStatus;
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["UUID"]["output"];
  orderId: Scalars["UUID"]["output"];
  orderOperationId: Scalars["UUID"]["output"];
  storeId: StoreId;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum StoreCreditEarningDisplayStatus {
  Available = "Available",
  Expired = "Expired",
  Pending = "Pending",
}

export enum StoreCreditErrorCode {
  AppliedAmountGreaterThanAvailableAmount = "AppliedAmountGreaterThanAvailableAmount",
  /** Generic error when we cannot apply store credit due to internal issue */
  CannotApplyStoreCredit = "CannotApplyStoreCredit",
}

export type StoreCreditHistoryItem = {
  __typename?: "StoreCreditHistoryItem";
  amount: Money;
  createdAt: Scalars["DateTime"]["output"];
  orderId: Scalars["UUID"]["output"];
  orderNumber: Scalars["String"]["output"];
  status: StoreCreditHistoryItemStatus;
};

export enum StoreCreditHistoryItemStatus {
  Earned = "Earned",
  EarnedExpired = "EarnedExpired",
  EarnedPending = "EarnedPending",
  EarnedReverted = "EarnedReverted",
  Spent = "Spent",
  SpentReverted = "SpentReverted",
}

export type StoreCreditSummary = {
  __typename?: "StoreCreditSummary";
  balance: Money;
  earned: Money;
  /**
   * Indicates if customer has earned any store credit at some point (even if it's expired)
   * Useful for determining if we should show the "History" section in the UI
   */
  hasEarningsHistory: Scalars["Boolean"]["output"];
  pending: Money;
  spent: Money;
};

export type StoreDiscount = {
  __typename?: "StoreDiscount";
  fixedAmount?: Maybe<Money>;
  id: Scalars["UUID"]["output"];
  isVisible?: Maybe<Scalars["Boolean"]["output"]>;
  maxAmount?: Maybe<Money>;
  minAmount?: Maybe<Money>;
  store: Store;
};

/**
 * Store id that represent the store 2-length for convenient usage in database and urls e.g "eu", "us", "ca".
 * Previously we called them short names. Compared to other enums these are explicitly in lowercase so easier to handle in url's
 */
export enum StoreId {
  /** Brazil store */
  Br = "br",
  /** Canada store */
  Ca = "ca",
  /** China store */
  Cn = "cn",
  /** Europe store */
  Eu = "eu",
  /** India store */
  In = "in",
  /** Japan store */
  Jp = "jp",
  /** Middle East store */
  Me = "me",
  /** Mexico store */
  Mx = "mx",
  /** Philippines store */
  Ph = "ph",
  /** Singapore store */
  Sg = "sg",
  /** Taiwan store */
  Tw = "tw",
  /** United Kingdom store */
  Uk = "uk",
  /** United States store */
  Us = "us",
  /** South Africa store */
  Za = "za",
}

export type StoreLimitation = {
  __typename?: "StoreLimitation";
  id: Scalars["UUID"]["output"];
  isVisible?: Maybe<Scalars["Boolean"]["output"]>;
  store: Store;
};

export enum StoreManagerPermission {
  AnalyticsView = "AnalyticsView",
  CheckoutCreate = "CheckoutCreate",
  CheckoutEdit = "CheckoutEdit",
  CheckoutView = "CheckoutView",
  CollectionView = "CollectionView",
  CommentCreate = "CommentCreate",
  CommentView = "CommentView",
  CustomerInvite = "CustomerInvite",
  CustomerView = "CustomerView",
  DiscountCreate = "DiscountCreate",
  DiscountEdit = "DiscountEdit",
  DiscountView = "DiscountView",
  IntegrationView = "IntegrationView",
  LanguageView = "LanguageView",
  LimitationCreate = "LimitationCreate",
  LimitationEdit = "LimitationEdit",
  LimitationView = "LimitationView",
  OrderDraftCreate = "OrderDraftCreate",
  OrderDraftEdit = "OrderDraftEdit",
  OrderExpire = "OrderExpire",
  OrderManualPaymentCreate = "OrderManualPaymentCreate",
  OrderPickAndFulfill = "OrderPickAndFulfill",
  OrderReturnResolve = "OrderReturnResolve",
  OrderTagEdit = "OrderTagEdit",
  OrderView = "OrderView",
  ProductInventoryEdit = "ProductInventoryEdit",
  ProductView = "ProductView",
  ReportView = "ReportView",
  SlugRedirectView = "SlugRedirectView",
  StoreCarrierView = "StoreCarrierView",
  StoreView = "StoreView",
  TaxRateCreate = "TaxRateCreate",
  TaxRateDelete = "TaxRateDelete",
  TaxRateEdit = "TaxRateEdit",
}

export enum StoreProductListType {
  UiCareWhitelist = "UiCareWhitelist",
}

export type StoreProductVariant = {
  __typename?: "StoreProductVariant";
  adminPanelInventory: StoreProductVariantInventory;
  backorderLimit?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  hasSyncedSkuPrice: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  isEarlyAccess?: Maybe<Scalars["Boolean"]["output"]>;
  isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  isVisibleInStore?: Maybe<Scalars["Boolean"]["output"]>;
  price?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  priceWithTax?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  sku?: Maybe<Scalars["String"]["output"]>;
  skuPrice?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  status?: Maybe<ProductStatus>;
  store: Store;
  uiCarePriceOverride?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  /** Acts as bigint string */
  weight?: Maybe<Scalars["String"]["output"]>;
};

export type StoreProductVariantInventory = {
  __typename?: "StoreProductVariantInventory";
  sku: Scalars["String"]["output"];
  totalQuantity?: Maybe<Scalars["Int"]["output"]>;
  warehouseInventory: Array<StoreProductVariantWarehouseInventory>;
};

export type StoreProductVariantInventoryCalculated = {
  __typename?: "StoreProductVariantInventoryCalculated";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  issuer: CalculatedInventoryIssuer;
  issuerOrderId?: Maybe<Scalars["UUID"]["output"]>;
  quantityAvailable: Scalars["Int"]["output"];
  quantityCommitted: Scalars["Int"]["output"];
  quantityDraft: Scalars["Int"]["output"];
  quantityNetsuite: Scalars["Int"]["output"];
  quantityPublic: Scalars["Int"]["output"];
  quantityUncommitted: Scalars["Int"]["output"];
  sku: Scalars["String"]["output"];
  warehouseId: Scalars["UUID"]["output"];
};

export type StoreProductVariantWarehouseInventory = {
  __typename?: "StoreProductVariantWarehouseInventory";
  /** Available quantity after calculation */
  quantityAvailable?: Maybe<Scalars["Int"]["output"]>;
  /** Base quantity before calculations */
  quantityInventory?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  sku: Scalars["String"]["output"];
  warehouseId: Scalars["UUID"]["output"];
  warehouseName: Scalars["String"]["output"];
};

export type StoreSeo = {
  __typename?: "StoreSeo";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  store?: Maybe<Store>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export enum StoreShippingRateType {
  Custom = "Custom",
  Dynamic = "Dynamic",
}

export type StoreShippingRateUnion =
  | CustomStoreShippingRate
  | DynamicStoreShippingRate;

export type StoreShippingZone = {
  __typename?: "StoreShippingZone";
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  store: Store;
  storeShippingRates: Array<StoreShippingRateUnion>;
  storeShippingZoneCountries: Array<StoreShippingZoneCountry>;
};

export type StoreShippingZoneCountry = {
  __typename?: "StoreShippingZoneCountry";
  country: CountryCode;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  zoneCode?: Maybe<Scalars["String"]["output"]>;
  zoneName?: Maybe<Scalars["String"]["output"]>;
};

export type StoreShippingZoneCountryInput = {
  country: CountryCode;
  zoneCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type StorefrontCheckout = {
  __typename?: "StorefrontCheckout";
  acceptsMarketing: Scalars["Boolean"]["output"];
  allowedSteps: Array<CheckoutAllowedStep>;
  availableShippingOptions: Array<ShippingOption>;
  billingAddress?: Maybe<CheckoutAddressUnion>;
  createdAt: Scalars["DateTime"]["output"];
  delivery?: Maybe<StorefrontCheckoutDelivery>;
  /** Returns max 15 items sorted by ratio */
  didYouForget: StorefrontCheckoutDidYouForget;
  discountCode?: Maybe<Scalars["TrimmedString"]["output"]>;
  discountFreeShipping: Scalars["Boolean"]["output"];
  discountItems: Array<AppliedItemDiscount>;
  email?: Maybe<Scalars["String"]["output"]>;
  errors: StorefrontCheckoutErrors;
  externalItems: Array<CheckoutExternalItem>;
  /** Returns store.has_custom_tax_rate to know to show subtotal or total */
  hasCustomTaxRate: Scalars["Boolean"]["output"];
  hasCustomer: Scalars["Boolean"]["output"];
  /** Returns store.has_tax_included_price to know what prices we have to work with */
  hasTaxIncludedPrice: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** Indicates if this is the active store checkout for customer */
  isActive: Scalars["Boolean"]["output"];
  items: Array<StorefrontCheckoutItem>;
  language: Language;
  mustValidateShippingAddress: Scalars["Boolean"]["output"];
  orderId?: Maybe<Scalars["UUID"]["output"]>;
  secret: Scalars["String"]["output"];
  shippingAddress?: Maybe<CheckoutAddressUnion>;
  shippingNotice?: Maybe<Notice>;
  shippingOption?: Maybe<ShippingOption>;
  store: Store;
  storeCredit: StorefrontCheckoutStoreCredit;
  /** Indicates that tax for checkout has been calculated */
  taxCalculated: Scalars["Boolean"]["output"];
  totals: CheckoutTotals;
  updatedAt: Scalars["DateTime"]["output"];
  /** @deprecated Use items.upsellProductCategories instead */
  upsellProducts: Array<UpsellProductCategory>;
};

export type StorefrontCheckoutAddressInput = {
  additionalInfo?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  address1: Scalars["TrimmedString"]["input"];
  address2?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  businessName?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  city: Scalars["TrimmedString"]["input"];
  country: CountryCode;
  customerAddressId?: InputMaybe<Scalars["UUID"]["input"]>;
  firstName: Scalars["TrimmedString"]["input"];
  lastName: Scalars["TrimmedString"]["input"];
  neighborhood?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  phoneNumber: Scalars["TrimmedString"]["input"];
  postalCode?: InputMaybe<Scalars["UppercaseTrimmedString"]["input"]>;
  province?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  referenceNumber?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  saveForFutureUse?: InputMaybe<Scalars["Boolean"]["input"]>;
  stateRegistrationNumber?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  taxId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  type: AddressType;
};

export type StorefrontCheckoutDelivery = {
  __typename?: "StorefrontCheckoutDelivery";
  addressHasLiftGate: Scalars["Boolean"]["output"];
  addressType: AddressType;
};

export type StorefrontCheckoutDeliveryInput = {
  addressHasLiftGate: Scalars["Boolean"]["input"];
  addressType: AddressType;
};

export type StorefrontCheckoutDidYouForget = {
  __typename?: "StorefrontCheckoutDidYouForget";
  items: Array<StorefrontCheckoutDidYouForgetItem>;
};

export type StorefrontCheckoutDidYouForgetItem = {
  __typename?: "StorefrontCheckoutDidYouForgetItem";
  cartItemProductId: Scalars["String"]["output"];
  didYouForgetProductId: Scalars["String"]["output"];
};

export type StorefrontCheckoutDiscountCodeError = {
  __typename?: "StorefrontCheckoutDiscountCodeError";
  code: DiscountCodeValidationErrorCode;
  message: Scalars["String"]["output"];
};

export type StorefrontCheckoutErrors = {
  __typename?: "StorefrontCheckoutErrors";
  discountCode?: Maybe<StorefrontCheckoutDiscountCodeError>;
  storeCredit?: Maybe<StorefrontCheckoutStoreCreditError>;
};

export type StorefrontCheckoutInput = {
  id: Scalars["UUID"]["input"];
  language?: InputMaybe<Scalars["LowercaseTrimmedString"]["input"]>;
  secret?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  skipShippingCalculation?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** It's a hint, will be used only for Avatax stores */
  skipTaxCalculation?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StorefrontCheckoutItem = {
  __typename?: "StorefrontCheckoutItem";
  bundleNotes: Array<ProductBundleNote>;
  createdAt: Scalars["DateTime"]["output"];
  discountTotal: Money;
  /** For hasTaxIncludedPrice this will be present */
  discountTotalWithTaxRate?: Maybe<Money>;
  /**
   * This just acts as a metadata for checkout item,
   * quantities inside are already accounted in `StorefrontCheckoutItem.quantity`
   */
  groups: Array<StorefrontCheckoutItemGroup>;
  hasTaxIncludedPrice: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  isShippingHeavyItem: Scalars["Boolean"]["output"];
  price: Money;
  product: StorefrontProduct;
  quantity: Scalars["NonNegativeInt"]["output"];
  /** Can user modify (remove, update quantity or add) this item */
  readOnly: Scalars["Boolean"]["output"];
  /**
   * Used in conjunction with "readOnly" when it is true.
   * Item will be moved to read only row until specified quantity. Any quantity
   * above it, will be moved to dynamic row, and can be increased over that limit
   * @deprecated Use readonlyUntil
   */
  readOnlyMinQuantity?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  readonlyUntil?: Maybe<Scalars["NonNegativeInt"]["output"]>;
  sku: Scalars["String"]["output"];
  subtotal: Money;
  /** Tariff per unit quantity (item_price * tariff_rate) */
  tariff: Money;
  /** Total tariff amount (tariff * quantity) */
  tariffTotal: Money;
  /** Return tax rate if checkout was filled enough to have tax calculated on the item */
  taxRate?: Maybe<Scalars["Float"]["output"]>;
  /** For custom tax stores we may already know tax total */
  taxTotal?: Maybe<Money>;
  total: Money;
  variant: StorefrontProductVariant;
};

export type StorefrontCheckoutItemGroup = {
  __typename?: "StorefrontCheckoutItemGroup";
  groupLinks?: Maybe<Array<StorefrontCheckoutItemGroupLink>>;
  /** Groups' id, important if we want to update existing group data */
  id: Scalars["UUID"]["output"];
  isGroupedProduct: Scalars["Boolean"]["output"];
  /**
   * Virtual subset quantity of `StorefrontCheckoutItem.quantity` to how many items
   * this group is assigned
   */
  parentQuantity: Scalars["NonNegativeInt"]["output"];
};

export type StorefrontCheckoutItemGroupInput = {
  /** Group identifier */
  id: Scalars["UUID"]["input"];
  isGroupedProduct?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Virtual concept/quantity, and this doesn't affect root level quantity.
   * Rules:
   *   - SUM of `parentQuantity` shouldn't be over `StorefrontCheckoutItemInput` in total (not just in input)
   *   - If addition will result in total `0`, it will remove group and linked items (will subtract linked item quantity)
   */
  parentQuantity: Scalars["Int"]["input"];
  updateGroupLinks: Array<StorefrontCheckoutItemGroupLinkInput>;
};

export type StorefrontCheckoutItemGroupLink = {
  __typename?: "StorefrontCheckoutItemGroupLink";
  checkoutItemId: Scalars["UUID"]["output"];
  /**
   * Should we include linked item title in parent product (e.g. UCG / 1TB)
   * Where UCG is parent product and 1TB is linked product
   */
  includeTitleInParentProduct: Scalars["Boolean"]["output"];
  /** Should we show item in cart under parent item in group (UICARE) or not (UCG+Storage) */
  isVisible: Scalars["Boolean"]["output"];
  /**
   * Virtual subset quantity of `StorefrontCheckoutItem.quantity` to how many of units
   * are assigned to given group
   */
  quantity: Scalars["NonNegativeInt"]["output"];
  storeProductVariantId: Scalars["UUID"]["output"];
};

export type StorefrontCheckoutItemGroupLinkInput = {
  includeTitleInParentProduct: Scalars["Boolean"]["input"];
  isVisible: Scalars["Boolean"]["input"];
  linkedStoreProductVariantId: Scalars["UUID"]["input"];
  /**
   * Quantity will affect root level, e.g. `quantity` will be added to existing value.
   * If after update all linked items are computed to 0, group will be removed.
   */
  quantity: Scalars["Int"]["input"];
};

export type StorefrontCheckoutItemInput = {
  /**
   * For `addItems` this acts as upsert, e.g. will override current quantity
   * For `updateItems` this acts as delta, e.g. it will add to existing value
   */
  quantity: Scalars["Int"]["input"];
  storeProductVariantId: Scalars["UUID"]["input"];
  /**
   * Will add products under current `StorefrontCheckoutItemInput.storeProductVariantId`
   * This is just for visual representation, and all quantities will be present in
   * `StorefrontCheckoutItem` (root level)
   */
  updateGroups?: InputMaybe<Array<StorefrontCheckoutItemGroupInput>>;
};

export type StorefrontCheckoutResponse = {
  __typename?: "StorefrontCheckoutResponse";
  checkout?: Maybe<StorefrontCheckout>;
};

export type StorefrontCheckoutStoreCredit = {
  __typename?: "StorefrontCheckoutStoreCredit";
  /** Amount that has been applied to the checkout */
  amountApplied: Scalars["NonNegativeInt"]["output"];
  /** Leftover amount that can be applied to the checkout (dynamic: `amountAvailableTotal - amountApplied`) */
  amountAvailableLeft: Scalars["NonNegativeInt"]["output"];
  /** Total amount that can be applied to the checkout (static) */
  amountAvailableTotal: Scalars["NonNegativeInt"]["output"];
  /** Amount that will be earned from physical products in the cart */
  amountToBeEarned: Scalars["NonNegativeInt"]["output"];
};

export type StorefrontCheckoutStoreCreditError = {
  __typename?: "StorefrontCheckoutStoreCreditError";
  code: StoreCreditErrorCode;
  message: Scalars["String"]["output"];
};

export type StorefrontCollection = {
  __typename?: "StorefrontCollection";
  alternativeStores: Array<AlternativeStoreCollectionInfo>;
  categories: Array<StorefrontCollectionCategory>;
  createdAt: Scalars["DateTime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  displayCurrency?: Maybe<Currency>;
  gallery?: Maybe<Gallery>;
  heroTitle?: Maybe<Scalars["String"]["output"]>;
  historicalSlugs: Array<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  missingProductAlternativeStores: Array<AlternativeStoreCollectionMissingProductInfo>;
  productIds: Array<Scalars["UUID"]["output"]>;
  products: Array<StorefrontProduct>;
  requestedLanguageId: Scalars["UUID"]["output"];
  sections: Array<CollectionSection>;
  seoDescription?: Maybe<Scalars["String"]["output"]>;
  seoTitle: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  sortBy: CollectionSort;
  storeId: StoreId;
  tags: Array<CollectionTag>;
  technicalSpecification?: Maybe<SpecificationEntity>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type StorefrontCollectionTechnicalSpecificationArgs = {
  filter?: InputMaybe<SpecificationEntityInput>;
};

export type StorefrontCollectionCategory = {
  __typename?: "StorefrontCollectionCategory";
  features: Array<StorefrontCollectionCategoryFeature>;
  gallery?: Maybe<Gallery>;
  id: Scalars["UUID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  products: Array<StorefrontProduct>;
  requestedLanguageId: Scalars["UUID"]["output"];
  type: CollectionCategoryType;
};

export type StorefrontCollectionCategoryFeature = {
  __typename?: "StorefrontCollectionCategoryFeature";
  description?: Maybe<Scalars["String"]["output"]>;
  icon: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
};

export type StorefrontCollectionListFilterInput = {
  displayCurrency?: InputMaybe<Currency>;
  language: Scalars["LowercaseTrimmedString"]["input"];
  slugs?: InputMaybe<Array<Scalars["LowercaseTrimmedString"]["input"]>>;
  storeId: StoreId;
};

export type StorefrontCollectionListInput = {
  filter: StorefrontCollectionListFilterInput;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
};

export type StorefrontCollectionListResponse = {
  __typename?: "StorefrontCollectionListResponse";
  items: Array<StorefrontCollection>;
  pagination: PaginationResponse;
};

export type StorefrontCreateCheckoutFromOrderInput = {
  orderId: Scalars["UUID"]["input"];
};

export type StorefrontCreateCheckoutFromOrderResponse = {
  __typename?: "StorefrontCreateCheckoutFromOrderResponse";
  checkoutId: Scalars["UUID"]["output"];
  checkoutSecret: Scalars["TrimmedString"]["output"];
};

export type StorefrontCreateCheckoutInput = {
  applyStoreCreditAmount?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  /** Removed if empty string given. Discount code should always be uppercase */
  discountCode?: InputMaybe<Scalars["UppercaseTrimmedString"]["input"]>;
  externalItems?: InputMaybe<Array<CheckoutExternalItemInput>>;
  gaClientId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  items: Array<StorefrontCheckoutItemInput>;
  language: Scalars["LowercaseTrimmedString"]["input"];
  metadata?: InputMaybe<Scalars["JSONObject"]["input"]>;
  reportIsWizardCheckout?: InputMaybe<Scalars["Boolean"]["input"]>;
  shippingAddress?: InputMaybe<StorefrontCheckoutAddressInput>;
  storeId: StoreId;
};

export type StorefrontCreateCheckoutResponse = {
  __typename?: "StorefrontCreateCheckoutResponse";
  checkout: StorefrontCheckout;
};

export type StorefrontHistoricalOrder = {
  __typename?: "StorefrontHistoricalOrder";
  currency: Currency;
  customer: Customer;
  email: Scalars["String"]["output"];
  fulfillmentDisplayStatus: OrderFulfillmentDisplayStatus;
  id: Scalars["UUID"]["output"];
  orderCreatedAt: Scalars["DateTime"]["output"];
  orderNumber: Scalars["String"]["output"];
  statusPageUrl: Scalars["String"]["output"];
  store: Store;
  total: Money;
  transactionDisplayStatus: OrderTransactionDisplayStatus;
};

export type StorefrontHistoricalOrdersListFilterInput = {
  fulfillmentDisplayStatus?: InputMaybe<Array<OrderFulfillmentDisplayStatus>>;
  stores?: InputMaybe<Array<StoreId>>;
};

export type StorefrontHistoricalOrdersListInput = {
  filter?: InputMaybe<StorefrontHistoricalOrdersListFilterInput>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type StorefrontHistoricalOrdersListResponse = PageResponse & {
  __typename?: "StorefrontHistoricalOrdersListResponse";
  allOrderDisplayStatusCount: AllOrderDisplayStatusCount;
  items: Array<StorefrontHistoricalOrder>;
  pagination: PaginationResponse;
};

export type StorefrontOption = {
  __typename?: "StorefrontOption";
  id: Scalars["UUID"]["output"];
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  values: Array<StorefrontOptionValue>;
};

export type StorefrontOptionValue = {
  __typename?: "StorefrontOptionValue";
  id: Scalars["UUID"]["output"];
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type StorefrontOrder = {
  __typename?: "StorefrontOrder";
  billingAddress?: Maybe<OrderAddressUnion>;
  /** @deprecated Use cancelOption instead */
  canCancelUntil?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Determine whether the order can be cancelled.
   *
   * By default, uses a short timeout which may return 'Unknown' if the ERP is slow.
   * Set 'waitForDefinitiveAnswer' to true for a more reliable result.
   */
  cancelOption: StorefrontOrderCancelOption;
  checkoutId?: Maybe<Scalars["UUID"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency: Currency;
  discountCode?: Maybe<Scalars["String"]["output"]>;
  displayStatus: OrderDisplayStatus;
  email?: Maybe<Scalars["String"]["output"]>;
  /** Requires customer login to access the order */
  enforceLogin: Scalars["Boolean"]["output"];
  fulfillments: StorefrontOrderFulfillmentSummary;
  fullAccessToOrder?: Maybe<Array<FullAccessToOrder>>;
  id: Scalars["UUID"]["output"];
  invoiceNote?: Maybe<Scalars["String"]["output"]>;
  invoiceUrl?: Maybe<Scalars["String"]["output"]>;
  items: Array<StorefrontOrderItem>;
  language: Scalars["String"]["output"];
  languageId: Scalars["UUID"]["output"];
  orderNumber?: Maybe<Scalars["String"]["output"]>;
  payByInvoiceMetadata?: Maybe<OrderPayByInvoiceMetadata>;
  payment: StorefrontOrderPayment;
  paymentExpireAt: Scalars["DateTime"]["output"];
  returnedItems?: Maybe<Array<ReturnedItem>>;
  returns?: Maybe<OrderReturnSummary>;
  /** Indicates that shipments are actively tracked for this order */
  shipmentsAreBeingTracked: Scalars["Boolean"]["output"];
  shippingAddress?: Maybe<OrderAddressUnion>;
  shippingOption?: Maybe<OrderShippingOption>;
  store: Store;
  storeCredit?: Maybe<StorefrontOrderStoreCredit>;
  totals: OrderTotals;
};

export type StorefrontOrderCancelOptionArgs = {
  waitForDefinitiveAnswer?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StorefrontOrderCancelOption = {
  __typename?: "StorefrontOrderCancelOption";
  option: OrderCancelOption;
};

export type StorefrontOrderFulfillment = {
  __typename?: "StorefrontOrderFulfillment";
  /** Protected field - requires full-access to order to view it */
  carrierCompanyName?: Maybe<Scalars["String"]["output"]>;
  /** Protected field - requires full-access to order to view it */
  carrierIsTrackable?: Maybe<Scalars["Boolean"]["output"]>;
  /** Protected field - requires full-access to order to view it */
  carrierTrackingNumber?: Maybe<Scalars["String"]["output"]>;
  /** Protected field - requires full-access to order to view it */
  carrierTrackingUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  items: Array<StorefrontOrderItem>;
  /** Protected field - requires full-access to order to view it */
  returnOptions?: Maybe<Array<ReturnOption>>;
  status: OrderFulfillmentStatus;
};

export type StorefrontOrderFulfillmentSummary = {
  __typename?: "StorefrontOrderFulfillmentSummary";
  fulfillmentLines: Array<StorefrontOrderFulfillment>;
  status: OrderFulfillmentDisplayStatus;
};

export type StorefrontOrderInput = {
  id: Scalars["UUID"]["input"];
  locale?: InputMaybe<Scalars["LowercaseTrimmedString"]["input"]>;
};

export type StorefrontOrderItem = {
  __typename?: "StorefrontOrderItem";
  collectionSlug?: Maybe<Scalars["String"]["output"]>;
  discountTotal: Money;
  galleryItemAsset?: Maybe<Asset>;
  hasTaxIncludedPrice: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  isEarlyAccess: Scalars["Boolean"]["output"];
  isVisibleInStore: Scalars["Boolean"]["output"];
  price: Money;
  productSlug: Scalars["String"]["output"];
  quantity: Scalars["NonNegativeInt"]["output"];
  returnAvailableQty: Scalars["NonNegativeInt"]["output"];
  returnability: ItemReturnability;
  sku: Scalars["String"]["output"];
  /** Variant slug */
  slug: Scalars["String"]["output"];
  /** Will be null if store product variant is deleted */
  storeProductVariantId?: Maybe<Scalars["UUID"]["output"]>;
  subtotal: Money;
  tariff: Money;
  tariffTotal: Money;
  /** Calculated tax rate of all tax details of an item as fraction in 0..1 range */
  taxRate: Scalars["Float"]["output"];
  taxTotal: Money;
  /** Combined with the variant if necessary */
  title: Scalars["String"]["output"];
  total: Money;
};

export type StorefrontOrderPayment = {
  __typename?: "StorefrontOrderPayment";
  /** Indicates if payment is a bank transfer */
  isBankTransfer: Scalars["Boolean"]["output"];
  /** Derived value from all charge statuses */
  status: OrderTransactionDisplayStatus;
  /** Only payment transactions */
  transactions: Array<StorefrontPaymentTransaction>;
};

export type StorefrontOrderStoreCredit = {
  __typename?: "StorefrontOrderStoreCredit";
  /** Actual earned amount (set after payment completes) */
  actualEarnAmount: Scalars["NonNegativeInt"]["output"];
  /** Amount of store credit applied to this order */
  appliedSpendAmount: Scalars["NonNegativeInt"]["output"];
  /** Snapshot of expected earn amount at order creation */
  expectedEarnAmount: Scalars["NonNegativeInt"]["output"];
};

export type StorefrontOrdersInput = {
  filter?: InputMaybe<StorefrontOrdersInputFilter>;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type StorefrontOrdersInputFilter = {
  fulfillmentDisplayStatus?: InputMaybe<Array<OrderFulfillmentDisplayStatus>>;
};

export type StorefrontOrdersResponse = PageResponse & {
  __typename?: "StorefrontOrdersResponse";
  allOrderDisplayStatusCount: AllOrderDisplayStatusCount;
  items: Array<StorefrontOrder>;
  pagination: PaginationResponse;
};

export type StorefrontPaymentTransaction = {
  __typename?: "StorefrontPaymentTransaction";
  bankTransferInstructions?: Maybe<Array<BankTransferInstructions>>;
  cardBrand?: Maybe<Scalars["String"]["output"]>;
  cardLastFour?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  method: OrderTransactionPaymentMethod;
  provider: PaymentProvider;
  /**
   * Not set when free order.
   * Set for providers which create an order-like entity first (instead of providing payment id right away).
   */
  providerOrderId?: Maybe<Scalars["String"]["output"]>;
  /**
   * Not set when free order.
   * Will be empty for PaymentProvider=Paypal
   */
  providerPaymentId?: Maybe<Scalars["String"]["output"]>;
  providerSecret?: Maybe<Scalars["String"]["output"]>;
  /** Total amount that is still due for the payment, e.g., for bank transfer */
  remainingTotal: Money;
  /** Used as payment transactions status, excluding refund status */
  status: OrderTransactionDisplayStatus;
  total: Money;
};

export type StorefrontProduct = {
  __typename?: "StorefrontProduct";
  alternativeStores: Array<AlternativeStoreProductInfo>;
  callout?: Maybe<Scalars["String"]["output"]>;
  carrierSetupMedia?: Maybe<Gallery>;
  /** Default collection slug for the product, used in cases when we don't how we got to a product via navigation menu */
  collectionSlug?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use compatibleProducts[].productIds */
  compatibleProductIds: Array<Scalars["UUID"]["output"]>;
  /**
   * For which main products, this child product/accessory is compatible with
   *
   * May be confusing, so as example:
   * - For HDD this will return UNVR/UDM etc.
   * - For UNVR/UDM this will return nothing
   */
  compatibleProducts: Array<StorefrontProductCompatibility>;
  createdAt: Scalars["DateTime"]["output"];
  croppedThumbnail?: Maybe<Asset>;
  /** @deprecated Use croppedThumbnail */
  croppedThumbnailMedia?: Maybe<Gallery>;
  customizationMedia?: Maybe<Gallery>;
  /** @deprecated Use technicalSpecification */
  datasheet?: Maybe<Datasheet>;
  deploymentMedia?: Maybe<Gallery>;
  description: Scalars["String"]["output"];
  /**
   * Human-readable SKU with regional postfix removed and PoE wattage appended from tags.
   * e.g. "USW-Pro-48-PoE-US" with tag "poe:100w" → "USW-Pro-48-PoE (100W)"
   */
  displaySku: Scalars["String"]["output"];
  documents: Array<ProductDocument>;
  /** Whether this product earns store credit when purchased */
  earnsStoreCredit: Scalars["Boolean"]["output"];
  family?: Maybe<ProductFamily>;
  gallery?: Maybe<Gallery>;
  gridDescription?: Maybe<Scalars["String"]["output"]>;
  hasTaxIncludedPrice: Scalars["Boolean"]["output"];
  /** Historical slugs for the product */
  historicalSlugs: Array<Scalars["String"]["output"]>;
  hsCode?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  installationMedia?: Maybe<Gallery>;
  keyFeatures?: Maybe<Scalars["String"]["output"]>;
  kind: ProductKind;
  languageId: Scalars["UUID"]["output"];
  mainCategory: MainCategory;
  manufacturer?: Maybe<Scalars["String"]["output"]>;
  mediaSectionOrder: Array<GalleryTag>;
  minDisplayPrice: Money;
  minDisplayRegularPrice?: Maybe<Money>;
  modelMedia?: Maybe<Gallery>;
  name: Scalars["String"]["output"];
  notes: Array<StorefrontProductNote>;
  options: Array<StorefrontOption>;
  organizationalCollectionSlug?: Maybe<Scalars["String"]["output"]>;
  performanceMedia?: Maybe<Gallery>;
  proCollectionSlug?: Maybe<Scalars["String"]["output"]>;
  productCustomization?: Maybe<StorefrontProductCustomization>;
  productFeatureMedia?: Maybe<Gallery>;
  productGroup?: Maybe<ProductGroup>;
  productInlineAccessoryGroup: Array<ProductInlineAccessoryGroup>;
  /**
   * For which child products, this main product is referenced
   *
   * May be confusing, so as example:
   * - For HDD this will return nothing
   * - For UNVR/UDM this will return HDD
   */
  referencedCompatibleProductIds: Array<Scalars["UUID"]["output"]>;
  relatedProductCategories: Array<RelatedProductCategory>;
  seoDescription: Scalars["String"]["output"];
  seoTitle: Scalars["String"]["output"];
  shortDescription: Scalars["String"]["output"];
  shortTitle?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  state: ProductState;
  /** Calculates variant statuses based on availability priority */
  status: DisplayProductStatus;
  storeId: StoreId;
  tags: Array<ProductTag>;
  taxCode?: Maybe<Scalars["String"]["output"]>;
  /** If store.has_custom_tax_rate is enabled, returns products' custom tax rate if defined */
  taxRate?: Maybe<Scalars["Float"]["output"]>;
  /** @deprecated Use techSpecsMedia */
  techSpecs?: Maybe<Gallery>;
  techSpecsMedia?: Maybe<Gallery>;
  technicalSpecification?: Maybe<SpecificationEntity>;
  thumbnail?: Maybe<Asset>;
  title: Scalars["String"]["output"];
  topologyMedia?: Maybe<Gallery>;
  type?: Maybe<ProductType>;
  updatedAt: Scalars["DateTime"]["output"];
  upsellProductCategories: Array<UpsellProductCategory>;
  url: Scalars["String"]["output"];
  variants: Array<StorefrontProductVariant>;
  whatsInTheBoxMedia?: Maybe<Gallery>;
};

export type StorefrontProductTechnicalSpecificationArgs = {
  filter?: InputMaybe<SpecificationEntityInput>;
};

export type StorefrontProductByIdFilterInput = {
  family?: InputMaybe<ProductFamily>;
  line?: InputMaybe<ProductLine>;
};

export type StorefrontProductCompatibility = {
  __typename?: "StorefrontProductCompatibility";
  note?: Maybe<Scalars["String"]["output"]>;
  noteMoveToBottom: Scalars["Boolean"]["output"];
  noteRequireCollectionSection: Scalars["Boolean"]["output"];
  productIds: Array<Scalars["UUID"]["output"]>;
};

export type StorefrontProductCustomization = {
  __typename?: "StorefrontProductCustomization";
  groups: Array<StorefrontProductCustomizationGroup>;
  id: Scalars["UUID"]["output"];
};

export type StorefrontProductCustomizationGroup = {
  __typename?: "StorefrontProductCustomizationGroup";
  id: Scalars["UUID"]["output"];
  matchVariants: Scalars["Boolean"]["output"];
  parentId?: Maybe<Scalars["UUID"]["output"]>;
  productIds: Array<Scalars["UUID"]["output"]>;
  showIncludedOption: Scalars["Boolean"]["output"];
  subtitle?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
};

export type StorefrontProductListFilterInput = {
  displayCurrency?: InputMaybe<Currency>;
  family?: InputMaybe<ProductFamily>;
  /** If not provided or passed `true`, it will check against context of caller (if has access to EA) */
  hasEarlyAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasPreviousPurchase?: InputMaybe<Scalars["Boolean"]["input"]>;
  language: Scalars["LowercaseTrimmedString"]["input"];
  line?: InputMaybe<ProductLine>;
  /**
   * Return products that are not visible to the public
   * Defaults to false
   */
  returnInvisibleProducts?: InputMaybe<Scalars["Boolean"]["input"]>;
  skus?: InputMaybe<Array<Scalars["LowercaseTrimmedString"]["input"]>>;
  slugs?: InputMaybe<Array<Scalars["LowercaseTrimmedString"]["input"]>>;
  storeId: StoreId;
  tags?: InputMaybe<Array<Scalars["LowercaseTrimmedString"]["input"]>>;
};

export type StorefrontProductListInput = {
  filter: StorefrontProductListFilterInput;
  limit: Scalars["PaginationLimit"]["input"];
  offset: Scalars["NonNegativeInt"]["input"];
  order?: InputMaybe<Array<StorefrontProductOrderBy>>;
  search?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type StorefrontProductListResponse = PageResponse & {
  __typename?: "StorefrontProductListResponse";
  items: Array<StorefrontProduct>;
  pagination: PaginationResponse;
};

export type StorefrontProductNote = {
  __typename?: "StorefrontProductNote";
  contentHtml: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
};

export type StorefrontProductOrderBy = {
  key: StorefrontProductOrderByKey;
  order: SortOrder;
};

export enum StorefrontProductOrderByKey {
  BaseSku = "baseSku",
  Family = "family",
  State = "state",
  Type = "type",
}

export type StorefrontProductUrlItem = {
  __typename?: "StorefrontProductUrlItem";
  storeId: StoreId;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type StorefrontProductUrls = {
  __typename?: "StorefrontProductUrls";
  baseSku?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  productLine?: Maybe<ProductLine>;
  shortTitle?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  urls: Array<StorefrontProductUrlItem>;
};

export type StorefrontProductVariant = {
  __typename?: "StorefrontProductVariant";
  /** Other stores in which the variant is currently available */
  availableInOtherStores: Array<StorefrontProductVariantAlternativeStore>;
  bundleDiscounts: Array<DiscountBundleMetadata>;
  bundleNotes: Array<ProductBundleNote>;
  campaignDiscounts: Array<CampaignDiscountMetadata>;
  /** Carrier setup media items for the variant (subset of galleryItemIds) */
  carrierSetupMediaItemIds: Array<Scalars["UUID"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  /** Customization media items for the variant (subset of galleryItemIds) */
  customizationMediaItemIds: Array<Scalars["UUID"]["output"]>;
  /** Deployment media items for the variant (subset of galleryItemIds) */
  deploymentMediaItemIds: Array<Scalars["UUID"]["output"]>;
  displayPrice: Money;
  displayRegularPrice?: Maybe<Money>;
  /**
   * Human-readable SKU with regional postfix removed and PoE wattage appended from tags.
   * e.g. "USW-Pro-48-PoE-US" with tag "poe:100w" → "USW-Pro-48-PoE (100W)"
   */
  displaySku: Scalars["String"]["output"];
  documents: Array<ProductDocument>;
  /** @deprecated galleryItemId is deprecated. Use galleryItemIds instead. */
  galleryItemId?: Maybe<Scalars["UUID"]["output"]>;
  /** All gallery item ids for the variant */
  galleryItemIds: Array<Scalars["UUID"]["output"]>;
  hasPurchaseHistory: Scalars["Boolean"]["output"];
  hasTaxIncludedPrice: Scalars["Boolean"]["output"];
  hasUiCare: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** Installation media items for the variant (subset of galleryItemIds) */
  installationMediaItemIds: Array<Scalars["UUID"]["output"]>;
  isEarlyAccess: Scalars["Boolean"]["output"];
  isVisibleInStore: Scalars["Boolean"]["output"];
  language: Language;
  optionValue1?: Maybe<StorefrontOptionValue>;
  optionValue2?: Maybe<StorefrontOptionValue>;
  optionValue3?: Maybe<StorefrontOptionValue>;
  optionValueIds?: Maybe<Array<Scalars["UUID"]["output"]>>;
  /** Performance media items for the variant (subset of galleryItemIds) */
  performanceMediaItemIds: Array<Scalars["UUID"]["output"]>;
  /** Product feature media items for the variant */
  productFeatureMediaItemIds: Array<Scalars["UUID"]["output"]>;
  /** Product media items for the variant (subset of galleryItemIds) */
  productMediaItemIds: Array<Scalars["UUID"]["output"]>;
  productVariantId: Scalars["UUID"]["output"];
  sku: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  status: DisplayProductStatus;
  storeId: StoreId;
  storePrice: Money;
  storeRegularPrice?: Maybe<Money>;
  /** Tech specs media items for the variant (subset of galleryItemIds) */
  techSpecsMediaItemIds: Array<Scalars["UUID"]["output"]>;
  title: Scalars["String"]["output"];
  /** Topology media items for the variant (subset of galleryItemIds) */
  topologyMediaItemIds: Array<Scalars["UUID"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  url: Scalars["String"]["output"];
  weight: Weight;
  /** What's in the box media items for the variant (subset of galleryItemIds) */
  whatsInTheBoxMediaItemIds: Array<Scalars["UUID"]["output"]>;
};

export type StorefrontProductVariantAlternativeStore = {
  __typename?: "StorefrontProductVariantAlternativeStore";
  /** @deprecated Use variants[].sku instead */
  sku: Scalars["String"]["output"];
  /** @deprecated Use variants[].slug instead */
  slug: Scalars["String"]["output"];
  store: StorefrontStore;
  variants: Array<StorefrontProductVariantAlternativeStoreVariant>;
};

export type StorefrontProductVariantAlternativeStoreVariant = {
  __typename?: "StorefrontProductVariantAlternativeStoreVariant";
  sku: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
};

export type StorefrontRecommendedProductsFilterInput = {
  /** Used for recently published products */
  collectionSlugs?: InputMaybe<
    Array<Scalars["LowercaseTrimmedString"]["input"]>
  >;
  line?: InputMaybe<ProductLine>;
};

export type StorefrontRecommendedProductsInput = {
  displayCurrency?: InputMaybe<Currency>;
  filter?: InputMaybe<StorefrontRecommendedProductsFilterInput>;
  language: Scalars["LowercaseTrimmedString"]["input"];
  /** Defaults to 3 */
  limit?: InputMaybe<Scalars["PaginationLimit"]["input"]>;
  /** Defaults to `MostSearched` */
  order?: InputMaybe<StorefrontRecommendedProductsOrderByKey>;
  storeId: StoreId;
};

export enum StorefrontRecommendedProductsOrderByKey {
  MostSearched = "MostSearched",
  RecentlyPublished = "RecentlyPublished",
}

export type StorefrontStore = {
  __typename?: "StorefrontStore";
  businessName: Scalars["String"]["output"];
  country: CountryCode;
  /** ISO 4217 */
  currency: Currency;
  hasUiCare: Scalars["Boolean"]["output"];
  id: StoreId;
  name: Scalars["String"]["output"];
};

export type StorefrontUpdateCheckoutInput = {
  acceptsMarketing?: InputMaybe<Scalars["Boolean"]["input"]>;
  applyStoreCreditAmount?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  billingAddress?: InputMaybe<StorefrontCheckoutAddressInput>;
  delivery?: InputMaybe<StorefrontCheckoutDeliveryInput>;
  /** Removed if empty string given. Discount code should always be uppercase */
  discountCode?: InputMaybe<Scalars["UppercaseTrimmedString"]["input"]>;
  email?: InputMaybe<Scalars["LowercaseTrimmedString"]["input"]>;
  /**
   * Intended to be used by API integrations to add additional items to the
   * checkout that doesn't exist in the store that the checkout is created for. All
   * the items that are added here will be displayed as unavailable in the checkout
   * cart screen.
   */
  externalItems?: InputMaybe<Array<CheckoutExternalItemInput>>;
  gaClientId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  id: Scalars["UUID"]["input"];
  invoiceNote?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  language?: InputMaybe<Scalars["LowercaseTrimmedString"]["input"]>;
  reportIsWizardCheckout?: InputMaybe<Scalars["Boolean"]["input"]>;
  secret?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  shippingAddress?: InputMaybe<StorefrontCheckoutAddressInput>;
  shippingMethodName?: InputMaybe<Scalars["String"]["input"]>;
  skipShippingCalculation?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** It's a hint, will be used only for Avatax stores */
  skipTaxCalculation?: InputMaybe<Scalars["Boolean"]["input"]>;
  storeCarrierServiceId?: InputMaybe<Scalars["UUID"]["input"]>;
  storeShippingRateId?: InputMaybe<Scalars["UUID"]["input"]>;
  /**
   * If updateItems is used, addItems and removeItems will be ignored.
   * All quantities inside act as delta, e.g. quantity can be -1; 0; +1;
   *
   * updateItems also introduces groups and links concept, which is used more for a
   * representation purpose. With it you can group some items under other items
   *
   * To update existing group, you'll need to provide `groupId` to alter it, otherwise,
   * new group will be made.
   */
  updateItems?: InputMaybe<Array<StorefrontCheckoutItemInput>>;
};

export type StorefrontUpdateCheckoutResponse = {
  __typename?: "StorefrontUpdateCheckoutResponse";
  checkout: StorefrontCheckout;
};

export type StripeAba = {
  __typename?: "StripeAba";
  accountNumber: Scalars["String"]["output"];
  bankName: Scalars["String"]["output"];
  routingNumber: Scalars["String"]["output"];
  type: BankTransferType;
};

export type StripeIban = {
  __typename?: "StripeIban";
  accountHolderName: Scalars["String"]["output"];
  bic: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  iban: Scalars["String"]["output"];
  type: BankTransferType;
};

export type StripeSortCode = {
  __typename?: "StripeSortCode";
  accountHolderName: Scalars["String"]["output"];
  accountNumber: Scalars["String"]["output"];
  sortCode: Scalars["String"]["output"];
  type: BankTransferType;
};

export type StripeSpei = {
  __typename?: "StripeSpei";
  bankCode: Scalars["String"]["output"];
  bankName: Scalars["String"]["output"];
  clabe: Scalars["String"]["output"];
  type: BankTransferType;
};

export type StripeSwift = {
  __typename?: "StripeSwift";
  accountNumber: Scalars["String"]["output"];
  bankName: Scalars["String"]["output"];
  swiftCode: Scalars["String"]["output"];
  type: BankTransferType;
};

export type StripeZengin = {
  __typename?: "StripeZengin";
  accountHolderName: Scalars["String"]["output"];
  accountNumber: Scalars["String"]["output"];
  accountType: Scalars["String"]["output"];
  bankCode: Scalars["String"]["output"];
  bankName: Scalars["String"]["output"];
  branchCode: Scalars["String"]["output"];
  branchName: Scalars["String"]["output"];
  type: BankTransferType;
};

export enum TagTemplateEntityType {
  Collection = "Collection",
  Product = "Product",
}

export enum TariffType {
  PerProduct = "PerProduct",
}

export type TaxExemptionEntitiesByStoreId = {
  __typename?: "TaxExemptionEntitiesByStoreId";
  regions: Array<CountryZone>;
  storeId: StoreId;
  taxExemptionEntities: Array<CustomerTaxExemptionEntity>;
};

export type TaxExemptionEntitiesByStoreIdResponse = {
  __typename?: "TaxExemptionEntitiesByStoreIdResponse";
  items: Array<TaxExemptionEntitiesByStoreId>;
};

/** Tax exemption entity types */
export enum TaxExemptionEntity {
  Agriculture = "Agriculture",
  CharitableExemptOrg = "CharitableExemptOrg",
  CommercialAquaculture = "CommercialAquaculture",
  CommercialFishery = "CommercialFishery",
  DirectMail = "DirectMail",
  DirectPay = "DirectPay",
  EducationalOrg = "EducationalOrg",
  FederalGov = "FederalGov",
  ForeignDiplomat = "ForeignDiplomat",
  IndustrialProduction = "IndustrialProduction",
  /** Represents full store exemption */
  InternalStore = "InternalStore",
  LocalGovernment = "LocalGovernment",
  NonResident = "NonResident",
  /** Represents no tax exemption selected */
  None = "None",
  Other = "Other",
  ReligiousOrg = "ReligiousOrg",
  Resale = "Resale",
  StateGov = "StateGov",
  TribalGov = "TribalGov",
}

export enum TaxExemptionEntityRequirement {
  /** Tax exemption based on country region/province/... */
  Region = "Region",
  /** Tax exemption based on customer's entered tax id */
  TaxId = "TaxId",
}

export enum TaxExemptionEntityStorefront {
  Agriculture = "Agriculture",
  CharitableExemptOrg = "CharitableExemptOrg",
  CommercialAquaculture = "CommercialAquaculture",
  CommercialFishery = "CommercialFishery",
  DirectMail = "DirectMail",
  DirectPay = "DirectPay",
  EducationalOrg = "EducationalOrg",
  FederalGov = "FederalGov",
  ForeignDiplomat = "ForeignDiplomat",
  IndustrialProduction = "IndustrialProduction",
  LocalGovernment = "LocalGovernment",
  NonResident = "NonResident",
  Other = "Other",
  ReligiousOrg = "ReligiousOrg",
  Resale = "Resale",
  StateGov = "StateGov",
  TribalGov = "TribalGov",
}

export enum TaxExemptionStatus {
  /** Active tax exemption that is taken into account during checkout */
  Active = "Active",
  /** Customer has requested a tax exemption */
  Pending = "Pending",
  /** Customer's request has been rejected */
  Rejected = "Rejected",
}

export type TaxIdMockValidation = {
  __typename?: "TaxIdMockValidation";
  taxId: Scalars["TrimmedString"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  validationStatus: TaxIdValidationStatus;
};

export type TaxIdValidationResponse = {
  __typename?: "TaxIdValidationResponse";
  status: TaxIdValidationStatus;
};

/** Tax ID validation service identifiers */
export enum TaxIdValidationService {
  /** Europe VIES */
  Eu = "Eu",
  /** Norway */
  No = "No",
  /** United Kingdom (except Northern Ireland) */
  Uk = "Uk",
}

export enum TaxIdValidationStatus {
  /** Tax id validation skipped and treated as valid */
  ForcedValid = "ForcedValid",
  /** Tax id validated successfully but isn't valid */
  Invalid = "Invalid",
  /** In cases when validation service is unavailable */
  Unavailable = "Unavailable",
  /** Tax id validated successfully and is valid */
  Valid = "Valid",
}

export type TaxLine = {
  createdAt: Scalars["DateTime"]["output"];
  currency: Currency;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  taxRate: Scalars["String"]["output"];
  taxTotal: Scalars["NonNegativeInt"]["output"];
  type: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type TaxRateResponse = {
  __typename?: "TaxRateResponse";
  rate: Scalars["Float"]["output"];
};

export enum TaxRateType {
  /** Applies to all products */
  Global = "Global",
  /** Applies to specific products */
  PerProduct = "PerProduct",
}

export type TimeZoneData = {
  __typename?: "TimeZoneData";
  abbr: Scalars["String"]["output"];
  isDST: Scalars["Boolean"]["output"];
  /** UTC offset in hours */
  offset: Scalars["Float"]["output"];
  text: Scalars["String"]["output"];
  utc: Array<Scalars["TimeZone"]["output"]>;
  value: Scalars["String"]["output"];
};

export type TotalAndUniqueCount = {
  __typename?: "TotalAndUniqueCount";
  total: Scalars["NonNegativeInt"]["output"];
  unique: Scalars["NonNegativeInt"]["output"];
};

/** Shared set of fields that describe monetary values of an entity */
export type Totals = {
  __typename?: "Totals";
  /** Discount part only */
  discount: Money;
  /** Total pre discount, pre tax, pre tariff */
  subtotal: Money;
  /** Tariff part only, pre tax */
  tariff: Money;
  /** Tax part only */
  tax: Money;
  /** Taxable amount - calculated via `subtotal - discount + tariff` */
  taxableTotal: Money;
  /** Total of all other fields - calculated via `taxableTotal + tax` */
  total: Money;
};

export type Translation = {
  language: Language;
};

export enum TranslationJobStatus {
  Idle = "Idle",
  Running = "Running",
  Waiting = "Waiting",
}

export type TranslationJobStatusResponse = {
  __typename?: "TranslationJobStatusResponse";
  currentRunStartedAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastSuccessfulRunCompletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastSuccessfulRunStartedAt?: Maybe<Scalars["DateTime"]["output"]>;
  nextRunScheduledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Whether Smartcat integration is enabled for this environment. */
  smartcatEnabled: Scalars["Boolean"]["output"];
  status: TranslationJobStatus;
};

export enum Unit {
  G = "g",
  Kg = "kg",
  Lb = "lb",
  Oz = "oz",
}

export enum UnitSystem {
  Imperial = "Imperial",
  Metric = "Metric",
}

export type UnregisterDeviceTokenInput = {
  platform: DeviceTokenPlatform;
  reason?: InputMaybe<InactiveReason>;
  token: Scalars["TrimmedString"]["input"];
};

export type UnregisterDeviceTokenResponse = {
  __typename?: "UnregisterDeviceTokenResponse";
  deviceToken?: Maybe<DeviceToken>;
};

export type UnshareWishlistInput = {
  wishlistId: Scalars["UUID"]["input"];
  wishlistShareIds: Array<Scalars["UUID"]["input"]>;
};

export type UpdateAssetAlternativeLinkInput = {
  alternativeAssetId?: InputMaybe<Scalars["UUID"]["input"]>;
  assetId: Scalars["UUID"]["input"];
};

export type UpdateAssetAlternativeLinkPayload = {
  __typename?: "UpdateAssetAlternativeLinkPayload";
  asset: Asset;
};

export type UpdateAssetModelVariantInput = {
  assetId: Scalars["UUID"]["input"];
  /** Camera FOV in degrees */
  cameraFov: Scalars["Float"]["input"];
  /** Vertical angle in degrees, default 75 */
  cameraPhi: Scalars["Int"]["input"];
  /** Camera distance in meters from the center of the object, default 0.5 */
  cameraRadius: Scalars["Float"]["input"];
  /** Horizontal angle in degrees, default 0 */
  cameraTheta: Scalars["Int"]["input"];
  /** The name of the glb file material */
  name: Scalars["String"]["input"];
  /** Exposure setting for the specific material */
  sceneBrightness: Scalars["Float"]["input"];
};

export type UpdateAssetModelVariantResponse = {
  __typename?: "UpdateAssetModelVariantResponse";
  updated: Array<AssetModelVariant>;
};

export type UpdateBackInStockSubscriptionInput = {
  locale?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  sku: Scalars["TrimmedString"]["input"];
  storeId: StoreId;
  subscribe: Scalars["Boolean"]["input"];
};

export type UpdateBackInStockSubscriptionResponse = {
  __typename?: "UpdateBackInStockSubscriptionResponse";
  isSubscribed: Scalars["Boolean"]["output"];
};

export type UpdateCollectionCategoryFeatureInput = {
  icon: Scalars["TrimmedString"]["input"];
  translations: Array<UpdateCollectionCategoryFeatureTranslationInput>;
};

export type UpdateCollectionCategoryFeatureTranslationInput = {
  description?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  languageId: Scalars["UUID"]["input"];
};

export type UpdateCollectionCategoryInput = {
  features: Array<UpdateCollectionCategoryFeatureInput>;
  isEnabled: Scalars["Boolean"]["input"];
  products: Array<Scalars["UUID"]["input"]>;
  type: CollectionCategoryType;
};

export type UpdateCollectionInput = {
  categories?: InputMaybe<Array<UpdateCollectionCategoryInput>>;
  collectionSections?: InputMaybe<Array<UpdateCollectionSectionInput>>;
  defaultIsVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  family?: InputMaybe<ProductFamily>;
  id: Scalars["UUID"]["input"];
  products?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  slug?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  sortBy?: InputMaybe<CollectionSort>;
  specification?: InputMaybe<UpdateSpecificationEntityInput>;
  storeCollections?: InputMaybe<Array<UpdateStoreCollectionInput>>;
  tags?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  translations?: InputMaybe<Array<UpdateCollectionTranslationInput>>;
  type?: InputMaybe<ProductType>;
};

export type UpdateCollectionResponse = {
  __typename?: "UpdateCollectionResponse";
  collection: Collection;
};

export type UpdateCollectionSectionInput = {
  id: Scalars["UUID"]["input"];
  tags: Array<Scalars["UUID"]["input"]>;
  title: Array<UpdateCollectionSectionTitleInput>;
};

export type UpdateCollectionSectionTitleInput = {
  languageId: Scalars["UUID"]["input"];
  title?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateCollectionTranslationInput = {
  description?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  heroTitle?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  languageId: Scalars["UUID"]["input"];
  seoDescription?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  seoTitle?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  title?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateCustomerAddressInput = {
  additionalInfo?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  address1: Scalars["TrimmedString"]["input"];
  address2?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  businessName?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  city: Scalars["TrimmedString"]["input"];
  country: CountryCode;
  firstName: Scalars["TrimmedString"]["input"];
  id: Scalars["UUID"]["input"];
  isAnyUsageType?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName: Scalars["TrimmedString"]["input"];
  neighborhood?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  phoneNumber: Scalars["TrimmedString"]["input"];
  postalCode?: InputMaybe<Scalars["UppercaseTrimmedString"]["input"]>;
  province?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  stateRegistrationNumber?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  taxId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  type: AddressType;
  usageType?: InputMaybe<AddressUsageType>;
};

export type UpdateCustomerInput = {
  acceptsMarketing?: InputMaybe<Scalars["Boolean"]["input"]>;
  additionalPaymentMethods?: InputMaybe<Array<CustomerAdditionalPaymentMethod>>;
  id: Scalars["UUID"]["input"];
  tags?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
};

export type UpdateCustomerPayByInvoiceMetadataInput = {
  contactEmail?: InputMaybe<Scalars["EmailAddress"]["input"]>;
  contactName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  referenceNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateCustomerResponse = {
  __typename?: "UpdateCustomerResponse";
  customer: Customer;
};

export type UpdateCustomersOwnMarketingInput = {
  acceptsMarketing: Scalars["Boolean"]["input"];
};

export type UpdateCustomersOwnMarketingResponse = {
  __typename?: "UpdateCustomersOwnMarketingResponse";
  customer: Customer;
};

export type UpdateDefaultStoreSeoInput = {
  description?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  title?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateDefaultWarehouseInput = {
  id: Scalars["UUID"]["input"];
};

export type UpdateDefaultWarehouseResponse = {
  __typename?: "UpdateDefaultWarehouseResponse";
  warehouse: Warehouse;
};

export type UpdateDiscountAmountInput = {
  currency: Currency;
  price: Scalars["Int"]["input"];
};

export type UpdateDiscountInput = {
  activeEndDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  activeStartDate: Scalars["DateTime"]["input"];
  /** Discount code should always be uppercase */
  codes: Array<Scalars["UppercaseTrimmedString"]["input"]>;
  customers?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  discountBundleProducts: Array<ApUpdateDiscountBundleProductInput>;
  discountProducts: Array<UpdateDiscountProductInput>;
  eligibility?: InputMaybe<DiscountEligibility>;
  fixedAmount?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  hasAllProducts: Scalars["Boolean"]["input"];
  hasCustomerLimit: Scalars["Boolean"]["input"];
  hasShippingIncluded: Scalars["Boolean"]["input"];
  id: Scalars["UUID"]["input"];
  isAutoApplied?: InputMaybe<Scalars["Boolean"]["input"]>;
  isEnabled: Scalars["Boolean"]["input"];
  isVisible: Scalars["Boolean"]["input"];
  limitPerCode?: InputMaybe<Scalars["Int"]["input"]>;
  maxAmount?: InputMaybe<UpdateDiscountAmountInput>;
  maxQty?: InputMaybe<Scalars["Int"]["input"]>;
  minAmount?: InputMaybe<UpdateDiscountAmountInput>;
  minQty?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["TrimmedString"]["input"];
  parentRatio?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  percentageAmount?: InputMaybe<Scalars["PositivePercentage"]["input"]>;
  requirementType?: InputMaybe<DiscountRequirementType>;
  slugGroup?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  storeDiscounts: Array<UpdateDiscountStoreInput>;
  type: DiscountType;
};

export type UpdateDiscountProductInput = {
  discountProductVariants: Array<UpdateDiscountProductVariantInput>;
  includeProspectiveVariants: Scalars["Boolean"]["input"];
  productId: Scalars["UUID"]["input"];
};

export type UpdateDiscountProductVariantInput = {
  isSelected: Scalars["Boolean"]["input"];
  productVariantId: Scalars["UUID"]["input"];
};

export type UpdateDiscountResponse = {
  __typename?: "UpdateDiscountResponse";
  discount: Discount;
};

export type UpdateDiscountStoreInput = {
  fixedAmount?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  storeId: StoreId;
};

export type UpdateInlineAccessoriesInput = {
  products: Array<UpdateInlineAccessoriesProductInput>;
};

export type UpdateInlineAccessoriesProductInput = {
  productId: Scalars["UUID"]["input"];
  renderAsCard: Scalars["Boolean"]["input"];
};

export type UpdateIntegrationInput = {
  id: Scalars["UUID"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  limits: Array<IntegrationSkuLimitInput>;
  name: Scalars["TrimmedString"]["input"];
};

export type UpdateIntegrationResponse = {
  __typename?: "UpdateIntegrationResponse";
  integration: ApIntegration;
};

export type UpdateLanguageInput = {
  id: Scalars["UUID"]["input"];
  locale?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  name?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateLanguageResponse = {
  __typename?: "UpdateLanguageResponse";
  language: Language;
};

export type UpdateLimitationConditionalProduct = {
  includeProspectiveVariants: Scalars["Boolean"]["input"];
  limitationConditionalProductVariants: Array<UpdateLimitationConditionalProductVariant>;
  productId: Scalars["UUID"]["input"];
};

export type UpdateLimitationConditionalProductVariant = {
  isSelected: Scalars["Boolean"]["input"];
  productVariantId: Scalars["UUID"]["input"];
};

export type UpdateLimitationInput = {
  applyType: LimitationApplyType;
  conditionalMinQuantity: Scalars["Int"]["input"];
  conditionalProducts: Array<UpdateLimitationConditionalProduct>;
  hasAllProducts: Scalars["Boolean"]["input"];
  id: Scalars["UUID"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  isVisible: Scalars["Boolean"]["input"];
  maxQuantity: Scalars["Int"]["input"];
  name: Scalars["TrimmedString"]["input"];
  products: Array<Scalars["UUID"]["input"]>;
  storeLimitations: Array<UpdateLimitationStoreInput>;
  type: LimitationType;
};

export type UpdateLimitationResponse = {
  __typename?: "UpdateLimitationResponse";
  limitation: Limitation;
};

export type UpdateLimitationStoreInput = {
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  storeId: StoreId;
};

export type UpdateNonDefaultStoreSeoInput = {
  description?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  storeId: StoreId;
  title?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateNotificationsInput = {
  deviceToken?: InputMaybe<DeviceTokenDataInput>;
  locale?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  notifications: Array<NotificationUpdateInput>;
};

export type UpdateOptionInput = {
  id: Scalars["UUID"]["input"];
  slug: Scalars["TrimmedString"]["input"];
  translations?: InputMaybe<Array<UpdateOptionTranslationInput>>;
  valueAdd?: InputMaybe<Array<UpdateValueAddTitleInput>>;
  valueEdit?: InputMaybe<Array<UpdateValueEditTitleInput>>;
  valueRemove?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
};

export type UpdateOptionResponse = {
  __typename?: "UpdateOptionResponse";
  option: Option;
};

export type UpdateOptionTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  title?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateOrderBillingAddressInput = {
  billingAddress: AddressInput;
  orderId: Scalars["UUID"]["input"];
};

export type UpdateOrderBillingAddressResponse = {
  __typename?: "UpdateOrderBillingAddressResponse";
  billingAddress: OrderAddressUnion;
};

export type UpdateOrderDetailsInput = {
  /** billing address in case of retry of order payment or manual order (created on the AP side) payment */
  billingAddress?: InputMaybe<AddressInput>;
  /** Custom return url for redirect-based payment methods. Currently used only in cases when storefront is in embedded mode and we have to redirect user back to the page that the storefront is embedded in. */
  customReturnUrl?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  /** invoice note in case of retry of order payment or manual order (created on the AP side) payment */
  invoiceNote?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  /** Session ID for Kount fraud assessment. */
  kountSessionId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  /** orderId to identify order */
  orderId: Scalars["TrimmedString"]["input"];
  /** Used for non-customer invoice payments */
  payByInvoice?: InputMaybe<OrderPayByInvoiceInput>;
  /** Selected payment method */
  paymentMethod?: InputMaybe<OrderTransactionPaymentMethod>;
  /** Used to identify to which payment provider order payment intent is updated */
  paymentProviderId: Scalars["TrimmedString"]["input"];
};

export type UpdateOrderDetailsResponse = {
  __typename?: "UpdateOrderDetailsResponse";
  billingAddress: OrderAddressUnion;
  paymentExpireAt: Scalars["DateTime"]["output"];
  /** Payment provider used in order; This will not be set only for pay by invoice orders */
  paymentProvider?: Maybe<PaymentProvider>;
  /** Only certain payment providers will return this field */
  paymentSecret?: Maybe<Scalars["String"]["output"]>;
  /** Only certain payment provider will return this field */
  providerOrderId?: Maybe<Scalars["String"]["output"]>;
  /** Will be empty for PaymentProvider=Paypal */
  providerPaymentId?: Maybe<Scalars["String"]["output"]>;
  /** At the time of writing this, only PagBrasil payment provider will return this field */
  providerPaymentLink?: Maybe<Scalars["String"]["output"]>;
};

export type UpdateProductBundleInput = {
  bundledProductIsStandalone?: InputMaybe<Scalars["Boolean"]["input"]>;
  bundledProductRatio?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  bundledProductSku?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  countries?: InputMaybe<Array<CountryCode>>;
  id: Scalars["UUID"]["input"];
  productRatio?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  productSku?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  storeId?: InputMaybe<StoreId>;
  strictMax?: InputMaybe<Scalars["Boolean"]["input"]>;
  strictMin?: InputMaybe<Scalars["Boolean"]["input"]>;
  syncAvailability?: InputMaybe<Scalars["Boolean"]["input"]>;
  translations?: InputMaybe<Array<ProductBundleTranslationInput>>;
};

export type UpdateProductCustomizationGroupInput = {
  id: Scalars["UUID"]["input"];
  matchVariants: Scalars["Boolean"]["input"];
  parentId?: InputMaybe<Scalars["UUID"]["input"]>;
  productIds: Array<Scalars["UUID"]["input"]>;
  showIncludedOption: Scalars["Boolean"]["input"];
  translations: Array<UpdateProductCustomizationGroupTranslationInput>;
};

export type UpdateProductCustomizationGroupTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  subtitle?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  title: Scalars["TrimmedString"]["input"];
};

export type UpdateProductCustomizationInput = {
  groups: Array<UpdateProductCustomizationGroupInput>;
  isEnabled: Scalars["Boolean"]["input"];
};

export type UpdateProductDefaultVariantInput = {
  backorderLimit?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  isEarlyAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisibleInStore?: InputMaybe<Scalars["Boolean"]["input"]>;
  order?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  price?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  sku?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  status?: InputMaybe<ProductStatus>;
  stores?: InputMaybe<Array<UpdateProductStoreProductVariantInput>>;
  uiCareManagement?: InputMaybe<ProductUiCareManagement>;
  /** Optional value to set a manual price for autogenerated UI Care products */
  uiCarePriceOverride?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  /** Acts as bigint string */
  weight?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateProductDocumentInput = {
  id: Scalars["UUID"]["input"];
  url: Scalars["TrimmedString"]["input"];
};

export type UpdateProductDocumentResponse = {
  __typename?: "UpdateProductDocumentResponse";
  document: ProductDocument;
};

export type UpdateProductFaqsInput = {
  faqs: Array<ProductFaqItemInput>;
  isHidden: Scalars["Boolean"]["input"];
  productId: Scalars["UUID"]["input"];
};

export type UpdateProductGroupInput = {
  masterProduct?: InputMaybe<Scalars["UUID"]["input"]>;
  products: Array<Scalars["UUID"]["input"]>;
};

export type UpdateProductInput = {
  affiliateCampaigns?: InputMaybe<Array<ApAffiliateCampaignsInput>>;
  assetModelSettings?: InputMaybe<
    Array<UpdateProductVariantAssetModelSettingsInput>
  >;
  defaultVariant?: InputMaybe<UpdateProductDefaultVariantInput>;
  forceUpdate?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["UUID"]["input"];
  inlineAccessories?: InputMaybe<UpdateInlineAccessoriesInput>;
  lastKnownUpdatedAt: Scalars["DateTime"]["input"];
  mediaSectionOrder?: InputMaybe<Array<GalleryTag>>;
  product?: InputMaybe<UpdateProductProductInput>;
  productCustomization?: InputMaybe<UpdateProductCustomizationInput>;
  productGroup?: InputMaybe<UpdateProductGroupInput>;
  productNotes?: InputMaybe<Array<UpsertProductNoteInput>>;
  productRegionalLimits?: InputMaybe<Array<UpdateProductRegionalLimitInput>>;
  relatedProducts?: InputMaybe<UpdateRelatedProductsInput>;
  skuRemaps?: InputMaybe<Array<UpdateProductSkuRemapInput>>;
  specification?: InputMaybe<UpdateSpecificationEntityInput>;
  upsellProducts?: InputMaybe<UpdateUpsellProductsInput>;
  variants?: InputMaybe<Array<UpdateProductVariantInput>>;
};

export type UpdateProductProductInput = {
  baseSku?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  countryOfOrigin?: InputMaybe<CountryCode>;
  defaultCollectionId?: InputMaybe<Scalars["UUID"]["input"]>;
  family?: InputMaybe<ProductFamily>;
  hsCode?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  kind?: InputMaybe<ProductKind>;
  manufacturer?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  organizationalCollectionId?: InputMaybe<Scalars["UUID"]["input"]>;
  proCollectionId?: InputMaybe<Scalars["UUID"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  searchFactor?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  slug?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  tags: Array<Scalars["UUID"]["input"]>;
  taxCode?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  trackQuantity?: InputMaybe<Scalars["Boolean"]["input"]>;
  translations?: InputMaybe<Array<UpdateProductTranslationInput>>;
  type?: InputMaybe<ProductType>;
  usedOptionValueIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  variesBy?: InputMaybe<Array<ProductVariesBy>>;
};

export type UpdateProductRegionalLimitInput = {
  countries?: InputMaybe<Array<ProductRegionalLimitCountryInput>>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  productId: Scalars["UUID"]["input"];
  services?: InputMaybe<Array<ProductRegionalLimitServiceInput>>;
  storeId: StoreId;
};

export type UpdateProductResponse = {
  __typename?: "UpdateProductResponse";
  product: ApProduct;
};

export type UpdateProductSkuRemapInput = {
  from: Scalars["TrimmedString"]["input"];
  storeId: StoreId;
  to?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateProductStoreProductVariantInput = {
  backorderLimit?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  isEarlyAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisibleInStore?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Depending on stores.hasTaxIncludedPrice this might be price with or without tax */
  price?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  sku?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  skuPrice?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  status?: InputMaybe<ProductStatus>;
  storeId: StoreId;
  /** Optional value to set a manual price for autogenerated UI Care products */
  uiCarePriceOverride?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  /** Acts as bigint string */
  weight?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateProductTranslationInput = {
  callout?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  datasheet?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  description?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  gridDescription?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  keyFeatures?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  keywords?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  languageId: Scalars["UUID"]["input"];
  seoDescription?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  seoTitle?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  shortDescription?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  shortTitle?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  title?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateProductVariantAssetModelSettingsInput = {
  assetId: Scalars["UUID"]["input"];
  materialVariants: Array<MaterialVariantInput>;
  productVariantId: Scalars["UUID"]["input"];
};

export type UpdateProductVariantInput = {
  backorderLimit?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  galleryItemIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  id: Scalars["UUID"]["input"];
  isEarlyAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisibleInStore?: InputMaybe<Scalars["Boolean"]["input"]>;
  optionValueIds: Array<Scalars["UUID"]["input"]>;
  order?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  price?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  sku: Scalars["TrimmedString"]["input"];
  status?: InputMaybe<ProductStatus>;
  stores?: InputMaybe<Array<UpdateProductStoreProductVariantInput>>;
  uiCareManagement?: InputMaybe<ProductUiCareManagement>;
  /** Optional value to set a manual price for autogenerated UI Care products */
  uiCarePriceOverride?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  /** Acts as bigint string */
  weight?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateRelatedProductsInput = {
  categoryId?: InputMaybe<Scalars["UUID"]["input"]>;
  products: Array<Scalars["UUID"]["input"]>;
};

export type UpdateSpecificationEntityFeatureInput = {
  /** Reference to existing SpecificationFeature */
  featureId: Scalars["UUID"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  /** Reference to existing SpecificationSection */
  sectionId: Scalars["UUID"]["input"];
  translations?: InputMaybe<
    Array<UpdateSpecificationEntityFeatureTranslationInput>
  >;
  valueFlag?: InputMaybe<SpecificationSectionFeatureFlag>;
};

export type UpdateSpecificationEntityFeatureTranslationInput = {
  languageId: Scalars["UUID"]["input"];
  note?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  valueText?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateSpecificationEntityInput = {
  features: Array<UpdateSpecificationEntityFeatureInput>;
  isEnabled: Scalars["Boolean"]["input"];
  specificationTemplateId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type UpdateStoreCarrierInput = {
  id: Scalars["UUID"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  name: Scalars["TrimmedString"]["input"];
  services: Array<StoreCarrierServiceInput>;
  storeId: StoreId;
  type: ShippingCarrier;
};

export type UpdateStoreCarrierResponse = {
  __typename?: "UpdateStoreCarrierResponse";
  carrier: StoreCarrier;
};

export type UpdateStoreCollectionInput = {
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  storeId: StoreId;
};

export type UpdateStoreInput = {
  address1?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  address2?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  businessName?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  city?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  contactEmail?: InputMaybe<Scalars["EmailAddress"]["input"]>;
  country?: InputMaybe<CountryCode>;
  hasCustomTaxRate?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasFreeOrderReturn?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasManualCustomerOrderPayments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasManualInventoryManagement?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasManualOrderPayments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasOrderReturn?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasReopenExpiredOrders?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasUiCare?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: StoreId;
  inventoryAlternativeStoreIds?: InputMaybe<Array<StoreId>>;
  name?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  orderPostfix?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  orderPrefix?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  orderReturnRestockFeePercent?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  postalCode?: InputMaybe<Scalars["UppercaseTrimmedString"]["input"]>;
  province?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  supportEmail?: InputMaybe<Scalars["EmailAddress"]["input"]>;
  terms: Scalars["TrimmedString"]["input"];
  /** NEP-503: Comment out currency and unit fields to avoid breaking changes */
  timezone?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateStoreResponse = {
  __typename?: "UpdateStoreResponse";
  store: Store;
};

export type UpdateStoreSeoInput = {
  defaultStoreSeo: UpdateDefaultStoreSeoInput;
  storeSeo: Array<UpdateNonDefaultStoreSeoInput>;
};

export type UpdateStoreSeoResponse = {
  __typename?: "UpdateStoreSeoResponse";
  storeSeo: Array<StoreSeo>;
};

export type UpdateStoreShippingRateInput = {
  customMaxPrice?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  customMinPrice?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  customRateName?: InputMaybe<Scalars["String"]["input"]>;
  customRatePrice?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  id: Scalars["UUID"]["input"];
  isApOnly: Scalars["Boolean"]["input"];
  isBusinessTypeRate: Scalars["Boolean"]["input"];
  isResidentialTypeRate: Scalars["Boolean"]["input"];
  storeCarrierId: Scalars["UUID"]["input"];
  storeCarrierServiceId?: InputMaybe<Scalars["UUID"]["input"]>;
  type: StoreShippingRateType;
};

export type UpdateStoreShippingRateResponse = {
  __typename?: "UpdateStoreShippingRateResponse";
  storeShippingRate: StoreShippingRateUnion;
};

export type UpdateStoreShippingZoneInput = {
  id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
  zones: Array<StoreShippingZoneCountryInput>;
};

export type UpdateStoreShippingZoneResponse = {
  __typename?: "UpdateStoreShippingZoneResponse";
  storeShippingZone: StoreShippingZone;
};

export type UpdateUpsellProductsInput = {
  alwaysUpsell: Scalars["Boolean"]["input"];
  categoryId?: InputMaybe<Scalars["UUID"]["input"]>;
  products: Array<Scalars["UUID"]["input"]>;
};

export type UpdateUserInput = {
  hasFullPermissions: Scalars["Boolean"]["input"];
  id: Scalars["UUID"]["input"];
  permissions: Array<Scalars["TrimmedString"]["input"]>;
  ssoId: Scalars["UUID"]["input"];
  storeIds?: InputMaybe<Array<StoreId>>;
};

export type UpdateUserResponse = {
  __typename?: "UpdateUserResponse";
  user: User;
};

export type UpdateValueAddTitleInput = {
  slug: Scalars["TrimmedString"]["input"];
  translations: Array<CreateOptionTranslationInput>;
};

export type UpdateValueEditTitleInput = {
  id: Scalars["UUID"]["input"];
  slug: Scalars["TrimmedString"]["input"];
  translations: Array<UpdateOptionTranslationInput>;
};

export type UpdateWarehouseInput = {
  address1: Scalars["TrimmedString"]["input"];
  address2?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  attentionName: Scalars["TrimmedString"]["input"];
  city: Scalars["TrimmedString"]["input"];
  country: CountryCode;
  email: Scalars["EmailAddress"]["input"];
  id: Scalars["UUID"]["input"];
  name: Scalars["TrimmedString"]["input"];
  netsuiteId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  postalCode?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  province?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateWarehouseResponse = {
  __typename?: "UpdateWarehouseResponse";
  warehouse: Warehouse;
};

export type UpdateWishlistInput = {
  id: Scalars["UUID"]["input"];
  isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type UpdateWishlistItemEntry = {
  /**
   * Delta quantity (e.g., +1 or -1). Final quantity is clamped to >= 0.
   * If result is 0, item is removed.
   */
  quantity?: InputMaybe<Scalars["Int"]["input"]>;
  sortOrder?: InputMaybe<Scalars["NonNegativeInt"]["input"]>;
  wishlistItemId: Scalars["UUID"]["input"];
};

export type UpdateWishlistItemInput = {
  items: Array<UpdateWishlistItemEntry>;
};

export type UploadImageInput = {
  /** Optional: Link this asset to an alternative asset (e.g., same angle, different variant) */
  alternativeAssetId?: InputMaybe<Scalars["UUID"]["input"]>;
  childAssetType?: InputMaybe<AssetChildAssetType>;
  entityId: Scalars["UUID"]["input"];
  entityType: AssetEntityType;
  galleryCategoryId?: InputMaybe<Scalars["UUID"]["input"]>;
  galleryTag?: InputMaybe<GalleryTag>;
  galleryTranslations?: InputMaybe<Array<ApGalleryItemTranslationInput>>;
  image: Scalars["Upload"]["input"];
  isHidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  languageId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Used for uploading preview video */
  parentAssetId?: InputMaybe<Scalars["UUID"]["input"]>;
  parentEmbedId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type UploadModelAssetVariantInput = {
  /** Camera FOV in degrees */
  cameraFov: Scalars["Float"]["input"];
  /** Vertical angle in degrees, default 75 */
  cameraPhi: Scalars["Int"]["input"];
  /** Camera distance in meters from the center of the object, default 0.5 */
  cameraRadius: Scalars["Float"]["input"];
  /** Horizontal angle in degrees, default 0 */
  cameraTheta: Scalars["Int"]["input"];
  /** The name of the glb file material */
  name: Scalars["String"]["input"];
  /** Exposure setting for the specific material */
  sceneBrightness: Scalars["Float"]["input"];
};

export type UploadModelInput = {
  entityId: Scalars["UUID"]["input"];
  entityType: AssetEntityType;
  galleryTag?: InputMaybe<GalleryTag>;
  languageId?: InputMaybe<Scalars["UUID"]["input"]>;
  model: Scalars["Upload"]["input"];
  modelVariantSettings: Array<UploadModelAssetVariantInput>;
};

export type UploadModelResponse = {
  __typename?: "UploadModelResponse";
  model: Model;
};

export type UploadProtectedAssetInput = {
  entityId: Scalars["UUID"]["input"];
  entityType: ProtectedAssetEntityType;
  file: Scalars["Upload"]["input"];
};

export type UploadProtectedAssetResponse = {
  __typename?: "UploadProtectedAssetResponse";
  protectedAsset: ProtectedAsset;
};

export type UploadResponse = {
  __typename?: "UploadResponse";
  asset: Asset;
};

export type UploadVideoInput = {
  /** Optional: Link this asset to an alternative asset (e.g., same angle, different variant) */
  alternativeAssetId?: InputMaybe<Scalars["UUID"]["input"]>;
  childAssetType?: InputMaybe<AssetChildAssetType>;
  entityId: Scalars["UUID"]["input"];
  entityType: AssetEntityType;
  galleryCategoryId?: InputMaybe<Scalars["UUID"]["input"]>;
  galleryTag?: InputMaybe<GalleryTag>;
  galleryTranslations?: InputMaybe<Array<ApGalleryItemTranslationInput>>;
  isHidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  languageId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Used for uploading preview video */
  parentAssetId?: InputMaybe<Scalars["UUID"]["input"]>;
  parentEmbedId?: InputMaybe<Scalars["UUID"]["input"]>;
  video: Scalars["Upload"]["input"];
};

export type UpsTrackingMetadata = {
  __typename?: "UpsTrackingMetadata";
  providerCode?: Maybe<Scalars["String"]["output"]>;
  providerDescription?: Maybe<Scalars["String"]["output"]>;
  providerStatusType?: Maybe<Scalars["String"]["output"]>;
  providerSubCode?: Maybe<Scalars["String"]["output"]>;
};

export type UpsellProductCategory = {
  __typename?: "UpsellProductCategory";
  id: Scalars["UUID"]["output"];
  items: Array<UpsellProductCategoryItem>;
  name: Scalars["String"]["output"];
  /** @deprecated Use items instead */
  productIds: Array<Scalars["UUID"]["output"]>;
};

export type UpsellProductCategoryItem = {
  __typename?: "UpsellProductCategoryItem";
  appliesToStoreProductVariantIds: Array<Scalars["UUID"]["output"]>;
  upsellProductId: Scalars["UUID"]["output"];
};

export type UpsellProductCategoryTranslation = Translation & {
  __typename?: "UpsellProductCategoryTranslation";
  language: Language;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type UpsertAssetZoneInput = {
  assetId: Scalars["UUID"]["input"];
  entityId: Scalars["String"]["input"];
  entityType: AssetZoneEntityType;
  iconPosition: AssetZoneIconPosition;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  subEntityId?: InputMaybe<Scalars["TrimmedString"]["input"]>;
  x0: Scalars["Int"]["input"];
  x1: Scalars["Int"]["input"];
  y0: Scalars["Int"]["input"];
  y1: Scalars["Int"]["input"];
};

export type UpsertAssetZoneResponse = {
  __typename?: "UpsertAssetZoneResponse";
  assetZone: AssetZone;
};

export type UpsertCollectionTagInput = {
  name: Scalars["TrimmedString"]["input"];
};

export type UpsertCollectionTagResponse = {
  __typename?: "UpsertCollectionTagResponse";
  created: Scalars["Boolean"]["output"];
  tag: CollectionTag;
};

export type UpsertCustomerAddressResponse = {
  __typename?: "UpsertCustomerAddressResponse";
  customerAddress: CustomerAddressUnion;
};

export type UpsertCustomerTagInput = {
  name: Scalars["TrimmedString"]["input"];
};

export type UpsertCustomerTagResponse = {
  __typename?: "UpsertCustomerTagResponse";
  created: Scalars["Boolean"]["output"];
  tag: CustomerTag;
};

export type UpsertOrderTagInput = {
  name: Scalars["TrimmedString"]["input"];
};

export type UpsertOrderTagResponse = {
  __typename?: "UpsertOrderTagResponse";
  created: Scalars["Boolean"]["output"];
  tag: OrderTag;
};

export type UpsertProductNoteInput = {
  id: Scalars["UUID"]["input"];
  /**
   * Null -> Applies to all stores
   * Store ID array -> Applies to specific stores (must be non-empty)
   */
  storeIds?: InputMaybe<Array<StoreId>>;
  translations?: InputMaybe<Array<ProductNoteTranslationInput>>;
};

export type UpsertProductTagInput = {
  name: Scalars["TrimmedString"]["input"];
};

export type UpsertProductTagResponse = {
  __typename?: "UpsertProductTagResponse";
  created: Scalars["Boolean"]["output"];
  tag: ProductTag;
};

export type User = {
  __typename?: "User";
  createdAt: Scalars["DateTime"]["output"];
  deactivatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  displayName: Scalars["String"]["output"];
  email: Scalars["EmailAddress"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  hasFullPermissions: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  isAdmin: Scalars["Boolean"]["output"];
  lastKnownIp?: Maybe<Scalars["String"]["output"]>;
  lastLogoutAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  lastOnlineAt?: Maybe<Scalars["DateTime"]["output"]>;
  locale?: Maybe<Scalars["String"]["output"]>;
  permissions: Array<Scalars["String"]["output"]>;
  picture?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  ssoId: Scalars["UUID"]["output"];
  storeIds: Array<StoreId>;
  updatedAt: Scalars["DateTime"]["output"];
  username?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Extension to `CountryCode` enum with user-assigned codes (follows ISO 3166-1 alpha-2).
 *
 * See https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#User-assigned_code_elements
 */
export enum UserAssignedCountryCode {
  /** Greece */
  El = "EL",
  /**
   * France - overlaps CountryCode.Fr but used to handle VIES scenario where France and Monaco is treated as France
   * there
   */
  Fr = "FR",
  /** Northern Ireland */
  Xi = "XI",
}

/**
 * Vat validation service identifiers
 * @deprecated Use TaxIdValidationService
 */
export enum VatValidationService {
  /** Europe VIES */
  Eu = "Eu",
  /** Norway */
  No = "No",
  /** United Kingdom (except Northern Ireland) */
  Uk = "Uk",
}

export type Warehouse = {
  __typename?: "Warehouse";
  address1: Scalars["String"]["output"];
  address2?: Maybe<Scalars["String"]["output"]>;
  attentionName: Scalars["String"]["output"];
  city: Scalars["String"]["output"];
  country: CountryCode;
  email: Scalars["EmailAddress"]["output"];
  id: Scalars["UUID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  netsuiteId?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  province?: Maybe<Scalars["String"]["output"]>;
};

export type WarehouseShippingZone = {
  __typename?: "WarehouseShippingZone";
  country: CountryCode;
  id: Scalars["UUID"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
  warehouse: Warehouse;
  zoneCode?: Maybe<Scalars["String"]["output"]>;
};

export type Weight = {
  __typename?: "Weight";
  formattedAmount: Scalars["String"]["output"];
  system: UnitSystem;
  unit: Unit;
};

export type Wishlist = {
  __typename?: "Wishlist";
  createdAt: Scalars["DateTime"]["output"];
  customerId: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  isPublic: Scalars["Boolean"]["output"];
  itemCount: Scalars["NonNegativeInt"]["output"];
  items: Array<WishlistItem>;
  name: Scalars["String"]["output"];
  shares: Array<WishlistShare>;
  storeId: StoreId;
  updatedAt: Scalars["DateTime"]["output"];
};

export type WishlistInput = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  shareToken?: InputMaybe<Scalars["TrimmedString"]["input"]>;
};

export type WishlistItem = {
  __typename?: "WishlistItem";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  product: StorefrontProduct;
  quantity: Scalars["NonNegativeInt"]["output"];
  sortOrder: Scalars["NonNegativeInt"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  variant: StorefrontProductVariant;
};

export type WishlistShare = {
  __typename?: "WishlistShare";
  accessLevel: WishlistShareAccessLevel;
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  shareToken: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export enum WishlistShareAccessLevel {
  Edit = "Edit",
  ReadOnly = "ReadOnly",
}

export type WishlistsInput = {
  storeId: StoreId;
};

export type ProductFragment = {
  __typename?: "StorefrontProduct";
  id: string;
  title: string;
  shortTitle?: string | null;
  name: string;
  collectionSlug?: string | null;
  status: DisplayProductStatus;
  thumbnail?: { __typename?: "Asset"; id: string; url: string } | null;
  upsellProductCategories: Array<{
    __typename?: "UpsellProductCategory";
    productIds: Array<string>;
  }>;
  tags: Array<{ __typename?: "ProductTag"; name: string }>;
  variants: Array<{
    __typename?: "StorefrontProductVariant";
    id: string;
    sku: string;
    displayPrice: { __typename?: "Money"; amount: number; currency: Currency };
  }>;
};

export type GetCollectionForUiCareQueryVariables = Exact<{
  slug: Scalars["LowercaseTrimmedString"]["input"];
  storeId: StoreId;
  language: Scalars["LowercaseTrimmedString"]["input"];
  displayCurrency: Currency;
}>;

export type GetCollectionForUiCareQuery = {
  __typename?: "Query";
  storefrontCollection: {
    __typename?: "StorefrontCollection";
    id: string;
    products: Array<{
      __typename?: "StorefrontProduct";
      id: string;
      title: string;
      shortTitle?: string | null;
      name: string;
      collectionSlug?: string | null;
      status: DisplayProductStatus;
      thumbnail?: { __typename?: "Asset"; id: string; url: string } | null;
      upsellProductCategories: Array<{
        __typename?: "UpsellProductCategory";
        productIds: Array<string>;
      }>;
      tags: Array<{ __typename?: "ProductTag"; name: string }>;
      variants: Array<{
        __typename?: "StorefrontProductVariant";
        id: string;
        sku: string;
        displayPrice: {
          __typename?: "Money";
          amount: number;
          currency: Currency;
        };
      }>;
    }>;
  };
};

export type UpsellProductFragment = {
  __typename?: "StorefrontProduct";
  id: string;
  title: string;
  shortTitle?: string | null;
  name: string;
  thumbnail?: { __typename?: "Asset"; id: string; url: string } | null;
  variants: Array<{
    __typename?: "StorefrontProductVariant";
    id: string;
    sku: string;
    displayPrice: { __typename?: "Money"; amount: number; currency: Currency };
  }>;
};

export type GetUpsellProductsForUiCareQueryVariables = Exact<{
  ids: Array<Scalars["UUID"]["input"]> | Scalars["UUID"]["input"];
  storeId: StoreId;
  language: Scalars["LowercaseTrimmedString"]["input"];
  displayCurrency: Currency;
}>;

export type GetUpsellProductsForUiCareQuery = {
  __typename?: "Query";
  storefrontProductsById: Array<{
    __typename?: "StorefrontProduct";
    id: string;
    title: string;
    shortTitle?: string | null;
    name: string;
    thumbnail?: { __typename?: "Asset"; id: string; url: string } | null;
    variants: Array<{
      __typename?: "StorefrontProductVariant";
      id: string;
      sku: string;
      displayPrice: {
        __typename?: "Money";
        amount: number;
        currency: Currency;
      };
    }>;
  }>;
};

export const ProductFragmentDoc = /*#__PURE__*/ gql`
  fragment ProductFragment on StorefrontProduct {
    id
    title
    shortTitle
    name
    thumbnail {
      id
      url
    }
    collectionSlug
    upsellProductCategories {
      productIds
    }
    tags {
      name
    }
    status
    variants {
      id
      sku
      displayPrice {
        amount
        currency
      }
    }
  }
`;
export const UpsellProductFragmentDoc = /*#__PURE__*/ gql`
  fragment UpsellProductFragment on StorefrontProduct {
    id
    title
    shortTitle
    name
    thumbnail {
      id
      url
    }
    variants {
      id
      sku
      displayPrice {
        amount
        currency
      }
    }
  }
`;
export const GetCollectionForUiCareDocument = /*#__PURE__*/ gql`
  query GetCollectionForUICare(
    $slug: LowercaseTrimmedString!
    $storeId: StoreId!
    $language: LowercaseTrimmedString!
    $displayCurrency: Currency!
  ) {
    storefrontCollection(
      slug: $slug
      storeId: $storeId
      language: $language
      displayCurrency: $displayCurrency
    ) {
      id
      products {
        ...ProductFragment
      }
    }
  }
  ${ProductFragmentDoc}
`;
export const GetUpsellProductsForUiCareDocument = /*#__PURE__*/ gql`
  query GetUpsellProductsForUICare(
    $ids: [UUID!]!
    $storeId: StoreId!
    $language: LowercaseTrimmedString!
    $displayCurrency: Currency!
  ) {
    storefrontProductsById(
      ids: $ids
      storeId: $storeId
      language: $language
      displayCurrency: $displayCurrency
    ) {
      ...UpsellProductFragment
    }
  }
  ${UpsellProductFragmentDoc}
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType,
  _variables,
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper,
) {
  return {
    GetCollectionForUICare(
      variables: GetCollectionForUiCareQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetCollectionForUiCareQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCollectionForUiCareQuery>({
            document: GetCollectionForUiCareDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetCollectionForUICare",
        "query",
        variables,
      );
    },
    GetUpsellProductsForUICare(
      variables: GetUpsellProductsForUiCareQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetUpsellProductsForUiCareQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetUpsellProductsForUiCareQuery>({
            document: GetUpsellProductsForUiCareDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetUpsellProductsForUICare",
        "query",
        variables,
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
